import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date scalar type */
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** Mongo Object ID scalar type */
  ObjectId: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AbortUploadEvent = {
  __typename?: 'AbortUploadEvent';
  _id: Scalars['String'];
  accountId: Scalars['ObjectId'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isAborted: Scalars['Boolean'];
  isCompleted: Scalars['Boolean'];
  progressStatus?: Maybe<Scalars['String']>;
  progressTrackingId: Scalars['ObjectId'];
  s3FileKey: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type AcceptApiInvitationInput = {
  firstName: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type Account = {
  __typename?: 'Account';
  _id: Scalars['String'];
  archivingReason?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  excludeFromReports?: Maybe<Scalars['Boolean']>;
  hubSpotId?: Maybe<Scalars['String']>;
  isSeeker: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  lastAccountTypeSwitchAt?: Maybe<Scalars['Date']>;
  mfaEnabled?: Maybe<Scalars['Boolean']>;
  mfaMethod?: Maybe<MfaMethodsEnum>;
  mfaSecret?: Maybe<Scalars['String']>;
  phone?: Maybe<Phone>;
  productSubscriptionId?: Maybe<Scalars['String']>;
  profile: Profile;
  provider?: Maybe<Scalars['String']>;
  role: Role;
  roleId: Scalars['String'];
  rollbackSubscriptionId?: Maybe<Scalars['String']>;
  showAllBillingPlans?: Maybe<Scalars['Boolean']>;
  ssoId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripeDefaultPaymentMethodId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  zohoId?: Maybe<Scalars['String']>;
};

export enum AccountActiveOrArchivedStatusesEnum {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export type AccountInput = {
  _id?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
};

export type AddMediaKitItems = {
  mediaIdsToAdd: Array<Scalars['ObjectId']>;
  portfolioId: Scalars['ObjectId'];
};

export type AddSaleTeamUserAccountInput = {
  email: Scalars['String'];
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
};

export type AddSaleTeamUserInput = {
  accountInput: AddSaleTeamUserAccountInput;
  assignedPropertiesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  profileInput: ProfileInput;
  saleTeamId: Scalars['ObjectId'];
  saleTeamRoleId: Scalars['ObjectId'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AdvancedPropertyDetailsInput = {
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  completionDate?: InputMaybe<Scalars['Date']>;
  constructionStartDate?: InputMaybe<Scalars['Date']>;
  interiorDesigner?: InputMaybe<Scalars['String']>;
  landscapeArchitect?: InputMaybe<Scalars['String']>;
  leadArchitect?: InputMaybe<Scalars['String']>;
  localArchitect?: InputMaybe<Scalars['String']>;
  numberOfTowers?: InputMaybe<Scalars['Float']>;
  numberOfUnits?: InputMaybe<Scalars['Float']>;
  overview?: InputMaybe<Scalars['String']>;
  projectDetails?: InputMaybe<Scalars['String']>;
  projectStatus?: InputMaybe<ProjectStatusesEnum>;
  propertyId: Scalars['ObjectId'];
  propertyTags?: InputMaybe<Array<PropertyTagsEnum>>;
  salesGalleryAddress?: InputMaybe<Scalars['String']>;
  salesGalleryHours?: InputMaybe<LocalTimeHoursInput>;
  salesGalleryStatus?: InputMaybe<SalesGalleryStatusesEnum>;
  stories?: InputMaybe<Scalars['Float']>;
  taxInformation?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<PropertyTransactionTypesEnum>;
  virtualTourLinks?: InputMaybe<Array<VirtualTourLinkInput>>;
  workingHours?: InputMaybe<WorkingHoursInput>;
  yearBuilt?: InputMaybe<Scalars['Float']>;
};

export type AmenitiesPayload = {
  __typename?: 'AmenitiesPayload';
  collection: Array<Amenity>;
  totalCount: Scalars['Float'];
};

export type Amenity = {
  __typename?: 'Amenity';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  imageFile?: Maybe<File>;
  imageFileId: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  isPrimary: Scalars['Boolean'];
  name: Scalars['String'];
  primaryAmenityId?: Maybe<Scalars['ObjectId']>;
  propertyId?: Maybe<Scalars['ObjectId']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type AmenityName = {
  __typename?: 'AmenityName';
  amenityId: Scalars['ObjectId'];
  name: Scalars['String'];
};

export type ApiBrokerInfo = {
  __typename?: 'ApiBrokerInfo';
  _id?: Maybe<Scalars['String']>;
};

export type ApiCredentialSafeDto = {
  __typename?: 'ApiCredentialSafeDTO';
  _id: Scalars['String'];
  adminDisabled?: Maybe<Scalars['Boolean']>;
  appId: Scalars['String'];
  associatedAccounts?: Maybe<Array<Scalars['ID']>>;
  associatedCompany?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  monthlyRequestLimit?: Maybe<Scalars['Float']>;
  partnerDisabled?: Maybe<Scalars['Boolean']>;
  referralCode?: Maybe<Scalars['String']>;
  type: ApiCredentialsTypesEnum;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type ApiCredentialsInput = {
  companyName?: InputMaybe<Scalars['String']>;
  isMarketplacePartner?: InputMaybe<Scalars['Boolean']>;
  referralCode?: InputMaybe<Scalars['String']>;
};

export type ApiCredentialsPluginUserResponse = {
  __typename?: 'ApiCredentialsPluginUserResponse';
  _id: Scalars['String'];
  appId?: Maybe<Scalars['String']>;
  associatedCompany?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  partnerDisabled?: Maybe<Scalars['Boolean']>;
};

export enum ApiCredentialsTypesEnum {
  COMPANY = 'COMPANY',
  PLUGIN_USER = 'PLUGIN_USER'
}

export type ApiCredentialsUserResponse = {
  __typename?: 'ApiCredentialsUserResponse';
  _id: Scalars['String'];
  appId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
};

export type ApiInvitationSafeDto = {
  __typename?: 'ApiInvitationSafeDTO';
  _id: Scalars['String'];
  acceptedAt?: Maybe<Scalars['Date']>;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  expiresAt: Scalars['Date'];
  isMarketplacePartner?: Maybe<Scalars['Boolean']>;
  referralCode?: Maybe<Scalars['String']>;
  status: ApiInvitationStatusEnum;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum ApiInvitationStatusEnum {
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  FULFILLED = 'FULFILLED',
  PENDING = 'PENDING',
  REVOKED = 'REVOKED'
}

export type ApiInvitationValidation = {
  __typename?: 'ApiInvitationValidation';
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  hasExistingAccount: Scalars['Boolean'];
  isValid: Scalars['Boolean'];
  status?: Maybe<ApiInvitationStatusEnum>;
};

export type ApiInvitationsPayload = {
  __typename?: 'ApiInvitationsPayload';
  collection: Array<ApiInvitationSafeDto>;
  totalCount: Scalars['Int'];
};

export type ApiMetric = {
  __typename?: 'ApiMetric';
  _id: Scalars['String'];
  appId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  credentialsType: Scalars['String'];
  dataPoints: Array<MetricDataPoint>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
  totalRequests: Scalars['Float'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type ApiMetricPayload = {
  __typename?: 'ApiMetricPayload';
  collection: Array<ApiMetric>;
  totalCount: Scalars['Float'];
};

export type ApiPluginUser = {
  __typename?: 'ApiPluginUser';
  account: Account;
  apiCredentials?: Maybe<ApiCredentialsPluginUserResponse>;
  broker?: Maybe<ApiBrokerInfo>;
  clientCount?: Maybe<Scalars['Float']>;
  monthlyApiAccess?: Maybe<Scalars['Float']>;
  profile: Profile;
};

export type ApiPluginUsersPayload = {
  __typename?: 'ApiPluginUsersPayload';
  collection: Array<ApiPluginUser>;
  totalCount: Scalars['Float'];
};

export type ApiQuotaStatusPayload = {
  __typename?: 'ApiQuotaStatusPayload';
  limit: Scalars['Float'];
  resetDate: Scalars['Date'];
  usage: Scalars['Float'];
};

export type ApiUser = {
  __typename?: 'ApiUser';
  account: Account;
  apiCredentials?: Maybe<ApiCredentialsUserResponse>;
  clientCount?: Maybe<Scalars['Float']>;
  monthlyApiAccess?: Maybe<Scalars['Float']>;
  profile: Profile;
};

export type ApiUsersPayload = {
  __typename?: 'ApiUsersPayload';
  collection: Array<ApiUser>;
  totalCount: Scalars['Float'];
};

export type ApprovePropertyInput = {
  propertyId: Scalars['ObjectId'];
};

export type ArchivePropertyInput = {
  propertyId: Scalars['ObjectId'];
};

export type AttributionInput = {
  fbclid?: InputMaybe<Scalars['String']>;
  gclid?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Scalars['String']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
};

export type AuditPropertyInput = {
  propertyId: Scalars['ObjectId'];
};

export type AuthResult = MfaTempTokenModel | TokensModel;

export type BasicInfoResponse = {
  __typename?: 'BasicInfoResponse';
  appId: Scalars['String'];
  hasKey: Scalars['Boolean'];
  isActive?: Maybe<Scalars['Boolean']>;
  referralCode?: Maybe<Scalars['String']>;
  type?: Maybe<ApiCredentialsTypesEnum>;
};

export type Branding = {
  __typename?: 'Branding';
  backgroundColor: Scalars['String'];
  mainColor: Scalars['String'];
  textColor: Scalars['String'];
};

export type BrandingInput = {
  backgroundColor: Scalars['String'];
  mainColor: Scalars['String'];
  textColor: Scalars['String'];
};

export enum BrandingTypeEnum {
  BRANDED = 'BRANDED',
  SHARED = 'SHARED',
  UNBRANDED = 'UNBRANDED'
}

export enum BrandingTypeFilterEnum {
  ALL = 'ALL',
  BRANDED = 'BRANDED',
  SHARED = 'SHARED',
  UNBRANDED = 'UNBRANDED'
}

export type Broker = {
  __typename?: 'Broker';
  _id: Scalars['String'];
  account: Account;
  accountId: Scalars['String'];
  accountSubscription?: Maybe<ProductSubscription>;
  agencyName?: Maybe<Scalars['String']>;
  agencyWebsite?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  demoExpirationDate?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  hasActiveApiCredential: Scalars['Boolean'];
  isRealUser: Scalars['Boolean'];
  isSeeker: Scalars['Boolean'];
  license?: Maybe<BrokerLicense>;
  preferredPropertySettings?: Maybe<PreferredPropertySettings>;
  profile: Profile;
  profileId: Scalars['String'];
  subscriptionType: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  workingHours?: Maybe<WorkingHours>;
};

export enum BrokerActivitiesTypesEnum {
  PORTFOLIO_ADDED = 'PORTFOLIO_ADDED',
  PROPERTY_VISITED = 'PROPERTY_VISITED'
}

export type BrokerActivity = {
  __typename?: 'BrokerActivity';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type BrokerAlertConfig = {
  __typename?: 'BrokerAlertConfig';
  _id: Scalars['String'];
  brokerId: Scalars['ObjectId'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  filter: BrokerAlertConfigFilter;
  name: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type BrokerAlertConfigConstructionDateRangeFilter = {
  __typename?: 'BrokerAlertConfigConstructionDateRangeFilter';
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export type BrokerAlertConfigFilter = {
  __typename?: 'BrokerAlertConfigFilter';
  amenities?: Maybe<Array<Scalars['String']>>;
  amenityIds?: Maybe<Array<Scalars['ObjectId']>>;
  buildingTypes?: Maybe<Array<BuildingTypesEnum>>;
  constructionDateRange?: Maybe<BrokerAlertConfigConstructionDateRangeFilter>;
  locationFilter?: Maybe<BrokerAlertConfigLocationFilter>;
  marketAreaIds?: Maybe<Array<Scalars['ObjectId']>>;
  priceRange?: Maybe<MinMaxRangePayload>;
  projectStatuses?: Maybe<Array<ProjectStatusesEnum>>;
  propertyTags?: Maybe<Array<PropertyTagsEnum>>;
  transactionType?: Maybe<PropertyTransactionTypesEnum>;
  unitNumberOfBathrooms?: Maybe<MinMaxRangePayload>;
  unitNumberOfBedrooms?: Maybe<MinMaxRangePayload>;
  unitNumberOfUnits?: Maybe<MinMaxRangePayload>;
  yearBuildRange?: Maybe<MinMaxRangePayload>;
};

export type BrokerAlertConfigLocationFilter = {
  __typename?: 'BrokerAlertConfigLocationFilter';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  radiusToSearchInMiles: Scalars['Float'];
};

export type BrokerAlertConfigPayload = {
  __typename?: 'BrokerAlertConfigPayload';
  collection: Array<BrokerAlertConfig>;
  totalCount: Scalars['Float'];
};

export type BrokerAlertItem = {
  __typename?: 'BrokerAlertItem';
  _id: Scalars['String'];
  brokerAlertConfig: BrokerAlertConfig;
  brokerAlertConfigId: Scalars['ObjectId'];
  brokerId: Scalars['ObjectId'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isHidden: Scalars['Boolean'];
  isNew: Scalars['Boolean'];
  isPropertyPublic: Scalars['Boolean'];
  property: Property;
  propertyId: Scalars['ObjectId'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type BrokerAlertItemPayload = {
  __typename?: 'BrokerAlertItemPayload';
  collection: Array<BrokerAlertItem>;
  totalCount: Scalars['Float'];
};

export type BrokerLicense = {
  __typename?: 'BrokerLicense';
  licenseExpirationDate?: Maybe<Scalars['Date']>;
  licenseJurisdictionCode?: Maybe<Scalars['String']>;
  licenseNumber: Scalars['String'];
  licenseStatus: Scalars['String'];
};

export enum BrokerLicenseStatusesEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING_REVIEW = 'PENDING_REVIEW'
}

export enum BrokerPortfolioComparisonFields {
  BUILDING_TYPE = 'BUILDING_TYPE',
  LOCATION = 'LOCATION',
  NUMBER_OF_BATHROOMS = 'NUMBER_OF_BATHROOMS',
  NUMBER_OF_BEDROOMS = 'NUMBER_OF_BEDROOMS',
  PROJECT_STATUS = 'PROJECT_STATUS',
  STARTING_PRICE = 'STARTING_PRICE',
  TAX_INFORMATION = 'TAX_INFORMATION',
  UNITS_AVAILABLE = 'UNITS_AVAILABLE',
  UNIT_SIZES = 'UNIT_SIZES'
}

export enum BrokerPortfolioStatusesEnum {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type BrokerReactionsStats = {
  __typename?: 'BrokerReactionsStats';
  negative: Scalars['Float'];
  neutral: Scalars['Float'];
  positive: Scalars['Float'];
  total: Scalars['Float'];
};

export type BrokerSavedFeaturedPortfolio = {
  __typename?: 'BrokerSavedFeaturedPortfolio';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  portfolio?: Maybe<FeaturedPortfolio>;
  portfolioId: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type BrokerSavedFeaturedPortfoliosPayload = {
  __typename?: 'BrokerSavedFeaturedPortfoliosPayload';
  collection: Array<BrokerSavedFeaturedPortfolio>;
  totalCount: Scalars['Float'];
};

export enum BrokerSubscriptionTypesEnum {
  BILLABLE = 'BILLABLE',
  DEMO = 'DEMO'
}

export type BrokerTrackedPropertiesPayload = {
  __typename?: 'BrokerTrackedPropertiesPayload';
  collection: Array<BrokerTrackedProperty>;
  totalCount: Scalars['Float'];
};

export type BrokerTrackedProperty = {
  __typename?: 'BrokerTrackedProperty';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  property: Property;
  propertyId: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type BrokerViewedPortfoliosFilter = {
  portfolioIds: Array<Scalars['ObjectId']>;
  range?: InputMaybe<DateRangeInput>;
};

export type BrokersPayload = {
  __typename?: 'BrokersPayload';
  collection: Array<Broker>;
  totalCount: Scalars['Float'];
};

export enum BuildingTypesEnum {
  ACTIVE_ADULT = 'ACTIVE_ADULT',
  BOUTIQUE = 'BOUTIQUE',
  CONDO = 'CONDO',
  CONDO_CONVERSION = 'CONDO_CONVERSION',
  CONDO_HOTEL = 'CONDO_HOTEL',
  LUXURY_APARTMENT = 'LUXURY_APARTMENT',
  PENTHOUSE = 'PENTHOUSE',
  PRIVATE_RESIDENCE = 'PRIVATE_RESIDENCE',
  SHORT_TERM_RENTAL_FRIENDLY = 'SHORT_TERM_RENTAL_FRIENDLY',
  SINGLE_FAMILY_HOME = 'SINGLE_FAMILY_HOME',
  TOWNHOME = 'TOWNHOME',
  VILLA = 'VILLA',
  WORKFORCE_HOUSING = 'WORKFORCE_HOUSING'
}

export type CanUserTrialForProductInput = {
  stripeProductId: Scalars['String'];
};

export type CancelProductSubscriptionInput = {
  cancelationReason: Scalars['String'];
  downgradeTo?: InputMaybe<Scalars['String']>;
  otherReason?: InputMaybe<Scalars['String']>;
};

export type ChangelogDocument = PropertyAboutChangelog | PropertyAdditionalInformationChangelog | PropertyDataReviewedChangelog | PropertyDeveloperOrganizationChangelog | PropertyFeaturesAndAmenitiesChangelog | PropertyHighlightsChangelog | PropertyInventoryUnitAddedChangelog | PropertyInventoryUnitRemovedChangelog | PropertyInventoryUnitUpdatedChangelog | PropertyLocationChangelog | PropertyMediaFilesMovedChangelog | PropertyMediaRemovedChangelog | PropertyMediaRenamedChangelog | PropertyMediaUploadedChangelog | PropertyNameChangelog | PropertyOrganizationSalesTeamsChangelog | PropertyPriceChangelog | PropertyVirtualToursChangelog | PropertyWebsiteChangelog;

export type CheckoutSessionDetails = {
  __typename?: 'CheckoutSessionDetails';
  customerName: Scalars['String'];
  status: Scalars['String'];
  totalAmount: Scalars['Int'];
  trialEndAt?: Maybe<Scalars['Int']>;
};

export type CmsSettings = {
  __typename?: 'CmsSettings';
  _id: Scalars['String'];
  activeToAwaitingAuditDays: Scalars['Float'];
  automatedTransitionsEnabled: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  newListingToActiveDays: Scalars['Float'];
  recentlyUpdatedToActiveDays: Scalars['Float'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum CmsStatusEnum {
  ACTIVE_LISTING = 'ACTIVE_LISTING',
  ARCHIVED = 'ARCHIVED',
  AWAITING_AUDIT = 'AWAITING_AUDIT',
  DRAFT = 'DRAFT',
  NEW_LISTING = 'NEW_LISTING',
  NOT_SET = 'NOT_SET',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PENDING_ARCHIVE = 'PENDING_ARCHIVE',
  PROPOSED = 'PROPOSED',
  RECENTLY_UPDATED = 'RECENTLY_UPDATED'
}

export type Comparison = {
  __typename?: 'Comparison';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  fieldsToCompare: Array<Scalars['String']>;
  portfolioFolderId?: Maybe<Scalars['String']>;
  portfolioIds: Array<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type ContactPhone = {
  __typename?: 'ContactPhone';
  dialCode: Scalars['String'];
  number: Scalars['String'];
};

export type CopyFeaturedPortfolioToBrokerPortfolioArgs = {
  featuredPortfolioId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type CopyFeaturedPortfolioToBrokerPortfolioResult = {
  __typename?: 'CopyFeaturedPortfolioToBrokerPortfolioResult';
  _id: Scalars['String'];
  name: Scalars['String'];
  propertyCount: Scalars['Float'];
};

export type CreateAlertConfigFilterInput = {
  amenityIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  cityNames?: InputMaybe<Array<Scalars['String']>>;
  cmsStatus?: InputMaybe<CmsStatusEnum>;
  completionDate?: InputMaybe<Scalars['Date']>;
  constructionDateRange?: InputMaybe<DateRangeInput>;
  countyNames?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  locationFilter?: InputMaybe<GetBrokerPropertiesLocationFilterInput>;
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  organizationIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  priceRange?: InputMaybe<PartialMinMaxRangeInput>;
  projectStatuses?: InputMaybe<Array<Scalars['String']>>;
  propertyTags?: InputMaybe<Array<PropertyTagsEnum>>;
  stateIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  strictPriceRange?: InputMaybe<PartialMinMaxRangeInput>;
  transactionType?: InputMaybe<PropertyTransactionTypesEnum>;
  unitNumberOfBathrooms?: InputMaybe<PartialMinMaxRangeInput>;
  unitNumberOfBedrooms?: InputMaybe<PartialMinMaxRangeInput>;
  unitNumberOfUnits?: InputMaybe<PartialMinMaxRangeInput>;
  yearBuildRange?: InputMaybe<MinMaxRangeInput>;
};

export type CreateAmenityInput = {
  imageFileId: Scalars['ObjectId'];
  isPrimary?: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CreateApiInvitationInput = {
  companyName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  expiresAt: Scalars['Date'];
  isMarketplacePartner?: InputMaybe<Scalars['Boolean']>;
  referralCode?: InputMaybe<Scalars['String']>;
};

export type CreateBrokerInput = {
  apiReferralCode?: InputMaybe<Scalars['String']>;
  dialCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  isSeeker?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  licenseNumber?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  ssoId?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
};

export type CreateBrokerSsoInput = {
  dialCode: Scalars['String'];
  licenseNumber?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  stateCode?: InputMaybe<Scalars['String']>;
};

export type CreateCheckoutSessionInput = {
  attribution?: InputMaybe<AttributionInput>;
  cancelUrl?: InputMaybe<Scalars['String']>;
  couponCode?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
  productId: Scalars['String'];
  successUrl?: InputMaybe<Scalars['String']>;
};

export type CreateCheckoutSessionPayload = {
  __typename?: 'CreateCheckoutSessionPayload';
  sessionUrl: Scalars['String'];
};

export type CreateFeaturedPortfolioInput = {
  cardDescription?: InputMaybe<Scalars['String']>;
  coverImageFileId?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Float']>;
  overview?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  visibility?: InputMaybe<Scalars['String']>;
};

export type CreateFeaturedPropertyInput = {
  coverImageFileId?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Float']>;
  overview?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['String'];
  shortOverview?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  visibility?: InputMaybe<Scalars['String']>;
};

export type CreateIdxFeedInput = {
  name: Scalars['String'];
  type: IdxFeedTypeEnum;
};

export type CreateMarketAreaInput = {
  name: Scalars['String'];
  stateId: Scalars['ObjectId'];
};

export type CreateMediaFileInput = {
  brandingType?: InputMaybe<BrandingTypeEnum>;
  fileUpload: FileUploadInput;
  mediaFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};

export type CreateMediaFolderInput = {
  folderName: Scalars['String'];
  mediaFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};

export type CreateOrganizationInput = {
  locationInput?: InputMaybe<LocationSaveInput>;
  logoFileId?: InputMaybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type CreateOrganizationUserAccountInput = {
  email: Scalars['String'];
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOrganizationUserInput = {
  accountInput: CreateOrganizationUserAccountInput;
  assignedPropertiesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  organizationId: Scalars['ObjectId'];
  profileInput: ProfileInput;
  roleId: Scalars['ObjectId'];
};

export type CreateProductSubscriptionInput = {
  stripeCouponId?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
  subscriptionProductId: Scalars['ObjectId'];
};

export type CreatePropertyInput = {
  cmsStatus?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationSaveInput>;
  marketAreaId?: InputMaybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  primaryOrganizationId?: InputMaybe<Scalars['ObjectId']>;
};

export type CreateSaleTeamInput = {
  logoFileId?: InputMaybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  phone?: InputMaybe<PhoneInput>;
  website?: InputMaybe<Scalars['String']>;
  workingHours?: InputMaybe<WorkingHoursInput>;
};

export type CreateSimpleBrokerInput = {
  isSeeker?: InputMaybe<Scalars['Boolean']>;
};

export type CreateSinglePropertyPortfolioInput = {
  name: Scalars['String'];
  propertyId: Scalars['ObjectId'];
};

export type CreateUnitInput = {
  averageBathroomsNumber?: InputMaybe<PartialMinMaxRangeInput>;
  averageBedroomsNumber?: InputMaybe<PartialMinMaxRangeInput>;
  averageExteriorSqft?: InputMaybe<PartialMinMaxRangeInput>;
  averageInteriorSqft?: InputMaybe<PartialMinMaxRangeInput>;
  averageTotalSqft?: InputMaybe<PartialMinMaxRangeInput>;
  customRooms?: InputMaybe<Scalars['String']>;
  floorPlanFileId?: InputMaybe<Scalars['ObjectId']>;
  highestPrice?: InputMaybe<Scalars['Float']>;
  inventoryType: Scalars['String'];
  name: Scalars['String'];
  propertyId: Scalars['ObjectId'];
  startingPrice?: InputMaybe<Scalars['Float']>;
};

export type DateRangeInput = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export type Developer = {
  __typename?: 'Developer';
  account: Account;
  accountId: Scalars['String'];
  assignedPropertiesIds?: Maybe<Array<Scalars['ObjectId']>>;
  organizationIds?: Maybe<Array<Scalars['ObjectId']>>;
  organizations?: Maybe<Array<Organization>>;
  profile: Profile;
  profileId: Scalars['String'];
  roleId: Scalars['String'];
  saleTeamId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type DeveloperAsSaleUser = OrganizationUser | SaleTeamUser;

export type EditAmenityInput = {
  _id: Scalars['ObjectId'];
  imageFileId: Scalars['ObjectId'];
  name: Scalars['String'];
};

export type EditMarketAreaInput = {
  _id: Scalars['ObjectId'];
  name: Scalars['String'];
  stateId: Scalars['ObjectId'];
};

export type EditMediaFileInput = {
  name: Scalars['String'];
};

export type EditMediaFolderInput = {
  mediaDetails: MediaFolderInput;
  mediaFolderId: Scalars['ObjectId'];
  noChangelog?: InputMaybe<Scalars['Boolean']>;
};

export type EditOrganizationInput = {
  locationInput?: InputMaybe<LocationSaveInput>;
  logoFileId?: InputMaybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type EditOrganizationUserAccountInput = {
  email?: InputMaybe<Scalars['String']>;
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
};

export type EditOrganizationUserInput = {
  accountInput?: InputMaybe<EditOrganizationUserAccountInput>;
  assignedPropertiesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  organizationUserId: Scalars['ObjectId'];
  profileInput?: InputMaybe<EditOrganizationUserProfileInput>;
  roleId: Scalars['ObjectId'];
};

export type EditOrganizationUserProfileInput = {
  _id?: InputMaybe<Scalars['String']>;
  avatarFileId?: InputMaybe<Scalars['ObjectId']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type EditSaleTeamInput = {
  logoFileId?: InputMaybe<Scalars['ObjectId']>;
  name: Scalars['String'];
  phone?: InputMaybe<PhoneInput>;
  website?: InputMaybe<Scalars['String']>;
  workingHours?: InputMaybe<WorkingHoursInput>;
};

export type EditSaleTeamUserAccountInput = {
  email: Scalars['String'];
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
};

export type EditSaleTeamUserInput = {
  accountInput?: InputMaybe<EditSaleTeamUserAccountInput>;
  assignedPropertiesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  profileInput?: InputMaybe<EditSaleTeamUserProfileInput>;
  saleTeamRoleId: Scalars['ObjectId'];
  saleTeamUserId: Scalars['ObjectId'];
};

export type EditSaleTeamUserProfileInput = {
  _id?: InputMaybe<Scalars['String']>;
  avatarFileId?: InputMaybe<Scalars['ObjectId']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type EditUnitInput = {
  noChangelog?: InputMaybe<Scalars['Boolean']>;
  unitDetails: UnitInput;
  unitId: Scalars['ObjectId'];
};

export type FeaturedPortfolio = {
  __typename?: 'FeaturedPortfolio';
  _id: Scalars['String'];
  cardDescription?: Maybe<Scalars['String']>;
  coverImageFile?: Maybe<File>;
  coverImageFileId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Float']>;
  overview?: Maybe<Scalars['String']>;
  propertyIds?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  visibility: FeaturedPortfolioVisibilityEnum;
};

export type FeaturedPortfolioOrder = {
  displayOrder: Scalars['Float'];
  featuredPortfolioId: Scalars['String'];
};

export type FeaturedPortfolioPropertiesPayload = {
  __typename?: 'FeaturedPortfolioPropertiesPayload';
  collection: Array<PropertyDetail>;
  totalCount: Scalars['Float'];
};

export type FeaturedPortfolioSummary = {
  __typename?: 'FeaturedPortfolioSummary';
  completionYearRange?: Maybe<MinMax>;
  marketAreas: Array<MarketAreaCount>;
  priceRange?: Maybe<MinMax>;
  propertyCount: Scalars['Float'];
};

export enum FeaturedPortfolioVisibilityEnum {
  HIDDEN = 'HIDDEN',
  PUBLIC = 'PUBLIC'
}

export type FeaturedPortfoliosPayload = {
  __typename?: 'FeaturedPortfoliosPayload';
  collection: Array<FeaturedPortfolio>;
  totalCount: Scalars['Float'];
};

export type FeaturedPropertiesPayload = {
  __typename?: 'FeaturedPropertiesPayload';
  collection: Array<FeaturedProperty>;
  totalCount: Scalars['Float'];
};

export type FeaturedProperty = {
  __typename?: 'FeaturedProperty';
  _id: Scalars['String'];
  coverImageFile?: Maybe<File>;
  coverImageFileId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  displayOrder?: Maybe<Scalars['Float']>;
  overview?: Maybe<Scalars['String']>;
  property: Property;
  propertyId: Scalars['String'];
  shortOverview?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  visibility: FeaturedPropertyVisibilityEnum;
};

export type FeaturedPropertyOrder = {
  displayOrder: Scalars['Float'];
  featuredPropertyId: Scalars['String'];
};

export enum FeaturedPropertyVisibilityEnum {
  HIDDEN = 'HIDDEN',
  PUBLIC = 'PUBLIC'
}

export type File = {
  __typename?: 'File';
  _id: Scalars['String'];
  copyFromFileId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  publicUrl: Scalars['String'];
  s3Key: Scalars['String'];
  size: Scalars['Float'];
  status: Scalars['String'];
  thumbnailFile?: Maybe<File>;
  thumbnailFileId?: Maybe<File>;
  thumbnailFileUrl?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type FileUploadInput = {
  file: Scalars['Upload'];
  fileSize?: InputMaybe<Scalars['Float']>;
  progressTrackingId?: InputMaybe<Scalars['String']>;
};

export type FlatPaginationInput = {
  endingBefore?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  startingAfter?: InputMaybe<Scalars['String']>;
};

export type FolderPathModel = {
  __typename?: 'FolderPathModel';
  _id: Scalars['String'];
  folderName: Scalars['String'];
};

export type GeneralPropertyDetailsInput = {
  averageBathroomsNumber?: InputMaybe<PartialMinMaxRangeInput>;
  averageBedroomsNumber?: InputMaybe<PartialMinMaxRangeInput>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<PhoneInput>;
  defaultInventoryDetails?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationSaveInput>;
  mainPropertyMediaId?: InputMaybe<Scalars['ObjectId']>;
  marketAreaId?: InputMaybe<Scalars['ObjectId']>;
  name?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  priceRange?: InputMaybe<PartialMinMaxRangeInput>;
  primaryOrganizationId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  saleTeams?: InputMaybe<Array<PropertySaleTeamInput>>;
  website?: InputMaybe<Scalars['String']>;
};

export type GenerateQrCodeResult = {
  __typename?: 'GenerateQrCodeResult';
  qrCode: Scalars['String'];
};

export type GeoLocationBoundsJson = {
  east: Scalars['Float'];
  north: Scalars['Float'];
  south: Scalars['Float'];
  west: Scalars['Float'];
};

export type GeoLocationJson = {
  __typename?: 'GeoLocationJSON';
  coordinates: Array<Scalars['Float']>;
  type: Scalars['String'];
};

export type GetAlertItemsFilterInput = {
  alertConfigIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  range?: InputMaybe<DateRangeInput>;
};

export type GetAllFilesInPropertyFilterInput = {
  brandingType?: InputMaybe<BrandingTypeFilterEnum>;
  excludeAgentsOnlyFolder?: InputMaybe<Scalars['Boolean']>;
  excludeSlideshowFolder?: Scalars['Boolean'];
  excludedMediaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  fileTypes?: InputMaybe<Array<MediaFileTypesFilterEnum>>;
  mediaFolderIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  portfolioId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetAllPropertyChangelogsFilterInput = {
  isHidden?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['ObjectId'];
};

export type GetAmenitiesFilterInput = {
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<Scalars['ObjectId']>;
  searchByName?: InputMaybe<Scalars['String']>;
};

export type GetAmenitiesForManageFilterInput = {
  propertyId: Scalars['ObjectId'];
  searchByName?: InputMaybe<Scalars['String']>;
};

export type GetApiUsersFilterInput = {
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetBrokerPropertiesFilterInput = {
  amenityIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  cityNames?: InputMaybe<Array<Scalars['String']>>;
  cmsStatus?: InputMaybe<CmsStatusEnum>;
  completionDate?: InputMaybe<Scalars['Date']>;
  constructionDateRange?: InputMaybe<DateRangeInput>;
  countyNames?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  locationFilter?: InputMaybe<GetBrokerPropertiesLocationFilterInput>;
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  organizationIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  priceRange?: InputMaybe<PartialMinMaxRangeInput>;
  projectStatuses?: InputMaybe<Array<Scalars['String']>>;
  propertyTags?: InputMaybe<Array<PropertyTagsEnum>>;
  searchText?: InputMaybe<Scalars['String']>;
  stateIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  strictPriceRange?: InputMaybe<PartialMinMaxRangeInput>;
  transactionType?: InputMaybe<PropertyTransactionTypesEnum>;
  unitNumberOfBathrooms?: InputMaybe<PartialMinMaxRangeInput>;
  unitNumberOfBedrooms?: InputMaybe<PartialMinMaxRangeInput>;
  unitNumberOfUnits?: InputMaybe<PartialMinMaxRangeInput>;
  yearBuildRange?: InputMaybe<MinMaxRangeInput>;
};

export type GetBrokerPropertiesLocationFilterInput = {
  bounds?: InputMaybe<GeoLocationBoundsJson>;
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  radiusToSearchInMiles?: InputMaybe<Scalars['Float']>;
};

export type GetBrokersFilter = {
  accountStatus?: InputMaybe<Array<Scalars['String']>>;
  isRealUser?: InputMaybe<Array<Scalars['Boolean']>>;
  isSeeker?: InputMaybe<Scalars['Boolean']>;
  licenseStatuses?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<Scalars['String']>>;
  subscriptionPlanTypes?: InputMaybe<Array<Scalars['String']>>;
  subscriptionStatuses?: InputMaybe<Array<Scalars['String']>>;
};

export type GetCmsUsersFilterInput = {
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetFeaturedPortfoliosFilter = {
  visibility?: InputMaybe<Array<FeaturedPortfolioVisibilityEnum>>;
};

export type GetFeaturedPropertiesFilter = {
  visibility?: InputMaybe<Array<FeaturedPropertyVisibilityEnum>>;
};

export type GetFileDownloadStatisticsArgsFilterInput = {
  dateRange?: InputMaybe<PartialDateRangeInput>;
  propertyId: Scalars['ObjectId'];
};

export type GetFileDownloadsStatisticItem = {
  __typename?: 'GetFileDownloadsStatisticItem';
  count: Scalars['Float'];
  file: File;
};

export type GetFileDownloadsStatisticPayload = {
  __typename?: 'GetFileDownloadsStatisticPayload';
  collection: Array<GetFileDownloadsStatisticItem>;
  totalCount: Scalars['Float'];
};

export type GetIdxEmbeddedPortfolioFeedInput = {
  idxFeedId: Scalars['ObjectId'];
};

export type GetIdxEmbeddedPropertyFeedInput = {
  idxFeedId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
  unitsArgs?: InputMaybe<GetUnitsArgs>;
};

export type GetIdxEmbeddedSearchBarFeedInput = {
  idxFeedId: Scalars['ObjectId'];
};

export type GetIdxFeedListFilterInput = {
  nameSearch?: InputMaybe<Scalars['String']>;
};

export type GetIdxFeedListInput = {
  filter?: InputMaybe<GetIdxFeedListFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type GetIdxFeedListPayload = {
  __typename?: 'GetIdxFeedListPayload';
  collection: Array<IdxFeed>;
  totalCount: Scalars['Float'];
};

export type GetIdxPortfolioFeedPropertiesInput = {
  idxFeedId: Scalars['ObjectId'];
  pagination?: InputMaybe<PaginationInput>;
  portfolioFolderId: Scalars['ObjectId'];
};

export type GetIdxPropertyFilesInput = {
  idxFeedId: Scalars['ObjectId'];
  mediaFolderIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  pagination?: InputMaybe<PaginationInput>;
  propertyId: Scalars['ObjectId'];
};

export type GetIdxSearchFeedPropertiesFiltersInput = {
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  locationFilter?: InputMaybe<GetBrokerPropertiesLocationFilterInput>;
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  priceRange?: InputMaybe<PartialMinMaxRangeInput>;
  projectStatus?: InputMaybe<Array<ProjectStatusesEnum>>;
  propertyTags?: InputMaybe<Array<PropertyTagsEnum>>;
  searchText?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<PropertyTransactionTypesEnum>;
};

export type GetIdxSearchFeedPropertiesInput = {
  filters?: InputMaybe<GetIdxSearchFeedPropertiesFiltersInput>;
  idxFeedId: Scalars['ObjectId'];
  pagination?: InputMaybe<PaginationInput>;
};

export type GetMarketAreasFilterInput = {
  code?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  stateNames?: InputMaybe<Array<Scalars['String']>>;
};

export type GetMarketAreasForFilterInput = {
  idxFeedId?: InputMaybe<Scalars['ObjectId']>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetMediaFoldersAndFilesFilterInput = {
  brandingType?: InputMaybe<BrandingTypeFilterEnum>;
  excludeSlideshowFolder?: Scalars['Boolean'];
  fileTypes?: InputMaybe<Array<MediaFileTypesFilterEnum>>;
  ignoreHierarchy?: InputMaybe<Scalars['Boolean']>;
  mediaFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetOrganizationUsersFilterInput = {
  organizationId: Scalars['ObjectId'];
  roleId?: InputMaybe<Scalars['ObjectId']>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetPortfolioMediaKitItemsInput = {
  excludeAgentsOnlyFolder?: InputMaybe<Scalars['Boolean']>;
  excludedMediaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  mediaFolderIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  portfolioId: Scalars['ObjectId'];
};

export type GetPortfolioPropertiesChangelogsFilterInput = {
  dateRange?: InputMaybe<PartialDateRangeInput>;
};

export type GetPortfoliosFilter = {
  status?: InputMaybe<BrokerPortfolioStatusesEnum>;
};

export type GetPortfoliosWithReactionsFilter = {
  guestUserId?: InputMaybe<Scalars['ObjectId']>;
};

export type GetPreviewInvoiceInput = {
  mode: Scalars['String'];
  newStripePriceId: Scalars['String'];
  promoCode?: InputMaybe<Scalars['String']>;
};

export type GetPropertiesFilterInput = {
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  cmsStatuses?: InputMaybe<Array<CmsStatusEnum>>;
  ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  organizationId?: InputMaybe<Scalars['ObjectId']>;
  projectStatuses?: InputMaybe<Array<ProjectStatusesEnum>>;
  propertyTags?: InputMaybe<Array<PropertyTagsEnum>>;
  searchByName?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<PropertyStatusesEnum>>;
  transactionTypes?: InputMaybe<Array<PropertyTransactionTypesEnum>>;
};

export type GetPropertyChangelogsFilterInput = {
  propertyId: Scalars['ObjectId'];
};

export type GetPropertyViewsByBrokerAFilter = {
  propertyIds?: Array<Scalars['ObjectId']>;
  range?: InputMaybe<DateRangeInput>;
};

export type GetSaleTeamUsersFilterInput = {
  saleTeamId: Scalars['ObjectId'];
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetSaleTeamsFilterInput = {
  internalTeamsByOrganizationIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  saleTeamIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type GetSavedFeaturedPortfoliosFilterInput = {
  portfolioIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type GetStatesFilterInput = {
  withMarketArea?: InputMaybe<Scalars['Boolean']>;
};

export type GetSubscriptionProductsFilterInput = {
  includeApiPlan?: InputMaybe<Scalars['Boolean']>;
  isApiUser?: InputMaybe<Scalars['Boolean']>;
  recurringTypes?: InputMaybe<Array<RecurringTypesEnum>>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
};

export type GetSystemActionLogsFilterInput = {
  dateRange?: InputMaybe<PartialDateRangeInput>;
  propertyId: Scalars['ObjectId'];
  type: SystemActionLogsTypeEnum;
};

export type GetTrackedPropertiesFilterInput = {
  propertyChangelogTypes?: InputMaybe<Array<PropertyChangelogTypesEnum>>;
  propertyIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  propertyUpdatesRange?: InputMaybe<DateRangeInput>;
  searchByName?: InputMaybe<Scalars['String']>;
};

export type GetUnitsArgs = {
  filter?: InputMaybe<GetUnitsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};

export type GetUnitsFilterInput = {
  inventoryType?: InputMaybe<Scalars['String']>;
  isRestricted?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<Scalars['ObjectId']>;
};

export type GetUserByApiCredentialsFilterInput = {
  apiCredentialsId: Scalars['ObjectId'];
  withBrokerInfo?: InputMaybe<Scalars['Boolean']>;
};

export type GuestUser = {
  __typename?: 'GuestUser';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fingerprintHash: Array<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type GuestUserPayload = {
  __typename?: 'GuestUserPayload';
  collection: Array<GuestUser>;
  totalCount: Scalars['Float'];
};

export type IdxActivity = {
  __typename?: 'IdxActivity';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  idxId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type IdxActivityCollection = {
  __typename?: 'IdxActivityCollection';
  date: Scalars['Date'];
  propertyClicks?: Maybe<Array<PropertyClick>>;
  totalClicks: Scalars['Float'];
};

export type IdxActivityPayload = {
  __typename?: 'IdxActivityPayload';
  collection: Array<IdxActivityCollection>;
};

export type IdxEmbeddedPortfolioFeedData = {
  __typename?: 'IdxEmbeddedPortfolioFeedData';
  idxFeed: IdxFeed;
  idxSettings: IdxSettings;
};

export type IdxEmbeddedPropertyFeedData = {
  __typename?: 'IdxEmbeddedPropertyFeedData';
  broker: Broker;
  idxFeed: IdxFeed;
  idxSettings: IdxSettings;
  property: Property;
  propertyAmenities: Array<Amenity>;
};

export type IdxEmbeddedSearchBarFeedData = {
  __typename?: 'IdxEmbeddedSearchBarFeedData';
  idxFeed: IdxFeed;
  idxSettings: IdxSettings;
};

export type IdxFeed = {
  __typename?: 'IdxFeed';
  _id: Scalars['String'];
  accountId: Scalars['ObjectId'];
  cities?: Maybe<Array<Place>>;
  counties?: Maybe<Array<Place>>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  marketAreaIds?: Maybe<Array<Scalars['ObjectId']>>;
  name: Scalars['String'];
  portfolioContent?: Maybe<Scalars['String']>;
  portfolioFolderId?: Maybe<Scalars['ObjectId']>;
  propertiesPerPage?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['ObjectId']>;
  searchBarContent?: Maybe<Scalars['String']>;
  showCustomPropertyDownloads?: Maybe<Scalars['Boolean']>;
  showPropertyDownloads?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum IdxFeedPortfolioContentEnum {
  LIST_IN_GRID = 'LIST_IN_GRID',
  LIST_IN_MAP = 'LIST_IN_MAP'
}

export enum IdxFeedSearchBarContentEnum {
  LIST_IN_GRID = 'LIST_IN_GRID',
  LIST_IN_MAP = 'LIST_IN_MAP',
  SEARCH_BAR_ONLY = 'SEARCH_BAR_ONLY'
}

export enum IdxFeedTypeEnum {
  MARKET_AREA = 'MARKET_AREA',
  PORTFOLIO = 'PORTFOLIO',
  SEARCH_BAR = 'SEARCH_BAR',
  SINGLE_PROPERTY = 'SINGLE_PROPERTY'
}

export type IdxPortfolioFeedPropertiesData = {
  __typename?: 'IdxPortfolioFeedPropertiesData';
  broker: Broker;
  portfolioFolder: Portfolio;
  portfolioItemCount: Scalars['Float'];
  portfolioItems: Array<Portfolio>;
};

export type IdxSearchFeedPropertiesData = {
  __typename?: 'IdxSearchFeedPropertiesData';
  properties: PropertiesPayload;
};

export type IdxSettings = {
  __typename?: 'IdxSettings';
  _id: Scalars['String'];
  accountId: Scalars['ObjectId'];
  branding: Branding;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isWixSite?: Maybe<Scalars['Boolean']>;
  showDashCredit?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  websiteDomain?: Maybe<Scalars['String']>;
};

export type InvoiceCoupon = {
  __typename?: 'InvoiceCoupon';
  amountOff?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  percentOff?: Maybe<Scalars['Float']>;
};

export type LocalTimeHours = {
  __typename?: 'LocalTimeHours';
  friday?: Maybe<LocalTimeRange>;
  monday?: Maybe<LocalTimeRange>;
  saturday?: Maybe<LocalTimeRange>;
  sunday?: Maybe<LocalTimeRange>;
  thursday?: Maybe<LocalTimeRange>;
  tuesday?: Maybe<LocalTimeRange>;
  wednesday?: Maybe<LocalTimeRange>;
};

export type LocalTimeHoursInput = {
  friday?: InputMaybe<LocalTimeRangeInput>;
  monday?: InputMaybe<LocalTimeRangeInput>;
  saturday?: InputMaybe<LocalTimeRangeInput>;
  sunday?: InputMaybe<LocalTimeRangeInput>;
  thursday?: InputMaybe<LocalTimeRangeInput>;
  tuesday?: InputMaybe<LocalTimeRangeInput>;
  wednesday?: InputMaybe<LocalTimeRangeInput>;
};

export type LocalTimeRange = {
  __typename?: 'LocalTimeRange';
  from: Scalars['String'];
  to: Scalars['String'];
};

export type LocalTimeRangeInput = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  _id: Scalars['String'];
  address?: Maybe<Address>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  geoLocation: GeoLocationJson;
  googlePlaceId: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type LocationSaveInput = {
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  googlePlaceId: Scalars['String'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  locationId?: InputMaybe<Scalars['ObjectId']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type MarketArea = {
  __typename?: 'MarketArea';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  state: State;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type MarketAreaCount = {
  __typename?: 'MarketAreaCount';
  count: Scalars['Float'];
  marketArea?: Maybe<MarketArea>;
};

export type MarketAreaPlaceOption = {
  __typename?: 'MarketAreaPlaceOption';
  cityKeys: Array<Scalars['String']>;
  count: Scalars['Int'];
  countyKeys: Array<Scalars['String']>;
  marketAreaId: Scalars['ObjectId'];
};

export type MarketAreasPayload = {
  __typename?: 'MarketAreasPayload';
  collection: Array<MarketArea>;
  totalCount: Scalars['Float'];
};

export type Media = {
  __typename?: 'Media';
  _id: Scalars['String'];
  brandingType?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  files: Array<File>;
  folderName?: Maybe<Scalars['String']>;
  foldersPathCollection?: Maybe<Array<FolderPathModel>>;
  mediaFolderId?: Maybe<Scalars['String']>;
  mediaItemsCount: Scalars['Float'];
  parentMediaFoldersIds?: Maybe<Array<Scalars['String']>>;
  propertyId: Scalars['String'];
  sizeInBytes: Scalars['Float'];
  systemFolderType?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum MediaFileTypesFilterEnum {
  DOCS = 'DOCS',
  IMAGES = 'IMAGES',
  VIDEOS = 'VIDEOS'
}

export type MediaFilesAndFoldersPayload = {
  __typename?: 'MediaFilesAndFoldersPayload';
  filesCollection?: Maybe<Array<Media>>;
  filesTotalCount: Scalars['Float'];
  foldersCollection: Array<Media>;
  foldersTotalCount: Scalars['Float'];
};

export type MediaFilesPayload = {
  __typename?: 'MediaFilesPayload';
  filesCollection?: Maybe<Array<Media>>;
  filesTotalCount: Scalars['Float'];
};

export type MediaFolderInput = {
  folderName: Scalars['String'];
};

export type MediaKitPayload = {
  __typename?: 'MediaKitPayload';
  collection: Array<PortfolioMediaKit>;
  totalCount: Scalars['Float'];
};

export type MediaObserveSubscriptionPayload = {
  __typename?: 'MediaObserveSubscriptionPayload';
  document: Media;
  trigger: Scalars['String'];
};

export type MetricDataPoint = {
  __typename?: 'MetricDataPoint';
  requestCount: Scalars['Float'];
  timestamp: Scalars['Date'];
};

export enum MfaMethodsEnum {
  APP = 'APP',
  EMAIL = 'EMAIL'
}

export type MfaTempTokenModel = {
  __typename?: 'MfaTempTokenModel';
  mfaEnabled: Scalars['Boolean'];
  mfaMethod?: Maybe<MfaMethodsEnum>;
  tempToken: Scalars['String'];
};

export type MinMax = {
  __typename?: 'MinMax';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type MinMaxRange = {
  __typename?: 'MinMaxRange';
  max?: Maybe<Scalars['Float']>;
  min: Scalars['Float'];
};

export type MinMaxRangeInput = {
  max?: InputMaybe<Scalars['Float']>;
  min: Scalars['Float'];
};

export type MinMaxRangePayload = {
  __typename?: 'MinMaxRangePayload';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  abortAllUploads: AbortUploadEvent;
  abortUpload: AbortUploadEvent;
  acceptApiInvitation: AuthResult;
  acceptApiInvitationForAccount: AuthResult;
  addAllMarketingFilesToPortfolio: Array<PortfolioMediaKit>;
  addFeaturedPortfolioToSaved: BrokerSavedFeaturedPortfolio;
  addFloorPlanToUnit: Unit;
  addNoteToProperty: PropertyNote;
  addPortfolioToComparison: Comparison;
  addPropertiesToPortfolio: Portfolio;
  addPropertyToPortfolio: Portfolio;
  addPropertyToTrack: BrokerTrackedProperty;
  addReactionByPortfolioAndProperty: PortfolioReaction;
  addSaleTeamUser: SaleTeamUser;
  addUserToAPI: ApiUser;
  addUserToCMS: User;
  approveProperty: Property;
  archiveBroker: Broker;
  archiveCMSUser: Scalars['Boolean'];
  archiveProperty: Property;
  attachDefaultStripePaymentMethod: Account;
  attachStripePaymentMethod: StripeAccount;
  auditProperty: Property;
  authorization: AuthResult;
  bulkUpdateMediaBrandingType: Array<Media>;
  cancelProductSubscription: ProductSubscription;
  cancelScheduledDowngrade: ProductSubscription;
  changeCurrentProductSubscription: ProductSubscriptionPayload;
  changePortfolioStatus: Portfolio;
  changeVerifiedStatusInProperty: Property;
  copyFeaturedPortfolioToBrokerPortfolio: CopyFeaturedPortfolioToBrokerPortfolioResult;
  createAlertConfig: BrokerAlertConfig;
  createAmenity: Amenity;
  createApiInvitation: ApiInvitationSafeDto;
  createApiPluginUser: ApiCredentialsUserResponse;
  createBroker: TokensModel;
  createBrokerSSO: TokensModel;
  createCheckoutSession: CreateCheckoutSessionPayload;
  createFeaturedPortfolio: FeaturedPortfolio;
  createFeaturedProperty: FeaturedProperty;
  createIdxFeed: IdxFeed;
  createIdxSettings: IdxSettings;
  createMarketArea: MarketArea;
  createMediaFile: Media;
  createMediaFolder: Media;
  createOrganization: Organization;
  createOrganizationUser: OrganizationUser;
  createPortfolioFolder: Portfolio;
  createProductSubscription: ProductSubscriptionPayload;
  createProperty: Property;
  createSaleTeam: SaleTeam;
  createSimpleBroker: Broker;
  createSinglePropertyPortfolio: Portfolio;
  createUnit: Unit;
  deleteAllBrokerActivities: Array<BrokerActivity>;
  deleteAmenity: Array<Amenity>;
  deleteBroker: Broker;
  deleteBrokerActivityById: BrokerActivity;
  deleteFeaturedPortfolio: FeaturedPortfolio;
  deleteFeaturedProperty: FeaturedProperty;
  deleteIdxFeed: Scalars['Boolean'];
  deleteMarketArea: MarketArea;
  deleteMediaFileById: Media;
  deleteMediaFiles: Array<Media>;
  deleteMediaFolderById: Media;
  deleteOrganization: Organization;
  deleteOrganizationUser: OrganizationUser;
  deletePortfolioById: Array<Portfolio>;
  deletePropertiesFromPortfolioByIds: Array<Portfolio>;
  deletePropertyFromPortfolioById: Portfolio;
  deleteSaleTeam: SaleTeam;
  deleteSaleTeamUser: SaleTeamUser;
  deleteUnit: Unit;
  deleteUserCMS: User;
  detachPaymentMethodFromCustomer: Account;
  duplicateAmenity: Property;
  duplicateUnit: Unit;
  editAmenity: Amenity;
  editInternalSaleTeamByOrganizationId: SaleTeam;
  editMarketArea: MarketArea;
  editMediaFile: File;
  editMediaFolder: Media;
  editOrganization: Organization;
  editOrganizationUser: OrganizationUser;
  editPortfolioFolderName: Portfolio;
  editPropertyNote: PropertyNote;
  editSaleTeam: SaleTeam;
  editSaleTeamUser: SaleTeamUser;
  editUnit: Unit;
  enableMfa: TokensModel;
  forgotPassword: Scalars['Boolean'];
  generateMagicLink: Scalars['Boolean'];
  generateNewApiToken: TokenResponse;
  getTokenWithMagicLink: AuthResult;
  logout: Scalars['Boolean'];
  makeFeaturedPropertyPublic: Scalars['String'];
  makePortfolioPublic: Scalars['String'];
  manuallyRegisterPortfolioView?: Maybe<ViewHistory>;
  mfaAuthentication: TokensModel;
  moveMediaInSortOrder: Media;
  moveMediaToFolder: Media;
  movePortfolios: Portfolio;
  orderFeaturedPortfolios: Array<FeaturedPortfolio>;
  orderFeaturedProperties: Array<FeaturedProperty>;
  orderPropertiesInPortfolio: FeaturedPortfolio;
  readPropertyNotes: PropertyNote;
  recordLastTouchAttribution: Scalars['Boolean'];
  refreshTokens: TokensModel;
  registerBroker: TokensModel;
  registerDeveloperUser: TokensModel;
  registerIdxActivity: IdxActivity;
  removeAlertConfig: BrokerAlertConfig;
  removeAllMarketingFilesFromPortfolio: Array<PortfolioMediaKit>;
  removeAmenitiesFromProperty: Property;
  removeFeaturedPortfolioFromSaved: BrokerSavedFeaturedPortfolio;
  removePropertyById: Scalars['Boolean'];
  removePropertyFromTracked: BrokerTrackedProperty;
  removePropertyNote: PropertyNote;
  renewProductSubscription: ProductSubscriptionPayload;
  resetCmsSettingsToDefaults: CmsSettings;
  resetPassword: Scalars['Boolean'];
  retryProductSubscriptionCharge: ProductSubscriptionPayload;
  revokeApiInvitation: ApiInvitationSafeDto;
  scheduleDowngrade: SubscriptionSchedule;
  sendEmailVerificationCode: Account;
  sendMessageToAgent: Scalars['Boolean'];
  sendMfaEmailCode: Scalars['Boolean'];
  sendRegistrationLinkToDeveloper: Scalars['Boolean'];
  sendVerificationCode: Account;
  setAdvancedPropertyDetails: Property;
  setAmenitiesToProperty: Property;
  setAmenityNameInProperty: Property;
  setApiCredentialAdminDisabled: ApiCredentialSafeDto;
  setApiCredentialMonthlyRequestLimit: ApiCredentialSafeDto;
  setBrokerShowAllBillingPlans: Broker;
  setGeneralPropertyDetails: Property;
  setGuestUserData: GuestUser;
  setHiddenStateToAlertItem: BrokerAlertItem;
  setMyPluginUserDisabled: ApiCredentialSafeDto;
  setOrganizationUserStatus: Scalars['Boolean'];
  setPortfolioMediaKitMedia: Scalars['Boolean'];
  setPropertyStatus: Property;
  setSaleTeamUserStatus: Scalars['Boolean'];
  switchAccountType: Account;
  temporaryAuthentication: TempAuthResult;
  toggleChangelogVisibility: PropertyChangelog;
  unarchiveBroker: Broker;
  updateAccountLanguage: Account;
  updateAlertConfig: BrokerAlertConfig;
  updateBrandedFilesReady: Property;
  updateBroker: Broker;
  updateBrokerLicenseStatus: Broker;
  updateCmsSettings: CmsSettings;
  updateCmsStatus: Property;
  updateCurrentBroker: Broker;
  updateCurrentUser: Profile;
  updateEmail: TokensModel;
  updateFeaturedPortfolio: FeaturedPortfolio;
  updateFeaturedProperty: FeaturedProperty;
  updateIdxFeed: IdxFeed;
  updateIdxSettings: IdxSettings;
  updateMediaBrandingType: Media;
  updatePassword: Scalars['Boolean'];
  updatePortfolioLocations: Portfolio;
  updatePortfolioPassword: Portfolio;
  updatePortfolioSettings: Portfolio;
  updateSSOId: Account;
  updateShowPopupOnPortfolio: Portfolio;
  updateUserAPI: ApiUser;
  updateUserCMS: User;
  uploadDraftFile: File;
  upsertComparison: Comparison;
  validateCoupon: ValidateCouponPayload;
  validatePhoneNumber: Account;
  verifyPhoneNumberAndUpdateAccount: Account;
};


export type MutationAbortUploadArgs = {
  progressTrackingId: Scalars['String'];
};


export type MutationAcceptApiInvitationArgs = {
  input: AcceptApiInvitationInput;
  token: Scalars['String'];
};


export type MutationAcceptApiInvitationForAccountArgs = {
  token: Scalars['String'];
};


export type MutationAddAllMarketingFilesToPortfolioArgs = {
  portfolioItemId: Scalars['String'];
};


export type MutationAddFeaturedPortfolioToSavedArgs = {
  portfolioId: Scalars['ObjectId'];
};


export type MutationAddFloorPlanToUnitArgs = {
  floorPlanFileId: Scalars['ObjectId'];
  unitId: Scalars['ObjectId'];
};


export type MutationAddNoteToPropertyArgs = {
  attachedFilesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  message: Scalars['String'];
  propertyId: Scalars['ObjectId'];
};


export type MutationAddPortfolioToComparisonArgs = {
  portfolioFolderId: Scalars['ObjectId'];
  portfolioItemId: Scalars['ObjectId'];
};


export type MutationAddPropertiesToPortfolioArgs = {
  portfolioFolderId: Scalars['ObjectId'];
  propertyIds: Array<Scalars['ObjectId']>;
};


export type MutationAddPropertyToPortfolioArgs = {
  portfolioFolderId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
  status?: InputMaybe<BrokerPortfolioStatusesEnum>;
};


export type MutationAddPropertyToTrackArgs = {
  propertyId: Scalars['ObjectId'];
};


export type MutationAddReactionByPortfolioAndPropertyArgs = {
  guestUserData?: InputMaybe<SetGuestUserDataArgs>;
  portfolioId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
  reaction: PortfolioReactionsEnum;
};


export type MutationAddSaleTeamUserArgs = {
  input: AddSaleTeamUserInput;
};


export type MutationAddUserToApiArgs = {
  accountInput: AccountInput;
  apiCredentialsInput?: InputMaybe<ApiCredentialsInput>;
  profileInput: ProfileInput;
};


export type MutationAddUserToCmsArgs = {
  accountInput: AccountInput;
  apiCredentialsInput?: InputMaybe<ApiCredentialsInput>;
  profileInput: ProfileInput;
};


export type MutationApprovePropertyArgs = {
  input: ApprovePropertyInput;
};


export type MutationArchiveBrokerArgs = {
  archivingReason: Scalars['String'];
  brokerId: Scalars['ObjectId'];
};


export type MutationArchiveCmsUserArgs = {
  archive?: Scalars['Boolean'];
  cmsUserAccountId: Scalars['ObjectId'];
};


export type MutationArchivePropertyArgs = {
  input: ArchivePropertyInput;
};


export type MutationAttachDefaultStripePaymentMethodArgs = {
  stripePaymentMethodId: Scalars['String'];
};


export type MutationAttachStripePaymentMethodArgs = {
  stripePaymentMethodId: Scalars['String'];
};


export type MutationAuditPropertyArgs = {
  input: AuditPropertyInput;
};


export type MutationAuthorizationArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationBulkUpdateMediaBrandingTypeArgs = {
  brandingType: BrandingTypeEnum;
  excludedIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  filter?: InputMaybe<GetMediaFoldersAndFilesFilterInput>;
  mediaFilesIds: Array<Scalars['ObjectId']>;
};


export type MutationCancelProductSubscriptionArgs = {
  input: CancelProductSubscriptionInput;
};


export type MutationChangeCurrentProductSubscriptionArgs = {
  input: UpdateProductSubscriptionInput;
};


export type MutationChangePortfolioStatusArgs = {
  isAddedMediaKit?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['ObjectId'];
  status: BrokerPortfolioStatusesEnum;
};


export type MutationChangeVerifiedStatusInPropertyArgs = {
  isMarkedAsVerified: Scalars['Boolean'];
  propertyId: Scalars['ObjectId'];
};


export type MutationCopyFeaturedPortfolioToBrokerPortfolioArgs = {
  args: CopyFeaturedPortfolioToBrokerPortfolioArgs;
};


export type MutationCreateAlertConfigArgs = {
  filter: CreateAlertConfigFilterInput;
  name: Scalars['String'];
};


export type MutationCreateAmenityArgs = {
  input: CreateAmenityInput;
};


export type MutationCreateApiInvitationArgs = {
  input: CreateApiInvitationInput;
};


export type MutationCreateApiPluginUserArgs = {
  referralCode: Scalars['String'];
};


export type MutationCreateBrokerArgs = {
  input: CreateBrokerInput;
};


export type MutationCreateBrokerSsoArgs = {
  input: CreateBrokerSsoInput;
};


export type MutationCreateCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


export type MutationCreateFeaturedPortfolioArgs = {
  input: CreateFeaturedPortfolioInput;
};


export type MutationCreateFeaturedPropertyArgs = {
  input: CreateFeaturedPropertyInput;
};


export type MutationCreateIdxFeedArgs = {
  input: CreateIdxFeedInput;
};


export type MutationCreateIdxSettingsArgs = {
  branding?: InputMaybe<BrandingInput>;
  isWixSite?: InputMaybe<Scalars['Boolean']>;
  showDashCredit: Scalars['Boolean'];
  websiteDomain: Scalars['String'];
};


export type MutationCreateMarketAreaArgs = {
  input: CreateMarketAreaInput;
};


export type MutationCreateMediaFileArgs = {
  input: CreateMediaFileInput;
};


export type MutationCreateMediaFolderArgs = {
  input: CreateMediaFolderInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationUserArgs = {
  input: CreateOrganizationUserInput;
};


export type MutationCreatePortfolioFolderArgs = {
  locations?: InputMaybe<PlaceTargetInput>;
  name: Scalars['String'];
};


export type MutationCreateProductSubscriptionArgs = {
  input: CreateProductSubscriptionInput;
};


export type MutationCreatePropertyArgs = {
  input: CreatePropertyInput;
};


export type MutationCreateSaleTeamArgs = {
  input: CreateSaleTeamInput;
};


export type MutationCreateSimpleBrokerArgs = {
  input: CreateSimpleBrokerInput;
};


export type MutationCreateSinglePropertyPortfolioArgs = {
  input: CreateSinglePropertyPortfolioInput;
};


export type MutationCreateUnitArgs = {
  input: CreateUnitInput;
};


export type MutationDeleteAllBrokerActivitiesArgs = {
  activityTypes: Array<BrokerActivitiesTypesEnum>;
};


export type MutationDeleteAmenityArgs = {
  amenityId: Scalars['ObjectId'];
};


export type MutationDeleteBrokerArgs = {
  brokerId: Scalars['ObjectId'];
};


export type MutationDeleteBrokerActivityByIdArgs = {
  activityId: Scalars['ObjectId'];
};


export type MutationDeleteFeaturedPortfolioArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type MutationDeleteFeaturedPropertyArgs = {
  featuredPropertyId: Scalars['String'];
};


export type MutationDeleteIdxFeedArgs = {
  idxFeedId: Scalars['ObjectId'];
};


export type MutationDeleteMarketAreaArgs = {
  marketAreaId: Scalars['ObjectId'];
};


export type MutationDeleteMediaFileByIdArgs = {
  mediaId: Scalars['ObjectId'];
  withContent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteMediaFilesArgs = {
  excludedIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  filter?: InputMaybe<GetMediaFoldersAndFilesFilterInput>;
  mediaFilesIds: Array<Scalars['ObjectId']>;
};


export type MutationDeleteMediaFolderByIdArgs = {
  mediaId: Scalars['ObjectId'];
  withContent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteOrganizationArgs = {
  organizationId: Scalars['ObjectId'];
};


export type MutationDeleteOrganizationUserArgs = {
  organizationUserId: Scalars['ObjectId'];
};


export type MutationDeletePortfolioByIdArgs = {
  portfolioId: Scalars['ObjectId'];
};


export type MutationDeletePropertiesFromPortfolioByIdsArgs = {
  portfolioFolderId: Scalars['ObjectId'];
  propertyIds: Array<Scalars['ObjectId']>;
};


export type MutationDeletePropertyFromPortfolioByIdArgs = {
  portfolioFolderId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
};


export type MutationDeleteSaleTeamArgs = {
  saleTeamId: Scalars['ObjectId'];
};


export type MutationDeleteSaleTeamUserArgs = {
  saleTeamId: Scalars['ObjectId'];
  saleTeamUserId: Scalars['ObjectId'];
};


export type MutationDeleteUnitArgs = {
  unitId: Scalars['ObjectId'];
};


export type MutationDeleteUserCmsArgs = {
  accountId: Scalars['ObjectId'];
  profileId: Scalars['ObjectId'];
};


export type MutationDetachPaymentMethodFromCustomerArgs = {
  stripePaymentMethodId: Scalars['String'];
};


export type MutationDuplicateAmenityArgs = {
  amenityId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
};


export type MutationDuplicateUnitArgs = {
  unitId: Scalars['ObjectId'];
};


export type MutationEditAmenityArgs = {
  input: EditAmenityInput;
};


export type MutationEditInternalSaleTeamByOrganizationIdArgs = {
  input: EditSaleTeamInput;
  organizationId: Scalars['ObjectId'];
};


export type MutationEditMarketAreaArgs = {
  input: EditMarketAreaInput;
};


export type MutationEditMediaFileArgs = {
  fileId: Scalars['ObjectId'];
  input: EditMediaFileInput;
};


export type MutationEditMediaFolderArgs = {
  input: EditMediaFolderInput;
};


export type MutationEditOrganizationArgs = {
  input: EditOrganizationInput;
  organizationId: Scalars['ObjectId'];
};


export type MutationEditOrganizationUserArgs = {
  input: EditOrganizationUserInput;
};


export type MutationEditPortfolioFolderNameArgs = {
  name: Scalars['String'];
  portfolioFolderId: Scalars['ObjectId'];
};


export type MutationEditPropertyNoteArgs = {
  attachedFilesIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  message: Scalars['String'];
  propertyNoteId: Scalars['ObjectId'];
};


export type MutationEditSaleTeamArgs = {
  input: EditSaleTeamInput;
  saleTeamId: Scalars['ObjectId'];
};


export type MutationEditSaleTeamUserArgs = {
  input: EditSaleTeamUserInput;
};


export type MutationEditUnitArgs = {
  input: EditUnitInput;
};


export type MutationEnableMfaArgs = {
  method?: InputMaybe<MfaMethodsEnum>;
  token: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationGenerateMagicLinkArgs = {
  email: Scalars['String'];
};


export type MutationMakeFeaturedPropertyPublicArgs = {
  featuredPropertyId: Scalars['String'];
  position: Scalars['String'];
};


export type MutationMakePortfolioPublicArgs = {
  featuredPortfolioId: Scalars['String'];
  position: Scalars['String'];
};


export type MutationManuallyRegisterPortfolioViewArgs = {
  viewedPortfolioId: Scalars['ObjectId'];
};


export type MutationMfaAuthenticationArgs = {
  token: Scalars['String'];
};


export type MutationMoveMediaInSortOrderArgs = {
  sortedMediaIds: Array<SortedMediaIdsInput>;
};


export type MutationMoveMediaToFolderArgs = {
  excludedIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  filter?: InputMaybe<GetMediaFoldersAndFilesFilterInput>;
  mediaFolderId: Scalars['ObjectId'];
  mediaIds: Array<Scalars['ObjectId']>;
};


export type MutationMovePortfoliosArgs = {
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  portfolioIds: Array<Scalars['ObjectId']>;
};


export type MutationOrderFeaturedPortfoliosArgs = {
  orders: Array<FeaturedPortfolioOrder>;
};


export type MutationOrderFeaturedPropertiesArgs = {
  orders: Array<FeaturedPropertyOrder>;
};


export type MutationOrderPropertiesInPortfolioArgs = {
  featuredPortfolioId: Scalars['String'];
  propertyIds: Array<Scalars['String']>;
};


export type MutationReadPropertyNotesArgs = {
  propertyNotesIds: Array<Scalars['ObjectId']>;
};


export type MutationRecordLastTouchAttributionArgs = {
  attribution: AttributionInput;
};


export type MutationRegisterBrokerArgs = {
  input: RegisterBrokerInput;
};


export type MutationRegisterDeveloperUserArgs = {
  input: AccountInput;
  signUpVerificationCode: Scalars['String'];
};


export type MutationRegisterIdxActivityArgs = {
  idxId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
};


export type MutationRemoveAlertConfigArgs = {
  alertConfigId: Scalars['ObjectId'];
};


export type MutationRemoveAllMarketingFilesFromPortfolioArgs = {
  portfolioItemId: Scalars['String'];
};


export type MutationRemoveAmenitiesFromPropertyArgs = {
  amenitiesIds: Array<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};


export type MutationRemoveFeaturedPortfolioFromSavedArgs = {
  brokerSavedFeaturedPortfolioId: Scalars['ObjectId'];
};


export type MutationRemovePropertyByIdArgs = {
  propertyId: Scalars['ObjectId'];
};


export type MutationRemovePropertyFromTrackedArgs = {
  brokerTrackedPropertyId: Scalars['ObjectId'];
};


export type MutationRemovePropertyNoteArgs = {
  propertyNoteId: Scalars['ObjectId'];
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String'];
};


export type MutationRevokeApiInvitationArgs = {
  invitationId: Scalars['String'];
};


export type MutationScheduleDowngradeArgs = {
  input: ScheduleDowngradeInput;
};


export type MutationSendMessageToAgentArgs = {
  input: SendMessageToAgentInput;
};


export type MutationSendRegistrationLinkToDeveloperArgs = {
  accountId: Scalars['ObjectId'];
};


export type MutationSendVerificationCodeArgs = {
  phone: PhoneInput;
};


export type MutationSetAdvancedPropertyDetailsArgs = {
  input: SetAdvancedPropertyDetailsInput;
};


export type MutationSetAmenitiesToPropertyArgs = {
  input: SetAmenitiesToPropertyInput;
};


export type MutationSetAmenityNameInPropertyArgs = {
  amenityId: Scalars['ObjectId'];
  isPrimary: Scalars['Boolean'];
  name: Scalars['String'];
  propertyId: Scalars['ObjectId'];
};


export type MutationSetApiCredentialAdminDisabledArgs = {
  adminDisabled: Scalars['Boolean'];
  apiCredentialsId: Scalars['String'];
};


export type MutationSetApiCredentialMonthlyRequestLimitArgs = {
  apiCredentialsId: Scalars['String'];
  monthlyRequestLimit?: InputMaybe<Scalars['Int']>;
};


export type MutationSetBrokerShowAllBillingPlansArgs = {
  brokerId: Scalars['ObjectId'];
  showAllBillingPlans: Scalars['Boolean'];
};


export type MutationSetGeneralPropertyDetailsArgs = {
  input: SetGeneralPropertyDetailsInput;
};


export type MutationSetGuestUserDataArgs = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  guestUserId?: InputMaybe<Scalars['ObjectId']>;
};


export type MutationSetHiddenStateToAlertItemArgs = {
  alertItemId: Scalars['ObjectId'];
  isHidden: Scalars['Boolean'];
};


export type MutationSetMyPluginUserDisabledArgs = {
  apiCredentialsId: Scalars['String'];
  disabled: Scalars['Boolean'];
};


export type MutationSetOrganizationUserStatusArgs = {
  organizationUserId: Scalars['ObjectId'];
  status: AccountActiveOrArchivedStatusesEnum;
};


export type MutationSetPortfolioMediaKitMediaArgs = {
  input: UpdateMediaKitInput;
};


export type MutationSetPropertyStatusArgs = {
  input: SetPropertyStatusInput;
};


export type MutationSetSaleTeamUserStatusArgs = {
  saleTeamUserId: Scalars['ObjectId'];
  status: AccountActiveOrArchivedStatusesEnum;
};


export type MutationSwitchAccountTypeArgs = {
  input: SwitchAccountInput;
};


export type MutationTemporaryAuthenticationArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationToggleChangelogVisibilityArgs = {
  input: ToggleChangelogVisibilityInput;
};


export type MutationUnarchiveBrokerArgs = {
  brokerId: Scalars['ObjectId'];
};


export type MutationUpdateAccountLanguageArgs = {
  language: Scalars['String'];
};


export type MutationUpdateAlertConfigArgs = {
  alertConfigId: Scalars['ObjectId'];
  filter: CreateAlertConfigFilterInput;
  name: Scalars['String'];
};


export type MutationUpdateBrandedFilesReadyArgs = {
  input: UpdateBrandedFilesReadyInput;
};


export type MutationUpdateBrokerArgs = {
  brokerId: Scalars['ObjectId'];
  input: UpdateBrokerInCmsInput;
};


export type MutationUpdateBrokerLicenseStatusArgs = {
  brokerId: Scalars['ObjectId'];
  input: UpdateBrokerLicenseStatusInput;
};


export type MutationUpdateCmsSettingsArgs = {
  input: UpdateCmsSettingsInput;
};


export type MutationUpdateCmsStatusArgs = {
  input: UpdateCmsStatusInput;
};


export type MutationUpdateCurrentBrokerArgs = {
  input: UpdateBrokerInput;
};


export type MutationUpdateCurrentUserArgs = {
  profileInput: ProfileInput;
};


export type MutationUpdateEmailArgs = {
  newEmail: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUpdateFeaturedPortfolioArgs = {
  featuredPortfolioId: Scalars['String'];
  input: UpdateFeaturedPortfolioInput;
};


export type MutationUpdateFeaturedPropertyArgs = {
  featuredPropertyId: Scalars['String'];
  input: UpdateFeaturedPropertyInput;
};


export type MutationUpdateIdxFeedArgs = {
  input: UpdateIdxFeedInput;
};


export type MutationUpdateIdxSettingsArgs = {
  input: UpdateIdxSettingsInput;
};


export type MutationUpdateMediaBrandingTypeArgs = {
  brandingType: BrandingTypeEnum;
  mediaId: Scalars['ObjectId'];
};


export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationUpdatePortfolioLocationsArgs = {
  locations: PlaceTargetInput;
  portfolioFolderId: Scalars['ObjectId'];
};


export type MutationUpdatePortfolioPasswordArgs = {
  password?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['ObjectId'];
};


export type MutationUpdatePortfolioSettingsArgs = {
  isAddedMediaKit?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['ObjectId'];
  showPopup?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<BrokerPortfolioStatusesEnum>;
};


export type MutationUpdateSsoIdArgs = {
  ssoId: Scalars['String'];
};


export type MutationUpdateShowPopupOnPortfolioArgs = {
  portfolioId: Scalars['ObjectId'];
  showPopup: Scalars['Boolean'];
};


export type MutationUpdateUserApiArgs = {
  accountUpdateInput: UpdateAccountInput;
  apiCredentialsInput?: InputMaybe<ApiCredentialsInput>;
  profileInput: ProfileInput;
};


export type MutationUpdateUserCmsArgs = {
  accountUpdateInput: UpdateAccountInput;
  apiCredentialsInput?: InputMaybe<ApiCredentialsInput>;
  profileInput: ProfileInput;
};


export type MutationUploadDraftFileArgs = {
  input: FileUploadInput;
};


export type MutationUpsertComparisonArgs = {
  fieldsToCompare: Array<BrokerPortfolioComparisonFields>;
  portfolioFolderId: Scalars['ObjectId'];
  portfolioIds: Array<Scalars['ObjectId']>;
};


export type MutationValidateCouponArgs = {
  args: ValidateCouponInput;
};


export type MutationValidatePhoneNumberArgs = {
  attribution?: InputMaybe<SignupAttributionInput>;
  code: Scalars['String'];
};


export type MutationVerifyPhoneNumberAndUpdateAccountArgs = {
  code: Scalars['String'];
  phone: PhoneInput;
};

export type NewPortfolioItemActivitiesPayload = {
  __typename?: 'NewPortfolioItemActivitiesPayload';
  collection: Array<NewPortfolioItemActivity>;
  totalCount: Scalars['Float'];
};

export type NewPortfolioItemActivity = {
  __typename?: 'NewPortfolioItemActivity';
  _id: Scalars['String'];
  activityDoc: NewPortfolioItemActivityDoc;
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  portfolioItem?: Maybe<Portfolio>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type NewPortfolioItemActivityDoc = {
  __typename?: 'NewPortfolioItemActivityDoc';
  portfolioItemId: Scalars['ObjectId'];
};

export type ObserveAccountPayload = {
  __typename?: 'ObserveAccountPayload';
  account: Account;
  trigger: Scalars['String'];
};

export type ObserveBrokerAlertItemsPayload = {
  __typename?: 'ObserveBrokerAlertItemsPayload';
  document: BrokerAlertItem;
  trigger: Scalars['String'];
};

export type ObserveBrokerPortfolioPayload = {
  __typename?: 'ObserveBrokerPortfolioPayload';
  document: Portfolio;
  trigger: Scalars['String'];
};

export type ObserveProgressTrackingPayload = {
  __typename?: 'ObserveProgressTrackingPayload';
  document: ProgressTrackingModel;
};

export type ObservePropertyNotesPayload = {
  __typename?: 'ObservePropertyNotesPayload';
  document: PropertyNote;
  trigger: Scalars['String'];
};

export type ObservePropertyPayload = {
  __typename?: 'ObservePropertyPayload';
  document: Property;
  trigger: Scalars['String'];
};

export type Organization = {
  __typename?: 'Organization';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  internalSaleTeam: SaleTeam;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  logoFile?: Maybe<File>;
  logoFileId?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  propertiesCount: Scalars['Float'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  _id: Scalars['String'];
  account: Account;
  accountId: Scalars['String'];
  assignedPropertiesIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  internalSaleTeamId?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  profile: Profile;
  profileId: Scalars['String'];
  saleTeamRole?: Maybe<Role>;
  saleTeamRoleId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type OrganizationUsersPayload = {
  __typename?: 'OrganizationUsersPayload';
  collection: Array<OrganizationUser>;
  totalCount: Scalars['Float'];
};

export type OrganizationsPayload = {
  __typename?: 'OrganizationsPayload';
  collection: Array<Organization>;
  totalCount: Scalars['Float'];
};

export type PaginationInput = {
  allowLimit?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type PartialDateRangeInput = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type PartialMinMaxRangeInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type Phone = {
  __typename?: 'Phone';
  dialCode?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type PhoneInput = {
  dialCode: Scalars['String'];
  number: Scalars['String'];
};

export type Place = {
  __typename?: 'Place';
  key: Scalars['String'];
  name: Scalars['String'];
  state: Scalars['String'];
};

export type PlaceInput = {
  name: Scalars['String'];
  state: Scalars['String'];
};

export type PlaceOption = {
  __typename?: 'PlaceOption';
  cityKeys: Array<Scalars['String']>;
  count: Scalars['Int'];
  countyKeys: Array<Scalars['String']>;
  key: Scalars['String'];
  name: Scalars['String'];
  state: Scalars['String'];
};

export type PlaceOptionsPayload = {
  __typename?: 'PlaceOptionsPayload';
  cities: Array<PlaceOption>;
  counties: Array<PlaceOption>;
  marketAreas: Array<MarketAreaPlaceOption>;
};

export type PlaceTargetInput = {
  cities?: InputMaybe<Array<PlaceInput>>;
  counties?: InputMaybe<Array<PlaceInput>>;
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type PluginUserOwnTotalApiUsageFilterInput = {
  range?: InputMaybe<DateRangeInput>;
};

export type Portfolio = {
  __typename?: 'Portfolio';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isAddedMediaKit?: Maybe<Scalars['Boolean']>;
  isParentRoot: Scalars['Boolean'];
  locations?: Maybe<PortfolioLocations>;
  name?: Maybe<Scalars['String']>;
  portfolioFolder?: Maybe<Portfolio>;
  portfolioFolderId?: Maybe<Scalars['String']>;
  portfolioPropertiesIds?: Maybe<Array<Scalars['ObjectId']>>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  reactions: BrokerReactionsStats;
  reactionsCount: Scalars['Float'];
  showPopup?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  viewsCount: Scalars['Float'];
  withPassword: Scalars['Boolean'];
};

export type PortfolioFolderItemsGroup = {
  __typename?: 'PortfolioFolderItemsGroup';
  collection: Array<Portfolio>;
  folderId: Scalars['String'];
  totalCount: Scalars['Float'];
};

export type PortfolioLocations = {
  __typename?: 'PortfolioLocations';
  cities: Array<Place>;
  counties: Array<Place>;
  marketAreaIds: Array<Scalars['ObjectId']>;
};

export type PortfolioMediaKit = {
  __typename?: 'PortfolioMediaKit';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isAddedToMediaKit?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Media>;
  mediaId: Scalars['ObjectId'];
  portfolioId: Scalars['ObjectId'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type PortfolioReaction = {
  __typename?: 'PortfolioReaction';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  guestUser: GuestUser;
  guestUserId: Scalars['String'];
  portfolioId: Scalars['String'];
  reaction: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum PortfolioReactionsEnum {
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE'
}

export type PortfolioTree = {
  __typename?: 'PortfolioTree';
  _id: Scalars['String'];
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isAddedMediaKit?: Maybe<Scalars['Boolean']>;
  isParentRoot: Scalars['Boolean'];
  items: Array<Portfolio>;
  name?: Maybe<Scalars['String']>;
  portfolioFolder?: Maybe<Portfolio>;
  portfolioFolderId?: Maybe<Scalars['String']>;
  portfolioPropertiesIds?: Maybe<Array<Scalars['ObjectId']>>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  reactions: BrokerReactionsStats;
  reactionsCount: Scalars['Float'];
  showPopup?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  viewsCount: Scalars['Float'];
  withPassword: Scalars['Boolean'];
};

export type PortfoliosPayload = {
  __typename?: 'PortfoliosPayload';
  collection: Array<Portfolio>;
  totalCount: Scalars['Float'];
};

export type PortfoliosTreePayload = {
  __typename?: 'PortfoliosTreePayload';
  collection: Array<PortfolioTree>;
  totalCount: Scalars['Float'];
};

export type PreferredPropertySettings = {
  __typename?: 'PreferredPropertySettings';
  buildingTypes?: Maybe<Array<BuildingTypesEnum>>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  priceRange?: Maybe<MinMax>;
  radiusInMiles?: Maybe<Scalars['Float']>;
};

export type PreferredPropertySettingsInput = {
  buildingTypes?: InputMaybe<Array<BuildingTypesEnum>>;
  locationInput?: InputMaybe<LocationSaveInput>;
  priceRange?: InputMaybe<PartialMinMaxRangeInput>;
  radiusInMiles?: InputMaybe<Scalars['Float']>;
};

export type PreviewInvoiceItem = {
  __typename?: 'PreviewInvoiceItem';
  amount: Scalars['Float'];
  description: Scalars['String'];
  id: Scalars['String'];
};

export type PreviewInvoicePayload = {
  __typename?: 'PreviewInvoicePayload';
  amountDue: Scalars['Float'];
  coupon?: Maybe<InvoiceCoupon>;
  dueDateMillis: Scalars['Float'];
  items: Array<PreviewInvoiceItem>;
};

export type ProductSubscription = {
  __typename?: 'ProductSubscription';
  _id: Scalars['String'];
  cancelationReason?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  currentPeriodEndAt: Scalars['Date'];
  currentPeriodStartAt: Scalars['Date'];
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  downgradeTo?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  otherReason?: Maybe<Scalars['String']>;
  schedule?: Maybe<SubscriptionSchedule>;
  status: Scalars['String'];
  stripeSubscriptionId: Scalars['String'];
  subscriptionInactiveAt?: Maybe<Scalars['Date']>;
  subscriptionProduct: SubscriptionProduct;
  subscriptionProductId: Scalars['String'];
  trialEndAt?: Maybe<Scalars['Date']>;
  trialStartAt?: Maybe<Scalars['Date']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type ProductSubscriptionPayload = {
  __typename?: 'ProductSubscriptionPayload';
  productSubscription: ProductSubscription;
  productSubscriptionPayment?: Maybe<ProductSubscriptionPayment>;
};

export type ProductSubscriptionPayment = {
  __typename?: 'ProductSubscriptionPayment';
  clientSecret?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
};

export type ProductSubscriptionsPayload = {
  __typename?: 'ProductSubscriptionsPayload';
  collection: Array<ProductSubscription>;
  totalCount: Scalars['Float'];
};

export type ProductsSubscriptionsObserveSubscriptionPayload = {
  __typename?: 'ProductsSubscriptionsObserveSubscriptionPayload';
  document: ProductSubscription;
  trigger: Scalars['String'];
};

export type Profile = {
  __typename?: 'Profile';
  _id: Scalars['String'];
  accountId: Scalars['String'];
  avatarFile?: Maybe<File>;
  avatarFileId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type ProfileInput = {
  _id?: InputMaybe<Scalars['String']>;
  avatarFileId?: InputMaybe<Scalars['ObjectId']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type ProgressTrackingModel = {
  __typename?: 'ProgressTrackingModel';
  expectedOperations?: Maybe<Array<Scalars['String']>>;
  operation?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['Float']>;
  progressTrackingId: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export enum ProjectStatusesEnum {
  COMING_SOON = 'COMING_SOON',
  COMPLETED = 'COMPLETED',
  LEAVING_SOON = 'LEAVING_SOON',
  NEW_CONSTRUCTION = 'NEW_CONSTRUCTION',
  NEW_LISTING = 'NEW_LISTING',
  PRE_CONSTRUCTION = 'PRE_CONSTRUCTION',
  PROPOSED = 'PROPOSED',
  SOLD_OUT = 'SOLD_OUT',
  UNDER_CONSTRUCTION = 'UNDER_CONSTRUCTION'
}

export type PropertiesPayload = {
  __typename?: 'PropertiesPayload';
  collection: Array<Property>;
  totalCount: Scalars['Float'];
};

export type Property = {
  __typename?: 'Property';
  _id: Scalars['String'];
  amenities: Array<Amenity>;
  amenityIds?: Maybe<Array<Scalars['String']>>;
  amenityNames?: Maybe<Array<AmenityName>>;
  availableUnitsNumber: Scalars['Float'];
  averageBathroomsNumber?: Maybe<MinMax>;
  averageBathroomsNumberValue?: Maybe<MinMaxRangePayload>;
  averageBedroomsNumber?: Maybe<MinMax>;
  averageBedroomsNumberValue?: Maybe<MinMaxRangePayload>;
  brandedFilesReady?: Maybe<Scalars['Boolean']>;
  buildingTypes: Array<BuildingTypesEnum>;
  cheapestUnit?: Maybe<Unit>;
  cmsStatus?: Maybe<Scalars['String']>;
  cmsStatusUpdatedAt?: Maybe<Scalars['Date']>;
  comingSoon?: Maybe<Scalars['Boolean']>;
  completionDate?: Maybe<Scalars['Date']>;
  constructionStartDate?: Maybe<Scalars['Date']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<ContactPhone>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  defaultInventoryDetails?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  firstPublicStatusDate?: Maybe<Scalars['Date']>;
  hasChangelog: Scalars['Boolean'];
  hasUnreadNotes: Scalars['Boolean'];
  interiorDesigner?: Maybe<Scalars['String']>;
  isMarkedAsVerified: Scalars['Boolean'];
  isRestricted: Scalars['Boolean'];
  landscapeArchitect?: Maybe<Scalars['String']>;
  lastChangelogType?: Maybe<PropertyChangelogTypesEnum>;
  lastUpdatedAtByChangelog?: Maybe<Scalars['Date']>;
  leadArchitect?: Maybe<Scalars['String']>;
  localArchitect?: Maybe<Scalars['String']>;
  location: Location;
  locationId: Scalars['ObjectId'];
  mainPropertyMediaFile?: Maybe<Media>;
  mainPropertyMediaId?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  marketArea?: Maybe<MarketArea>;
  name: Scalars['String'];
  numberOfTowers?: Maybe<Scalars['Float']>;
  numberOfUnits?: Maybe<Scalars['Float']>;
  organizationIds?: Maybe<Array<Scalars['String']>>;
  organizations?: Maybe<Array<Organization>>;
  overview?: Maybe<Scalars['String']>;
  priceRange?: Maybe<MinMax>;
  primaryOrganization?: Maybe<Organization>;
  primaryOrganizationId?: Maybe<Scalars['String']>;
  projectDetails?: Maybe<Scalars['String']>;
  projectStatus?: Maybe<Scalars['String']>;
  propertyTags?: Maybe<Array<PropertyTagsEnum>>;
  rootMediaFolderId: Scalars['String'];
  saleTeams?: Maybe<Array<PropertySaleTeam>>;
  salesGalleryAddress?: Maybe<Scalars['String']>;
  salesGalleryHours?: Maybe<LocalTimeHours>;
  salesGalleryStatus?: Maybe<SalesGalleryStatusesEnum>;
  slideshowMedia: Array<Media>;
  slideshowMediaFolderId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stories?: Maybe<Scalars['Float']>;
  taxInformation?: Maybe<Scalars['String']>;
  transactionType: PropertyTransactionTypesEnum;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  verifiedAt?: Maybe<Scalars['Date']>;
  virtualTourLinks?: Maybe<Array<VirtualTourLink>>;
  website?: Maybe<Scalars['String']>;
  workingHours?: Maybe<WorkingHours>;
  yearBuilt?: Maybe<Scalars['Float']>;
};

export type PropertyAboutChangelog = {
  __typename?: 'PropertyAboutChangelog';
  projectDetails?: Maybe<Scalars['String']>;
};

export type PropertyAdditionalInformationChangelog = {
  __typename?: 'PropertyAdditionalInformationChangelog';
  buildingTypes: Array<BuildingTypesEnum>;
  completionDate?: Maybe<Scalars['Date']>;
  constructionStartDate?: Maybe<Scalars['Date']>;
  numberOfTowers?: Maybe<Scalars['Float']>;
  numberOfUnits?: Maybe<Scalars['Float']>;
  projectStatus?: Maybe<Scalars['String']>;
  propertyTags?: Maybe<Array<PropertyTagsEnum>>;
  salesGalleryAddress?: Maybe<Scalars['String']>;
  salesGalleryHours?: Maybe<LocalTimeHours>;
  salesGalleryStatus?: Maybe<SalesGalleryStatusesEnum>;
  stories?: Maybe<Scalars['Float']>;
  transactionType?: Maybe<PropertyTransactionTypesEnum>;
  yearBuilt?: Maybe<Scalars['Float']>;
};

export type PropertyChangelog = {
  __typename?: 'PropertyChangelog';
  _id: Scalars['String'];
  afterUpdate: ChangelogDocument;
  beforeUpdate?: Maybe<ChangelogDocument>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  property: Property;
  propertyId: Scalars['ObjectId'];
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum PropertyChangelogTypesEnum {
  PROPERTY_ABOUT = 'PROPERTY_ABOUT',
  PROPERTY_ADDITIONAL_INFORMATION = 'PROPERTY_ADDITIONAL_INFORMATION',
  PROPERTY_DATA_REVIEWED = 'PROPERTY_DATA_REVIEWED',
  PROPERTY_DEVELOPER_ORGANIZATION = 'PROPERTY_DEVELOPER_ORGANIZATION',
  PROPERTY_FEATURES_AND_AMENITIES = 'PROPERTY_FEATURES_AND_AMENITIES',
  PROPERTY_HIGHLIGHTS = 'PROPERTY_HIGHLIGHTS',
  PROPERTY_INVENTORY_UNIT_ADDED = 'PROPERTY_INVENTORY_UNIT_ADDED',
  PROPERTY_INVENTORY_UNIT_REMOVED = 'PROPERTY_INVENTORY_UNIT_REMOVED',
  PROPERTY_INVENTORY_UNIT_UPDATED = 'PROPERTY_INVENTORY_UNIT_UPDATED',
  PROPERTY_LOCATION = 'PROPERTY_LOCATION',
  PROPERTY_MEDIA_FILES_MOVED = 'PROPERTY_MEDIA_FILES_MOVED',
  PROPERTY_MEDIA_REMOVED = 'PROPERTY_MEDIA_REMOVED',
  PROPERTY_MEDIA_RENAMED = 'PROPERTY_MEDIA_RENAMED',
  PROPERTY_MEDIA_UPLOADED = 'PROPERTY_MEDIA_UPLOADED',
  PROPERTY_NAME = 'PROPERTY_NAME',
  PROPERTY_PRICE = 'PROPERTY_PRICE',
  PROPERTY_SALES_TEAMS = 'PROPERTY_SALES_TEAMS',
  PROPERTY_VIRTUAL_TOURS = 'PROPERTY_VIRTUAL_TOURS',
  PROPERTY_WEBSITE = 'PROPERTY_WEBSITE'
}

export type PropertyChangelogsPayload = {
  __typename?: 'PropertyChangelogsPayload';
  collection: Array<PropertyChangelog>;
  totalCount: Scalars['Float'];
};

export type PropertyClick = {
  __typename?: 'PropertyClick';
  address?: Maybe<Scalars['String']>;
  clickCount: Scalars['Float'];
  name: Scalars['String'];
  propertyId: Scalars['ObjectId'];
};

export type PropertyDataReviewedChangelog = {
  __typename?: 'PropertyDataReviewedChangelog';
  reviewed: Scalars['Boolean'];
};

export type PropertyDetail = {
  __typename?: 'PropertyDetail';
  _id: Scalars['String'];
  averageBathroomsNumber?: Maybe<MinMax>;
  averageBedroomsNumber?: Maybe<MinMax>;
  completionDate?: Maybe<Scalars['Date']>;
  mainPropertyMediaFile?: Maybe<Media>;
  marketArea?: Maybe<MarketArea>;
  name: Scalars['String'];
  overview?: Maybe<Scalars['String']>;
  priceRange?: Maybe<MinMax>;
  projectStatus?: Maybe<Scalars['String']>;
  yearBuilt?: Maybe<Scalars['Float']>;
};

export type PropertyDeveloperOrganizationChangelog = {
  __typename?: 'PropertyDeveloperOrganizationChangelog';
  interiorDesigner?: Maybe<Scalars['String']>;
  landscapeArchitect?: Maybe<Scalars['String']>;
  leadArchitect?: Maybe<Scalars['String']>;
  localArchitect?: Maybe<Scalars['String']>;
  logoFileId?: Maybe<Scalars['ObjectId']>;
  name?: Maybe<Scalars['String']>;
  organizationIds: Array<Scalars['String']>;
};

export type PropertyFeaturesAndAmenitiesChangelog = {
  __typename?: 'PropertyFeaturesAndAmenitiesChangelog';
  amenityIds?: Maybe<Array<Scalars['String']>>;
  amenityNames?: Maybe<Array<AmenityName>>;
};

export type PropertyHighlightsChangelog = {
  __typename?: 'PropertyHighlightsChangelog';
  overview?: Maybe<Scalars['String']>;
};

export type PropertyInventoryUnitAddedChangelog = {
  __typename?: 'PropertyInventoryUnitAddedChangelog';
  newUnitId: Scalars['String'];
};

export type PropertyInventoryUnitRemovedChangelog = {
  __typename?: 'PropertyInventoryUnitRemovedChangelog';
  removedUnitId: Scalars['String'];
};

export type PropertyInventoryUnitUpdatedChangelog = {
  __typename?: 'PropertyInventoryUnitUpdatedChangelog';
  averageBathroomsNumber: MinMaxRange;
  averageBedroomsNumber: MinMaxRange;
  averageExteriorSqft: MinMaxRange;
  averageInteriorSqft: MinMaxRange;
  averageTotalSqft: MinMaxRange;
  floorPlanFileId?: Maybe<Scalars['String']>;
  highestPrice?: Maybe<Scalars['Float']>;
  inventoryType: Scalars['String'];
  name: Scalars['String'];
  startingPrice?: Maybe<Scalars['Float']>;
};

export type PropertyLocationChangelog = {
  __typename?: 'PropertyLocationChangelog';
  address: Address;
};

export type PropertyMediaFilesMovedChangelog = {
  __typename?: 'PropertyMediaFilesMovedChangelog';
  mediaFilesIds: Array<Scalars['ObjectId']>;
  mediaFolderId?: Maybe<Scalars['ObjectId']>;
};

export type PropertyMediaRemovedChangelog = {
  __typename?: 'PropertyMediaRemovedChangelog';
  removedMediaIds: Array<Scalars['ObjectId']>;
};

export type PropertyMediaRenamedChangelog = {
  __typename?: 'PropertyMediaRenamedChangelog';
  name: Scalars['String'];
};

export type PropertyMediaUploadedChangelog = {
  __typename?: 'PropertyMediaUploadedChangelog';
  folderName?: Maybe<Scalars['String']>;
  mediaFolderId: Scalars['String'];
  uploadedMediaId: Scalars['String'];
};

export type PropertyNameChangelog = {
  __typename?: 'PropertyNameChangelog';
  name: Scalars['String'];
};

export type PropertyNote = {
  __typename?: 'PropertyNote';
  _id: Scalars['String'];
  attachedFiles?: Maybe<Array<File>>;
  attachedFilesIds: Array<Scalars['String']>;
  authorAccount?: Maybe<Account>;
  authorProfile?: Maybe<Profile>;
  createdAt: Scalars['Date'];
  createdBy: Scalars['String'];
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  propertyId: Scalars['String'];
  readBy: Array<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type PropertyNotesPayload = {
  __typename?: 'PropertyNotesPayload';
  collection: Array<PropertyNote>;
  totalCount: Scalars['Float'];
};

export type PropertyOrganizationSalesTeamsChangelog = {
  __typename?: 'PropertyOrganizationSalesTeamsChangelog';
  saleTeams?: Maybe<Array<PropertySaleTeam>>;
};

export type PropertyPriceChangelog = {
  __typename?: 'PropertyPriceChangelog';
  priceRange?: Maybe<MinMax>;
};

export type PropertySaleTeam = {
  __typename?: 'PropertySaleTeam';
  commission?: Maybe<Scalars['Float']>;
  contactUrl?: Maybe<Scalars['String']>;
  saleAssociateIds?: Maybe<Array<Scalars['String']>>;
  saleAssociates?: Maybe<Array<DeveloperAsSaleUser>>;
  saleDirector?: Maybe<DeveloperAsSaleUser>;
  saleDirectorId?: Maybe<Scalars['String']>;
  saleTeam: SaleTeam;
  saleTeamId: Scalars['String'];
};

export type PropertySaleTeamInput = {
  commission?: InputMaybe<Scalars['Float']>;
  contactUrl?: InputMaybe<Scalars['String']>;
  saleAssociateIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  saleDirectorId?: InputMaybe<Scalars['ObjectId']>;
  saleTeamId: Scalars['ObjectId'];
};

export enum PropertyStatusesEnum {
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  SOLD_OUT = 'SOLD_OUT'
}

export type PropertySummary = {
  __typename?: 'PropertySummary';
  _id: Scalars['String'];
  name: Scalars['String'];
};

export enum PropertyTagsEnum {
  ACTIVE_ADULT = 'ACTIVE_ADULT',
  BOUTIQUE = 'BOUTIQUE',
  BRANDED_RESIDENCES = 'BRANDED_RESIDENCES',
  CONDO_CONVERSION = 'CONDO_CONVERSION',
  EB5_PROGRAM = 'EB5_PROGRAM',
  LIMITED_INVENTORY = 'LIMITED_INVENTORY',
  MASTER_PLANNED = 'MASTER_PLANNED',
  PENTHOUSE = 'PENTHOUSE',
  RESORT_STYLE = 'RESORT_STYLE',
  SHORT_TERM_RENTAL_FRIENDLY = 'SHORT_TERM_RENTAL_FRIENDLY',
  WATERFRONT = 'WATERFRONT',
  WORKFORCE_HOUSING = 'WORKFORCE_HOUSING'
}

export enum PropertyTransactionTypesEnum {
  FOR_RENT = 'FOR_RENT',
  FOR_SALE = 'FOR_SALE'
}

export type PropertyVirtualToursChangelog = {
  __typename?: 'PropertyVirtualToursChangelog';
  virtualTourLinks: Array<VirtualTourLink>;
};

export type PropertyVisitActivitiesPayload = {
  __typename?: 'PropertyVisitActivitiesPayload';
  collection: Array<PropertyVisitActivity>;
  totalCount: Scalars['Float'];
};

export type PropertyVisitActivity = {
  __typename?: 'PropertyVisitActivity';
  _id: Scalars['String'];
  activityDoc: PropertyVisitActivityDoc;
  brokerId: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  property: Property;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type PropertyVisitActivityDoc = {
  __typename?: 'PropertyVisitActivityDoc';
  propertyId: Scalars['ObjectId'];
};

export type PropertyWebsiteChangelog = {
  __typename?: 'PropertyWebsiteChangelog';
  website?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  apiInvitations: ApiInvitationsPayload;
  canUserTrialForProduct: Scalars['Boolean'];
  checkIfPortfolioHasMediaKit: Scalars['Boolean'];
  countPropertiesInPlaces: Scalars['Int'];
  currentBrokerHasAlertConfigs: Scalars['Boolean'];
  currentBrokerHasPortfolios: Scalars['Boolean'];
  downloadPropertiesXml: XmlDownloadResponse;
  generateMfaQrCode: GenerateQrCodeResult;
  getAccount: Account;
  getAccountBySignUpVerificationCode: Account;
  getAlertConfigById: BrokerAlertConfig;
  getAlertConfigs: BrokerAlertConfigPayload;
  getAlertItems: BrokerAlertItemPayload;
  getAllFilesInProperty: MediaFilesAndFoldersPayload;
  getAllFilesInPropertyPreview: MediaFilesAndFoldersPayload;
  getAllFoldersInProperty: Array<Media>;
  getAllPortfolioFolders: Array<Portfolio>;
  getAllPropertyChangelogs: PropertyChangelogsPayload;
  getAmenities: AmenitiesPayload;
  getAmenitiesForManage: AmenitiesPayload;
  getApiCredentialsBasicInfo?: Maybe<BasicInfoResponse>;
  getApiCredentialsById: ApiCredentialSafeDto;
  getApiPluginUsers: ApiPluginUsersPayload;
  getApiQuotaStatusByAppId: ApiQuotaStatusPayload;
  getApiUsers: ApiUsersPayload;
  getBrokerById: Broker;
  getBrokerForAccountManagement: Broker;
  getBrokerGuestUser: GuestUserPayload;
  getBrokerNewPortfolioItemActivities: NewPortfolioItemActivitiesPayload;
  getBrokerProperties: PropertiesPayload;
  getBrokerViewedPortfolios: ViewHistoryPayload;
  getBrokers: BrokersPayload;
  getCMSUsers: UsersPayload;
  getCheckoutSessionDetails: CheckoutSessionDetails;
  getCmsSettings: CmsSettings;
  getCompanyOwnApiQuotaStatus: ApiQuotaStatusPayload;
  getCompanyOwnMonthlyApiUsage: Scalars['Int'];
  getCompanyOwnTotalApiUsage: ApiMetricPayload;
  getComparison?: Maybe<Comparison>;
  getCurrentAccountProductSubscription?: Maybe<ProductSubscription>;
  getCurrentAccountTrialProductSubscriptions?: Maybe<ProductSubscriptionsPayload>;
  getCurrentBroker: Broker;
  getCurrentDeveloperProperties: PropertiesPayload;
  getCurrentDeveloperUser: Developer;
  getCurrentStripeAccount?: Maybe<StripeAccount>;
  getCurrentStripeAccountTransactions: StripeAccountTransactionsFlatPayload;
  getDevelopersAsSaleUsersBySaleTeamAndRole: Array<DeveloperAsSaleUser>;
  getExternalSaleTeamByIdForDeveloper: SaleTeam;
  getExternalSaleTeamsForDeveloper: SaleTeamsPayload;
  getFeaturedPortfolioById: FeaturedPortfolio;
  getFeaturedPortfolioByIdPublic: FeaturedPortfolio;
  getFeaturedPortfolioMarketAreas: Array<MarketAreaCount>;
  getFeaturedPortfolioMarketAreasPublic: Array<MarketAreaCount>;
  getFeaturedPortfolioProperties: FeaturedPortfolioPropertiesPayload;
  getFeaturedPortfolioPropertiesAdmin: Array<PropertySummary>;
  getFeaturedPortfolioPropertiesPublic: FeaturedPortfolioPropertiesPayload;
  getFeaturedPortfolioSummary?: Maybe<FeaturedPortfolioSummary>;
  getFeaturedPortfolioSummaryPublic?: Maybe<FeaturedPortfolioSummary>;
  getFeaturedPortfolios: FeaturedPortfoliosPayload;
  getFeaturedProperties: FeaturedPropertiesPayload;
  getFeaturedPropertyById: FeaturedProperty;
  getFileDownloadsStatistic: GetFileDownloadsStatisticPayload;
  getFoldersPathOfMedia?: Maybe<Scalars['String']>;
  getGuestUserReactionsCount: Scalars['Float'];
  getIdxActivity: IdxActivityPayload;
  getIdxEmbeddedPortfolioFeed: IdxEmbeddedPortfolioFeedData;
  getIdxEmbeddedPropertyFeed: IdxEmbeddedPropertyFeedData;
  getIdxEmbeddedSearchBarFeed: IdxEmbeddedSearchBarFeedData;
  getIdxFeedDetails: IdxFeed;
  getIdxFeedList: GetIdxFeedListPayload;
  getIdxPortfolioFeedProperties: IdxPortfolioFeedPropertiesData;
  getIdxPropertyFiles: MediaFilesPayload;
  getIdxSearchFeedProperties: IdxSearchFeedPropertiesData;
  getIdxSettings: IdxSettings;
  getInternalOrganizationSaleTeam: SaleTeam;
  getIsFeaturedPortfolioSaved?: Maybe<BrokerSavedFeaturedPortfolio>;
  getIsPropertyTracked?: Maybe<BrokerTrackedProperty>;
  getMarketAreas: MarketAreasPayload;
  getMarketAreasForFilter: Array<MarketArea>;
  getMediaFolderById: Media;
  getMediaFoldersAndFiles: MediaFilesAndFoldersPayload;
  getMonthlyApiUsageByAppId: Scalars['Int'];
  getMyApiPluginUsers: ApiPluginUsersPayload;
  getNumberOfNewAlertItems: Scalars['Float'];
  getNumberOfPortfolioPropertiesChangelogs: Scalars['Float'];
  getOrganizationById: Organization;
  getOrganizationRoles: RolesPayload;
  getOrganizationUsers: OrganizationUsersPayload;
  getOrganizationUsersByOrganizationRole: OrganizationUsersPayload;
  getOrganizations: OrganizationsPayload;
  getPlaceOptions: PlaceOptionsPayload;
  getPluginUserOwnApiQuotaStatus: ApiQuotaStatusPayload;
  getPluginUserOwnMonthlyApiUsage: Scalars['Int'];
  getPluginUserOwnTotalApiUsage: ApiMetricPayload;
  getPortfolioFirstPublicProperty?: Maybe<Portfolio>;
  getPortfolioFolderById: Portfolio;
  getPortfolioFolderItems: PortfoliosPayload;
  getPortfolioFolderItemsBulk: Array<PortfolioFolderItemsGroup>;
  getPortfolioFolderRoot: Portfolio;
  getPortfolioMediaKitItems: MediaKitPayload;
  getPortfolioPassword?: Maybe<Scalars['String']>;
  getPortfolioPropertiesChangelogs: PropertyChangelogsPayload;
  getPortfolioPropertiesToCompare: PropertiesPayload;
  getPortfolios: PortfoliosPayload;
  getPortfoliosByPublicFolder: PortfoliosPayload;
  getPortfoliosTree: PortfoliosTreePayload;
  getPortfoliosWithReactions: PortfoliosPayload;
  getPreviewInvoice: PreviewInvoicePayload;
  getProperties: PropertiesPayload;
  getPropertiesByOrganizationRole: PropertiesPayload;
  getPropertyAmenitiesInPublicBrokerPortfolio: AmenitiesPayload;
  getPropertyById: Property;
  getPropertyChangelogs: PropertyChangelogsPayload;
  getPropertyNotes: PropertyNotesPayload;
  getPropertySlideshowMediaInPublicBrokerPortfolio: Array<Media>;
  getPropertyUnitsInPublicBrokerPortfolio: UnitsPayload;
  getPropertyUnitsSqftRange?: Maybe<MinMaxRangePayload>;
  getPropertyViewsByBroker: ViewHistoryPayload;
  getPropertyVisitActivities: PropertyVisitActivitiesPayload;
  getPublicBrokerPortfolio: Portfolio;
  getReactionsStatsForBroker: BrokerReactionsStats;
  getSaleTeamById: SaleTeam;
  getSaleTeamUserNameByEmail?: Maybe<SaleTeamUserNamePayload>;
  getSaleTeamUsers: SaleTeamUsersPayload;
  getSaleTeams: SaleTeamsPayload;
  getSalesTeamRoles: RolesPayload;
  getSavedFeaturedPortfolios: BrokerSavedFeaturedPortfoliosPayload;
  getSavedFeaturedPortfoliosCount: Scalars['Float'];
  getSingleBrokerById: Broker;
  getSlideshowMediaByProperty: Array<Media>;
  getSubscriptionProducts: Array<SubscriptionProduct>;
  getSystemActionCount: Scalars['Float'];
  getTopLevelFoldersInProperty: Array<Media>;
  getTotalApiUsage: ApiMetricPayload;
  getTotalApiUsageByAppId: Scalars['Int'];
  getTrackedProperties: BrokerTrackedPropertiesPayload;
  getTrackedPropertiesByOrganizationCount: Scalars['Float'];
  getTrackedPropertyIds: Array<TrackedPropertyId>;
  getTrendingList?: Maybe<TrendingList>;
  getUSStateByName: State;
  getUSStates: Array<State>;
  getUniqPropertiesAmenities: Array<Scalars['String']>;
  getUniqPropertiesMarkets: Array<UnitPropertyMarket>;
  getUnits: UnitsPayload;
  getUnitsInPublicProperty: UnitsPayload;
  getUserByApiCredentialsId: ApiPluginUser;
  getUserPublicPortfolioFolders: Array<Portfolio>;
  globalSearch: SearchIndexPayload;
  myPendingApiAccess: Scalars['Boolean'];
  recommendedProperties: Array<Property>;
  similarProperties: Array<Property>;
  simulateError: Broker;
  validateApiInvitation: ApiInvitationValidation;
};


export type QueryApiInvitationsArgs = {
  searchText?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ApiInvitationStatusEnum>;
};


export type QueryCanUserTrialForProductArgs = {
  input: CanUserTrialForProductInput;
};


export type QueryCheckIfPortfolioHasMediaKitArgs = {
  portfolioId: Scalars['ObjectId'];
};


export type QueryCountPropertiesInPlacesArgs = {
  input: PlaceTargetInput;
};


export type QueryGetAccountBySignUpVerificationCodeArgs = {
  signUpVerificationCode: Scalars['String'];
};


export type QueryGetAlertConfigByIdArgs = {
  alertConfigId: Scalars['ObjectId'];
};


export type QueryGetAlertConfigsArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAlertItemsArgs = {
  filter?: InputMaybe<GetAlertItemsFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAllFilesInPropertyArgs = {
  filter: GetAllFilesInPropertyFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  isRestricted?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAllFilesInPropertyPreviewArgs = {
  filter: GetAllFilesInPropertyFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  isRestricted?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  previewAsSeeker?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAllFoldersInPropertyArgs = {
  excludeSlideshowFolder?: Scalars['Boolean'];
  includeRootFolder?: InputMaybe<Scalars['Boolean']>;
  mediaFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};


export type QueryGetAllPropertyChangelogsArgs = {
  filter: GetAllPropertyChangelogsFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAmenitiesArgs = {
  filter?: InputMaybe<GetAmenitiesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetAmenitiesForManageArgs = {
  filter: GetAmenitiesForManageFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetApiCredentialsByIdArgs = {
  apiCredentialsId: Scalars['String'];
};


export type QueryGetApiPluginUsersArgs = {
  filter?: InputMaybe<GetApiUsersFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetApiQuotaStatusByAppIdArgs = {
  appId: Scalars['String'];
};


export type QueryGetApiUsersArgs = {
  filter?: InputMaybe<GetApiUsersFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetBrokerByIdArgs = {
  brokerId: Scalars['ObjectId'];
};


export type QueryGetBrokerGuestUserArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetBrokerNewPortfolioItemActivitiesArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetBrokerPropertiesArgs = {
  filter?: InputMaybe<GetBrokerPropertiesFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetBrokerViewedPortfoliosArgs = {
  filter?: InputMaybe<BrokerViewedPortfoliosFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetBrokersArgs = {
  filter?: InputMaybe<GetBrokersFilter>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetCmsUsersArgs = {
  filter?: InputMaybe<GetCmsUsersFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetCheckoutSessionDetailsArgs = {
  sessionId: Scalars['String'];
};


export type QueryGetCompanyOwnMonthlyApiUsageArgs = {
  targetMonth: Scalars['Int'];
};


export type QueryGetCompanyOwnTotalApiUsageArgs = {
  filter?: InputMaybe<PluginUserOwnTotalApiUsageFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetComparisonArgs = {
  portfolioFolderId: Scalars['ObjectId'];
};


export type QueryGetCurrentDeveloperPropertiesArgs = {
  filter?: InputMaybe<GetPropertiesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetCurrentStripeAccountTransactionsArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetDevelopersAsSaleUsersBySaleTeamAndRoleArgs = {
  roleType?: InputMaybe<RoleTypesEnum>;
  saleTeamId: Scalars['ObjectId'];
};


export type QueryGetExternalSaleTeamByIdForDeveloperArgs = {
  saleTeamId: Scalars['ObjectId'];
};


export type QueryGetExternalSaleTeamsForDeveloperArgs = {
  filter?: InputMaybe<GetSaleTeamsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetFeaturedPortfolioByIdArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioByIdPublicArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioMarketAreasArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioMarketAreasPublicArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioPropertiesArgs = {
  featuredPortfolioId: Scalars['String'];
  pagination?: InputMaybe<FlatPaginationInput>;
};


export type QueryGetFeaturedPortfolioPropertiesAdminArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioPropertiesPublicArgs = {
  featuredPortfolioId: Scalars['String'];
  pagination?: InputMaybe<FlatPaginationInput>;
};


export type QueryGetFeaturedPortfolioSummaryArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfolioSummaryPublicArgs = {
  featuredPortfolioId: Scalars['String'];
};


export type QueryGetFeaturedPortfoliosArgs = {
  filter?: InputMaybe<GetFeaturedPortfoliosFilter>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetFeaturedPropertiesArgs = {
  filter?: InputMaybe<GetFeaturedPropertiesFilter>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetFeaturedPropertyByIdArgs = {
  featuredPropertyId: Scalars['String'];
};


export type QueryGetFileDownloadsStatisticArgs = {
  filter?: InputMaybe<GetFileDownloadStatisticsArgsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetFoldersPathOfMediaArgs = {
  mediaId: Scalars['ObjectId'];
};


export type QueryGetGuestUserReactionsCountArgs = {
  filter: GetPortfoliosWithReactionsFilter;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetIdxActivityArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  idxId: Scalars['ObjectId'];
};


export type QueryGetIdxEmbeddedPortfolioFeedArgs = {
  input: GetIdxEmbeddedPortfolioFeedInput;
};


export type QueryGetIdxEmbeddedPropertyFeedArgs = {
  input: GetIdxEmbeddedPropertyFeedInput;
};


export type QueryGetIdxEmbeddedSearchBarFeedArgs = {
  input: GetIdxEmbeddedSearchBarFeedInput;
};


export type QueryGetIdxFeedDetailsArgs = {
  idxFeedId?: InputMaybe<Scalars['ObjectId']>;
};


export type QueryGetIdxFeedListArgs = {
  input: GetIdxFeedListInput;
};


export type QueryGetIdxPortfolioFeedPropertiesArgs = {
  input: GetIdxPortfolioFeedPropertiesInput;
};


export type QueryGetIdxPropertyFilesArgs = {
  input: GetIdxPropertyFilesInput;
};


export type QueryGetIdxSearchFeedPropertiesArgs = {
  input: GetIdxSearchFeedPropertiesInput;
};


export type QueryGetInternalOrganizationSaleTeamArgs = {
  organizationId: Scalars['ObjectId'];
};


export type QueryGetIsFeaturedPortfolioSavedArgs = {
  portfolioId: Scalars['ObjectId'];
};


export type QueryGetIsPropertyTrackedArgs = {
  propertyId: Scalars['ObjectId'];
};


export type QueryGetMarketAreasArgs = {
  filter?: InputMaybe<GetMarketAreasFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetMarketAreasForFilterArgs = {
  input: GetMarketAreasForFilterInput;
};


export type QueryGetMediaFolderByIdArgs = {
  folderId: Scalars['ObjectId'];
};


export type QueryGetMediaFoldersAndFilesArgs = {
  filter: GetMediaFoldersAndFilesFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetMonthlyApiUsageByAppIdArgs = {
  appId: Scalars['String'];
  targetMonth: Scalars['Int'];
};


export type QueryGetMyApiPluginUsersArgs = {
  filter?: InputMaybe<GetApiUsersFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetNumberOfNewAlertItemsArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  range?: InputMaybe<DateRangeInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetNumberOfPortfolioPropertiesChangelogsArgs = {
  dateRange?: InputMaybe<PartialDateRangeInput>;
};


export type QueryGetOrganizationByIdArgs = {
  organizationId: Scalars['ObjectId'];
};


export type QueryGetOrganizationUsersArgs = {
  filter: GetOrganizationUsersFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetOrganizationUsersByOrganizationRoleArgs = {
  filter: GetOrganizationUsersFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetOrganizationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchByName?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPluginUserOwnMonthlyApiUsageArgs = {
  targetMonth: Scalars['Int'];
};


export type QueryGetPluginUserOwnTotalApiUsageArgs = {
  filter?: InputMaybe<PluginUserOwnTotalApiUsageFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPortfolioFirstPublicPropertyArgs = {
  brokerId: Scalars['String'];
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderName: Scalars['String'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfolioFolderByIdArgs = {
  portfolioFolderId: Scalars['ObjectId'];
};


export type QueryGetPortfolioFolderItemsArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  portfolioFolderId: Scalars['ObjectId'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfolioFolderItemsBulkArgs = {
  folderIds: Array<Scalars['ObjectId']>;
  limitPerFolder?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetPortfolioMediaKitItemsArgs = {
  filter: GetPortfolioMediaKitItemsInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfolioPasswordArgs = {
  portfolioId: Scalars['ObjectId'];
};


export type QueryGetPortfolioPropertiesChangelogsArgs = {
  filter?: InputMaybe<GetPortfolioPropertiesChangelogsFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfolioPropertiesToCompareArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  portfolioFolderId: Scalars['ObjectId'];
  portfolioIds: Array<Scalars['ObjectId']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfoliosArgs = {
  filter?: InputMaybe<GetPortfoliosFilter>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfoliosByPublicFolderArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfoliosTreeArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPortfoliosWithReactionsArgs = {
  filter?: InputMaybe<GetPortfoliosWithReactionsFilter>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPreviewInvoiceArgs = {
  input: GetPreviewInvoiceInput;
};


export type QueryGetPropertiesArgs = {
  filter?: InputMaybe<GetPropertiesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertiesByOrganizationRoleArgs = {
  filter?: InputMaybe<GetPropertiesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertyAmenitiesInPublicBrokerPortfolioArgs = {
  brokerId: Scalars['ObjectId'];
  filter?: InputMaybe<GetAmenitiesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertyByIdArgs = {
  propertyId: Scalars['ObjectId'];
};


export type QueryGetPropertyChangelogsArgs = {
  filter: GetPropertyChangelogsFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertyNotesArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  propertyId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertySlideshowMediaInPublicBrokerPortfolioArgs = {
  brokerId: Scalars['ObjectId'];
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};


export type QueryGetPropertyUnitsInPublicBrokerPortfolioArgs = {
  brokerId: Scalars['ObjectId'];
  filter?: InputMaybe<GetUnitsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPropertyUnitsSqftRangeArgs = {
  propertyId: Scalars['ObjectId'];
};


export type QueryGetPropertyViewsByBrokerArgs = {
  filter: GetPropertyViewsByBrokerAFilter;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPropertyVisitActivitiesArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetPublicBrokerPortfolioArgs = {
  brokerId: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderName?: InputMaybe<Scalars['String']>;
  portfolioName: Scalars['String'];
};


export type QueryGetReactionsStatsForBrokerArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type QueryGetSaleTeamByIdArgs = {
  saleTeamId: Scalars['ObjectId'];
};


export type QueryGetSaleTeamUserNameByEmailArgs = {
  email: Scalars['String'];
};


export type QueryGetSaleTeamUsersArgs = {
  filter: GetSaleTeamUsersFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetSaleTeamsArgs = {
  filter?: InputMaybe<GetSaleTeamsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetSavedFeaturedPortfoliosArgs = {
  filter?: InputMaybe<GetSavedFeaturedPortfoliosFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetSavedFeaturedPortfoliosCountArgs = {
  filter?: InputMaybe<GetSavedFeaturedPortfoliosFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetSingleBrokerByIdArgs = {
  brokerId: Scalars['ObjectId'];
};


export type QueryGetSlideshowMediaByPropertyArgs = {
  propertyId: Scalars['ObjectId'];
};


export type QueryGetSubscriptionProductsArgs = {
  filter?: InputMaybe<GetSubscriptionProductsFilterInput>;
};


export type QueryGetSystemActionCountArgs = {
  filter: GetSystemActionLogsFilterInput;
};


export type QueryGetTopLevelFoldersInPropertyArgs = {
  propertyId: Scalars['ObjectId'];
};


export type QueryGetTotalApiUsageArgs = {
  filter?: InputMaybe<TotalApiUsageFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetTotalApiUsageByAppIdArgs = {
  appId: Scalars['String'];
};


export type QueryGetTrackedPropertiesArgs = {
  filter?: InputMaybe<GetTrackedPropertiesFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetTrackedPropertiesByOrganizationCountArgs = {
  filter?: InputMaybe<GetTrackedPropertiesFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetTrendingListArgs = {
  type: Scalars['String'];
};


export type QueryGetUsStateByNameArgs = {
  stateName: Scalars['String'];
};


export type QueryGetUsStatesArgs = {
  filter?: InputMaybe<GetStatesFilterInput>;
};


export type QueryGetUniqPropertiesAmenitiesArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetUnitsArgs = {
  filter?: InputMaybe<GetUnitsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetUnitsInPublicPropertyArgs = {
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  propertyId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput>>;
};


export type QueryGetUserByApiCredentialsIdArgs = {
  filter?: InputMaybe<GetUserByApiCredentialsFilterInput>;
};


export type QueryGlobalSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryRecommendedPropertiesArgs = {
  excludePropertyIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerySimilarPropertiesArgs = {
  propertyId: Scalars['ID'];
};


export type QueryValidateApiInvitationArgs = {
  token: Scalars['String'];
};

export enum RecurringTypesEnum {
  DAY = 'DAY',
  FREE = 'FREE',
  MONTH = 'MONTH',
  SIXMONTH = 'SIXMONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type RegisterBrokerInput = {
  accountInput: AccountInput;
  profileInput: ProfileInput;
};

export type RemoveMediaKitItems = {
  mediaIdsToRemove: Array<Scalars['ObjectId']>;
  portfolioId: Scalars['ObjectId'];
};

export type Role = {
  __typename?: 'Role';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export enum RoleTypesEnum {
  API_USER = 'API_USER',
  BROKER = 'BROKER',
  ORG_DEVELOPER = 'ORG_DEVELOPER',
  ORG_OWNER = 'ORG_OWNER',
  ORG_SALES_ASSOCIATE = 'ORG_SALES_ASSOCIATE',
  ORG_SALES_DIRECTOR = 'ORG_SALES_DIRECTOR',
  ORG_SALES_STUFF = 'ORG_SALES_STUFF',
  SUPER_ADMIN = 'SUPER_ADMIN'
}

export type RolesPayload = {
  __typename?: 'RolesPayload';
  collection: Array<Role>;
  totalCount: Scalars['Float'];
};

export type SaleTeam = {
  __typename?: 'SaleTeam';
  _id: Scalars['String'];
  countOfUsers?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  logoFile?: Maybe<File>;
  logoFileId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  phone?: Maybe<SalesTeamPhone>;
  relatedToSaleTeamOrganizationsNames?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  workingHours?: Maybe<WorkingHours>;
};

export type SaleTeamUser = {
  __typename?: 'SaleTeamUser';
  _id: Scalars['String'];
  account: Account;
  accountId: Scalars['String'];
  assignedPropertiesIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  profile: Profile;
  profileId: Scalars['String'];
  role: Role;
  saleTeamId: Scalars['String'];
  saleTeamRoleId: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type SaleTeamUserNamePayload = {
  __typename?: 'SaleTeamUserNamePayload';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type SaleTeamUsersPayload = {
  __typename?: 'SaleTeamUsersPayload';
  collection: Array<SaleTeamUser>;
  totalCount: Scalars['Float'];
};

export type SaleTeamsPayload = {
  __typename?: 'SaleTeamsPayload';
  collection: Array<SaleTeam>;
  totalCount: Scalars['Float'];
};

export enum SalesGalleryStatusesEnum {
  APPOINTMENT_ONLY = 'APPOINTMENT_ONLY',
  COMING_SOON = 'COMING_SOON',
  HOURS_AVAILABLE = 'HOURS_AVAILABLE',
  NO_INFORMATION = 'NO_INFORMATION'
}

export type SalesTeamPhone = {
  __typename?: 'SalesTeamPhone';
  dialCode: Scalars['String'];
  number: Scalars['String'];
};

export type ScheduleDowngradeInput = {
  newStripePriceId: Scalars['String'];
};

export type SearchIndex = {
  __typename?: 'SearchIndex';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  display: SearchIndexDisplay;
  meta: SearchIndexMeta;
  refId: Scalars['String'];
  refs?: Maybe<SearchIndexRefs>;
  search: SearchIndexSearch;
  subtype: SearchIndexSubtypeEnum;
  type: SearchIndexTypeEnum;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type SearchIndexDisplay = {
  __typename?: 'SearchIndexDisplay';
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SearchIndexMeta = {
  __typename?: 'SearchIndexMeta';
  isActive: Scalars['Boolean'];
  popularityScore?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SearchIndexPayload = {
  __typename?: 'SearchIndexPayload';
  collection: Array<SearchIndex>;
  totalCount: Scalars['Float'];
};

export type SearchIndexRefs = {
  __typename?: 'SearchIndexRefs';
  locationId?: Maybe<Scalars['ObjectId']>;
  marketAreaId?: Maybe<Scalars['ObjectId']>;
  organizationId?: Maybe<Scalars['ObjectId']>;
  propertyId?: Maybe<Scalars['ObjectId']>;
  stateId?: Maybe<Scalars['ObjectId']>;
};

export type SearchIndexSearch = {
  __typename?: 'SearchIndexSearch';
  primaryTokens: Array<Scalars['String']>;
  secondaryTokens: Array<Scalars['String']>;
};

export enum SearchIndexSubtypeEnum {
  CITY = 'CITY',
  COUNTY = 'COUNTY',
  DEVELOPER = 'DEVELOPER',
  MARKET_AREA = 'MARKET_AREA',
  PROPERTY = 'PROPERTY',
  STATE = 'STATE'
}

export enum SearchIndexTypeEnum {
  LOCATION = 'LOCATION',
  ORGANIZATION = 'ORGANIZATION',
  PROPERTY = 'PROPERTY'
}

export type SendMessageToAgentInput = {
  broker_email: Scalars['String'];
  broker_name: Scalars['String'];
  customer_email: Scalars['String'];
  customer_message: Scalars['String'];
  customer_name: Scalars['String'];
  customer_phone: Scalars['String'];
  portfolio_folder_name: Scalars['String'];
  property_name: Scalars['String'];
};

export type SetAdvancedPropertyDetailsInput = {
  noChangelog?: InputMaybe<Scalars['Boolean']>;
  propertyDetails: AdvancedPropertyDetailsInput;
};

export type SetAmenitiesToPropertyInput = {
  amenityIds: Array<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
};

export type SetGeneralPropertyDetailsInput = {
  noChangelog?: InputMaybe<Scalars['Boolean']>;
  propertyDetails: GeneralPropertyDetailsInput;
};

export type SetGuestUserDataArgs = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  guestUserId?: InputMaybe<Scalars['ObjectId']>;
};

export type SetPropertyStatusInput = {
  propertyId: Scalars['ObjectId'];
  status?: InputMaybe<PropertyStatusesEnum>;
};

export type SignupAttributionInput = {
  first?: InputMaybe<AttributionInput>;
  signup?: InputMaybe<AttributionInput>;
};

export type SimilarityBreakdown = {
  __typename?: 'SimilarityBreakdown';
  amenities?: Maybe<Scalars['Float']>;
  bedrooms?: Maybe<Scalars['Float']>;
  buildingTypes?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['Float']>;
  marketArea?: Maybe<Scalars['Float']>;
  priceRange?: Maybe<Scalars['Float']>;
  projectStatus?: Maybe<Scalars['Float']>;
};

export type SimilarityEntry = {
  __typename?: 'SimilarityEntry';
  breakdown?: Maybe<SimilarityBreakdown>;
  propertyId: Scalars['String'];
  score: Scalars['Float'];
};

export type SortInput = {
  fieldName: Scalars['String'];
  sortOrder: Scalars['Float'];
};

export type SortedMediaIdsInput = {
  mediaIdToMove: Scalars['ObjectId'];
  mediaIdToReplace: Scalars['ObjectId'];
};

export type State = {
  __typename?: 'State';
  _id: Scalars['String'];
  code: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  withMarketArea: Scalars['Boolean'];
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  paymentMethods?: Maybe<Array<StripeAccountPaymentMethod>>;
};

export type StripeAccountPaymentMethod = {
  __typename?: 'StripeAccountPaymentMethod';
  cardBrand: Scalars['String'];
  cardNumber: Scalars['String'];
  expiredMonth: Scalars['Float'];
  expiredYear: Scalars['Float'];
  paymentMethodId: Scalars['String'];
};

export type StripeAccountTransaction = {
  __typename?: 'StripeAccountTransaction';
  amount: Scalars['Float'];
  dateOfCharge: Scalars['Date'];
  invoiceId: Scalars['String'];
  invoiceName: Scalars['String'];
  invoicePdfUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type StripeAccountTransactionsFlatPayload = {
  __typename?: 'StripeAccountTransactionsFlatPayload';
  collection: Array<StripeAccountTransaction>;
  hasMore: Scalars['Boolean'];
};

export type Subscription = {
  __typename?: 'Subscription';
  observeBrokerAlertItemChanges: ObserveBrokerAlertItemsPayload;
  observeCurrentAccountChanges: ObserveAccountPayload;
  observeCurrentAccountProductSubscription: ProductsSubscriptionsObserveSubscriptionPayload;
  observeMediaChanges: MediaObserveSubscriptionPayload;
  observePortfoliosChanges: ObserveBrokerPortfolioPayload;
  observeProgressTrackingByType: ObserveProgressTrackingPayload;
  observePropertiesChanges: ObservePropertyPayload;
  observePropertyNotesChanges: ObservePropertyNotesPayload;
  observeSubscriptionProductsChanges: SubscriptionProductsObserveSubscriptionPayload;
};


export type SubscriptionObserveMediaChangesArgs = {
  filter: GetMediaFoldersAndFilesFilterInput;
  flatPagination?: InputMaybe<FlatPaginationInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput>>;
};


export type SubscriptionObserveProgressTrackingByTypeArgs = {
  type: Scalars['String'];
};


export type SubscriptionObservePropertyNotesChangesArgs = {
  propertyId: Scalars['ObjectId'];
};

export type SubscriptionProduct = {
  __typename?: 'SubscriptionProduct';
  _id: Scalars['String'];
  coupons?: Maybe<Array<SubscriptionProductCoupon>>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  features: Array<SubscriptionProductFeature>;
  legacy?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  price: Scalars['Float'];
  recurringType: Scalars['String'];
  stripePriceId: Scalars['String'];
  stripeProductId: Scalars['String'];
  trial?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type SubscriptionProductCoupon = {
  __typename?: 'SubscriptionProductCoupon';
  active?: Maybe<Scalars['Boolean']>;
  amountOff?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['String'];
  duration_in_months?: Maybe<Scalars['Float']>;
  limitation?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['Float']>;
  stripeCouponId: Scalars['String'];
};

export type SubscriptionProductFeature = {
  __typename?: 'SubscriptionProductFeature';
  active: Scalars['Boolean'];
  feature: Scalars['String'];
};

export type SubscriptionProductsObserveSubscriptionPayload = {
  __typename?: 'SubscriptionProductsObserveSubscriptionPayload';
  document: SubscriptionProduct;
  trigger: Scalars['String'];
};

export type SubscriptionSchedule = {
  __typename?: 'SubscriptionSchedule';
  metadata?: Maybe<Scalars['JSON']>;
  nextPhasePriceId?: Maybe<Scalars['String']>;
  nextPhaseStart?: Maybe<Scalars['Date']>;
  scheduleId: Scalars['String'];
};

export type SwitchAccountInput = {
  licenseNumber?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  toSeeker?: InputMaybe<Scalars['Boolean']>;
};

export type SystemActionLogsMetadata = {
  __typename?: 'SystemActionLogsMetadata';
  mediaId?: Maybe<Scalars['ObjectId']>;
  portfolioId?: Maybe<Scalars['ObjectId']>;
  propertyId?: Maybe<Scalars['ObjectId']>;
};

export enum SystemActionLogsTypeEnum {
  MEDIA_ADDED_TO_MEDIA_KIT = 'MEDIA_ADDED_TO_MEDIA_KIT',
  MEDIA_DOWNLOADED = 'MEDIA_DOWNLOADED',
  PROPERTY_ADDED_TO_PORTFOLIO = 'PROPERTY_ADDED_TO_PORTFOLIO',
  PROPERTY_ADDED_TO_TRACK_FOLDER = 'PROPERTY_ADDED_TO_TRACK_FOLDER',
  PROPERTY_SHARED = 'PROPERTY_SHARED'
}

export type TempAuthResult = {
  __typename?: 'TempAuthResult';
  account: Account;
  tempToken: Scalars['String'];
};

export type ToggleChangelogVisibilityInput = {
  changelogId: Scalars['ObjectId'];
};

export type TokenResponse = {
  __typename?: 'TokenResponse';
  token: Scalars['String'];
};

export type TokensModel = {
  __typename?: 'TokensModel';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  refreshTokenExpiry?: Maybe<Scalars['String']>;
};

export type TotalApiUsageFilterInput = {
  appId?: InputMaybe<Scalars['String']>;
  getCompanyClients?: InputMaybe<Scalars['Boolean']>;
  getCompanyTotal?: InputMaybe<Scalars['Boolean']>;
  range?: InputMaybe<DateRangeInput>;
  type?: InputMaybe<Scalars['String']>;
};

export type TrackedPropertyId = {
  __typename?: 'TrackedPropertyId';
  _id: Scalars['String'];
  propertyId: Scalars['String'];
};

export type TrendingList = {
  __typename?: 'TrendingList';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  items: Array<TrendingListItem>;
  periodEnd: Scalars['Date'];
  periodStart: Scalars['Date'];
  type: Scalars['String'];
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type TrendingListItem = {
  __typename?: 'TrendingListItem';
  portfolio?: Maybe<Portfolio>;
  portfolioId?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
};

export type Unit = {
  __typename?: 'Unit';
  _id: Scalars['String'];
  averageBathroomsNumber: MinMaxRange;
  averageBedroomsNumber: MinMaxRange;
  averageExteriorSqft: MinMaxRange;
  averageInteriorSqft: MinMaxRange;
  averageTotalSqft: MinMaxRange;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  customRooms?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  floorPlanFile?: Maybe<File>;
  floorPlanFileId?: Maybe<Scalars['String']>;
  highestPrice?: Maybe<Scalars['Float']>;
  inventoryType: Scalars['String'];
  name: Scalars['String'];
  propertyId: Scalars['String'];
  startingPrice?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type UnitInput = {
  averageBathroomsNumber: MinMaxRangeInput;
  averageBedroomsNumber: MinMaxRangeInput;
  averageExteriorSqft: MinMaxRangeInput;
  averageInteriorSqft: MinMaxRangeInput;
  averageTotalSqft: MinMaxRangeInput;
  customRooms?: InputMaybe<Scalars['String']>;
  floorPlanFileId?: InputMaybe<Scalars['ObjectId']>;
  highestPrice?: InputMaybe<Scalars['Float']>;
  inventoryType: Scalars['String'];
  name: Scalars['String'];
  startingPrice?: InputMaybe<Scalars['Float']>;
};

export type UnitPropertyMarket = {
  __typename?: 'UnitPropertyMarket';
  _id: Scalars['String'];
  name: Scalars['String'];
};

export type UnitsPayload = {
  __typename?: 'UnitsPayload';
  collection: Array<Unit>;
  totalCount: Scalars['Float'];
};

export type UpdateAccountInput = {
  _id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UpdateBrandedFilesReadyInput = {
  brandedFilesReady: Scalars['Boolean'];
  propertyId: Scalars['ObjectId'];
};

export type UpdateBrokerAccountInput = {
  phone?: InputMaybe<PhoneInput>;
};

export type UpdateBrokerInCmsInput = {
  accountInput?: InputMaybe<UpdateBrokerAccountInput>;
  agencyName?: InputMaybe<Scalars['String']>;
  agencyWebsite?: InputMaybe<Scalars['String']>;
  demoExpirationDate?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
  isRealUser?: InputMaybe<Scalars['Boolean']>;
  license?: InputMaybe<UpdateBrokerLicenseInput>;
  preferredPropertySettingsInput?: InputMaybe<PreferredPropertySettingsInput>;
  profileInput?: InputMaybe<UpdateBrokerProfileInput>;
  subscriptionType: BrokerSubscriptionTypesEnum;
  workingHours?: InputMaybe<WorkingHoursInput>;
};

export type UpdateBrokerInput = {
  accountInput?: InputMaybe<UpdateBrokerAccountInput>;
  agencyName?: InputMaybe<Scalars['String']>;
  agencyWebsite?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  excludeFromReports?: InputMaybe<Scalars['Boolean']>;
  isRealUser?: InputMaybe<Scalars['Boolean']>;
  license?: InputMaybe<UpdateBrokerLicenseInput>;
  preferredPropertySettingsInput?: InputMaybe<PreferredPropertySettingsInput>;
  profileInput?: InputMaybe<UpdateBrokerProfileInput>;
  workingHours?: InputMaybe<WorkingHoursInput>;
};

export type UpdateBrokerLicenseInput = {
  licenseJurisdictionCode?: InputMaybe<Scalars['String']>;
  licenseNumber: Scalars['String'];
};

export type UpdateBrokerLicenseStatusInput = {
  notify: Scalars['Boolean'];
  reason: Scalars['String'];
  status: BrokerLicenseStatusesEnum;
};

export type UpdateBrokerProfileInput = {
  avatarFileId?: InputMaybe<Scalars['ObjectId']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateCmsSettingsInput = {
  activeToAwaitingAuditDays?: InputMaybe<Scalars['Float']>;
  automatedTransitionsEnabled?: InputMaybe<Scalars['Boolean']>;
  newListingToActiveDays?: InputMaybe<Scalars['Float']>;
  recentlyUpdatedToActiveDays?: InputMaybe<Scalars['Float']>;
};

export type UpdateCmsStatusInput = {
  propertyId: Scalars['ObjectId'];
  status: CmsStatusEnum;
};

export type UpdateFeaturedPortfolioInput = {
  cardDescription?: InputMaybe<Scalars['String']>;
  coverImageFileId?: InputMaybe<Scalars['String']>;
  overview?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['String']>;
};

export type UpdateFeaturedPropertyInput = {
  coverImageFileId?: InputMaybe<Scalars['String']>;
  overview?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  shortOverview?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['String']>;
};

export type UpdateIdxFeedInput = {
  cities?: InputMaybe<Array<PlaceInput>>;
  counties?: InputMaybe<Array<PlaceInput>>;
  idxFeedId: Scalars['ObjectId'];
  marketAreaIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  name?: InputMaybe<Scalars['String']>;
  portfolioContent?: InputMaybe<IdxFeedPortfolioContentEnum>;
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertiesPerPage?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['ObjectId']>;
  searchBarContent?: InputMaybe<IdxFeedSearchBarContentEnum>;
  showCustomPropertyDownloads?: InputMaybe<Scalars['Boolean']>;
  showPropertyDownloads?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<IdxFeedTypeEnum>;
};

export type UpdateIdxSettingsInput = {
  branding?: InputMaybe<BrandingInput>;
  idxSettingsId: Scalars['ObjectId'];
  isWixSite?: InputMaybe<Scalars['Boolean']>;
  showDashCredit: Scalars['Boolean'];
  websiteDomain: Scalars['String'];
};

export type UpdateMediaKitInput = {
  addMediaKitItems: Array<AddMediaKitItems>;
  removeMediaKitItems: Array<RemoveMediaKitItems>;
};

export type UpdateProductSubscriptionInput = {
  stripeCouponId?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
  subscriptionProductId: Scalars['ObjectId'];
};

export type User = {
  __typename?: 'User';
  account: Account;
  profile: Profile;
};

export type UsersPayload = {
  __typename?: 'UsersPayload';
  collection: Array<User>;
  totalCount: Scalars['Float'];
};

export type ValidateCouponInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  subscriptionProductId: Scalars['ObjectId'];
  userHasTrialed: Scalars['Boolean'];
};

export type ValidateCouponPayload = {
  __typename?: 'ValidateCouponPayload';
  coupon?: Maybe<SubscriptionProductCoupon>;
  invalidMessageType?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
};

export type ViewHistory = {
  __typename?: 'ViewHistory';
  _id: Scalars['String'];
  createdAt: Scalars['Date'];
  createdBy?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  historyType: Scalars['String'];
  lastViewAt?: Maybe<Scalars['Date']>;
  portfolio?: Maybe<Portfolio>;
  portfolioId?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  updatedBy?: Maybe<Scalars['String']>;
  viewedByAccountId?: Maybe<Scalars['String']>;
  viewedByVisitorHash?: Maybe<Scalars['String']>;
  visitorType: Scalars['String'];
};

export type ViewHistoryPayload = {
  __typename?: 'ViewHistoryPayload';
  collection: Array<ViewHistory>;
  totalCount: Scalars['Float'];
};

export type VirtualTourLink = {
  __typename?: 'VirtualTourLink';
  label?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type VirtualTourLinkInput = {
  label?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type WorkingHours = {
  __typename?: 'WorkingHours';
  friday?: Maybe<WorkingRange>;
  monday?: Maybe<WorkingRange>;
  saturday?: Maybe<WorkingRange>;
  sunday?: Maybe<WorkingRange>;
  thursday?: Maybe<WorkingRange>;
  tuesday?: Maybe<WorkingRange>;
  wednesday?: Maybe<WorkingRange>;
};

export type WorkingHoursInput = {
  friday?: InputMaybe<WorkingRangeInput>;
  monday?: InputMaybe<WorkingRangeInput>;
  saturday?: InputMaybe<WorkingRangeInput>;
  sunday?: InputMaybe<WorkingRangeInput>;
  thursday?: InputMaybe<WorkingRangeInput>;
  tuesday?: InputMaybe<WorkingRangeInput>;
  wednesday?: InputMaybe<WorkingRangeInput>;
};

export type WorkingRange = {
  __typename?: 'WorkingRange';
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type WorkingRangeInput = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type XmlDownloadResponse = {
  __typename?: 'XmlDownloadResponse';
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AbortUploadEvent: ResolverTypeWrapper<AbortUploadEvent>;
  AcceptApiInvitationInput: AcceptApiInvitationInput;
  Account: ResolverTypeWrapper<Account>;
  AccountActiveOrArchivedStatusesEnum: AccountActiveOrArchivedStatusesEnum;
  AccountInput: AccountInput;
  AddMediaKitItems: AddMediaKitItems;
  AddSaleTeamUserAccountInput: AddSaleTeamUserAccountInput;
  AddSaleTeamUserInput: AddSaleTeamUserInput;
  Address: ResolverTypeWrapper<Address>;
  AdvancedPropertyDetailsInput: AdvancedPropertyDetailsInput;
  AmenitiesPayload: ResolverTypeWrapper<AmenitiesPayload>;
  Amenity: ResolverTypeWrapper<Amenity>;
  AmenityName: ResolverTypeWrapper<AmenityName>;
  ApiBrokerInfo: ResolverTypeWrapper<ApiBrokerInfo>;
  ApiCredentialSafeDTO: ResolverTypeWrapper<ApiCredentialSafeDto>;
  ApiCredentialsInput: ApiCredentialsInput;
  ApiCredentialsPluginUserResponse: ResolverTypeWrapper<ApiCredentialsPluginUserResponse>;
  ApiCredentialsTypesEnum: ApiCredentialsTypesEnum;
  ApiCredentialsUserResponse: ResolverTypeWrapper<ApiCredentialsUserResponse>;
  ApiInvitationSafeDTO: ResolverTypeWrapper<ApiInvitationSafeDto>;
  ApiInvitationStatusEnum: ApiInvitationStatusEnum;
  ApiInvitationValidation: ResolverTypeWrapper<ApiInvitationValidation>;
  ApiInvitationsPayload: ResolverTypeWrapper<ApiInvitationsPayload>;
  ApiMetric: ResolverTypeWrapper<ApiMetric>;
  ApiMetricPayload: ResolverTypeWrapper<ApiMetricPayload>;
  ApiPluginUser: ResolverTypeWrapper<ApiPluginUser>;
  ApiPluginUsersPayload: ResolverTypeWrapper<ApiPluginUsersPayload>;
  ApiQuotaStatusPayload: ResolverTypeWrapper<ApiQuotaStatusPayload>;
  ApiUser: ResolverTypeWrapper<ApiUser>;
  ApiUsersPayload: ResolverTypeWrapper<ApiUsersPayload>;
  ApprovePropertyInput: ApprovePropertyInput;
  ArchivePropertyInput: ArchivePropertyInput;
  AttributionInput: AttributionInput;
  AuditPropertyInput: AuditPropertyInput;
  AuthResult: ResolversTypes['MfaTempTokenModel'] | ResolversTypes['TokensModel'];
  BasicInfoResponse: ResolverTypeWrapper<BasicInfoResponse>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Branding: ResolverTypeWrapper<Branding>;
  BrandingInput: BrandingInput;
  BrandingTypeEnum: BrandingTypeEnum;
  BrandingTypeFilterEnum: BrandingTypeFilterEnum;
  Broker: ResolverTypeWrapper<Broker>;
  BrokerActivitiesTypesEnum: BrokerActivitiesTypesEnum;
  BrokerActivity: ResolverTypeWrapper<BrokerActivity>;
  BrokerAlertConfig: ResolverTypeWrapper<BrokerAlertConfig>;
  BrokerAlertConfigConstructionDateRangeFilter: ResolverTypeWrapper<BrokerAlertConfigConstructionDateRangeFilter>;
  BrokerAlertConfigFilter: ResolverTypeWrapper<BrokerAlertConfigFilter>;
  BrokerAlertConfigLocationFilter: ResolverTypeWrapper<BrokerAlertConfigLocationFilter>;
  BrokerAlertConfigPayload: ResolverTypeWrapper<BrokerAlertConfigPayload>;
  BrokerAlertItem: ResolverTypeWrapper<BrokerAlertItem>;
  BrokerAlertItemPayload: ResolverTypeWrapper<BrokerAlertItemPayload>;
  BrokerLicense: ResolverTypeWrapper<BrokerLicense>;
  BrokerLicenseStatusesEnum: BrokerLicenseStatusesEnum;
  BrokerPortfolioComparisonFields: BrokerPortfolioComparisonFields;
  BrokerPortfolioStatusesEnum: BrokerPortfolioStatusesEnum;
  BrokerReactionsStats: ResolverTypeWrapper<BrokerReactionsStats>;
  BrokerSavedFeaturedPortfolio: ResolverTypeWrapper<BrokerSavedFeaturedPortfolio>;
  BrokerSavedFeaturedPortfoliosPayload: ResolverTypeWrapper<BrokerSavedFeaturedPortfoliosPayload>;
  BrokerSubscriptionTypesEnum: BrokerSubscriptionTypesEnum;
  BrokerTrackedPropertiesPayload: ResolverTypeWrapper<BrokerTrackedPropertiesPayload>;
  BrokerTrackedProperty: ResolverTypeWrapper<BrokerTrackedProperty>;
  BrokerViewedPortfoliosFilter: BrokerViewedPortfoliosFilter;
  BrokersPayload: ResolverTypeWrapper<BrokersPayload>;
  BuildingTypesEnum: BuildingTypesEnum;
  CanUserTrialForProductInput: CanUserTrialForProductInput;
  CancelProductSubscriptionInput: CancelProductSubscriptionInput;
  ChangelogDocument: ResolversTypes['PropertyAboutChangelog'] | ResolversTypes['PropertyAdditionalInformationChangelog'] | ResolversTypes['PropertyDataReviewedChangelog'] | ResolversTypes['PropertyDeveloperOrganizationChangelog'] | ResolversTypes['PropertyFeaturesAndAmenitiesChangelog'] | ResolversTypes['PropertyHighlightsChangelog'] | ResolversTypes['PropertyInventoryUnitAddedChangelog'] | ResolversTypes['PropertyInventoryUnitRemovedChangelog'] | ResolversTypes['PropertyInventoryUnitUpdatedChangelog'] | ResolversTypes['PropertyLocationChangelog'] | ResolversTypes['PropertyMediaFilesMovedChangelog'] | ResolversTypes['PropertyMediaRemovedChangelog'] | ResolversTypes['PropertyMediaRenamedChangelog'] | ResolversTypes['PropertyMediaUploadedChangelog'] | ResolversTypes['PropertyNameChangelog'] | ResolversTypes['PropertyOrganizationSalesTeamsChangelog'] | ResolversTypes['PropertyPriceChangelog'] | ResolversTypes['PropertyVirtualToursChangelog'] | ResolversTypes['PropertyWebsiteChangelog'];
  CheckoutSessionDetails: ResolverTypeWrapper<CheckoutSessionDetails>;
  CmsSettings: ResolverTypeWrapper<CmsSettings>;
  CmsStatusEnum: CmsStatusEnum;
  Comparison: ResolverTypeWrapper<Comparison>;
  ContactPhone: ResolverTypeWrapper<ContactPhone>;
  CopyFeaturedPortfolioToBrokerPortfolioArgs: CopyFeaturedPortfolioToBrokerPortfolioArgs;
  CopyFeaturedPortfolioToBrokerPortfolioResult: ResolverTypeWrapper<CopyFeaturedPortfolioToBrokerPortfolioResult>;
  CreateAlertConfigFilterInput: CreateAlertConfigFilterInput;
  CreateAmenityInput: CreateAmenityInput;
  CreateApiInvitationInput: CreateApiInvitationInput;
  CreateBrokerInput: CreateBrokerInput;
  CreateBrokerSSOInput: CreateBrokerSsoInput;
  CreateCheckoutSessionInput: CreateCheckoutSessionInput;
  CreateCheckoutSessionPayload: ResolverTypeWrapper<CreateCheckoutSessionPayload>;
  CreateFeaturedPortfolioInput: CreateFeaturedPortfolioInput;
  CreateFeaturedPropertyInput: CreateFeaturedPropertyInput;
  CreateIdxFeedInput: CreateIdxFeedInput;
  CreateMarketAreaInput: CreateMarketAreaInput;
  CreateMediaFileInput: CreateMediaFileInput;
  CreateMediaFolderInput: CreateMediaFolderInput;
  CreateOrganizationInput: CreateOrganizationInput;
  CreateOrganizationUserAccountInput: CreateOrganizationUserAccountInput;
  CreateOrganizationUserInput: CreateOrganizationUserInput;
  CreateProductSubscriptionInput: CreateProductSubscriptionInput;
  CreatePropertyInput: CreatePropertyInput;
  CreateSaleTeamInput: CreateSaleTeamInput;
  CreateSimpleBrokerInput: CreateSimpleBrokerInput;
  CreateSinglePropertyPortfolioInput: CreateSinglePropertyPortfolioInput;
  CreateUnitInput: CreateUnitInput;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  DateRangeInput: DateRangeInput;
  Developer: ResolverTypeWrapper<Developer>;
  DeveloperAsSaleUser: ResolversTypes['OrganizationUser'] | ResolversTypes['SaleTeamUser'];
  EditAmenityInput: EditAmenityInput;
  EditMarketAreaInput: EditMarketAreaInput;
  EditMediaFileInput: EditMediaFileInput;
  EditMediaFolderInput: EditMediaFolderInput;
  EditOrganizationInput: EditOrganizationInput;
  EditOrganizationUserAccountInput: EditOrganizationUserAccountInput;
  EditOrganizationUserInput: EditOrganizationUserInput;
  EditOrganizationUserProfileInput: EditOrganizationUserProfileInput;
  EditSaleTeamInput: EditSaleTeamInput;
  EditSaleTeamUserAccountInput: EditSaleTeamUserAccountInput;
  EditSaleTeamUserInput: EditSaleTeamUserInput;
  EditSaleTeamUserProfileInput: EditSaleTeamUserProfileInput;
  EditUnitInput: EditUnitInput;
  FeaturedPortfolio: ResolverTypeWrapper<FeaturedPortfolio>;
  FeaturedPortfolioOrder: FeaturedPortfolioOrder;
  FeaturedPortfolioPropertiesPayload: ResolverTypeWrapper<FeaturedPortfolioPropertiesPayload>;
  FeaturedPortfolioSummary: ResolverTypeWrapper<FeaturedPortfolioSummary>;
  FeaturedPortfolioVisibilityEnum: FeaturedPortfolioVisibilityEnum;
  FeaturedPortfoliosPayload: ResolverTypeWrapper<FeaturedPortfoliosPayload>;
  FeaturedPropertiesPayload: ResolverTypeWrapper<FeaturedPropertiesPayload>;
  FeaturedProperty: ResolverTypeWrapper<FeaturedProperty>;
  FeaturedPropertyOrder: FeaturedPropertyOrder;
  FeaturedPropertyVisibilityEnum: FeaturedPropertyVisibilityEnum;
  File: ResolverTypeWrapper<File>;
  FileUploadInput: FileUploadInput;
  FlatPaginationInput: FlatPaginationInput;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  FolderPathModel: ResolverTypeWrapper<FolderPathModel>;
  GeneralPropertyDetailsInput: GeneralPropertyDetailsInput;
  GenerateQrCodeResult: ResolverTypeWrapper<GenerateQrCodeResult>;
  GeoLocationBoundsJSON: GeoLocationBoundsJson;
  GeoLocationJSON: ResolverTypeWrapper<GeoLocationJson>;
  GetAlertItemsFilterInput: GetAlertItemsFilterInput;
  GetAllFilesInPropertyFilterInput: GetAllFilesInPropertyFilterInput;
  GetAllPropertyChangelogsFilterInput: GetAllPropertyChangelogsFilterInput;
  GetAmenitiesFilterInput: GetAmenitiesFilterInput;
  GetAmenitiesForManageFilterInput: GetAmenitiesForManageFilterInput;
  GetApiUsersFilterInput: GetApiUsersFilterInput;
  GetBrokerPropertiesFilterInput: GetBrokerPropertiesFilterInput;
  GetBrokerPropertiesLocationFilterInput: GetBrokerPropertiesLocationFilterInput;
  GetBrokersFilter: GetBrokersFilter;
  GetCMSUsersFilterInput: GetCmsUsersFilterInput;
  GetFeaturedPortfoliosFilter: GetFeaturedPortfoliosFilter;
  GetFeaturedPropertiesFilter: GetFeaturedPropertiesFilter;
  GetFileDownloadStatisticsArgsFilterInput: GetFileDownloadStatisticsArgsFilterInput;
  GetFileDownloadsStatisticItem: ResolverTypeWrapper<GetFileDownloadsStatisticItem>;
  GetFileDownloadsStatisticPayload: ResolverTypeWrapper<GetFileDownloadsStatisticPayload>;
  GetIdxEmbeddedPortfolioFeedInput: GetIdxEmbeddedPortfolioFeedInput;
  GetIdxEmbeddedPropertyFeedInput: GetIdxEmbeddedPropertyFeedInput;
  GetIdxEmbeddedSearchBarFeedInput: GetIdxEmbeddedSearchBarFeedInput;
  GetIdxFeedListFilterInput: GetIdxFeedListFilterInput;
  GetIdxFeedListInput: GetIdxFeedListInput;
  GetIdxFeedListPayload: ResolverTypeWrapper<GetIdxFeedListPayload>;
  GetIdxPortfolioFeedPropertiesInput: GetIdxPortfolioFeedPropertiesInput;
  GetIdxPropertyFilesInput: GetIdxPropertyFilesInput;
  GetIdxSearchFeedPropertiesFiltersInput: GetIdxSearchFeedPropertiesFiltersInput;
  GetIdxSearchFeedPropertiesInput: GetIdxSearchFeedPropertiesInput;
  GetMarketAreasFilterInput: GetMarketAreasFilterInput;
  GetMarketAreasForFilterInput: GetMarketAreasForFilterInput;
  GetMediaFoldersAndFilesFilterInput: GetMediaFoldersAndFilesFilterInput;
  GetOrganizationUsersFilterInput: GetOrganizationUsersFilterInput;
  GetPortfolioMediaKitItemsInput: GetPortfolioMediaKitItemsInput;
  GetPortfolioPropertiesChangelogsFilterInput: GetPortfolioPropertiesChangelogsFilterInput;
  GetPortfoliosFilter: GetPortfoliosFilter;
  GetPortfoliosWithReactionsFilter: GetPortfoliosWithReactionsFilter;
  GetPreviewInvoiceInput: GetPreviewInvoiceInput;
  GetPropertiesFilterInput: GetPropertiesFilterInput;
  GetPropertyChangelogsFilterInput: GetPropertyChangelogsFilterInput;
  GetPropertyViewsByBrokerAFilter: GetPropertyViewsByBrokerAFilter;
  GetSaleTeamUsersFilterInput: GetSaleTeamUsersFilterInput;
  GetSaleTeamsFilterInput: GetSaleTeamsFilterInput;
  GetSavedFeaturedPortfoliosFilterInput: GetSavedFeaturedPortfoliosFilterInput;
  GetStatesFilterInput: GetStatesFilterInput;
  GetSubscriptionProductsFilterInput: GetSubscriptionProductsFilterInput;
  GetSystemActionLogsFilterInput: GetSystemActionLogsFilterInput;
  GetTrackedPropertiesFilterInput: GetTrackedPropertiesFilterInput;
  GetUnitsArgs: GetUnitsArgs;
  GetUnitsFilterInput: GetUnitsFilterInput;
  GetUserByApiCredentialsFilterInput: GetUserByApiCredentialsFilterInput;
  GuestUser: ResolverTypeWrapper<GuestUser>;
  GuestUserPayload: ResolverTypeWrapper<GuestUserPayload>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  IdxActivity: ResolverTypeWrapper<IdxActivity>;
  IdxActivityCollection: ResolverTypeWrapper<IdxActivityCollection>;
  IdxActivityPayload: ResolverTypeWrapper<IdxActivityPayload>;
  IdxEmbeddedPortfolioFeedData: ResolverTypeWrapper<IdxEmbeddedPortfolioFeedData>;
  IdxEmbeddedPropertyFeedData: ResolverTypeWrapper<IdxEmbeddedPropertyFeedData>;
  IdxEmbeddedSearchBarFeedData: ResolverTypeWrapper<IdxEmbeddedSearchBarFeedData>;
  IdxFeed: ResolverTypeWrapper<IdxFeed>;
  IdxFeedPortfolioContentEnum: IdxFeedPortfolioContentEnum;
  IdxFeedSearchBarContentEnum: IdxFeedSearchBarContentEnum;
  IdxFeedTypeEnum: IdxFeedTypeEnum;
  IdxPortfolioFeedPropertiesData: ResolverTypeWrapper<IdxPortfolioFeedPropertiesData>;
  IdxSearchFeedPropertiesData: ResolverTypeWrapper<IdxSearchFeedPropertiesData>;
  IdxSettings: ResolverTypeWrapper<IdxSettings>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  InvoiceCoupon: ResolverTypeWrapper<InvoiceCoupon>;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  LocalTimeHours: ResolverTypeWrapper<LocalTimeHours>;
  LocalTimeHoursInput: LocalTimeHoursInput;
  LocalTimeRange: ResolverTypeWrapper<LocalTimeRange>;
  LocalTimeRangeInput: LocalTimeRangeInput;
  Location: ResolverTypeWrapper<Location>;
  LocationSaveInput: LocationSaveInput;
  MarketArea: ResolverTypeWrapper<MarketArea>;
  MarketAreaCount: ResolverTypeWrapper<MarketAreaCount>;
  MarketAreaPlaceOption: ResolverTypeWrapper<MarketAreaPlaceOption>;
  MarketAreasPayload: ResolverTypeWrapper<MarketAreasPayload>;
  Media: ResolverTypeWrapper<Media>;
  MediaFileTypesFilterEnum: MediaFileTypesFilterEnum;
  MediaFilesAndFoldersPayload: ResolverTypeWrapper<MediaFilesAndFoldersPayload>;
  MediaFilesPayload: ResolverTypeWrapper<MediaFilesPayload>;
  MediaFolderInput: MediaFolderInput;
  MediaKitPayload: ResolverTypeWrapper<MediaKitPayload>;
  MediaObserveSubscriptionPayload: ResolverTypeWrapper<MediaObserveSubscriptionPayload>;
  MetricDataPoint: ResolverTypeWrapper<MetricDataPoint>;
  MfaMethodsEnum: MfaMethodsEnum;
  MfaTempTokenModel: ResolverTypeWrapper<MfaTempTokenModel>;
  MinMax: ResolverTypeWrapper<MinMax>;
  MinMaxRange: ResolverTypeWrapper<MinMaxRange>;
  MinMaxRangeInput: MinMaxRangeInput;
  MinMaxRangePayload: ResolverTypeWrapper<MinMaxRangePayload>;
  Mutation: ResolverTypeWrapper<{}>;
  NewPortfolioItemActivitiesPayload: ResolverTypeWrapper<NewPortfolioItemActivitiesPayload>;
  NewPortfolioItemActivity: ResolverTypeWrapper<NewPortfolioItemActivity>;
  NewPortfolioItemActivityDoc: ResolverTypeWrapper<NewPortfolioItemActivityDoc>;
  ObjectId: ResolverTypeWrapper<Scalars['ObjectId']>;
  ObserveAccountPayload: ResolverTypeWrapper<ObserveAccountPayload>;
  ObserveBrokerAlertItemsPayload: ResolverTypeWrapper<ObserveBrokerAlertItemsPayload>;
  ObserveBrokerPortfolioPayload: ResolverTypeWrapper<ObserveBrokerPortfolioPayload>;
  ObserveProgressTrackingPayload: ResolverTypeWrapper<ObserveProgressTrackingPayload>;
  ObservePropertyNotesPayload: ResolverTypeWrapper<ObservePropertyNotesPayload>;
  ObservePropertyPayload: ResolverTypeWrapper<ObservePropertyPayload>;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationUser: ResolverTypeWrapper<OrganizationUser>;
  OrganizationUsersPayload: ResolverTypeWrapper<OrganizationUsersPayload>;
  OrganizationsPayload: ResolverTypeWrapper<OrganizationsPayload>;
  PaginationInput: PaginationInput;
  PartialDateRangeInput: PartialDateRangeInput;
  PartialMinMaxRangeInput: PartialMinMaxRangeInput;
  Phone: ResolverTypeWrapper<Phone>;
  PhoneInput: PhoneInput;
  Place: ResolverTypeWrapper<Place>;
  PlaceInput: PlaceInput;
  PlaceOption: ResolverTypeWrapper<PlaceOption>;
  PlaceOptionsPayload: ResolverTypeWrapper<PlaceOptionsPayload>;
  PlaceTargetInput: PlaceTargetInput;
  PluginUserOwnTotalApiUsageFilterInput: PluginUserOwnTotalApiUsageFilterInput;
  Portfolio: ResolverTypeWrapper<Portfolio>;
  PortfolioFolderItemsGroup: ResolverTypeWrapper<PortfolioFolderItemsGroup>;
  PortfolioLocations: ResolverTypeWrapper<PortfolioLocations>;
  PortfolioMediaKit: ResolverTypeWrapper<PortfolioMediaKit>;
  PortfolioReaction: ResolverTypeWrapper<PortfolioReaction>;
  PortfolioReactionsEnum: PortfolioReactionsEnum;
  PortfolioTree: ResolverTypeWrapper<PortfolioTree>;
  PortfoliosPayload: ResolverTypeWrapper<PortfoliosPayload>;
  PortfoliosTreePayload: ResolverTypeWrapper<PortfoliosTreePayload>;
  PreferredPropertySettings: ResolverTypeWrapper<PreferredPropertySettings>;
  PreferredPropertySettingsInput: PreferredPropertySettingsInput;
  PreviewInvoiceItem: ResolverTypeWrapper<PreviewInvoiceItem>;
  PreviewInvoicePayload: ResolverTypeWrapper<PreviewInvoicePayload>;
  ProductSubscription: ResolverTypeWrapper<ProductSubscription>;
  ProductSubscriptionPayload: ResolverTypeWrapper<ProductSubscriptionPayload>;
  ProductSubscriptionPayment: ResolverTypeWrapper<ProductSubscriptionPayment>;
  ProductSubscriptionsPayload: ResolverTypeWrapper<ProductSubscriptionsPayload>;
  ProductsSubscriptionsObserveSubscriptionPayload: ResolverTypeWrapper<ProductsSubscriptionsObserveSubscriptionPayload>;
  Profile: ResolverTypeWrapper<Profile>;
  ProfileInput: ProfileInput;
  ProgressTrackingModel: ResolverTypeWrapper<ProgressTrackingModel>;
  ProjectStatusesEnum: ProjectStatusesEnum;
  PropertiesPayload: ResolverTypeWrapper<PropertiesPayload>;
  Property: ResolverTypeWrapper<Property>;
  PropertyAboutChangelog: ResolverTypeWrapper<PropertyAboutChangelog>;
  PropertyAdditionalInformationChangelog: ResolverTypeWrapper<PropertyAdditionalInformationChangelog>;
  PropertyChangelog: ResolverTypeWrapper<Omit<PropertyChangelog, 'afterUpdate' | 'beforeUpdate'> & { afterUpdate: ResolversTypes['ChangelogDocument'], beforeUpdate?: Maybe<ResolversTypes['ChangelogDocument']> }>;
  PropertyChangelogTypesEnum: PropertyChangelogTypesEnum;
  PropertyChangelogsPayload: ResolverTypeWrapper<PropertyChangelogsPayload>;
  PropertyClick: ResolverTypeWrapper<PropertyClick>;
  PropertyDataReviewedChangelog: ResolverTypeWrapper<PropertyDataReviewedChangelog>;
  PropertyDetail: ResolverTypeWrapper<PropertyDetail>;
  PropertyDeveloperOrganizationChangelog: ResolverTypeWrapper<PropertyDeveloperOrganizationChangelog>;
  PropertyFeaturesAndAmenitiesChangelog: ResolverTypeWrapper<PropertyFeaturesAndAmenitiesChangelog>;
  PropertyHighlightsChangelog: ResolverTypeWrapper<PropertyHighlightsChangelog>;
  PropertyInventoryUnitAddedChangelog: ResolverTypeWrapper<PropertyInventoryUnitAddedChangelog>;
  PropertyInventoryUnitRemovedChangelog: ResolverTypeWrapper<PropertyInventoryUnitRemovedChangelog>;
  PropertyInventoryUnitUpdatedChangelog: ResolverTypeWrapper<PropertyInventoryUnitUpdatedChangelog>;
  PropertyLocationChangelog: ResolverTypeWrapper<PropertyLocationChangelog>;
  PropertyMediaFilesMovedChangelog: ResolverTypeWrapper<PropertyMediaFilesMovedChangelog>;
  PropertyMediaRemovedChangelog: ResolverTypeWrapper<PropertyMediaRemovedChangelog>;
  PropertyMediaRenamedChangelog: ResolverTypeWrapper<PropertyMediaRenamedChangelog>;
  PropertyMediaUploadedChangelog: ResolverTypeWrapper<PropertyMediaUploadedChangelog>;
  PropertyNameChangelog: ResolverTypeWrapper<PropertyNameChangelog>;
  PropertyNote: ResolverTypeWrapper<PropertyNote>;
  PropertyNotesPayload: ResolverTypeWrapper<PropertyNotesPayload>;
  PropertyOrganizationSalesTeamsChangelog: ResolverTypeWrapper<PropertyOrganizationSalesTeamsChangelog>;
  PropertyPriceChangelog: ResolverTypeWrapper<PropertyPriceChangelog>;
  PropertySaleTeam: ResolverTypeWrapper<Omit<PropertySaleTeam, 'saleAssociates' | 'saleDirector'> & { saleAssociates?: Maybe<Array<ResolversTypes['DeveloperAsSaleUser']>>, saleDirector?: Maybe<ResolversTypes['DeveloperAsSaleUser']> }>;
  PropertySaleTeamInput: PropertySaleTeamInput;
  PropertyStatusesEnum: PropertyStatusesEnum;
  PropertySummary: ResolverTypeWrapper<PropertySummary>;
  PropertyTagsEnum: PropertyTagsEnum;
  PropertyTransactionTypesEnum: PropertyTransactionTypesEnum;
  PropertyVirtualToursChangelog: ResolverTypeWrapper<PropertyVirtualToursChangelog>;
  PropertyVisitActivitiesPayload: ResolverTypeWrapper<PropertyVisitActivitiesPayload>;
  PropertyVisitActivity: ResolverTypeWrapper<PropertyVisitActivity>;
  PropertyVisitActivityDoc: ResolverTypeWrapper<PropertyVisitActivityDoc>;
  PropertyWebsiteChangelog: ResolverTypeWrapper<PropertyWebsiteChangelog>;
  Query: ResolverTypeWrapper<{}>;
  RecurringTypesEnum: RecurringTypesEnum;
  RegisterBrokerInput: RegisterBrokerInput;
  RemoveMediaKitItems: RemoveMediaKitItems;
  Role: ResolverTypeWrapper<Role>;
  RoleTypesEnum: RoleTypesEnum;
  RolesPayload: ResolverTypeWrapper<RolesPayload>;
  SaleTeam: ResolverTypeWrapper<SaleTeam>;
  SaleTeamUser: ResolverTypeWrapper<SaleTeamUser>;
  SaleTeamUserNamePayload: ResolverTypeWrapper<SaleTeamUserNamePayload>;
  SaleTeamUsersPayload: ResolverTypeWrapper<SaleTeamUsersPayload>;
  SaleTeamsPayload: ResolverTypeWrapper<SaleTeamsPayload>;
  SalesGalleryStatusesEnum: SalesGalleryStatusesEnum;
  SalesTeamPhone: ResolverTypeWrapper<SalesTeamPhone>;
  ScheduleDowngradeInput: ScheduleDowngradeInput;
  SearchIndex: ResolverTypeWrapper<SearchIndex>;
  SearchIndexDisplay: ResolverTypeWrapper<SearchIndexDisplay>;
  SearchIndexMeta: ResolverTypeWrapper<SearchIndexMeta>;
  SearchIndexPayload: ResolverTypeWrapper<SearchIndexPayload>;
  SearchIndexRefs: ResolverTypeWrapper<SearchIndexRefs>;
  SearchIndexSearch: ResolverTypeWrapper<SearchIndexSearch>;
  SearchIndexSubtypeEnum: SearchIndexSubtypeEnum;
  SearchIndexTypeEnum: SearchIndexTypeEnum;
  SendMessageToAgentInput: SendMessageToAgentInput;
  SetAdvancedPropertyDetailsInput: SetAdvancedPropertyDetailsInput;
  SetAmenitiesToPropertyInput: SetAmenitiesToPropertyInput;
  SetGeneralPropertyDetailsInput: SetGeneralPropertyDetailsInput;
  SetGuestUserDataArgs: SetGuestUserDataArgs;
  SetPropertyStatusInput: SetPropertyStatusInput;
  SignupAttributionInput: SignupAttributionInput;
  SimilarityBreakdown: ResolverTypeWrapper<SimilarityBreakdown>;
  SimilarityEntry: ResolverTypeWrapper<SimilarityEntry>;
  SortInput: SortInput;
  SortedMediaIdsInput: SortedMediaIdsInput;
  State: ResolverTypeWrapper<State>;
  String: ResolverTypeWrapper<Scalars['String']>;
  StripeAccount: ResolverTypeWrapper<StripeAccount>;
  StripeAccountPaymentMethod: ResolverTypeWrapper<StripeAccountPaymentMethod>;
  StripeAccountTransaction: ResolverTypeWrapper<StripeAccountTransaction>;
  StripeAccountTransactionsFlatPayload: ResolverTypeWrapper<StripeAccountTransactionsFlatPayload>;
  Subscription: ResolverTypeWrapper<{}>;
  SubscriptionProduct: ResolverTypeWrapper<SubscriptionProduct>;
  SubscriptionProductCoupon: ResolverTypeWrapper<SubscriptionProductCoupon>;
  SubscriptionProductFeature: ResolverTypeWrapper<SubscriptionProductFeature>;
  SubscriptionProductsObserveSubscriptionPayload: ResolverTypeWrapper<SubscriptionProductsObserveSubscriptionPayload>;
  SubscriptionSchedule: ResolverTypeWrapper<SubscriptionSchedule>;
  SwitchAccountInput: SwitchAccountInput;
  SystemActionLogsMetadata: ResolverTypeWrapper<SystemActionLogsMetadata>;
  SystemActionLogsTypeEnum: SystemActionLogsTypeEnum;
  TempAuthResult: ResolverTypeWrapper<TempAuthResult>;
  ToggleChangelogVisibilityInput: ToggleChangelogVisibilityInput;
  TokenResponse: ResolverTypeWrapper<TokenResponse>;
  TokensModel: ResolverTypeWrapper<TokensModel>;
  TotalApiUsageFilterInput: TotalApiUsageFilterInput;
  TrackedPropertyId: ResolverTypeWrapper<TrackedPropertyId>;
  TrendingList: ResolverTypeWrapper<TrendingList>;
  TrendingListItem: ResolverTypeWrapper<TrendingListItem>;
  Unit: ResolverTypeWrapper<Unit>;
  UnitInput: UnitInput;
  UnitPropertyMarket: ResolverTypeWrapper<UnitPropertyMarket>;
  UnitsPayload: ResolverTypeWrapper<UnitsPayload>;
  UpdateAccountInput: UpdateAccountInput;
  UpdateBrandedFilesReadyInput: UpdateBrandedFilesReadyInput;
  UpdateBrokerAccountInput: UpdateBrokerAccountInput;
  UpdateBrokerInCMSInput: UpdateBrokerInCmsInput;
  UpdateBrokerInput: UpdateBrokerInput;
  UpdateBrokerLicenseInput: UpdateBrokerLicenseInput;
  UpdateBrokerLicenseStatusInput: UpdateBrokerLicenseStatusInput;
  UpdateBrokerProfileInput: UpdateBrokerProfileInput;
  UpdateCmsSettingsInput: UpdateCmsSettingsInput;
  UpdateCmsStatusInput: UpdateCmsStatusInput;
  UpdateFeaturedPortfolioInput: UpdateFeaturedPortfolioInput;
  UpdateFeaturedPropertyInput: UpdateFeaturedPropertyInput;
  UpdateIdxFeedInput: UpdateIdxFeedInput;
  UpdateIdxSettingsInput: UpdateIdxSettingsInput;
  UpdateMediaKitInput: UpdateMediaKitInput;
  UpdateProductSubscriptionInput: UpdateProductSubscriptionInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
  User: ResolverTypeWrapper<User>;
  UsersPayload: ResolverTypeWrapper<UsersPayload>;
  ValidateCouponInput: ValidateCouponInput;
  ValidateCouponPayload: ResolverTypeWrapper<ValidateCouponPayload>;
  ViewHistory: ResolverTypeWrapper<ViewHistory>;
  ViewHistoryPayload: ResolverTypeWrapper<ViewHistoryPayload>;
  VirtualTourLink: ResolverTypeWrapper<VirtualTourLink>;
  VirtualTourLinkInput: VirtualTourLinkInput;
  WorkingHours: ResolverTypeWrapper<WorkingHours>;
  WorkingHoursInput: WorkingHoursInput;
  WorkingRange: ResolverTypeWrapper<WorkingRange>;
  WorkingRangeInput: WorkingRangeInput;
  XmlDownloadResponse: ResolverTypeWrapper<XmlDownloadResponse>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AbortUploadEvent: AbortUploadEvent;
  AcceptApiInvitationInput: AcceptApiInvitationInput;
  Account: Account;
  AccountInput: AccountInput;
  AddMediaKitItems: AddMediaKitItems;
  AddSaleTeamUserAccountInput: AddSaleTeamUserAccountInput;
  AddSaleTeamUserInput: AddSaleTeamUserInput;
  Address: Address;
  AdvancedPropertyDetailsInput: AdvancedPropertyDetailsInput;
  AmenitiesPayload: AmenitiesPayload;
  Amenity: Amenity;
  AmenityName: AmenityName;
  ApiBrokerInfo: ApiBrokerInfo;
  ApiCredentialSafeDTO: ApiCredentialSafeDto;
  ApiCredentialsInput: ApiCredentialsInput;
  ApiCredentialsPluginUserResponse: ApiCredentialsPluginUserResponse;
  ApiCredentialsUserResponse: ApiCredentialsUserResponse;
  ApiInvitationSafeDTO: ApiInvitationSafeDto;
  ApiInvitationValidation: ApiInvitationValidation;
  ApiInvitationsPayload: ApiInvitationsPayload;
  ApiMetric: ApiMetric;
  ApiMetricPayload: ApiMetricPayload;
  ApiPluginUser: ApiPluginUser;
  ApiPluginUsersPayload: ApiPluginUsersPayload;
  ApiQuotaStatusPayload: ApiQuotaStatusPayload;
  ApiUser: ApiUser;
  ApiUsersPayload: ApiUsersPayload;
  ApprovePropertyInput: ApprovePropertyInput;
  ArchivePropertyInput: ArchivePropertyInput;
  AttributionInput: AttributionInput;
  AuditPropertyInput: AuditPropertyInput;
  AuthResult: ResolversParentTypes['MfaTempTokenModel'] | ResolversParentTypes['TokensModel'];
  BasicInfoResponse: BasicInfoResponse;
  Boolean: Scalars['Boolean'];
  Branding: Branding;
  BrandingInput: BrandingInput;
  Broker: Broker;
  BrokerActivity: BrokerActivity;
  BrokerAlertConfig: BrokerAlertConfig;
  BrokerAlertConfigConstructionDateRangeFilter: BrokerAlertConfigConstructionDateRangeFilter;
  BrokerAlertConfigFilter: BrokerAlertConfigFilter;
  BrokerAlertConfigLocationFilter: BrokerAlertConfigLocationFilter;
  BrokerAlertConfigPayload: BrokerAlertConfigPayload;
  BrokerAlertItem: BrokerAlertItem;
  BrokerAlertItemPayload: BrokerAlertItemPayload;
  BrokerLicense: BrokerLicense;
  BrokerReactionsStats: BrokerReactionsStats;
  BrokerSavedFeaturedPortfolio: BrokerSavedFeaturedPortfolio;
  BrokerSavedFeaturedPortfoliosPayload: BrokerSavedFeaturedPortfoliosPayload;
  BrokerTrackedPropertiesPayload: BrokerTrackedPropertiesPayload;
  BrokerTrackedProperty: BrokerTrackedProperty;
  BrokerViewedPortfoliosFilter: BrokerViewedPortfoliosFilter;
  BrokersPayload: BrokersPayload;
  CanUserTrialForProductInput: CanUserTrialForProductInput;
  CancelProductSubscriptionInput: CancelProductSubscriptionInput;
  ChangelogDocument: ResolversParentTypes['PropertyAboutChangelog'] | ResolversParentTypes['PropertyAdditionalInformationChangelog'] | ResolversParentTypes['PropertyDataReviewedChangelog'] | ResolversParentTypes['PropertyDeveloperOrganizationChangelog'] | ResolversParentTypes['PropertyFeaturesAndAmenitiesChangelog'] | ResolversParentTypes['PropertyHighlightsChangelog'] | ResolversParentTypes['PropertyInventoryUnitAddedChangelog'] | ResolversParentTypes['PropertyInventoryUnitRemovedChangelog'] | ResolversParentTypes['PropertyInventoryUnitUpdatedChangelog'] | ResolversParentTypes['PropertyLocationChangelog'] | ResolversParentTypes['PropertyMediaFilesMovedChangelog'] | ResolversParentTypes['PropertyMediaRemovedChangelog'] | ResolversParentTypes['PropertyMediaRenamedChangelog'] | ResolversParentTypes['PropertyMediaUploadedChangelog'] | ResolversParentTypes['PropertyNameChangelog'] | ResolversParentTypes['PropertyOrganizationSalesTeamsChangelog'] | ResolversParentTypes['PropertyPriceChangelog'] | ResolversParentTypes['PropertyVirtualToursChangelog'] | ResolversParentTypes['PropertyWebsiteChangelog'];
  CheckoutSessionDetails: CheckoutSessionDetails;
  CmsSettings: CmsSettings;
  Comparison: Comparison;
  ContactPhone: ContactPhone;
  CopyFeaturedPortfolioToBrokerPortfolioArgs: CopyFeaturedPortfolioToBrokerPortfolioArgs;
  CopyFeaturedPortfolioToBrokerPortfolioResult: CopyFeaturedPortfolioToBrokerPortfolioResult;
  CreateAlertConfigFilterInput: CreateAlertConfigFilterInput;
  CreateAmenityInput: CreateAmenityInput;
  CreateApiInvitationInput: CreateApiInvitationInput;
  CreateBrokerInput: CreateBrokerInput;
  CreateBrokerSSOInput: CreateBrokerSsoInput;
  CreateCheckoutSessionInput: CreateCheckoutSessionInput;
  CreateCheckoutSessionPayload: CreateCheckoutSessionPayload;
  CreateFeaturedPortfolioInput: CreateFeaturedPortfolioInput;
  CreateFeaturedPropertyInput: CreateFeaturedPropertyInput;
  CreateIdxFeedInput: CreateIdxFeedInput;
  CreateMarketAreaInput: CreateMarketAreaInput;
  CreateMediaFileInput: CreateMediaFileInput;
  CreateMediaFolderInput: CreateMediaFolderInput;
  CreateOrganizationInput: CreateOrganizationInput;
  CreateOrganizationUserAccountInput: CreateOrganizationUserAccountInput;
  CreateOrganizationUserInput: CreateOrganizationUserInput;
  CreateProductSubscriptionInput: CreateProductSubscriptionInput;
  CreatePropertyInput: CreatePropertyInput;
  CreateSaleTeamInput: CreateSaleTeamInput;
  CreateSimpleBrokerInput: CreateSimpleBrokerInput;
  CreateSinglePropertyPortfolioInput: CreateSinglePropertyPortfolioInput;
  CreateUnitInput: CreateUnitInput;
  Date: Scalars['Date'];
  DateRangeInput: DateRangeInput;
  Developer: Developer;
  DeveloperAsSaleUser: ResolversParentTypes['OrganizationUser'] | ResolversParentTypes['SaleTeamUser'];
  EditAmenityInput: EditAmenityInput;
  EditMarketAreaInput: EditMarketAreaInput;
  EditMediaFileInput: EditMediaFileInput;
  EditMediaFolderInput: EditMediaFolderInput;
  EditOrganizationInput: EditOrganizationInput;
  EditOrganizationUserAccountInput: EditOrganizationUserAccountInput;
  EditOrganizationUserInput: EditOrganizationUserInput;
  EditOrganizationUserProfileInput: EditOrganizationUserProfileInput;
  EditSaleTeamInput: EditSaleTeamInput;
  EditSaleTeamUserAccountInput: EditSaleTeamUserAccountInput;
  EditSaleTeamUserInput: EditSaleTeamUserInput;
  EditSaleTeamUserProfileInput: EditSaleTeamUserProfileInput;
  EditUnitInput: EditUnitInput;
  FeaturedPortfolio: FeaturedPortfolio;
  FeaturedPortfolioOrder: FeaturedPortfolioOrder;
  FeaturedPortfolioPropertiesPayload: FeaturedPortfolioPropertiesPayload;
  FeaturedPortfolioSummary: FeaturedPortfolioSummary;
  FeaturedPortfoliosPayload: FeaturedPortfoliosPayload;
  FeaturedPropertiesPayload: FeaturedPropertiesPayload;
  FeaturedProperty: FeaturedProperty;
  FeaturedPropertyOrder: FeaturedPropertyOrder;
  File: File;
  FileUploadInput: FileUploadInput;
  FlatPaginationInput: FlatPaginationInput;
  Float: Scalars['Float'];
  FolderPathModel: FolderPathModel;
  GeneralPropertyDetailsInput: GeneralPropertyDetailsInput;
  GenerateQrCodeResult: GenerateQrCodeResult;
  GeoLocationBoundsJSON: GeoLocationBoundsJson;
  GeoLocationJSON: GeoLocationJson;
  GetAlertItemsFilterInput: GetAlertItemsFilterInput;
  GetAllFilesInPropertyFilterInput: GetAllFilesInPropertyFilterInput;
  GetAllPropertyChangelogsFilterInput: GetAllPropertyChangelogsFilterInput;
  GetAmenitiesFilterInput: GetAmenitiesFilterInput;
  GetAmenitiesForManageFilterInput: GetAmenitiesForManageFilterInput;
  GetApiUsersFilterInput: GetApiUsersFilterInput;
  GetBrokerPropertiesFilterInput: GetBrokerPropertiesFilterInput;
  GetBrokerPropertiesLocationFilterInput: GetBrokerPropertiesLocationFilterInput;
  GetBrokersFilter: GetBrokersFilter;
  GetCMSUsersFilterInput: GetCmsUsersFilterInput;
  GetFeaturedPortfoliosFilter: GetFeaturedPortfoliosFilter;
  GetFeaturedPropertiesFilter: GetFeaturedPropertiesFilter;
  GetFileDownloadStatisticsArgsFilterInput: GetFileDownloadStatisticsArgsFilterInput;
  GetFileDownloadsStatisticItem: GetFileDownloadsStatisticItem;
  GetFileDownloadsStatisticPayload: GetFileDownloadsStatisticPayload;
  GetIdxEmbeddedPortfolioFeedInput: GetIdxEmbeddedPortfolioFeedInput;
  GetIdxEmbeddedPropertyFeedInput: GetIdxEmbeddedPropertyFeedInput;
  GetIdxEmbeddedSearchBarFeedInput: GetIdxEmbeddedSearchBarFeedInput;
  GetIdxFeedListFilterInput: GetIdxFeedListFilterInput;
  GetIdxFeedListInput: GetIdxFeedListInput;
  GetIdxFeedListPayload: GetIdxFeedListPayload;
  GetIdxPortfolioFeedPropertiesInput: GetIdxPortfolioFeedPropertiesInput;
  GetIdxPropertyFilesInput: GetIdxPropertyFilesInput;
  GetIdxSearchFeedPropertiesFiltersInput: GetIdxSearchFeedPropertiesFiltersInput;
  GetIdxSearchFeedPropertiesInput: GetIdxSearchFeedPropertiesInput;
  GetMarketAreasFilterInput: GetMarketAreasFilterInput;
  GetMarketAreasForFilterInput: GetMarketAreasForFilterInput;
  GetMediaFoldersAndFilesFilterInput: GetMediaFoldersAndFilesFilterInput;
  GetOrganizationUsersFilterInput: GetOrganizationUsersFilterInput;
  GetPortfolioMediaKitItemsInput: GetPortfolioMediaKitItemsInput;
  GetPortfolioPropertiesChangelogsFilterInput: GetPortfolioPropertiesChangelogsFilterInput;
  GetPortfoliosFilter: GetPortfoliosFilter;
  GetPortfoliosWithReactionsFilter: GetPortfoliosWithReactionsFilter;
  GetPreviewInvoiceInput: GetPreviewInvoiceInput;
  GetPropertiesFilterInput: GetPropertiesFilterInput;
  GetPropertyChangelogsFilterInput: GetPropertyChangelogsFilterInput;
  GetPropertyViewsByBrokerAFilter: GetPropertyViewsByBrokerAFilter;
  GetSaleTeamUsersFilterInput: GetSaleTeamUsersFilterInput;
  GetSaleTeamsFilterInput: GetSaleTeamsFilterInput;
  GetSavedFeaturedPortfoliosFilterInput: GetSavedFeaturedPortfoliosFilterInput;
  GetStatesFilterInput: GetStatesFilterInput;
  GetSubscriptionProductsFilterInput: GetSubscriptionProductsFilterInput;
  GetSystemActionLogsFilterInput: GetSystemActionLogsFilterInput;
  GetTrackedPropertiesFilterInput: GetTrackedPropertiesFilterInput;
  GetUnitsArgs: GetUnitsArgs;
  GetUnitsFilterInput: GetUnitsFilterInput;
  GetUserByApiCredentialsFilterInput: GetUserByApiCredentialsFilterInput;
  GuestUser: GuestUser;
  GuestUserPayload: GuestUserPayload;
  ID: Scalars['ID'];
  IdxActivity: IdxActivity;
  IdxActivityCollection: IdxActivityCollection;
  IdxActivityPayload: IdxActivityPayload;
  IdxEmbeddedPortfolioFeedData: IdxEmbeddedPortfolioFeedData;
  IdxEmbeddedPropertyFeedData: IdxEmbeddedPropertyFeedData;
  IdxEmbeddedSearchBarFeedData: IdxEmbeddedSearchBarFeedData;
  IdxFeed: IdxFeed;
  IdxPortfolioFeedPropertiesData: IdxPortfolioFeedPropertiesData;
  IdxSearchFeedPropertiesData: IdxSearchFeedPropertiesData;
  IdxSettings: IdxSettings;
  Int: Scalars['Int'];
  InvoiceCoupon: InvoiceCoupon;
  JSON: Scalars['JSON'];
  LocalTimeHours: LocalTimeHours;
  LocalTimeHoursInput: LocalTimeHoursInput;
  LocalTimeRange: LocalTimeRange;
  LocalTimeRangeInput: LocalTimeRangeInput;
  Location: Location;
  LocationSaveInput: LocationSaveInput;
  MarketArea: MarketArea;
  MarketAreaCount: MarketAreaCount;
  MarketAreaPlaceOption: MarketAreaPlaceOption;
  MarketAreasPayload: MarketAreasPayload;
  Media: Media;
  MediaFilesAndFoldersPayload: MediaFilesAndFoldersPayload;
  MediaFilesPayload: MediaFilesPayload;
  MediaFolderInput: MediaFolderInput;
  MediaKitPayload: MediaKitPayload;
  MediaObserveSubscriptionPayload: MediaObserveSubscriptionPayload;
  MetricDataPoint: MetricDataPoint;
  MfaTempTokenModel: MfaTempTokenModel;
  MinMax: MinMax;
  MinMaxRange: MinMaxRange;
  MinMaxRangeInput: MinMaxRangeInput;
  MinMaxRangePayload: MinMaxRangePayload;
  Mutation: {};
  NewPortfolioItemActivitiesPayload: NewPortfolioItemActivitiesPayload;
  NewPortfolioItemActivity: NewPortfolioItemActivity;
  NewPortfolioItemActivityDoc: NewPortfolioItemActivityDoc;
  ObjectId: Scalars['ObjectId'];
  ObserveAccountPayload: ObserveAccountPayload;
  ObserveBrokerAlertItemsPayload: ObserveBrokerAlertItemsPayload;
  ObserveBrokerPortfolioPayload: ObserveBrokerPortfolioPayload;
  ObserveProgressTrackingPayload: ObserveProgressTrackingPayload;
  ObservePropertyNotesPayload: ObservePropertyNotesPayload;
  ObservePropertyPayload: ObservePropertyPayload;
  Organization: Organization;
  OrganizationUser: OrganizationUser;
  OrganizationUsersPayload: OrganizationUsersPayload;
  OrganizationsPayload: OrganizationsPayload;
  PaginationInput: PaginationInput;
  PartialDateRangeInput: PartialDateRangeInput;
  PartialMinMaxRangeInput: PartialMinMaxRangeInput;
  Phone: Phone;
  PhoneInput: PhoneInput;
  Place: Place;
  PlaceInput: PlaceInput;
  PlaceOption: PlaceOption;
  PlaceOptionsPayload: PlaceOptionsPayload;
  PlaceTargetInput: PlaceTargetInput;
  PluginUserOwnTotalApiUsageFilterInput: PluginUserOwnTotalApiUsageFilterInput;
  Portfolio: Portfolio;
  PortfolioFolderItemsGroup: PortfolioFolderItemsGroup;
  PortfolioLocations: PortfolioLocations;
  PortfolioMediaKit: PortfolioMediaKit;
  PortfolioReaction: PortfolioReaction;
  PortfolioTree: PortfolioTree;
  PortfoliosPayload: PortfoliosPayload;
  PortfoliosTreePayload: PortfoliosTreePayload;
  PreferredPropertySettings: PreferredPropertySettings;
  PreferredPropertySettingsInput: PreferredPropertySettingsInput;
  PreviewInvoiceItem: PreviewInvoiceItem;
  PreviewInvoicePayload: PreviewInvoicePayload;
  ProductSubscription: ProductSubscription;
  ProductSubscriptionPayload: ProductSubscriptionPayload;
  ProductSubscriptionPayment: ProductSubscriptionPayment;
  ProductSubscriptionsPayload: ProductSubscriptionsPayload;
  ProductsSubscriptionsObserveSubscriptionPayload: ProductsSubscriptionsObserveSubscriptionPayload;
  Profile: Profile;
  ProfileInput: ProfileInput;
  ProgressTrackingModel: ProgressTrackingModel;
  PropertiesPayload: PropertiesPayload;
  Property: Property;
  PropertyAboutChangelog: PropertyAboutChangelog;
  PropertyAdditionalInformationChangelog: PropertyAdditionalInformationChangelog;
  PropertyChangelog: Omit<PropertyChangelog, 'afterUpdate' | 'beforeUpdate'> & { afterUpdate: ResolversParentTypes['ChangelogDocument'], beforeUpdate?: Maybe<ResolversParentTypes['ChangelogDocument']> };
  PropertyChangelogsPayload: PropertyChangelogsPayload;
  PropertyClick: PropertyClick;
  PropertyDataReviewedChangelog: PropertyDataReviewedChangelog;
  PropertyDetail: PropertyDetail;
  PropertyDeveloperOrganizationChangelog: PropertyDeveloperOrganizationChangelog;
  PropertyFeaturesAndAmenitiesChangelog: PropertyFeaturesAndAmenitiesChangelog;
  PropertyHighlightsChangelog: PropertyHighlightsChangelog;
  PropertyInventoryUnitAddedChangelog: PropertyInventoryUnitAddedChangelog;
  PropertyInventoryUnitRemovedChangelog: PropertyInventoryUnitRemovedChangelog;
  PropertyInventoryUnitUpdatedChangelog: PropertyInventoryUnitUpdatedChangelog;
  PropertyLocationChangelog: PropertyLocationChangelog;
  PropertyMediaFilesMovedChangelog: PropertyMediaFilesMovedChangelog;
  PropertyMediaRemovedChangelog: PropertyMediaRemovedChangelog;
  PropertyMediaRenamedChangelog: PropertyMediaRenamedChangelog;
  PropertyMediaUploadedChangelog: PropertyMediaUploadedChangelog;
  PropertyNameChangelog: PropertyNameChangelog;
  PropertyNote: PropertyNote;
  PropertyNotesPayload: PropertyNotesPayload;
  PropertyOrganizationSalesTeamsChangelog: PropertyOrganizationSalesTeamsChangelog;
  PropertyPriceChangelog: PropertyPriceChangelog;
  PropertySaleTeam: Omit<PropertySaleTeam, 'saleAssociates' | 'saleDirector'> & { saleAssociates?: Maybe<Array<ResolversParentTypes['DeveloperAsSaleUser']>>, saleDirector?: Maybe<ResolversParentTypes['DeveloperAsSaleUser']> };
  PropertySaleTeamInput: PropertySaleTeamInput;
  PropertySummary: PropertySummary;
  PropertyVirtualToursChangelog: PropertyVirtualToursChangelog;
  PropertyVisitActivitiesPayload: PropertyVisitActivitiesPayload;
  PropertyVisitActivity: PropertyVisitActivity;
  PropertyVisitActivityDoc: PropertyVisitActivityDoc;
  PropertyWebsiteChangelog: PropertyWebsiteChangelog;
  Query: {};
  RegisterBrokerInput: RegisterBrokerInput;
  RemoveMediaKitItems: RemoveMediaKitItems;
  Role: Role;
  RolesPayload: RolesPayload;
  SaleTeam: SaleTeam;
  SaleTeamUser: SaleTeamUser;
  SaleTeamUserNamePayload: SaleTeamUserNamePayload;
  SaleTeamUsersPayload: SaleTeamUsersPayload;
  SaleTeamsPayload: SaleTeamsPayload;
  SalesTeamPhone: SalesTeamPhone;
  ScheduleDowngradeInput: ScheduleDowngradeInput;
  SearchIndex: SearchIndex;
  SearchIndexDisplay: SearchIndexDisplay;
  SearchIndexMeta: SearchIndexMeta;
  SearchIndexPayload: SearchIndexPayload;
  SearchIndexRefs: SearchIndexRefs;
  SearchIndexSearch: SearchIndexSearch;
  SendMessageToAgentInput: SendMessageToAgentInput;
  SetAdvancedPropertyDetailsInput: SetAdvancedPropertyDetailsInput;
  SetAmenitiesToPropertyInput: SetAmenitiesToPropertyInput;
  SetGeneralPropertyDetailsInput: SetGeneralPropertyDetailsInput;
  SetGuestUserDataArgs: SetGuestUserDataArgs;
  SetPropertyStatusInput: SetPropertyStatusInput;
  SignupAttributionInput: SignupAttributionInput;
  SimilarityBreakdown: SimilarityBreakdown;
  SimilarityEntry: SimilarityEntry;
  SortInput: SortInput;
  SortedMediaIdsInput: SortedMediaIdsInput;
  State: State;
  String: Scalars['String'];
  StripeAccount: StripeAccount;
  StripeAccountPaymentMethod: StripeAccountPaymentMethod;
  StripeAccountTransaction: StripeAccountTransaction;
  StripeAccountTransactionsFlatPayload: StripeAccountTransactionsFlatPayload;
  Subscription: {};
  SubscriptionProduct: SubscriptionProduct;
  SubscriptionProductCoupon: SubscriptionProductCoupon;
  SubscriptionProductFeature: SubscriptionProductFeature;
  SubscriptionProductsObserveSubscriptionPayload: SubscriptionProductsObserveSubscriptionPayload;
  SubscriptionSchedule: SubscriptionSchedule;
  SwitchAccountInput: SwitchAccountInput;
  SystemActionLogsMetadata: SystemActionLogsMetadata;
  TempAuthResult: TempAuthResult;
  ToggleChangelogVisibilityInput: ToggleChangelogVisibilityInput;
  TokenResponse: TokenResponse;
  TokensModel: TokensModel;
  TotalApiUsageFilterInput: TotalApiUsageFilterInput;
  TrackedPropertyId: TrackedPropertyId;
  TrendingList: TrendingList;
  TrendingListItem: TrendingListItem;
  Unit: Unit;
  UnitInput: UnitInput;
  UnitPropertyMarket: UnitPropertyMarket;
  UnitsPayload: UnitsPayload;
  UpdateAccountInput: UpdateAccountInput;
  UpdateBrandedFilesReadyInput: UpdateBrandedFilesReadyInput;
  UpdateBrokerAccountInput: UpdateBrokerAccountInput;
  UpdateBrokerInCMSInput: UpdateBrokerInCmsInput;
  UpdateBrokerInput: UpdateBrokerInput;
  UpdateBrokerLicenseInput: UpdateBrokerLicenseInput;
  UpdateBrokerLicenseStatusInput: UpdateBrokerLicenseStatusInput;
  UpdateBrokerProfileInput: UpdateBrokerProfileInput;
  UpdateCmsSettingsInput: UpdateCmsSettingsInput;
  UpdateCmsStatusInput: UpdateCmsStatusInput;
  UpdateFeaturedPortfolioInput: UpdateFeaturedPortfolioInput;
  UpdateFeaturedPropertyInput: UpdateFeaturedPropertyInput;
  UpdateIdxFeedInput: UpdateIdxFeedInput;
  UpdateIdxSettingsInput: UpdateIdxSettingsInput;
  UpdateMediaKitInput: UpdateMediaKitInput;
  UpdateProductSubscriptionInput: UpdateProductSubscriptionInput;
  Upload: Scalars['Upload'];
  User: User;
  UsersPayload: UsersPayload;
  ValidateCouponInput: ValidateCouponInput;
  ValidateCouponPayload: ValidateCouponPayload;
  ViewHistory: ViewHistory;
  ViewHistoryPayload: ViewHistoryPayload;
  VirtualTourLink: VirtualTourLink;
  VirtualTourLinkInput: VirtualTourLinkInput;
  WorkingHours: WorkingHours;
  WorkingHoursInput: WorkingHoursInput;
  WorkingRange: WorkingRange;
  WorkingRangeInput: WorkingRangeInput;
  XmlDownloadResponse: XmlDownloadResponse;
}>;

export type AbortUploadEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['AbortUploadEvent'] = ResolversParentTypes['AbortUploadEvent']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAborted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  progressStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progressTrackingId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  s3FileKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  archivingReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  excludeFromReports?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hubSpotId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSeeker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastAccountTypeSwitchAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  mfaEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mfaMethod?: Resolver<Maybe<ResolversTypes['MfaMethodsEnum']>, ParentType, ContextType>;
  mfaSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['Phone']>, ParentType, ContextType>;
  productSubscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rollbackSubscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showAllBillingPlans?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ssoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripeCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripeDefaultPaymentMethodId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zohoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = ResolversObject<{
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmenitiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AmenitiesPayload'] = ResolversParentTypes['AmenitiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Amenity']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmenityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Amenity'] = ResolversParentTypes['Amenity']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  imageFileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPrimary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primaryAmenityId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmenityNameResolvers<ContextType = any, ParentType extends ResolversParentTypes['AmenityName'] = ResolversParentTypes['AmenityName']> = ResolversObject<{
  amenityId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiBrokerInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiBrokerInfo'] = ResolversParentTypes['ApiBrokerInfo']> = ResolversObject<{
  _id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiCredentialSafeDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiCredentialSafeDTO'] = ResolversParentTypes['ApiCredentialSafeDTO']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  adminDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  appId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  associatedAccounts?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  associatedCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  monthlyRequestLimit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  partnerDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ApiCredentialsTypesEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiCredentialsPluginUserResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiCredentialsPluginUserResponse'] = ResolversParentTypes['ApiCredentialsPluginUserResponse']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  appId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  associatedCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  partnerDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiCredentialsUserResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiCredentialsUserResponse'] = ResolversParentTypes['ApiCredentialsUserResponse']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  appId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiInvitationSafeDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiInvitationSafeDTO'] = ResolversParentTypes['ApiInvitationSafeDTO']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  acceptedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  isMarketplacePartner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ApiInvitationStatusEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiInvitationValidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiInvitationValidation'] = ResolversParentTypes['ApiInvitationValidation']> = ResolversObject<{
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasExistingAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ApiInvitationStatusEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiInvitationsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiInvitationsPayload'] = ResolversParentTypes['ApiInvitationsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ApiInvitationSafeDTO']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiMetricResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiMetric'] = ResolversParentTypes['ApiMetric']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  appId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  credentialsType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dataPoints?: Resolver<Array<ResolversTypes['MetricDataPoint']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  totalRequests?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiMetricPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiMetricPayload'] = ResolversParentTypes['ApiMetricPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ApiMetric']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiPluginUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiPluginUser'] = ResolversParentTypes['ApiPluginUser']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  apiCredentials?: Resolver<Maybe<ResolversTypes['ApiCredentialsPluginUserResponse']>, ParentType, ContextType>;
  broker?: Resolver<Maybe<ResolversTypes['ApiBrokerInfo']>, ParentType, ContextType>;
  clientCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  monthlyApiAccess?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiPluginUsersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiPluginUsersPayload'] = ResolversParentTypes['ApiPluginUsersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ApiPluginUser']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiQuotaStatusPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiQuotaStatusPayload'] = ResolversParentTypes['ApiQuotaStatusPayload']> = ResolversObject<{
  limit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  resetDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  usage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiUser'] = ResolversParentTypes['ApiUser']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  apiCredentials?: Resolver<Maybe<ResolversTypes['ApiCredentialsUserResponse']>, ParentType, ContextType>;
  clientCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  monthlyApiAccess?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiUsersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiUsersPayload'] = ResolversParentTypes['ApiUsersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ApiUser']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuthResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthResult'] = ResolversParentTypes['AuthResult']> = ResolversObject<{
  __resolveType: TypeResolveFn<'MfaTempTokenModel' | 'TokensModel', ParentType, ContextType>;
}>;

export type BasicInfoResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BasicInfoResponse'] = ResolversParentTypes['BasicInfoResponse']> = ResolversObject<{
  appId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasKey?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  referralCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ApiCredentialsTypesEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrandingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Branding'] = ResolversParentTypes['Branding']> = ResolversObject<{
  backgroundColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mainColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  textColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Broker'] = ResolversParentTypes['Broker']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountSubscription?: Resolver<Maybe<ResolversTypes['ProductSubscription']>, ParentType, ContextType>;
  agencyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agencyWebsite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  demoExpirationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasActiveApiCredential?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRealUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSeeker?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  license?: Resolver<Maybe<ResolversTypes['BrokerLicense']>, ParentType, ContextType>;
  preferredPropertySettings?: Resolver<Maybe<ResolversTypes['PreferredPropertySettings']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workingHours?: Resolver<Maybe<ResolversTypes['WorkingHours']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerActivity'] = ResolversParentTypes['BrokerActivity']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertConfig'] = ResolversParentTypes['BrokerAlertConfig']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filter?: Resolver<ResolversTypes['BrokerAlertConfigFilter'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertConfigConstructionDateRangeFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertConfigConstructionDateRangeFilter'] = ResolversParentTypes['BrokerAlertConfigConstructionDateRangeFilter']> = ResolversObject<{
  endDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertConfigFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertConfigFilter'] = ResolversParentTypes['BrokerAlertConfigFilter']> = ResolversObject<{
  amenities?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  amenityIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  buildingTypes?: Resolver<Maybe<Array<ResolversTypes['BuildingTypesEnum']>>, ParentType, ContextType>;
  constructionDateRange?: Resolver<Maybe<ResolversTypes['BrokerAlertConfigConstructionDateRangeFilter']>, ParentType, ContextType>;
  locationFilter?: Resolver<Maybe<ResolversTypes['BrokerAlertConfigLocationFilter']>, ParentType, ContextType>;
  marketAreaIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  projectStatuses?: Resolver<Maybe<Array<ResolversTypes['ProjectStatusesEnum']>>, ParentType, ContextType>;
  propertyTags?: Resolver<Maybe<Array<ResolversTypes['PropertyTagsEnum']>>, ParentType, ContextType>;
  transactionType?: Resolver<Maybe<ResolversTypes['PropertyTransactionTypesEnum']>, ParentType, ContextType>;
  unitNumberOfBathrooms?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  unitNumberOfBedrooms?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  unitNumberOfUnits?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  yearBuildRange?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertConfigLocationFilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertConfigLocationFilter'] = ResolversParentTypes['BrokerAlertConfigLocationFilter']> = ResolversObject<{
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  radiusToSearchInMiles?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertConfigPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertConfigPayload'] = ResolversParentTypes['BrokerAlertConfigPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['BrokerAlertConfig']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertItem'] = ResolversParentTypes['BrokerAlertItem']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerAlertConfig?: Resolver<ResolversTypes['BrokerAlertConfig'], ParentType, ContextType>;
  brokerAlertConfigId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isNew?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPropertyPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerAlertItemPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerAlertItemPayload'] = ResolversParentTypes['BrokerAlertItemPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['BrokerAlertItem']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerLicenseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerLicense'] = ResolversParentTypes['BrokerLicense']> = ResolversObject<{
  licenseExpirationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  licenseJurisdictionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  licenseNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  licenseStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerReactionsStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerReactionsStats'] = ResolversParentTypes['BrokerReactionsStats']> = ResolversObject<{
  negative?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  neutral?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  positive?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerSavedFeaturedPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerSavedFeaturedPortfolio'] = ResolversParentTypes['BrokerSavedFeaturedPortfolio']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolio?: Resolver<Maybe<ResolversTypes['FeaturedPortfolio']>, ParentType, ContextType>;
  portfolioId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerSavedFeaturedPortfoliosPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerSavedFeaturedPortfoliosPayload'] = ResolversParentTypes['BrokerSavedFeaturedPortfoliosPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['BrokerSavedFeaturedPortfolio']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerTrackedPropertiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerTrackedPropertiesPayload'] = ResolversParentTypes['BrokerTrackedPropertiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['BrokerTrackedProperty']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokerTrackedPropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokerTrackedProperty'] = ResolversParentTypes['BrokerTrackedProperty']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrokersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrokersPayload'] = ResolversParentTypes['BrokersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Broker']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChangelogDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangelogDocument'] = ResolversParentTypes['ChangelogDocument']> = ResolversObject<{
  __resolveType: TypeResolveFn<'PropertyAboutChangelog' | 'PropertyAdditionalInformationChangelog' | 'PropertyDataReviewedChangelog' | 'PropertyDeveloperOrganizationChangelog' | 'PropertyFeaturesAndAmenitiesChangelog' | 'PropertyHighlightsChangelog' | 'PropertyInventoryUnitAddedChangelog' | 'PropertyInventoryUnitRemovedChangelog' | 'PropertyInventoryUnitUpdatedChangelog' | 'PropertyLocationChangelog' | 'PropertyMediaFilesMovedChangelog' | 'PropertyMediaRemovedChangelog' | 'PropertyMediaRenamedChangelog' | 'PropertyMediaUploadedChangelog' | 'PropertyNameChangelog' | 'PropertyOrganizationSalesTeamsChangelog' | 'PropertyPriceChangelog' | 'PropertyVirtualToursChangelog' | 'PropertyWebsiteChangelog', ParentType, ContextType>;
}>;

export type CheckoutSessionDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckoutSessionDetails'] = ResolversParentTypes['CheckoutSessionDetails']> = ResolversObject<{
  customerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  trialEndAt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CmsSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CmsSettings'] = ResolversParentTypes['CmsSettings']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activeToAwaitingAuditDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  automatedTransitionsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newListingToActiveDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  recentlyUpdatedToActiveDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ComparisonResolvers<ContextType = any, ParentType extends ResolversParentTypes['Comparison'] = ResolversParentTypes['Comparison']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldsToCompare?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioFolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactPhoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactPhone'] = ResolversParentTypes['ContactPhone']> = ResolversObject<{
  dialCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CopyFeaturedPortfolioToBrokerPortfolioResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CopyFeaturedPortfolioToBrokerPortfolioResult'] = ResolversParentTypes['CopyFeaturedPortfolioToBrokerPortfolioResult']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateCheckoutSessionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCheckoutSessionPayload'] = ResolversParentTypes['CreateCheckoutSessionPayload']> = ResolversObject<{
  sessionUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DeveloperResolvers<ContextType = any, ParentType extends ResolversParentTypes['Developer'] = ResolversParentTypes['Developer']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assignedPropertiesIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  organizationIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  organizations?: Resolver<Maybe<Array<ResolversTypes['Organization']>>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleTeamId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeveloperAsSaleUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeveloperAsSaleUser'] = ResolversParentTypes['DeveloperAsSaleUser']> = ResolversObject<{
  __resolveType: TypeResolveFn<'OrganizationUser' | 'SaleTeamUser', ParentType, ContextType>;
}>;

export type FeaturedPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedPortfolio'] = ResolversParentTypes['FeaturedPortfolio']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cardDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coverImageFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  coverImageFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  propertyIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes['FeaturedPortfolioVisibilityEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeaturedPortfolioPropertiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedPortfolioPropertiesPayload'] = ResolversParentTypes['FeaturedPortfolioPropertiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PropertyDetail']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeaturedPortfolioSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedPortfolioSummary'] = ResolversParentTypes['FeaturedPortfolioSummary']> = ResolversObject<{
  completionYearRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  marketAreas?: Resolver<Array<ResolversTypes['MarketAreaCount']>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  propertyCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeaturedPortfoliosPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedPortfoliosPayload'] = ResolversParentTypes['FeaturedPortfoliosPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['FeaturedPortfolio']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeaturedPropertiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedPropertiesPayload'] = ResolversParentTypes['FeaturedPropertiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['FeaturedProperty']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeaturedPropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturedProperty'] = ResolversParentTypes['FeaturedProperty']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coverImageFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  coverImageFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortOverview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes['FeaturedPropertyVisibilityEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FileResolvers<ContextType = any, ParentType extends ResolversParentTypes['File'] = ResolversParentTypes['File']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  copyFromFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  s3Key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumbnailFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  thumbnailFileId?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  thumbnailFileUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FolderPathModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['FolderPathModel'] = ResolversParentTypes['FolderPathModel']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  folderName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateQrCodeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateQrCodeResult'] = ResolversParentTypes['GenerateQrCodeResult']> = ResolversObject<{
  qrCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GeoLocationJsonResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeoLocationJSON'] = ResolversParentTypes['GeoLocationJSON']> = ResolversObject<{
  coordinates?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GetFileDownloadsStatisticItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetFileDownloadsStatisticItem'] = ResolversParentTypes['GetFileDownloadsStatisticItem']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  file?: Resolver<ResolversTypes['File'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GetFileDownloadsStatisticPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetFileDownloadsStatisticPayload'] = ResolversParentTypes['GetFileDownloadsStatisticPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['GetFileDownloadsStatisticItem']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GetIdxFeedListPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetIdxFeedListPayload'] = ResolversParentTypes['GetIdxFeedListPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['IdxFeed']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GuestUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuestUser'] = ResolversParentTypes['GuestUser']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fingerprintHash?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GuestUserPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuestUserPayload'] = ResolversParentTypes['GuestUserPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['GuestUser']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxActivity'] = ResolversParentTypes['IdxActivity']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  idxId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxActivityCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxActivityCollection'] = ResolversParentTypes['IdxActivityCollection']> = ResolversObject<{
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  propertyClicks?: Resolver<Maybe<Array<ResolversTypes['PropertyClick']>>, ParentType, ContextType>;
  totalClicks?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxActivityPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxActivityPayload'] = ResolversParentTypes['IdxActivityPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['IdxActivityCollection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxEmbeddedPortfolioFeedDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxEmbeddedPortfolioFeedData'] = ResolversParentTypes['IdxEmbeddedPortfolioFeedData']> = ResolversObject<{
  idxFeed?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType>;
  idxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxEmbeddedPropertyFeedDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxEmbeddedPropertyFeedData'] = ResolversParentTypes['IdxEmbeddedPropertyFeedData']> = ResolversObject<{
  broker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType>;
  idxFeed?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType>;
  idxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  propertyAmenities?: Resolver<Array<ResolversTypes['Amenity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxEmbeddedSearchBarFeedDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxEmbeddedSearchBarFeedData'] = ResolversParentTypes['IdxEmbeddedSearchBarFeedData']> = ResolversObject<{
  idxFeed?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType>;
  idxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxFeedResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxFeed'] = ResolversParentTypes['IdxFeed']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  cities?: Resolver<Maybe<Array<ResolversTypes['Place']>>, ParentType, ContextType>;
  counties?: Resolver<Maybe<Array<ResolversTypes['Place']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketAreaIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portfolioContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioFolderId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  propertiesPerPage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  searchBarContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showCustomPropertyDownloads?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showPropertyDownloads?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxPortfolioFeedPropertiesDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxPortfolioFeedPropertiesData'] = ResolversParentTypes['IdxPortfolioFeedPropertiesData']> = ResolversObject<{
  broker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType>;
  portfolioFolder?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType>;
  portfolioItemCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  portfolioItems?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxSearchFeedPropertiesDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxSearchFeedPropertiesData'] = ResolversParentTypes['IdxSearchFeedPropertiesData']> = ResolversObject<{
  properties?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdxSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdxSettings'] = ResolversParentTypes['IdxSettings']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  branding?: Resolver<ResolversTypes['Branding'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isWixSite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showDashCredit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websiteDomain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvoiceCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceCoupon'] = ResolversParentTypes['InvoiceCoupon']> = ResolversObject<{
  amountOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percentOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type LocalTimeHoursResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalTimeHours'] = ResolversParentTypes['LocalTimeHours']> = ResolversObject<{
  friday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  monday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  saturday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  sunday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  thursday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  tuesday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  wednesday?: Resolver<Maybe<ResolversTypes['LocalTimeRange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocalTimeRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocalTimeRange'] = ResolversParentTypes['LocalTimeRange']> = ResolversObject<{
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geoLocation?: Resolver<ResolversTypes['GeoLocationJSON'], ParentType, ContextType>;
  googlePlaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketAreaResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketArea'] = ResolversParentTypes['MarketArea']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['State'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketAreaCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketAreaCount'] = ResolversParentTypes['MarketAreaCount']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  marketArea?: Resolver<Maybe<ResolversTypes['MarketArea']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketAreaPlaceOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketAreaPlaceOption'] = ResolversParentTypes['MarketAreaPlaceOption']> = ResolversObject<{
  cityKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  countyKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  marketAreaId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarketAreasPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketAreasPayload'] = ResolversParentTypes['MarketAreasPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['MarketArea']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['Media'] = ResolversParentTypes['Media']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brandingType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Array<ResolversTypes['File']>, ParentType, ContextType>;
  folderName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  foldersPathCollection?: Resolver<Maybe<Array<ResolversTypes['FolderPathModel']>>, ParentType, ContextType>;
  mediaFolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaItemsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  parentMediaFoldersIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sizeInBytes?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  systemFolderType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaFilesAndFoldersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaFilesAndFoldersPayload'] = ResolversParentTypes['MediaFilesAndFoldersPayload']> = ResolversObject<{
  filesCollection?: Resolver<Maybe<Array<ResolversTypes['Media']>>, ParentType, ContextType>;
  filesTotalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  foldersCollection?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType>;
  foldersTotalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaFilesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaFilesPayload'] = ResolversParentTypes['MediaFilesPayload']> = ResolversObject<{
  filesCollection?: Resolver<Maybe<Array<ResolversTypes['Media']>>, ParentType, ContextType>;
  filesTotalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaKitPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaKitPayload'] = ResolversParentTypes['MediaKitPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PortfolioMediaKit']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaObserveSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MediaObserveSubscriptionPayload'] = ResolversParentTypes['MediaObserveSubscriptionPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['Media'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MetricDataPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetricDataPoint'] = ResolversParentTypes['MetricDataPoint']> = ResolversObject<{
  requestCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MfaTempTokenModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['MfaTempTokenModel'] = ResolversParentTypes['MfaTempTokenModel']> = ResolversObject<{
  mfaEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mfaMethod?: Resolver<Maybe<ResolversTypes['MfaMethodsEnum']>, ParentType, ContextType>;
  tempToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MinMaxResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinMax'] = ResolversParentTypes['MinMax']> = ResolversObject<{
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MinMaxRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinMaxRange'] = ResolversParentTypes['MinMaxRange']> = ResolversObject<{
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MinMaxRangePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinMaxRangePayload'] = ResolversParentTypes['MinMaxRangePayload']> = ResolversObject<{
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  abortAllUploads?: Resolver<ResolversTypes['AbortUploadEvent'], ParentType, ContextType>;
  abortUpload?: Resolver<ResolversTypes['AbortUploadEvent'], ParentType, ContextType, RequireFields<MutationAbortUploadArgs, 'progressTrackingId'>>;
  acceptApiInvitation?: Resolver<ResolversTypes['AuthResult'], ParentType, ContextType, RequireFields<MutationAcceptApiInvitationArgs, 'input' | 'token'>>;
  acceptApiInvitationForAccount?: Resolver<ResolversTypes['AuthResult'], ParentType, ContextType, RequireFields<MutationAcceptApiInvitationForAccountArgs, 'token'>>;
  addAllMarketingFilesToPortfolio?: Resolver<Array<ResolversTypes['PortfolioMediaKit']>, ParentType, ContextType, RequireFields<MutationAddAllMarketingFilesToPortfolioArgs, 'portfolioItemId'>>;
  addFeaturedPortfolioToSaved?: Resolver<ResolversTypes['BrokerSavedFeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationAddFeaturedPortfolioToSavedArgs, 'portfolioId'>>;
  addFloorPlanToUnit?: Resolver<ResolversTypes['Unit'], ParentType, ContextType, RequireFields<MutationAddFloorPlanToUnitArgs, 'floorPlanFileId' | 'unitId'>>;
  addNoteToProperty?: Resolver<ResolversTypes['PropertyNote'], ParentType, ContextType, RequireFields<MutationAddNoteToPropertyArgs, 'message' | 'propertyId'>>;
  addPortfolioToComparison?: Resolver<ResolversTypes['Comparison'], ParentType, ContextType, RequireFields<MutationAddPortfolioToComparisonArgs, 'portfolioFolderId' | 'portfolioItemId'>>;
  addPropertiesToPortfolio?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationAddPropertiesToPortfolioArgs, 'portfolioFolderId' | 'propertyIds'>>;
  addPropertyToPortfolio?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationAddPropertyToPortfolioArgs, 'portfolioFolderId' | 'propertyId'>>;
  addPropertyToTrack?: Resolver<ResolversTypes['BrokerTrackedProperty'], ParentType, ContextType, RequireFields<MutationAddPropertyToTrackArgs, 'propertyId'>>;
  addReactionByPortfolioAndProperty?: Resolver<ResolversTypes['PortfolioReaction'], ParentType, ContextType, RequireFields<MutationAddReactionByPortfolioAndPropertyArgs, 'portfolioId' | 'propertyId' | 'reaction'>>;
  addSaleTeamUser?: Resolver<ResolversTypes['SaleTeamUser'], ParentType, ContextType, RequireFields<MutationAddSaleTeamUserArgs, 'input'>>;
  addUserToAPI?: Resolver<ResolversTypes['ApiUser'], ParentType, ContextType, RequireFields<MutationAddUserToApiArgs, 'accountInput' | 'profileInput'>>;
  addUserToCMS?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationAddUserToCmsArgs, 'accountInput' | 'profileInput'>>;
  approveProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationApprovePropertyArgs, 'input'>>;
  archiveBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationArchiveBrokerArgs, 'archivingReason' | 'brokerId'>>;
  archiveCMSUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationArchiveCmsUserArgs, 'archive' | 'cmsUserAccountId'>>;
  archiveProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationArchivePropertyArgs, 'input'>>;
  attachDefaultStripePaymentMethod?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationAttachDefaultStripePaymentMethodArgs, 'stripePaymentMethodId'>>;
  attachStripePaymentMethod?: Resolver<ResolversTypes['StripeAccount'], ParentType, ContextType, RequireFields<MutationAttachStripePaymentMethodArgs, 'stripePaymentMethodId'>>;
  auditProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationAuditPropertyArgs, 'input'>>;
  authorization?: Resolver<ResolversTypes['AuthResult'], ParentType, ContextType, RequireFields<MutationAuthorizationArgs, 'email' | 'password'>>;
  bulkUpdateMediaBrandingType?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<MutationBulkUpdateMediaBrandingTypeArgs, 'brandingType' | 'mediaFilesIds'>>;
  cancelProductSubscription?: Resolver<ResolversTypes['ProductSubscription'], ParentType, ContextType, RequireFields<MutationCancelProductSubscriptionArgs, 'input'>>;
  cancelScheduledDowngrade?: Resolver<ResolversTypes['ProductSubscription'], ParentType, ContextType>;
  changeCurrentProductSubscription?: Resolver<ResolversTypes['ProductSubscriptionPayload'], ParentType, ContextType, RequireFields<MutationChangeCurrentProductSubscriptionArgs, 'input'>>;
  changePortfolioStatus?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationChangePortfolioStatusArgs, 'portfolioId' | 'status'>>;
  changeVerifiedStatusInProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationChangeVerifiedStatusInPropertyArgs, 'isMarkedAsVerified' | 'propertyId'>>;
  copyFeaturedPortfolioToBrokerPortfolio?: Resolver<ResolversTypes['CopyFeaturedPortfolioToBrokerPortfolioResult'], ParentType, ContextType, RequireFields<MutationCopyFeaturedPortfolioToBrokerPortfolioArgs, 'args'>>;
  createAlertConfig?: Resolver<ResolversTypes['BrokerAlertConfig'], ParentType, ContextType, RequireFields<MutationCreateAlertConfigArgs, 'filter' | 'name'>>;
  createAmenity?: Resolver<ResolversTypes['Amenity'], ParentType, ContextType, RequireFields<MutationCreateAmenityArgs, 'input'>>;
  createApiInvitation?: Resolver<ResolversTypes['ApiInvitationSafeDTO'], ParentType, ContextType, RequireFields<MutationCreateApiInvitationArgs, 'input'>>;
  createApiPluginUser?: Resolver<ResolversTypes['ApiCredentialsUserResponse'], ParentType, ContextType, RequireFields<MutationCreateApiPluginUserArgs, 'referralCode'>>;
  createBroker?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationCreateBrokerArgs, 'input'>>;
  createBrokerSSO?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationCreateBrokerSsoArgs, 'input'>>;
  createCheckoutSession?: Resolver<ResolversTypes['CreateCheckoutSessionPayload'], ParentType, ContextType, RequireFields<MutationCreateCheckoutSessionArgs, 'input'>>;
  createFeaturedPortfolio?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationCreateFeaturedPortfolioArgs, 'input'>>;
  createFeaturedProperty?: Resolver<ResolversTypes['FeaturedProperty'], ParentType, ContextType, RequireFields<MutationCreateFeaturedPropertyArgs, 'input'>>;
  createIdxFeed?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType, RequireFields<MutationCreateIdxFeedArgs, 'input'>>;
  createIdxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType, RequireFields<MutationCreateIdxSettingsArgs, 'showDashCredit' | 'websiteDomain'>>;
  createMarketArea?: Resolver<ResolversTypes['MarketArea'], ParentType, ContextType, RequireFields<MutationCreateMarketAreaArgs, 'input'>>;
  createMediaFile?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationCreateMediaFileArgs, 'input'>>;
  createMediaFolder?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationCreateMediaFolderArgs, 'input'>>;
  createOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationCreateOrganizationArgs, 'input'>>;
  createOrganizationUser?: Resolver<ResolversTypes['OrganizationUser'], ParentType, ContextType, RequireFields<MutationCreateOrganizationUserArgs, 'input'>>;
  createPortfolioFolder?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationCreatePortfolioFolderArgs, 'name'>>;
  createProductSubscription?: Resolver<ResolversTypes['ProductSubscriptionPayload'], ParentType, ContextType, RequireFields<MutationCreateProductSubscriptionArgs, 'input'>>;
  createProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationCreatePropertyArgs, 'input'>>;
  createSaleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<MutationCreateSaleTeamArgs, 'input'>>;
  createSimpleBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationCreateSimpleBrokerArgs, 'input'>>;
  createSinglePropertyPortfolio?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationCreateSinglePropertyPortfolioArgs, 'input'>>;
  createUnit?: Resolver<ResolversTypes['Unit'], ParentType, ContextType, RequireFields<MutationCreateUnitArgs, 'input'>>;
  deleteAllBrokerActivities?: Resolver<Array<ResolversTypes['BrokerActivity']>, ParentType, ContextType, RequireFields<MutationDeleteAllBrokerActivitiesArgs, 'activityTypes'>>;
  deleteAmenity?: Resolver<Array<ResolversTypes['Amenity']>, ParentType, ContextType, RequireFields<MutationDeleteAmenityArgs, 'amenityId'>>;
  deleteBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationDeleteBrokerArgs, 'brokerId'>>;
  deleteBrokerActivityById?: Resolver<ResolversTypes['BrokerActivity'], ParentType, ContextType, RequireFields<MutationDeleteBrokerActivityByIdArgs, 'activityId'>>;
  deleteFeaturedPortfolio?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationDeleteFeaturedPortfolioArgs, 'featuredPortfolioId'>>;
  deleteFeaturedProperty?: Resolver<ResolversTypes['FeaturedProperty'], ParentType, ContextType, RequireFields<MutationDeleteFeaturedPropertyArgs, 'featuredPropertyId'>>;
  deleteIdxFeed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteIdxFeedArgs, 'idxFeedId'>>;
  deleteMarketArea?: Resolver<ResolversTypes['MarketArea'], ParentType, ContextType, RequireFields<MutationDeleteMarketAreaArgs, 'marketAreaId'>>;
  deleteMediaFileById?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationDeleteMediaFileByIdArgs, 'mediaId'>>;
  deleteMediaFiles?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<MutationDeleteMediaFilesArgs, 'mediaFilesIds'>>;
  deleteMediaFolderById?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationDeleteMediaFolderByIdArgs, 'mediaId'>>;
  deleteOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationDeleteOrganizationArgs, 'organizationId'>>;
  deleteOrganizationUser?: Resolver<ResolversTypes['OrganizationUser'], ParentType, ContextType, RequireFields<MutationDeleteOrganizationUserArgs, 'organizationUserId'>>;
  deletePortfolioById?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType, RequireFields<MutationDeletePortfolioByIdArgs, 'portfolioId'>>;
  deletePropertiesFromPortfolioByIds?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType, RequireFields<MutationDeletePropertiesFromPortfolioByIdsArgs, 'portfolioFolderId' | 'propertyIds'>>;
  deletePropertyFromPortfolioById?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationDeletePropertyFromPortfolioByIdArgs, 'portfolioFolderId' | 'propertyId'>>;
  deleteSaleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<MutationDeleteSaleTeamArgs, 'saleTeamId'>>;
  deleteSaleTeamUser?: Resolver<ResolversTypes['SaleTeamUser'], ParentType, ContextType, RequireFields<MutationDeleteSaleTeamUserArgs, 'saleTeamId' | 'saleTeamUserId'>>;
  deleteUnit?: Resolver<ResolversTypes['Unit'], ParentType, ContextType, RequireFields<MutationDeleteUnitArgs, 'unitId'>>;
  deleteUserCMS?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationDeleteUserCmsArgs, 'accountId' | 'profileId'>>;
  detachPaymentMethodFromCustomer?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationDetachPaymentMethodFromCustomerArgs, 'stripePaymentMethodId'>>;
  duplicateAmenity?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationDuplicateAmenityArgs, 'amenityId' | 'propertyId'>>;
  duplicateUnit?: Resolver<ResolversTypes['Unit'], ParentType, ContextType, RequireFields<MutationDuplicateUnitArgs, 'unitId'>>;
  editAmenity?: Resolver<ResolversTypes['Amenity'], ParentType, ContextType, RequireFields<MutationEditAmenityArgs, 'input'>>;
  editInternalSaleTeamByOrganizationId?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<MutationEditInternalSaleTeamByOrganizationIdArgs, 'input' | 'organizationId'>>;
  editMarketArea?: Resolver<ResolversTypes['MarketArea'], ParentType, ContextType, RequireFields<MutationEditMarketAreaArgs, 'input'>>;
  editMediaFile?: Resolver<ResolversTypes['File'], ParentType, ContextType, RequireFields<MutationEditMediaFileArgs, 'fileId' | 'input'>>;
  editMediaFolder?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationEditMediaFolderArgs, 'input'>>;
  editOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<MutationEditOrganizationArgs, 'input' | 'organizationId'>>;
  editOrganizationUser?: Resolver<ResolversTypes['OrganizationUser'], ParentType, ContextType, RequireFields<MutationEditOrganizationUserArgs, 'input'>>;
  editPortfolioFolderName?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationEditPortfolioFolderNameArgs, 'name' | 'portfolioFolderId'>>;
  editPropertyNote?: Resolver<ResolversTypes['PropertyNote'], ParentType, ContextType, RequireFields<MutationEditPropertyNoteArgs, 'message' | 'propertyNoteId'>>;
  editSaleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<MutationEditSaleTeamArgs, 'input' | 'saleTeamId'>>;
  editSaleTeamUser?: Resolver<ResolversTypes['SaleTeamUser'], ParentType, ContextType, RequireFields<MutationEditSaleTeamUserArgs, 'input'>>;
  editUnit?: Resolver<ResolversTypes['Unit'], ParentType, ContextType, RequireFields<MutationEditUnitArgs, 'input'>>;
  enableMfa?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationEnableMfaArgs, 'token'>>;
  forgotPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationForgotPasswordArgs, 'email'>>;
  generateMagicLink?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationGenerateMagicLinkArgs, 'email'>>;
  generateNewApiToken?: Resolver<ResolversTypes['TokenResponse'], ParentType, ContextType>;
  getTokenWithMagicLink?: Resolver<ResolversTypes['AuthResult'], ParentType, ContextType>;
  logout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  makeFeaturedPropertyPublic?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationMakeFeaturedPropertyPublicArgs, 'featuredPropertyId' | 'position'>>;
  makePortfolioPublic?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationMakePortfolioPublicArgs, 'featuredPortfolioId' | 'position'>>;
  manuallyRegisterPortfolioView?: Resolver<Maybe<ResolversTypes['ViewHistory']>, ParentType, ContextType, RequireFields<MutationManuallyRegisterPortfolioViewArgs, 'viewedPortfolioId'>>;
  mfaAuthentication?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationMfaAuthenticationArgs, 'token'>>;
  moveMediaInSortOrder?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationMoveMediaInSortOrderArgs, 'sortedMediaIds'>>;
  moveMediaToFolder?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationMoveMediaToFolderArgs, 'mediaFolderId' | 'mediaIds'>>;
  movePortfolios?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationMovePortfoliosArgs, 'portfolioIds'>>;
  orderFeaturedPortfolios?: Resolver<Array<ResolversTypes['FeaturedPortfolio']>, ParentType, ContextType, RequireFields<MutationOrderFeaturedPortfoliosArgs, 'orders'>>;
  orderFeaturedProperties?: Resolver<Array<ResolversTypes['FeaturedProperty']>, ParentType, ContextType, RequireFields<MutationOrderFeaturedPropertiesArgs, 'orders'>>;
  orderPropertiesInPortfolio?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationOrderPropertiesInPortfolioArgs, 'featuredPortfolioId' | 'propertyIds'>>;
  readPropertyNotes?: Resolver<ResolversTypes['PropertyNote'], ParentType, ContextType, RequireFields<MutationReadPropertyNotesArgs, 'propertyNotesIds'>>;
  recordLastTouchAttribution?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRecordLastTouchAttributionArgs, 'attribution'>>;
  refreshTokens?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType>;
  registerBroker?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationRegisterBrokerArgs, 'input'>>;
  registerDeveloperUser?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationRegisterDeveloperUserArgs, 'input' | 'signUpVerificationCode'>>;
  registerIdxActivity?: Resolver<ResolversTypes['IdxActivity'], ParentType, ContextType, RequireFields<MutationRegisterIdxActivityArgs, 'idxId' | 'propertyId'>>;
  removeAlertConfig?: Resolver<ResolversTypes['BrokerAlertConfig'], ParentType, ContextType, RequireFields<MutationRemoveAlertConfigArgs, 'alertConfigId'>>;
  removeAllMarketingFilesFromPortfolio?: Resolver<Array<ResolversTypes['PortfolioMediaKit']>, ParentType, ContextType, RequireFields<MutationRemoveAllMarketingFilesFromPortfolioArgs, 'portfolioItemId'>>;
  removeAmenitiesFromProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationRemoveAmenitiesFromPropertyArgs, 'amenitiesIds' | 'propertyId'>>;
  removeFeaturedPortfolioFromSaved?: Resolver<ResolversTypes['BrokerSavedFeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationRemoveFeaturedPortfolioFromSavedArgs, 'brokerSavedFeaturedPortfolioId'>>;
  removePropertyById?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemovePropertyByIdArgs, 'propertyId'>>;
  removePropertyFromTracked?: Resolver<ResolversTypes['BrokerTrackedProperty'], ParentType, ContextType, RequireFields<MutationRemovePropertyFromTrackedArgs, 'brokerTrackedPropertyId'>>;
  removePropertyNote?: Resolver<ResolversTypes['PropertyNote'], ParentType, ContextType, RequireFields<MutationRemovePropertyNoteArgs, 'propertyNoteId'>>;
  renewProductSubscription?: Resolver<ResolversTypes['ProductSubscriptionPayload'], ParentType, ContextType>;
  resetCmsSettingsToDefaults?: Resolver<ResolversTypes['CmsSettings'], ParentType, ContextType>;
  resetPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationResetPasswordArgs, 'newPassword'>>;
  retryProductSubscriptionCharge?: Resolver<ResolversTypes['ProductSubscriptionPayload'], ParentType, ContextType>;
  revokeApiInvitation?: Resolver<ResolversTypes['ApiInvitationSafeDTO'], ParentType, ContextType, RequireFields<MutationRevokeApiInvitationArgs, 'invitationId'>>;
  scheduleDowngrade?: Resolver<ResolversTypes['SubscriptionSchedule'], ParentType, ContextType, RequireFields<MutationScheduleDowngradeArgs, 'input'>>;
  sendEmailVerificationCode?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  sendMessageToAgent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendMessageToAgentArgs, 'input'>>;
  sendMfaEmailCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sendRegistrationLinkToDeveloper?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendRegistrationLinkToDeveloperArgs, 'accountId'>>;
  sendVerificationCode?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationSendVerificationCodeArgs, 'phone'>>;
  setAdvancedPropertyDetails?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationSetAdvancedPropertyDetailsArgs, 'input'>>;
  setAmenitiesToProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationSetAmenitiesToPropertyArgs, 'input'>>;
  setAmenityNameInProperty?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationSetAmenityNameInPropertyArgs, 'amenityId' | 'isPrimary' | 'name' | 'propertyId'>>;
  setApiCredentialAdminDisabled?: Resolver<ResolversTypes['ApiCredentialSafeDTO'], ParentType, ContextType, RequireFields<MutationSetApiCredentialAdminDisabledArgs, 'adminDisabled' | 'apiCredentialsId'>>;
  setApiCredentialMonthlyRequestLimit?: Resolver<ResolversTypes['ApiCredentialSafeDTO'], ParentType, ContextType, RequireFields<MutationSetApiCredentialMonthlyRequestLimitArgs, 'apiCredentialsId'>>;
  setBrokerShowAllBillingPlans?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationSetBrokerShowAllBillingPlansArgs, 'brokerId' | 'showAllBillingPlans'>>;
  setGeneralPropertyDetails?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationSetGeneralPropertyDetailsArgs, 'input'>>;
  setGuestUserData?: Resolver<ResolversTypes['GuestUser'], ParentType, ContextType, Partial<MutationSetGuestUserDataArgs>>;
  setHiddenStateToAlertItem?: Resolver<ResolversTypes['BrokerAlertItem'], ParentType, ContextType, RequireFields<MutationSetHiddenStateToAlertItemArgs, 'alertItemId' | 'isHidden'>>;
  setMyPluginUserDisabled?: Resolver<ResolversTypes['ApiCredentialSafeDTO'], ParentType, ContextType, RequireFields<MutationSetMyPluginUserDisabledArgs, 'apiCredentialsId' | 'disabled'>>;
  setOrganizationUserStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetOrganizationUserStatusArgs, 'organizationUserId' | 'status'>>;
  setPortfolioMediaKitMedia?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetPortfolioMediaKitMediaArgs, 'input'>>;
  setPropertyStatus?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationSetPropertyStatusArgs, 'input'>>;
  setSaleTeamUserStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetSaleTeamUserStatusArgs, 'saleTeamUserId' | 'status'>>;
  switchAccountType?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationSwitchAccountTypeArgs, 'input'>>;
  temporaryAuthentication?: Resolver<ResolversTypes['TempAuthResult'], ParentType, ContextType, RequireFields<MutationTemporaryAuthenticationArgs, 'email' | 'password'>>;
  toggleChangelogVisibility?: Resolver<ResolversTypes['PropertyChangelog'], ParentType, ContextType, RequireFields<MutationToggleChangelogVisibilityArgs, 'input'>>;
  unarchiveBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationUnarchiveBrokerArgs, 'brokerId'>>;
  updateAccountLanguage?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationUpdateAccountLanguageArgs, 'language'>>;
  updateAlertConfig?: Resolver<ResolversTypes['BrokerAlertConfig'], ParentType, ContextType, RequireFields<MutationUpdateAlertConfigArgs, 'alertConfigId' | 'filter' | 'name'>>;
  updateBrandedFilesReady?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationUpdateBrandedFilesReadyArgs, 'input'>>;
  updateBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationUpdateBrokerArgs, 'brokerId' | 'input'>>;
  updateBrokerLicenseStatus?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationUpdateBrokerLicenseStatusArgs, 'brokerId' | 'input'>>;
  updateCmsSettings?: Resolver<ResolversTypes['CmsSettings'], ParentType, ContextType, RequireFields<MutationUpdateCmsSettingsArgs, 'input'>>;
  updateCmsStatus?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<MutationUpdateCmsStatusArgs, 'input'>>;
  updateCurrentBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<MutationUpdateCurrentBrokerArgs, 'input'>>;
  updateCurrentUser?: Resolver<ResolversTypes['Profile'], ParentType, ContextType, RequireFields<MutationUpdateCurrentUserArgs, 'profileInput'>>;
  updateEmail?: Resolver<ResolversTypes['TokensModel'], ParentType, ContextType, RequireFields<MutationUpdateEmailArgs, 'newEmail' | 'password'>>;
  updateFeaturedPortfolio?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<MutationUpdateFeaturedPortfolioArgs, 'featuredPortfolioId' | 'input'>>;
  updateFeaturedProperty?: Resolver<ResolversTypes['FeaturedProperty'], ParentType, ContextType, RequireFields<MutationUpdateFeaturedPropertyArgs, 'featuredPropertyId' | 'input'>>;
  updateIdxFeed?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType, RequireFields<MutationUpdateIdxFeedArgs, 'input'>>;
  updateIdxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType, RequireFields<MutationUpdateIdxSettingsArgs, 'input'>>;
  updateMediaBrandingType?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<MutationUpdateMediaBrandingTypeArgs, 'brandingType' | 'mediaId'>>;
  updatePassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdatePasswordArgs, 'newPassword' | 'oldPassword'>>;
  updatePortfolioLocations?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationUpdatePortfolioLocationsArgs, 'locations' | 'portfolioFolderId'>>;
  updatePortfolioPassword?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationUpdatePortfolioPasswordArgs, 'password' | 'portfolioId'>>;
  updatePortfolioSettings?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationUpdatePortfolioSettingsArgs, 'portfolioId'>>;
  updateSSOId?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationUpdateSsoIdArgs, 'ssoId'>>;
  updateShowPopupOnPortfolio?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<MutationUpdateShowPopupOnPortfolioArgs, 'portfolioId' | 'showPopup'>>;
  updateUserAPI?: Resolver<ResolversTypes['ApiUser'], ParentType, ContextType, RequireFields<MutationUpdateUserApiArgs, 'accountUpdateInput' | 'profileInput'>>;
  updateUserCMS?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateUserCmsArgs, 'accountUpdateInput' | 'profileInput'>>;
  uploadDraftFile?: Resolver<ResolversTypes['File'], ParentType, ContextType, RequireFields<MutationUploadDraftFileArgs, 'input'>>;
  upsertComparison?: Resolver<ResolversTypes['Comparison'], ParentType, ContextType, RequireFields<MutationUpsertComparisonArgs, 'fieldsToCompare' | 'portfolioFolderId' | 'portfolioIds'>>;
  validateCoupon?: Resolver<ResolversTypes['ValidateCouponPayload'], ParentType, ContextType, RequireFields<MutationValidateCouponArgs, 'args'>>;
  validatePhoneNumber?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationValidatePhoneNumberArgs, 'code'>>;
  verifyPhoneNumberAndUpdateAccount?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<MutationVerifyPhoneNumberAndUpdateAccountArgs, 'code' | 'phone'>>;
}>;

export type NewPortfolioItemActivitiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewPortfolioItemActivitiesPayload'] = ResolversParentTypes['NewPortfolioItemActivitiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['NewPortfolioItemActivity']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NewPortfolioItemActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewPortfolioItemActivity'] = ResolversParentTypes['NewPortfolioItemActivity']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityDoc?: Resolver<ResolversTypes['NewPortfolioItemActivityDoc'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioItem?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NewPortfolioItemActivityDocResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewPortfolioItemActivityDoc'] = ResolversParentTypes['NewPortfolioItemActivityDoc']> = ResolversObject<{
  portfolioItemId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface ObjectIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ObjectId'], any> {
  name: 'ObjectId';
}

export type ObserveAccountPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObserveAccountPayload'] = ResolversParentTypes['ObserveAccountPayload']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ObserveBrokerAlertItemsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObserveBrokerAlertItemsPayload'] = ResolversParentTypes['ObserveBrokerAlertItemsPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['BrokerAlertItem'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ObserveBrokerPortfolioPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObserveBrokerPortfolioPayload'] = ResolversParentTypes['ObserveBrokerPortfolioPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ObserveProgressTrackingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObserveProgressTrackingPayload'] = ResolversParentTypes['ObserveProgressTrackingPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['ProgressTrackingModel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ObservePropertyNotesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObservePropertyNotesPayload'] = ResolversParentTypes['ObservePropertyNotesPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['PropertyNote'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ObservePropertyPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObservePropertyPayload'] = ResolversParentTypes['ObservePropertyPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  internalSaleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  locationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  logoFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertiesCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationUser'] = ResolversParentTypes['OrganizationUser']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assignedPropertiesIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  internalSaleTeamId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleTeamRole?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType>;
  saleTeamRoleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationUsersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationUsersPayload'] = ResolversParentTypes['OrganizationUsersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['OrganizationUser']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationsPayload'] = ResolversParentTypes['OrganizationsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PhoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['Phone'] = ResolversParentTypes['Phone']> = ResolversObject<{
  dialCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Place'] = ResolversParentTypes['Place']> = ResolversObject<{
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlaceOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaceOption'] = ResolversParentTypes['PlaceOption']> = ResolversObject<{
  cityKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  countyKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlaceOptionsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaceOptionsPayload'] = ResolversParentTypes['PlaceOptionsPayload']> = ResolversObject<{
  cities?: Resolver<Array<ResolversTypes['PlaceOption']>, ParentType, ContextType>;
  counties?: Resolver<Array<ResolversTypes['PlaceOption']>, ParentType, ContextType>;
  marketAreas?: Resolver<Array<ResolversTypes['MarketAreaPlaceOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['Portfolio'] = ResolversParentTypes['Portfolio']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAddedMediaKit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isParentRoot?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  locations?: Resolver<Maybe<ResolversTypes['PortfolioLocations']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioFolder?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  portfolioFolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioPropertiesIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['Property']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reactions?: Resolver<ResolversTypes['BrokerReactionsStats'], ParentType, ContextType>;
  reactionsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  showPopup?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  withPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioFolderItemsGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioFolderItemsGroup'] = ResolversParentTypes['PortfolioFolderItemsGroup']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  folderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioLocationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioLocations'] = ResolversParentTypes['PortfolioLocations']> = ResolversObject<{
  cities?: Resolver<Array<ResolversTypes['Place']>, ParentType, ContextType>;
  counties?: Resolver<Array<ResolversTypes['Place']>, ParentType, ContextType>;
  marketAreaIds?: Resolver<Array<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioMediaKitResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioMediaKit'] = ResolversParentTypes['PortfolioMediaKit']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAddedToMediaKit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  media?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  mediaId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  portfolioId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioReactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioReaction'] = ResolversParentTypes['PortfolioReaction']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guestUser?: Resolver<ResolversTypes['GuestUser'], ParentType, ContextType>;
  guestUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portfolioId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reaction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfolioTreeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioTree'] = ResolversParentTypes['PortfolioTree']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAddedMediaKit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isParentRoot?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioFolder?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  portfolioFolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioPropertiesIds?: Resolver<Maybe<Array<ResolversTypes['ObjectId']>>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['Property']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reactions?: Resolver<ResolversTypes['BrokerReactionsStats'], ParentType, ContextType>;
  reactionsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  showPopup?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  withPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfoliosPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfoliosPayload'] = ResolversParentTypes['PortfoliosPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfoliosTreePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfoliosTreePayload'] = ResolversParentTypes['PortfoliosTreePayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PortfolioTree']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PreferredPropertySettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreferredPropertySettings'] = ResolversParentTypes['PreferredPropertySettings']> = ResolversObject<{
  buildingTypes?: Resolver<Maybe<Array<ResolversTypes['BuildingTypesEnum']>>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  locationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  radiusInMiles?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PreviewInvoiceItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviewInvoiceItem'] = ResolversParentTypes['PreviewInvoiceItem']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PreviewInvoicePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviewInvoicePayload'] = ResolversParentTypes['PreviewInvoicePayload']> = ResolversObject<{
  amountDue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  coupon?: Resolver<Maybe<ResolversTypes['InvoiceCoupon']>, ParentType, ContextType>;
  dueDateMillis?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['PreviewInvoiceItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSubscription'] = ResolversParentTypes['ProductSubscription']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancelationReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentPeriodEndAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  currentPeriodStartAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downgradeTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  otherReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schedule?: Resolver<Maybe<ResolversTypes['SubscriptionSchedule']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripeSubscriptionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionInactiveAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  subscriptionProduct?: Resolver<ResolversTypes['SubscriptionProduct'], ParentType, ContextType>;
  subscriptionProductId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trialEndAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  trialStartAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSubscriptionPayload'] = ResolversParentTypes['ProductSubscriptionPayload']> = ResolversObject<{
  productSubscription?: Resolver<ResolversTypes['ProductSubscription'], ParentType, ContextType>;
  productSubscriptionPayment?: Resolver<Maybe<ResolversTypes['ProductSubscriptionPayment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductSubscriptionPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSubscriptionPayment'] = ResolversParentTypes['ProductSubscriptionPayment']> = ResolversObject<{
  clientSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductSubscriptionsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSubscriptionsPayload'] = ResolversParentTypes['ProductSubscriptionsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ProductSubscription']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductsSubscriptionsObserveSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductsSubscriptionsObserveSubscriptionPayload'] = ResolversParentTypes['ProductsSubscriptionsObserveSubscriptionPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['ProductSubscription'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['Profile'] = ResolversParentTypes['Profile']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  avatarFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  avatarFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProgressTrackingModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProgressTrackingModel'] = ResolversParentTypes['ProgressTrackingModel']> = ResolversObject<{
  expectedOperations?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  operation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  progressTrackingId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertiesPayload'] = ResolversParentTypes['PropertiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Property']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Property'] = ResolversParentTypes['Property']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amenities?: Resolver<Array<ResolversTypes['Amenity']>, ParentType, ContextType>;
  amenityIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  amenityNames?: Resolver<Maybe<Array<ResolversTypes['AmenityName']>>, ParentType, ContextType>;
  availableUnitsNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  averageBathroomsNumber?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  averageBathroomsNumberValue?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  averageBedroomsNumber?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  averageBedroomsNumberValue?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType>;
  brandedFilesReady?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  buildingTypes?: Resolver<Array<ResolversTypes['BuildingTypesEnum']>, ParentType, ContextType>;
  cheapestUnit?: Resolver<Maybe<ResolversTypes['Unit']>, ParentType, ContextType>;
  cmsStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cmsStatusUpdatedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  comingSoon?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  completionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  constructionStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  contactEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactPhone?: Resolver<Maybe<ResolversTypes['ContactPhone']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultInventoryDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstPublicStatusDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  hasChangelog?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasUnreadNotes?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  interiorDesigner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isMarkedAsVerified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRestricted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  landscapeArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastChangelogType?: Resolver<Maybe<ResolversTypes['PropertyChangelogTypesEnum']>, ParentType, ContextType>;
  lastUpdatedAtByChangelog?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  leadArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>;
  locationId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  mainPropertyMediaFile?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  mainPropertyMediaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  market?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketArea?: Resolver<Maybe<ResolversTypes['MarketArea']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numberOfTowers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfUnits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organizationIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  organizations?: Resolver<Maybe<Array<ResolversTypes['Organization']>>, ParentType, ContextType>;
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  primaryOrganization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType>;
  primaryOrganizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  propertyTags?: Resolver<Maybe<Array<ResolversTypes['PropertyTagsEnum']>>, ParentType, ContextType>;
  rootMediaFolderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleTeams?: Resolver<Maybe<Array<ResolversTypes['PropertySaleTeam']>>, ParentType, ContextType>;
  salesGalleryAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesGalleryHours?: Resolver<Maybe<ResolversTypes['LocalTimeHours']>, ParentType, ContextType>;
  salesGalleryStatus?: Resolver<Maybe<ResolversTypes['SalesGalleryStatusesEnum']>, ParentType, ContextType>;
  slideshowMedia?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType>;
  slideshowMediaFolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stories?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  taxInformation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['PropertyTransactionTypesEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verifiedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  virtualTourLinks?: Resolver<Maybe<Array<ResolversTypes['VirtualTourLink']>>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workingHours?: Resolver<Maybe<ResolversTypes['WorkingHours']>, ParentType, ContextType>;
  yearBuilt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyAboutChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyAboutChangelog'] = ResolversParentTypes['PropertyAboutChangelog']> = ResolversObject<{
  projectDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyAdditionalInformationChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyAdditionalInformationChangelog'] = ResolversParentTypes['PropertyAdditionalInformationChangelog']> = ResolversObject<{
  buildingTypes?: Resolver<Array<ResolversTypes['BuildingTypesEnum']>, ParentType, ContextType>;
  completionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  constructionStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  numberOfTowers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfUnits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  projectStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  propertyTags?: Resolver<Maybe<Array<ResolversTypes['PropertyTagsEnum']>>, ParentType, ContextType>;
  salesGalleryAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesGalleryHours?: Resolver<Maybe<ResolversTypes['LocalTimeHours']>, ParentType, ContextType>;
  salesGalleryStatus?: Resolver<Maybe<ResolversTypes['SalesGalleryStatusesEnum']>, ParentType, ContextType>;
  stories?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  transactionType?: Resolver<Maybe<ResolversTypes['PropertyTransactionTypesEnum']>, ParentType, ContextType>;
  yearBuilt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyChangelog'] = ResolversParentTypes['PropertyChangelog']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  afterUpdate?: Resolver<ResolversTypes['ChangelogDocument'], ParentType, ContextType>;
  beforeUpdate?: Resolver<Maybe<ResolversTypes['ChangelogDocument']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isHidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyChangelogsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyChangelogsPayload'] = ResolversParentTypes['PropertyChangelogsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PropertyChangelog']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyClickResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyClick'] = ResolversParentTypes['PropertyClick']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clickCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyDataReviewedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyDataReviewedChangelog'] = ResolversParentTypes['PropertyDataReviewedChangelog']> = ResolversObject<{
  reviewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyDetail'] = ResolversParentTypes['PropertyDetail']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  averageBathroomsNumber?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  averageBedroomsNumber?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  completionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  mainPropertyMediaFile?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  marketArea?: Resolver<Maybe<ResolversTypes['MarketArea']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  projectStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yearBuilt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyDeveloperOrganizationChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyDeveloperOrganizationChangelog'] = ResolversParentTypes['PropertyDeveloperOrganizationChangelog']> = ResolversObject<{
  interiorDesigner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  landscapeArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  leadArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localArchitect?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoFileId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyFeaturesAndAmenitiesChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyFeaturesAndAmenitiesChangelog'] = ResolversParentTypes['PropertyFeaturesAndAmenitiesChangelog']> = ResolversObject<{
  amenityIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  amenityNames?: Resolver<Maybe<Array<ResolversTypes['AmenityName']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyHighlightsChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyHighlightsChangelog'] = ResolversParentTypes['PropertyHighlightsChangelog']> = ResolversObject<{
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyInventoryUnitAddedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyInventoryUnitAddedChangelog'] = ResolversParentTypes['PropertyInventoryUnitAddedChangelog']> = ResolversObject<{
  newUnitId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyInventoryUnitRemovedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyInventoryUnitRemovedChangelog'] = ResolversParentTypes['PropertyInventoryUnitRemovedChangelog']> = ResolversObject<{
  removedUnitId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyInventoryUnitUpdatedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyInventoryUnitUpdatedChangelog'] = ResolversParentTypes['PropertyInventoryUnitUpdatedChangelog']> = ResolversObject<{
  averageBathroomsNumber?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageBedroomsNumber?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageExteriorSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageInteriorSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageTotalSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  floorPlanFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highestPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  inventoryType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startingPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyLocationChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyLocationChangelog'] = ResolversParentTypes['PropertyLocationChangelog']> = ResolversObject<{
  address?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyMediaFilesMovedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyMediaFilesMovedChangelog'] = ResolversParentTypes['PropertyMediaFilesMovedChangelog']> = ResolversObject<{
  mediaFilesIds?: Resolver<Array<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  mediaFolderId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyMediaRemovedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyMediaRemovedChangelog'] = ResolversParentTypes['PropertyMediaRemovedChangelog']> = ResolversObject<{
  removedMediaIds?: Resolver<Array<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyMediaRenamedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyMediaRenamedChangelog'] = ResolversParentTypes['PropertyMediaRenamedChangelog']> = ResolversObject<{
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyMediaUploadedChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyMediaUploadedChangelog'] = ResolversParentTypes['PropertyMediaUploadedChangelog']> = ResolversObject<{
  folderName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediaFolderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadedMediaId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyNameChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyNameChangelog'] = ResolversParentTypes['PropertyNameChangelog']> = ResolversObject<{
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyNote'] = ResolversParentTypes['PropertyNote']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  attachedFiles?: Resolver<Maybe<Array<ResolversTypes['File']>>, ParentType, ContextType>;
  attachedFilesIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  authorAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  authorProfile?: Resolver<Maybe<ResolversTypes['Profile']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readBy?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyNotesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyNotesPayload'] = ResolversParentTypes['PropertyNotesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PropertyNote']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyOrganizationSalesTeamsChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyOrganizationSalesTeamsChangelog'] = ResolversParentTypes['PropertyOrganizationSalesTeamsChangelog']> = ResolversObject<{
  saleTeams?: Resolver<Maybe<Array<ResolversTypes['PropertySaleTeam']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyPriceChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyPriceChangelog'] = ResolversParentTypes['PropertyPriceChangelog']> = ResolversObject<{
  priceRange?: Resolver<Maybe<ResolversTypes['MinMax']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertySaleTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertySaleTeam'] = ResolversParentTypes['PropertySaleTeam']> = ResolversObject<{
  commission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contactUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleAssociateIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  saleAssociates?: Resolver<Maybe<Array<ResolversTypes['DeveloperAsSaleUser']>>, ParentType, ContextType>;
  saleDirector?: Resolver<Maybe<ResolversTypes['DeveloperAsSaleUser']>, ParentType, ContextType>;
  saleDirectorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType>;
  saleTeamId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertySummary'] = ResolversParentTypes['PropertySummary']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyVirtualToursChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyVirtualToursChangelog'] = ResolversParentTypes['PropertyVirtualToursChangelog']> = ResolversObject<{
  virtualTourLinks?: Resolver<Array<ResolversTypes['VirtualTourLink']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyVisitActivitiesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyVisitActivitiesPayload'] = ResolversParentTypes['PropertyVisitActivitiesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['PropertyVisitActivity']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyVisitActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyVisitActivity'] = ResolversParentTypes['PropertyVisitActivity']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  activityDoc?: Resolver<ResolversTypes['PropertyVisitActivityDoc'], ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  property?: Resolver<ResolversTypes['Property'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyVisitActivityDocResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyVisitActivityDoc'] = ResolversParentTypes['PropertyVisitActivityDoc']> = ResolversObject<{
  propertyId?: Resolver<ResolversTypes['ObjectId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PropertyWebsiteChangelogResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyWebsiteChangelog'] = ResolversParentTypes['PropertyWebsiteChangelog']> = ResolversObject<{
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  apiInvitations?: Resolver<ResolversTypes['ApiInvitationsPayload'], ParentType, ContextType, Partial<QueryApiInvitationsArgs>>;
  canUserTrialForProduct?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryCanUserTrialForProductArgs, 'input'>>;
  checkIfPortfolioHasMediaKit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryCheckIfPortfolioHasMediaKitArgs, 'portfolioId'>>;
  countPropertiesInPlaces?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryCountPropertiesInPlacesArgs, 'input'>>;
  currentBrokerHasAlertConfigs?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  currentBrokerHasPortfolios?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  downloadPropertiesXml?: Resolver<ResolversTypes['XmlDownloadResponse'], ParentType, ContextType>;
  generateMfaQrCode?: Resolver<ResolversTypes['GenerateQrCodeResult'], ParentType, ContextType>;
  getAccount?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  getAccountBySignUpVerificationCode?: Resolver<ResolversTypes['Account'], ParentType, ContextType, RequireFields<QueryGetAccountBySignUpVerificationCodeArgs, 'signUpVerificationCode'>>;
  getAlertConfigById?: Resolver<ResolversTypes['BrokerAlertConfig'], ParentType, ContextType, RequireFields<QueryGetAlertConfigByIdArgs, 'alertConfigId'>>;
  getAlertConfigs?: Resolver<ResolversTypes['BrokerAlertConfigPayload'], ParentType, ContextType, Partial<QueryGetAlertConfigsArgs>>;
  getAlertItems?: Resolver<ResolversTypes['BrokerAlertItemPayload'], ParentType, ContextType, Partial<QueryGetAlertItemsArgs>>;
  getAllFilesInProperty?: Resolver<ResolversTypes['MediaFilesAndFoldersPayload'], ParentType, ContextType, RequireFields<QueryGetAllFilesInPropertyArgs, 'filter'>>;
  getAllFilesInPropertyPreview?: Resolver<ResolversTypes['MediaFilesAndFoldersPayload'], ParentType, ContextType, RequireFields<QueryGetAllFilesInPropertyPreviewArgs, 'filter'>>;
  getAllFoldersInProperty?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<QueryGetAllFoldersInPropertyArgs, 'excludeSlideshowFolder' | 'includeRootFolder' | 'propertyId'>>;
  getAllPortfolioFolders?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  getAllPropertyChangelogs?: Resolver<ResolversTypes['PropertyChangelogsPayload'], ParentType, ContextType, RequireFields<QueryGetAllPropertyChangelogsArgs, 'filter'>>;
  getAmenities?: Resolver<ResolversTypes['AmenitiesPayload'], ParentType, ContextType, Partial<QueryGetAmenitiesArgs>>;
  getAmenitiesForManage?: Resolver<ResolversTypes['AmenitiesPayload'], ParentType, ContextType, RequireFields<QueryGetAmenitiesForManageArgs, 'filter'>>;
  getApiCredentialsBasicInfo?: Resolver<Maybe<ResolversTypes['BasicInfoResponse']>, ParentType, ContextType>;
  getApiCredentialsById?: Resolver<ResolversTypes['ApiCredentialSafeDTO'], ParentType, ContextType, RequireFields<QueryGetApiCredentialsByIdArgs, 'apiCredentialsId'>>;
  getApiPluginUsers?: Resolver<ResolversTypes['ApiPluginUsersPayload'], ParentType, ContextType, Partial<QueryGetApiPluginUsersArgs>>;
  getApiQuotaStatusByAppId?: Resolver<ResolversTypes['ApiQuotaStatusPayload'], ParentType, ContextType, RequireFields<QueryGetApiQuotaStatusByAppIdArgs, 'appId'>>;
  getApiUsers?: Resolver<ResolversTypes['ApiUsersPayload'], ParentType, ContextType, Partial<QueryGetApiUsersArgs>>;
  getBrokerById?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<QueryGetBrokerByIdArgs, 'brokerId'>>;
  getBrokerForAccountManagement?: Resolver<ResolversTypes['Broker'], ParentType, ContextType>;
  getBrokerGuestUser?: Resolver<ResolversTypes['GuestUserPayload'], ParentType, ContextType, Partial<QueryGetBrokerGuestUserArgs>>;
  getBrokerNewPortfolioItemActivities?: Resolver<ResolversTypes['NewPortfolioItemActivitiesPayload'], ParentType, ContextType, Partial<QueryGetBrokerNewPortfolioItemActivitiesArgs>>;
  getBrokerProperties?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType, Partial<QueryGetBrokerPropertiesArgs>>;
  getBrokerViewedPortfolios?: Resolver<ResolversTypes['ViewHistoryPayload'], ParentType, ContextType, Partial<QueryGetBrokerViewedPortfoliosArgs>>;
  getBrokers?: Resolver<ResolversTypes['BrokersPayload'], ParentType, ContextType, Partial<QueryGetBrokersArgs>>;
  getCMSUsers?: Resolver<ResolversTypes['UsersPayload'], ParentType, ContextType, Partial<QueryGetCmsUsersArgs>>;
  getCheckoutSessionDetails?: Resolver<ResolversTypes['CheckoutSessionDetails'], ParentType, ContextType, RequireFields<QueryGetCheckoutSessionDetailsArgs, 'sessionId'>>;
  getCmsSettings?: Resolver<ResolversTypes['CmsSettings'], ParentType, ContextType>;
  getCompanyOwnApiQuotaStatus?: Resolver<ResolversTypes['ApiQuotaStatusPayload'], ParentType, ContextType>;
  getCompanyOwnMonthlyApiUsage?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryGetCompanyOwnMonthlyApiUsageArgs, 'targetMonth'>>;
  getCompanyOwnTotalApiUsage?: Resolver<ResolversTypes['ApiMetricPayload'], ParentType, ContextType, Partial<QueryGetCompanyOwnTotalApiUsageArgs>>;
  getComparison?: Resolver<Maybe<ResolversTypes['Comparison']>, ParentType, ContextType, RequireFields<QueryGetComparisonArgs, 'portfolioFolderId'>>;
  getCurrentAccountProductSubscription?: Resolver<Maybe<ResolversTypes['ProductSubscription']>, ParentType, ContextType>;
  getCurrentAccountTrialProductSubscriptions?: Resolver<Maybe<ResolversTypes['ProductSubscriptionsPayload']>, ParentType, ContextType>;
  getCurrentBroker?: Resolver<ResolversTypes['Broker'], ParentType, ContextType>;
  getCurrentDeveloperProperties?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType, Partial<QueryGetCurrentDeveloperPropertiesArgs>>;
  getCurrentDeveloperUser?: Resolver<ResolversTypes['Developer'], ParentType, ContextType>;
  getCurrentStripeAccount?: Resolver<Maybe<ResolversTypes['StripeAccount']>, ParentType, ContextType>;
  getCurrentStripeAccountTransactions?: Resolver<ResolversTypes['StripeAccountTransactionsFlatPayload'], ParentType, ContextType, Partial<QueryGetCurrentStripeAccountTransactionsArgs>>;
  getDevelopersAsSaleUsersBySaleTeamAndRole?: Resolver<Array<ResolversTypes['DeveloperAsSaleUser']>, ParentType, ContextType, RequireFields<QueryGetDevelopersAsSaleUsersBySaleTeamAndRoleArgs, 'saleTeamId'>>;
  getExternalSaleTeamByIdForDeveloper?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<QueryGetExternalSaleTeamByIdForDeveloperArgs, 'saleTeamId'>>;
  getExternalSaleTeamsForDeveloper?: Resolver<ResolversTypes['SaleTeamsPayload'], ParentType, ContextType, Partial<QueryGetExternalSaleTeamsForDeveloperArgs>>;
  getFeaturedPortfolioById?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioByIdArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioByIdPublic?: Resolver<ResolversTypes['FeaturedPortfolio'], ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioByIdPublicArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioMarketAreas?: Resolver<Array<ResolversTypes['MarketAreaCount']>, ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioMarketAreasArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioMarketAreasPublic?: Resolver<Array<ResolversTypes['MarketAreaCount']>, ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioMarketAreasPublicArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioProperties?: Resolver<ResolversTypes['FeaturedPortfolioPropertiesPayload'], ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioPropertiesArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioPropertiesAdmin?: Resolver<Array<ResolversTypes['PropertySummary']>, ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioPropertiesAdminArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioPropertiesPublic?: Resolver<ResolversTypes['FeaturedPortfolioPropertiesPayload'], ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioPropertiesPublicArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioSummary?: Resolver<Maybe<ResolversTypes['FeaturedPortfolioSummary']>, ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioSummaryArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolioSummaryPublic?: Resolver<Maybe<ResolversTypes['FeaturedPortfolioSummary']>, ParentType, ContextType, RequireFields<QueryGetFeaturedPortfolioSummaryPublicArgs, 'featuredPortfolioId'>>;
  getFeaturedPortfolios?: Resolver<ResolversTypes['FeaturedPortfoliosPayload'], ParentType, ContextType, Partial<QueryGetFeaturedPortfoliosArgs>>;
  getFeaturedProperties?: Resolver<ResolversTypes['FeaturedPropertiesPayload'], ParentType, ContextType, Partial<QueryGetFeaturedPropertiesArgs>>;
  getFeaturedPropertyById?: Resolver<ResolversTypes['FeaturedProperty'], ParentType, ContextType, RequireFields<QueryGetFeaturedPropertyByIdArgs, 'featuredPropertyId'>>;
  getFileDownloadsStatistic?: Resolver<ResolversTypes['GetFileDownloadsStatisticPayload'], ParentType, ContextType, Partial<QueryGetFileDownloadsStatisticArgs>>;
  getFoldersPathOfMedia?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetFoldersPathOfMediaArgs, 'mediaId'>>;
  getGuestUserReactionsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryGetGuestUserReactionsCountArgs, 'filter'>>;
  getIdxActivity?: Resolver<ResolversTypes['IdxActivityPayload'], ParentType, ContextType, RequireFields<QueryGetIdxActivityArgs, 'idxId'>>;
  getIdxEmbeddedPortfolioFeed?: Resolver<ResolversTypes['IdxEmbeddedPortfolioFeedData'], ParentType, ContextType, RequireFields<QueryGetIdxEmbeddedPortfolioFeedArgs, 'input'>>;
  getIdxEmbeddedPropertyFeed?: Resolver<ResolversTypes['IdxEmbeddedPropertyFeedData'], ParentType, ContextType, RequireFields<QueryGetIdxEmbeddedPropertyFeedArgs, 'input'>>;
  getIdxEmbeddedSearchBarFeed?: Resolver<ResolversTypes['IdxEmbeddedSearchBarFeedData'], ParentType, ContextType, RequireFields<QueryGetIdxEmbeddedSearchBarFeedArgs, 'input'>>;
  getIdxFeedDetails?: Resolver<ResolversTypes['IdxFeed'], ParentType, ContextType, Partial<QueryGetIdxFeedDetailsArgs>>;
  getIdxFeedList?: Resolver<ResolversTypes['GetIdxFeedListPayload'], ParentType, ContextType, RequireFields<QueryGetIdxFeedListArgs, 'input'>>;
  getIdxPortfolioFeedProperties?: Resolver<ResolversTypes['IdxPortfolioFeedPropertiesData'], ParentType, ContextType, RequireFields<QueryGetIdxPortfolioFeedPropertiesArgs, 'input'>>;
  getIdxPropertyFiles?: Resolver<ResolversTypes['MediaFilesPayload'], ParentType, ContextType, RequireFields<QueryGetIdxPropertyFilesArgs, 'input'>>;
  getIdxSearchFeedProperties?: Resolver<ResolversTypes['IdxSearchFeedPropertiesData'], ParentType, ContextType, RequireFields<QueryGetIdxSearchFeedPropertiesArgs, 'input'>>;
  getIdxSettings?: Resolver<ResolversTypes['IdxSettings'], ParentType, ContextType>;
  getInternalOrganizationSaleTeam?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<QueryGetInternalOrganizationSaleTeamArgs, 'organizationId'>>;
  getIsFeaturedPortfolioSaved?: Resolver<Maybe<ResolversTypes['BrokerSavedFeaturedPortfolio']>, ParentType, ContextType, RequireFields<QueryGetIsFeaturedPortfolioSavedArgs, 'portfolioId'>>;
  getIsPropertyTracked?: Resolver<Maybe<ResolversTypes['BrokerTrackedProperty']>, ParentType, ContextType, RequireFields<QueryGetIsPropertyTrackedArgs, 'propertyId'>>;
  getMarketAreas?: Resolver<ResolversTypes['MarketAreasPayload'], ParentType, ContextType, Partial<QueryGetMarketAreasArgs>>;
  getMarketAreasForFilter?: Resolver<Array<ResolversTypes['MarketArea']>, ParentType, ContextType, RequireFields<QueryGetMarketAreasForFilterArgs, 'input'>>;
  getMediaFolderById?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<QueryGetMediaFolderByIdArgs, 'folderId'>>;
  getMediaFoldersAndFiles?: Resolver<ResolversTypes['MediaFilesAndFoldersPayload'], ParentType, ContextType, RequireFields<QueryGetMediaFoldersAndFilesArgs, 'filter'>>;
  getMonthlyApiUsageByAppId?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryGetMonthlyApiUsageByAppIdArgs, 'appId' | 'targetMonth'>>;
  getMyApiPluginUsers?: Resolver<ResolversTypes['ApiPluginUsersPayload'], ParentType, ContextType, Partial<QueryGetMyApiPluginUsersArgs>>;
  getNumberOfNewAlertItems?: Resolver<ResolversTypes['Float'], ParentType, ContextType, Partial<QueryGetNumberOfNewAlertItemsArgs>>;
  getNumberOfPortfolioPropertiesChangelogs?: Resolver<ResolversTypes['Float'], ParentType, ContextType, Partial<QueryGetNumberOfPortfolioPropertiesChangelogsArgs>>;
  getOrganizationById?: Resolver<ResolversTypes['Organization'], ParentType, ContextType, RequireFields<QueryGetOrganizationByIdArgs, 'organizationId'>>;
  getOrganizationRoles?: Resolver<ResolversTypes['RolesPayload'], ParentType, ContextType>;
  getOrganizationUsers?: Resolver<ResolversTypes['OrganizationUsersPayload'], ParentType, ContextType, RequireFields<QueryGetOrganizationUsersArgs, 'filter'>>;
  getOrganizationUsersByOrganizationRole?: Resolver<ResolversTypes['OrganizationUsersPayload'], ParentType, ContextType, RequireFields<QueryGetOrganizationUsersByOrganizationRoleArgs, 'filter'>>;
  getOrganizations?: Resolver<ResolversTypes['OrganizationsPayload'], ParentType, ContextType, Partial<QueryGetOrganizationsArgs>>;
  getPlaceOptions?: Resolver<ResolversTypes['PlaceOptionsPayload'], ParentType, ContextType>;
  getPluginUserOwnApiQuotaStatus?: Resolver<ResolversTypes['ApiQuotaStatusPayload'], ParentType, ContextType>;
  getPluginUserOwnMonthlyApiUsage?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryGetPluginUserOwnMonthlyApiUsageArgs, 'targetMonth'>>;
  getPluginUserOwnTotalApiUsage?: Resolver<ResolversTypes['ApiMetricPayload'], ParentType, ContextType, Partial<QueryGetPluginUserOwnTotalApiUsageArgs>>;
  getPortfolioFirstPublicProperty?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType, RequireFields<QueryGetPortfolioFirstPublicPropertyArgs, 'brokerId' | 'portfolioFolderName'>>;
  getPortfolioFolderById?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<QueryGetPortfolioFolderByIdArgs, 'portfolioFolderId'>>;
  getPortfolioFolderItems?: Resolver<ResolversTypes['PortfoliosPayload'], ParentType, ContextType, RequireFields<QueryGetPortfolioFolderItemsArgs, 'portfolioFolderId'>>;
  getPortfolioFolderItemsBulk?: Resolver<Array<ResolversTypes['PortfolioFolderItemsGroup']>, ParentType, ContextType, RequireFields<QueryGetPortfolioFolderItemsBulkArgs, 'folderIds' | 'limitPerFolder'>>;
  getPortfolioFolderRoot?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType>;
  getPortfolioMediaKitItems?: Resolver<ResolversTypes['MediaKitPayload'], ParentType, ContextType, RequireFields<QueryGetPortfolioMediaKitItemsArgs, 'filter'>>;
  getPortfolioPassword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetPortfolioPasswordArgs, 'portfolioId'>>;
  getPortfolioPropertiesChangelogs?: Resolver<ResolversTypes['PropertyChangelogsPayload'], ParentType, ContextType, Partial<QueryGetPortfolioPropertiesChangelogsArgs>>;
  getPortfolioPropertiesToCompare?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType, RequireFields<QueryGetPortfolioPropertiesToCompareArgs, 'portfolioFolderId' | 'portfolioIds'>>;
  getPortfolios?: Resolver<ResolversTypes['PortfoliosPayload'], ParentType, ContextType, Partial<QueryGetPortfoliosArgs>>;
  getPortfoliosByPublicFolder?: Resolver<ResolversTypes['PortfoliosPayload'], ParentType, ContextType, RequireFields<QueryGetPortfoliosByPublicFolderArgs, 'portfolioFolderId'>>;
  getPortfoliosTree?: Resolver<ResolversTypes['PortfoliosTreePayload'], ParentType, ContextType, Partial<QueryGetPortfoliosTreeArgs>>;
  getPortfoliosWithReactions?: Resolver<ResolversTypes['PortfoliosPayload'], ParentType, ContextType, Partial<QueryGetPortfoliosWithReactionsArgs>>;
  getPreviewInvoice?: Resolver<ResolversTypes['PreviewInvoicePayload'], ParentType, ContextType, RequireFields<QueryGetPreviewInvoiceArgs, 'input'>>;
  getProperties?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType, Partial<QueryGetPropertiesArgs>>;
  getPropertiesByOrganizationRole?: Resolver<ResolversTypes['PropertiesPayload'], ParentType, ContextType, Partial<QueryGetPropertiesByOrganizationRoleArgs>>;
  getPropertyAmenitiesInPublicBrokerPortfolio?: Resolver<ResolversTypes['AmenitiesPayload'], ParentType, ContextType, RequireFields<QueryGetPropertyAmenitiesInPublicBrokerPortfolioArgs, 'brokerId' | 'propertyId'>>;
  getPropertyById?: Resolver<ResolversTypes['Property'], ParentType, ContextType, RequireFields<QueryGetPropertyByIdArgs, 'propertyId'>>;
  getPropertyChangelogs?: Resolver<ResolversTypes['PropertyChangelogsPayload'], ParentType, ContextType, RequireFields<QueryGetPropertyChangelogsArgs, 'filter'>>;
  getPropertyNotes?: Resolver<ResolversTypes['PropertyNotesPayload'], ParentType, ContextType, RequireFields<QueryGetPropertyNotesArgs, 'propertyId'>>;
  getPropertySlideshowMediaInPublicBrokerPortfolio?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<QueryGetPropertySlideshowMediaInPublicBrokerPortfolioArgs, 'brokerId' | 'propertyId'>>;
  getPropertyUnitsInPublicBrokerPortfolio?: Resolver<ResolversTypes['UnitsPayload'], ParentType, ContextType, RequireFields<QueryGetPropertyUnitsInPublicBrokerPortfolioArgs, 'brokerId' | 'propertyId'>>;
  getPropertyUnitsSqftRange?: Resolver<Maybe<ResolversTypes['MinMaxRangePayload']>, ParentType, ContextType, RequireFields<QueryGetPropertyUnitsSqftRangeArgs, 'propertyId'>>;
  getPropertyViewsByBroker?: Resolver<ResolversTypes['ViewHistoryPayload'], ParentType, ContextType, RequireFields<QueryGetPropertyViewsByBrokerArgs, 'filter'>>;
  getPropertyVisitActivities?: Resolver<ResolversTypes['PropertyVisitActivitiesPayload'], ParentType, ContextType, Partial<QueryGetPropertyVisitActivitiesArgs>>;
  getPublicBrokerPortfolio?: Resolver<ResolversTypes['Portfolio'], ParentType, ContextType, RequireFields<QueryGetPublicBrokerPortfolioArgs, 'brokerId' | 'portfolioName'>>;
  getReactionsStatsForBroker?: Resolver<ResolversTypes['BrokerReactionsStats'], ParentType, ContextType, Partial<QueryGetReactionsStatsForBrokerArgs>>;
  getSaleTeamById?: Resolver<ResolversTypes['SaleTeam'], ParentType, ContextType, RequireFields<QueryGetSaleTeamByIdArgs, 'saleTeamId'>>;
  getSaleTeamUserNameByEmail?: Resolver<Maybe<ResolversTypes['SaleTeamUserNamePayload']>, ParentType, ContextType, RequireFields<QueryGetSaleTeamUserNameByEmailArgs, 'email'>>;
  getSaleTeamUsers?: Resolver<ResolversTypes['SaleTeamUsersPayload'], ParentType, ContextType, RequireFields<QueryGetSaleTeamUsersArgs, 'filter'>>;
  getSaleTeams?: Resolver<ResolversTypes['SaleTeamsPayload'], ParentType, ContextType, Partial<QueryGetSaleTeamsArgs>>;
  getSalesTeamRoles?: Resolver<ResolversTypes['RolesPayload'], ParentType, ContextType>;
  getSavedFeaturedPortfolios?: Resolver<ResolversTypes['BrokerSavedFeaturedPortfoliosPayload'], ParentType, ContextType, Partial<QueryGetSavedFeaturedPortfoliosArgs>>;
  getSavedFeaturedPortfoliosCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType, Partial<QueryGetSavedFeaturedPortfoliosCountArgs>>;
  getSingleBrokerById?: Resolver<ResolversTypes['Broker'], ParentType, ContextType, RequireFields<QueryGetSingleBrokerByIdArgs, 'brokerId'>>;
  getSlideshowMediaByProperty?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<QueryGetSlideshowMediaByPropertyArgs, 'propertyId'>>;
  getSubscriptionProducts?: Resolver<Array<ResolversTypes['SubscriptionProduct']>, ParentType, ContextType, Partial<QueryGetSubscriptionProductsArgs>>;
  getSystemActionCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryGetSystemActionCountArgs, 'filter'>>;
  getTopLevelFoldersInProperty?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType, RequireFields<QueryGetTopLevelFoldersInPropertyArgs, 'propertyId'>>;
  getTotalApiUsage?: Resolver<ResolversTypes['ApiMetricPayload'], ParentType, ContextType, Partial<QueryGetTotalApiUsageArgs>>;
  getTotalApiUsageByAppId?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryGetTotalApiUsageByAppIdArgs, 'appId'>>;
  getTrackedProperties?: Resolver<ResolversTypes['BrokerTrackedPropertiesPayload'], ParentType, ContextType, Partial<QueryGetTrackedPropertiesArgs>>;
  getTrackedPropertiesByOrganizationCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType, Partial<QueryGetTrackedPropertiesByOrganizationCountArgs>>;
  getTrackedPropertyIds?: Resolver<Array<ResolversTypes['TrackedPropertyId']>, ParentType, ContextType>;
  getTrendingList?: Resolver<Maybe<ResolversTypes['TrendingList']>, ParentType, ContextType, RequireFields<QueryGetTrendingListArgs, 'type'>>;
  getUSStateByName?: Resolver<ResolversTypes['State'], ParentType, ContextType, RequireFields<QueryGetUsStateByNameArgs, 'stateName'>>;
  getUSStates?: Resolver<Array<ResolversTypes['State']>, ParentType, ContextType, Partial<QueryGetUsStatesArgs>>;
  getUniqPropertiesAmenities?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, Partial<QueryGetUniqPropertiesAmenitiesArgs>>;
  getUniqPropertiesMarkets?: Resolver<Array<ResolversTypes['UnitPropertyMarket']>, ParentType, ContextType>;
  getUnits?: Resolver<ResolversTypes['UnitsPayload'], ParentType, ContextType, Partial<QueryGetUnitsArgs>>;
  getUnitsInPublicProperty?: Resolver<ResolversTypes['UnitsPayload'], ParentType, ContextType, RequireFields<QueryGetUnitsInPublicPropertyArgs, 'propertyId'>>;
  getUserByApiCredentialsId?: Resolver<ResolversTypes['ApiPluginUser'], ParentType, ContextType, Partial<QueryGetUserByApiCredentialsIdArgs>>;
  getUserPublicPortfolioFolders?: Resolver<Array<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  globalSearch?: Resolver<ResolversTypes['SearchIndexPayload'], ParentType, ContextType, RequireFields<QueryGlobalSearchArgs, 'limit' | 'query'>>;
  myPendingApiAccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  recommendedProperties?: Resolver<Array<ResolversTypes['Property']>, ParentType, ContextType, Partial<QueryRecommendedPropertiesArgs>>;
  similarProperties?: Resolver<Array<ResolversTypes['Property']>, ParentType, ContextType, RequireFields<QuerySimilarPropertiesArgs, 'propertyId'>>;
  simulateError?: Resolver<ResolversTypes['Broker'], ParentType, ContextType>;
  validateApiInvitation?: Resolver<ResolversTypes['ApiInvitationValidation'], ParentType, ContextType, RequireFields<QueryValidateApiInvitationArgs, 'token'>>;
}>;

export type RoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Role'] = ResolversParentTypes['Role']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RolesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RolesPayload'] = ResolversParentTypes['RolesPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Role']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleTeam'] = ResolversParentTypes['SaleTeam']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countOfUsers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  logoFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['SalesTeamPhone']>, ParentType, ContextType>;
  relatedToSaleTeamOrganizationsNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workingHours?: Resolver<Maybe<ResolversTypes['WorkingHours']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleTeamUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleTeamUser'] = ResolversParentTypes['SaleTeamUser']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assignedPropertiesIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  profileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  saleTeamId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleTeamRoleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleTeamUserNamePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleTeamUserNamePayload'] = ResolversParentTypes['SaleTeamUserNamePayload']> = ResolversObject<{
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleTeamUsersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleTeamUsersPayload'] = ResolversParentTypes['SaleTeamUsersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['SaleTeamUser']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleTeamsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaleTeamsPayload'] = ResolversParentTypes['SaleTeamsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['SaleTeam']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SalesTeamPhoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesTeamPhone'] = ResolversParentTypes['SalesTeamPhone']> = ResolversObject<{
  dialCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndex'] = ResolversParentTypes['SearchIndex']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display?: Resolver<ResolversTypes['SearchIndexDisplay'], ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['SearchIndexMeta'], ParentType, ContextType>;
  refId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refs?: Resolver<Maybe<ResolversTypes['SearchIndexRefs']>, ParentType, ContextType>;
  search?: Resolver<ResolversTypes['SearchIndexSearch'], ParentType, ContextType>;
  subtype?: Resolver<ResolversTypes['SearchIndexSubtypeEnum'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SearchIndexTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexDisplayResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndexDisplay'] = ResolversParentTypes['SearchIndexDisplay']> = ResolversObject<{
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndexMeta'] = ResolversParentTypes['SearchIndexMeta']> = ResolversObject<{
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  popularityScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndexPayload'] = ResolversParentTypes['SearchIndexPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['SearchIndex']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexRefsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndexRefs'] = ResolversParentTypes['SearchIndexRefs']> = ResolversObject<{
  locationId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  marketAreaId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  stateId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchIndexSearchResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchIndexSearch'] = ResolversParentTypes['SearchIndexSearch']> = ResolversObject<{
  primaryTokens?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryTokens?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SimilarityBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimilarityBreakdown'] = ResolversParentTypes['SimilarityBreakdown']> = ResolversObject<{
  amenities?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bedrooms?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buildingTypes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  marketArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  priceRange?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  projectStatus?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SimilarityEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimilarityEntry'] = ResolversParentTypes['SimilarityEntry']> = ResolversObject<{
  breakdown?: Resolver<Maybe<ResolversTypes['SimilarityBreakdown']>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StateResolvers<ContextType = any, ParentType extends ResolversParentTypes['State'] = ResolversParentTypes['State']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  withMarketArea?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StripeAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['StripeAccount'] = ResolversParentTypes['StripeAccount']> = ResolversObject<{
  paymentMethods?: Resolver<Maybe<Array<ResolversTypes['StripeAccountPaymentMethod']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StripeAccountPaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['StripeAccountPaymentMethod'] = ResolversParentTypes['StripeAccountPaymentMethod']> = ResolversObject<{
  cardBrand?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cardNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiredMonth?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  expiredYear?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paymentMethodId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StripeAccountTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StripeAccountTransaction'] = ResolversParentTypes['StripeAccountTransaction']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dateOfCharge?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  invoiceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invoiceName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invoicePdfUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StripeAccountTransactionsFlatPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['StripeAccountTransactionsFlatPayload'] = ResolversParentTypes['StripeAccountTransactionsFlatPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['StripeAccountTransaction']>, ParentType, ContextType>;
  hasMore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = ResolversObject<{
  observeBrokerAlertItemChanges?: SubscriptionResolver<ResolversTypes['ObserveBrokerAlertItemsPayload'], "observeBrokerAlertItemChanges", ParentType, ContextType>;
  observeCurrentAccountChanges?: SubscriptionResolver<ResolversTypes['ObserveAccountPayload'], "observeCurrentAccountChanges", ParentType, ContextType>;
  observeCurrentAccountProductSubscription?: SubscriptionResolver<ResolversTypes['ProductsSubscriptionsObserveSubscriptionPayload'], "observeCurrentAccountProductSubscription", ParentType, ContextType>;
  observeMediaChanges?: SubscriptionResolver<ResolversTypes['MediaObserveSubscriptionPayload'], "observeMediaChanges", ParentType, ContextType, RequireFields<SubscriptionObserveMediaChangesArgs, 'filter'>>;
  observePortfoliosChanges?: SubscriptionResolver<ResolversTypes['ObserveBrokerPortfolioPayload'], "observePortfoliosChanges", ParentType, ContextType>;
  observeProgressTrackingByType?: SubscriptionResolver<ResolversTypes['ObserveProgressTrackingPayload'], "observeProgressTrackingByType", ParentType, ContextType, RequireFields<SubscriptionObserveProgressTrackingByTypeArgs, 'type'>>;
  observePropertiesChanges?: SubscriptionResolver<ResolversTypes['ObservePropertyPayload'], "observePropertiesChanges", ParentType, ContextType>;
  observePropertyNotesChanges?: SubscriptionResolver<ResolversTypes['ObservePropertyNotesPayload'], "observePropertyNotesChanges", ParentType, ContextType, RequireFields<SubscriptionObservePropertyNotesChangesArgs, 'propertyId'>>;
  observeSubscriptionProductsChanges?: SubscriptionResolver<ResolversTypes['SubscriptionProductsObserveSubscriptionPayload'], "observeSubscriptionProductsChanges", ParentType, ContextType>;
}>;

export type SubscriptionProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionProduct'] = ResolversParentTypes['SubscriptionProduct']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coupons?: Resolver<Maybe<Array<ResolversTypes['SubscriptionProductCoupon']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  features?: Resolver<Array<ResolversTypes['SubscriptionProductFeature']>, ParentType, ContextType>;
  legacy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  recurringType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripePriceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripeProductId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trial?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionProductCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionProductCoupon'] = ResolversParentTypes['SubscriptionProductCoupon']> = ResolversObject<{
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  amountOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  duration_in_months?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  limitation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  stripeCouponId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionProductFeatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionProductFeature'] = ResolversParentTypes['SubscriptionProductFeature']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  feature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionProductsObserveSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionProductsObserveSubscriptionPayload'] = ResolversParentTypes['SubscriptionProductsObserveSubscriptionPayload']> = ResolversObject<{
  document?: Resolver<ResolversTypes['SubscriptionProduct'], ParentType, ContextType>;
  trigger?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionScheduleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionSchedule'] = ResolversParentTypes['SubscriptionSchedule']> = ResolversObject<{
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  nextPhasePriceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nextPhaseStart?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  scheduleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SystemActionLogsMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SystemActionLogsMetadata'] = ResolversParentTypes['SystemActionLogsMetadata']> = ResolversObject<{
  mediaId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  portfolioId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['ObjectId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TempAuthResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TempAuthResult'] = ResolversParentTypes['TempAuthResult']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  tempToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TokenResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TokenResponse'] = ResolversParentTypes['TokenResponse']> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TokensModelResolvers<ContextType = any, ParentType extends ResolversParentTypes['TokensModel'] = ResolversParentTypes['TokensModel']> = ResolversObject<{
  accessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshTokenExpiry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrackedPropertyIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrackedPropertyId'] = ResolversParentTypes['TrackedPropertyId']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrendingListResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrendingList'] = ResolversParentTypes['TrendingList']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['TrendingListItem']>, ParentType, ContextType>;
  periodEnd?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  periodStart?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrendingListItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrendingListItem'] = ResolversParentTypes['TrendingListItem']> = ResolversObject<{
  portfolio?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  portfolioId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['Property']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnitResolvers<ContextType = any, ParentType extends ResolversParentTypes['Unit'] = ResolversParentTypes['Unit']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  averageBathroomsNumber?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageBedroomsNumber?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageExteriorSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageInteriorSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  averageTotalSqft?: Resolver<ResolversTypes['MinMaxRange'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customRooms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorPlanFile?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  floorPlanFileId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  highestPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  inventoryType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startingPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnitPropertyMarketResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnitPropertyMarket'] = ResolversParentTypes['UnitPropertyMarket']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnitsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnitsPayload'] = ResolversParentTypes['UnitsPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['Unit']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>;
  profile?: Resolver<ResolversTypes['Profile'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UsersPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersPayload'] = ResolversParentTypes['UsersPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ValidateCouponPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateCouponPayload'] = ResolversParentTypes['ValidateCouponPayload']> = ResolversObject<{
  coupon?: Resolver<Maybe<ResolversTypes['SubscriptionProductCoupon']>, ParentType, ContextType>;
  invalidMessageType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ViewHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewHistory'] = ResolversParentTypes['ViewHistory']> = ResolversObject<{
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  historyType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastViewAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  portfolio?: Resolver<Maybe<ResolversTypes['Portfolio']>, ParentType, ContextType>;
  portfolioId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['Property']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewedByAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewedByVisitorHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitorType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ViewHistoryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewHistoryPayload'] = ResolversParentTypes['ViewHistoryPayload']> = ResolversObject<{
  collection?: Resolver<Array<ResolversTypes['ViewHistory']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VirtualTourLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['VirtualTourLink'] = ResolversParentTypes['VirtualTourLink']> = ResolversObject<{
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WorkingHoursResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkingHours'] = ResolversParentTypes['WorkingHours']> = ResolversObject<{
  friday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  monday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  saturday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  sunday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  thursday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  tuesday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  wednesday?: Resolver<Maybe<ResolversTypes['WorkingRange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WorkingRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkingRange'] = ResolversParentTypes['WorkingRange']> = ResolversObject<{
  from?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type XmlDownloadResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['XmlDownloadResponse'] = ResolversParentTypes['XmlDownloadResponse']> = ResolversObject<{
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  AbortUploadEvent?: AbortUploadEventResolvers<ContextType>;
  Account?: AccountResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  AmenitiesPayload?: AmenitiesPayloadResolvers<ContextType>;
  Amenity?: AmenityResolvers<ContextType>;
  AmenityName?: AmenityNameResolvers<ContextType>;
  ApiBrokerInfo?: ApiBrokerInfoResolvers<ContextType>;
  ApiCredentialSafeDTO?: ApiCredentialSafeDtoResolvers<ContextType>;
  ApiCredentialsPluginUserResponse?: ApiCredentialsPluginUserResponseResolvers<ContextType>;
  ApiCredentialsUserResponse?: ApiCredentialsUserResponseResolvers<ContextType>;
  ApiInvitationSafeDTO?: ApiInvitationSafeDtoResolvers<ContextType>;
  ApiInvitationValidation?: ApiInvitationValidationResolvers<ContextType>;
  ApiInvitationsPayload?: ApiInvitationsPayloadResolvers<ContextType>;
  ApiMetric?: ApiMetricResolvers<ContextType>;
  ApiMetricPayload?: ApiMetricPayloadResolvers<ContextType>;
  ApiPluginUser?: ApiPluginUserResolvers<ContextType>;
  ApiPluginUsersPayload?: ApiPluginUsersPayloadResolvers<ContextType>;
  ApiQuotaStatusPayload?: ApiQuotaStatusPayloadResolvers<ContextType>;
  ApiUser?: ApiUserResolvers<ContextType>;
  ApiUsersPayload?: ApiUsersPayloadResolvers<ContextType>;
  AuthResult?: AuthResultResolvers<ContextType>;
  BasicInfoResponse?: BasicInfoResponseResolvers<ContextType>;
  Branding?: BrandingResolvers<ContextType>;
  Broker?: BrokerResolvers<ContextType>;
  BrokerActivity?: BrokerActivityResolvers<ContextType>;
  BrokerAlertConfig?: BrokerAlertConfigResolvers<ContextType>;
  BrokerAlertConfigConstructionDateRangeFilter?: BrokerAlertConfigConstructionDateRangeFilterResolvers<ContextType>;
  BrokerAlertConfigFilter?: BrokerAlertConfigFilterResolvers<ContextType>;
  BrokerAlertConfigLocationFilter?: BrokerAlertConfigLocationFilterResolvers<ContextType>;
  BrokerAlertConfigPayload?: BrokerAlertConfigPayloadResolvers<ContextType>;
  BrokerAlertItem?: BrokerAlertItemResolvers<ContextType>;
  BrokerAlertItemPayload?: BrokerAlertItemPayloadResolvers<ContextType>;
  BrokerLicense?: BrokerLicenseResolvers<ContextType>;
  BrokerReactionsStats?: BrokerReactionsStatsResolvers<ContextType>;
  BrokerSavedFeaturedPortfolio?: BrokerSavedFeaturedPortfolioResolvers<ContextType>;
  BrokerSavedFeaturedPortfoliosPayload?: BrokerSavedFeaturedPortfoliosPayloadResolvers<ContextType>;
  BrokerTrackedPropertiesPayload?: BrokerTrackedPropertiesPayloadResolvers<ContextType>;
  BrokerTrackedProperty?: BrokerTrackedPropertyResolvers<ContextType>;
  BrokersPayload?: BrokersPayloadResolvers<ContextType>;
  ChangelogDocument?: ChangelogDocumentResolvers<ContextType>;
  CheckoutSessionDetails?: CheckoutSessionDetailsResolvers<ContextType>;
  CmsSettings?: CmsSettingsResolvers<ContextType>;
  Comparison?: ComparisonResolvers<ContextType>;
  ContactPhone?: ContactPhoneResolvers<ContextType>;
  CopyFeaturedPortfolioToBrokerPortfolioResult?: CopyFeaturedPortfolioToBrokerPortfolioResultResolvers<ContextType>;
  CreateCheckoutSessionPayload?: CreateCheckoutSessionPayloadResolvers<ContextType>;
  Date?: GraphQLScalarType;
  Developer?: DeveloperResolvers<ContextType>;
  DeveloperAsSaleUser?: DeveloperAsSaleUserResolvers<ContextType>;
  FeaturedPortfolio?: FeaturedPortfolioResolvers<ContextType>;
  FeaturedPortfolioPropertiesPayload?: FeaturedPortfolioPropertiesPayloadResolvers<ContextType>;
  FeaturedPortfolioSummary?: FeaturedPortfolioSummaryResolvers<ContextType>;
  FeaturedPortfoliosPayload?: FeaturedPortfoliosPayloadResolvers<ContextType>;
  FeaturedPropertiesPayload?: FeaturedPropertiesPayloadResolvers<ContextType>;
  FeaturedProperty?: FeaturedPropertyResolvers<ContextType>;
  File?: FileResolvers<ContextType>;
  FolderPathModel?: FolderPathModelResolvers<ContextType>;
  GenerateQrCodeResult?: GenerateQrCodeResultResolvers<ContextType>;
  GeoLocationJSON?: GeoLocationJsonResolvers<ContextType>;
  GetFileDownloadsStatisticItem?: GetFileDownloadsStatisticItemResolvers<ContextType>;
  GetFileDownloadsStatisticPayload?: GetFileDownloadsStatisticPayloadResolvers<ContextType>;
  GetIdxFeedListPayload?: GetIdxFeedListPayloadResolvers<ContextType>;
  GuestUser?: GuestUserResolvers<ContextType>;
  GuestUserPayload?: GuestUserPayloadResolvers<ContextType>;
  IdxActivity?: IdxActivityResolvers<ContextType>;
  IdxActivityCollection?: IdxActivityCollectionResolvers<ContextType>;
  IdxActivityPayload?: IdxActivityPayloadResolvers<ContextType>;
  IdxEmbeddedPortfolioFeedData?: IdxEmbeddedPortfolioFeedDataResolvers<ContextType>;
  IdxEmbeddedPropertyFeedData?: IdxEmbeddedPropertyFeedDataResolvers<ContextType>;
  IdxEmbeddedSearchBarFeedData?: IdxEmbeddedSearchBarFeedDataResolvers<ContextType>;
  IdxFeed?: IdxFeedResolvers<ContextType>;
  IdxPortfolioFeedPropertiesData?: IdxPortfolioFeedPropertiesDataResolvers<ContextType>;
  IdxSearchFeedPropertiesData?: IdxSearchFeedPropertiesDataResolvers<ContextType>;
  IdxSettings?: IdxSettingsResolvers<ContextType>;
  InvoiceCoupon?: InvoiceCouponResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  LocalTimeHours?: LocalTimeHoursResolvers<ContextType>;
  LocalTimeRange?: LocalTimeRangeResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  MarketArea?: MarketAreaResolvers<ContextType>;
  MarketAreaCount?: MarketAreaCountResolvers<ContextType>;
  MarketAreaPlaceOption?: MarketAreaPlaceOptionResolvers<ContextType>;
  MarketAreasPayload?: MarketAreasPayloadResolvers<ContextType>;
  Media?: MediaResolvers<ContextType>;
  MediaFilesAndFoldersPayload?: MediaFilesAndFoldersPayloadResolvers<ContextType>;
  MediaFilesPayload?: MediaFilesPayloadResolvers<ContextType>;
  MediaKitPayload?: MediaKitPayloadResolvers<ContextType>;
  MediaObserveSubscriptionPayload?: MediaObserveSubscriptionPayloadResolvers<ContextType>;
  MetricDataPoint?: MetricDataPointResolvers<ContextType>;
  MfaTempTokenModel?: MfaTempTokenModelResolvers<ContextType>;
  MinMax?: MinMaxResolvers<ContextType>;
  MinMaxRange?: MinMaxRangeResolvers<ContextType>;
  MinMaxRangePayload?: MinMaxRangePayloadResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NewPortfolioItemActivitiesPayload?: NewPortfolioItemActivitiesPayloadResolvers<ContextType>;
  NewPortfolioItemActivity?: NewPortfolioItemActivityResolvers<ContextType>;
  NewPortfolioItemActivityDoc?: NewPortfolioItemActivityDocResolvers<ContextType>;
  ObjectId?: GraphQLScalarType;
  ObserveAccountPayload?: ObserveAccountPayloadResolvers<ContextType>;
  ObserveBrokerAlertItemsPayload?: ObserveBrokerAlertItemsPayloadResolvers<ContextType>;
  ObserveBrokerPortfolioPayload?: ObserveBrokerPortfolioPayloadResolvers<ContextType>;
  ObserveProgressTrackingPayload?: ObserveProgressTrackingPayloadResolvers<ContextType>;
  ObservePropertyNotesPayload?: ObservePropertyNotesPayloadResolvers<ContextType>;
  ObservePropertyPayload?: ObservePropertyPayloadResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationUser?: OrganizationUserResolvers<ContextType>;
  OrganizationUsersPayload?: OrganizationUsersPayloadResolvers<ContextType>;
  OrganizationsPayload?: OrganizationsPayloadResolvers<ContextType>;
  Phone?: PhoneResolvers<ContextType>;
  Place?: PlaceResolvers<ContextType>;
  PlaceOption?: PlaceOptionResolvers<ContextType>;
  PlaceOptionsPayload?: PlaceOptionsPayloadResolvers<ContextType>;
  Portfolio?: PortfolioResolvers<ContextType>;
  PortfolioFolderItemsGroup?: PortfolioFolderItemsGroupResolvers<ContextType>;
  PortfolioLocations?: PortfolioLocationsResolvers<ContextType>;
  PortfolioMediaKit?: PortfolioMediaKitResolvers<ContextType>;
  PortfolioReaction?: PortfolioReactionResolvers<ContextType>;
  PortfolioTree?: PortfolioTreeResolvers<ContextType>;
  PortfoliosPayload?: PortfoliosPayloadResolvers<ContextType>;
  PortfoliosTreePayload?: PortfoliosTreePayloadResolvers<ContextType>;
  PreferredPropertySettings?: PreferredPropertySettingsResolvers<ContextType>;
  PreviewInvoiceItem?: PreviewInvoiceItemResolvers<ContextType>;
  PreviewInvoicePayload?: PreviewInvoicePayloadResolvers<ContextType>;
  ProductSubscription?: ProductSubscriptionResolvers<ContextType>;
  ProductSubscriptionPayload?: ProductSubscriptionPayloadResolvers<ContextType>;
  ProductSubscriptionPayment?: ProductSubscriptionPaymentResolvers<ContextType>;
  ProductSubscriptionsPayload?: ProductSubscriptionsPayloadResolvers<ContextType>;
  ProductsSubscriptionsObserveSubscriptionPayload?: ProductsSubscriptionsObserveSubscriptionPayloadResolvers<ContextType>;
  Profile?: ProfileResolvers<ContextType>;
  ProgressTrackingModel?: ProgressTrackingModelResolvers<ContextType>;
  PropertiesPayload?: PropertiesPayloadResolvers<ContextType>;
  Property?: PropertyResolvers<ContextType>;
  PropertyAboutChangelog?: PropertyAboutChangelogResolvers<ContextType>;
  PropertyAdditionalInformationChangelog?: PropertyAdditionalInformationChangelogResolvers<ContextType>;
  PropertyChangelog?: PropertyChangelogResolvers<ContextType>;
  PropertyChangelogsPayload?: PropertyChangelogsPayloadResolvers<ContextType>;
  PropertyClick?: PropertyClickResolvers<ContextType>;
  PropertyDataReviewedChangelog?: PropertyDataReviewedChangelogResolvers<ContextType>;
  PropertyDetail?: PropertyDetailResolvers<ContextType>;
  PropertyDeveloperOrganizationChangelog?: PropertyDeveloperOrganizationChangelogResolvers<ContextType>;
  PropertyFeaturesAndAmenitiesChangelog?: PropertyFeaturesAndAmenitiesChangelogResolvers<ContextType>;
  PropertyHighlightsChangelog?: PropertyHighlightsChangelogResolvers<ContextType>;
  PropertyInventoryUnitAddedChangelog?: PropertyInventoryUnitAddedChangelogResolvers<ContextType>;
  PropertyInventoryUnitRemovedChangelog?: PropertyInventoryUnitRemovedChangelogResolvers<ContextType>;
  PropertyInventoryUnitUpdatedChangelog?: PropertyInventoryUnitUpdatedChangelogResolvers<ContextType>;
  PropertyLocationChangelog?: PropertyLocationChangelogResolvers<ContextType>;
  PropertyMediaFilesMovedChangelog?: PropertyMediaFilesMovedChangelogResolvers<ContextType>;
  PropertyMediaRemovedChangelog?: PropertyMediaRemovedChangelogResolvers<ContextType>;
  PropertyMediaRenamedChangelog?: PropertyMediaRenamedChangelogResolvers<ContextType>;
  PropertyMediaUploadedChangelog?: PropertyMediaUploadedChangelogResolvers<ContextType>;
  PropertyNameChangelog?: PropertyNameChangelogResolvers<ContextType>;
  PropertyNote?: PropertyNoteResolvers<ContextType>;
  PropertyNotesPayload?: PropertyNotesPayloadResolvers<ContextType>;
  PropertyOrganizationSalesTeamsChangelog?: PropertyOrganizationSalesTeamsChangelogResolvers<ContextType>;
  PropertyPriceChangelog?: PropertyPriceChangelogResolvers<ContextType>;
  PropertySaleTeam?: PropertySaleTeamResolvers<ContextType>;
  PropertySummary?: PropertySummaryResolvers<ContextType>;
  PropertyVirtualToursChangelog?: PropertyVirtualToursChangelogResolvers<ContextType>;
  PropertyVisitActivitiesPayload?: PropertyVisitActivitiesPayloadResolvers<ContextType>;
  PropertyVisitActivity?: PropertyVisitActivityResolvers<ContextType>;
  PropertyVisitActivityDoc?: PropertyVisitActivityDocResolvers<ContextType>;
  PropertyWebsiteChangelog?: PropertyWebsiteChangelogResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  RolesPayload?: RolesPayloadResolvers<ContextType>;
  SaleTeam?: SaleTeamResolvers<ContextType>;
  SaleTeamUser?: SaleTeamUserResolvers<ContextType>;
  SaleTeamUserNamePayload?: SaleTeamUserNamePayloadResolvers<ContextType>;
  SaleTeamUsersPayload?: SaleTeamUsersPayloadResolvers<ContextType>;
  SaleTeamsPayload?: SaleTeamsPayloadResolvers<ContextType>;
  SalesTeamPhone?: SalesTeamPhoneResolvers<ContextType>;
  SearchIndex?: SearchIndexResolvers<ContextType>;
  SearchIndexDisplay?: SearchIndexDisplayResolvers<ContextType>;
  SearchIndexMeta?: SearchIndexMetaResolvers<ContextType>;
  SearchIndexPayload?: SearchIndexPayloadResolvers<ContextType>;
  SearchIndexRefs?: SearchIndexRefsResolvers<ContextType>;
  SearchIndexSearch?: SearchIndexSearchResolvers<ContextType>;
  SimilarityBreakdown?: SimilarityBreakdownResolvers<ContextType>;
  SimilarityEntry?: SimilarityEntryResolvers<ContextType>;
  State?: StateResolvers<ContextType>;
  StripeAccount?: StripeAccountResolvers<ContextType>;
  StripeAccountPaymentMethod?: StripeAccountPaymentMethodResolvers<ContextType>;
  StripeAccountTransaction?: StripeAccountTransactionResolvers<ContextType>;
  StripeAccountTransactionsFlatPayload?: StripeAccountTransactionsFlatPayloadResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SubscriptionProduct?: SubscriptionProductResolvers<ContextType>;
  SubscriptionProductCoupon?: SubscriptionProductCouponResolvers<ContextType>;
  SubscriptionProductFeature?: SubscriptionProductFeatureResolvers<ContextType>;
  SubscriptionProductsObserveSubscriptionPayload?: SubscriptionProductsObserveSubscriptionPayloadResolvers<ContextType>;
  SubscriptionSchedule?: SubscriptionScheduleResolvers<ContextType>;
  SystemActionLogsMetadata?: SystemActionLogsMetadataResolvers<ContextType>;
  TempAuthResult?: TempAuthResultResolvers<ContextType>;
  TokenResponse?: TokenResponseResolvers<ContextType>;
  TokensModel?: TokensModelResolvers<ContextType>;
  TrackedPropertyId?: TrackedPropertyIdResolvers<ContextType>;
  TrendingList?: TrendingListResolvers<ContextType>;
  TrendingListItem?: TrendingListItemResolvers<ContextType>;
  Unit?: UnitResolvers<ContextType>;
  UnitPropertyMarket?: UnitPropertyMarketResolvers<ContextType>;
  UnitsPayload?: UnitsPayloadResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UsersPayload?: UsersPayloadResolvers<ContextType>;
  ValidateCouponPayload?: ValidateCouponPayloadResolvers<ContextType>;
  ViewHistory?: ViewHistoryResolvers<ContextType>;
  ViewHistoryPayload?: ViewHistoryPayloadResolvers<ContextType>;
  VirtualTourLink?: VirtualTourLinkResolvers<ContextType>;
  WorkingHours?: WorkingHoursResolvers<ContextType>;
  WorkingRange?: WorkingRangeResolvers<ContextType>;
  XmlDownloadResponse?: XmlDownloadResponseResolvers<ContextType>;
}>;


export type TokensModelFragment = { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null };

export type AccountFragment = { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, ssoId?: string | null, stripeCustomerId?: string | null, provider?: string | null, isSeeker: boolean, lastAccountTypeSwitchAt?: any | null, showAllBillingPlans?: boolean | null, language?: string | null, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } };

export type StripeAccountFragment = { __typename?: 'StripeAccount', paymentMethods?: Array<{ __typename?: 'StripeAccountPaymentMethod', paymentMethodId: string, cardNumber: string, expiredMonth: number, expiredYear: number, cardBrand: string }> | null };

export type AuthorizationMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type AuthorizationMutation = { __typename?: 'Mutation', authorization: { __typename: 'MfaTempTokenModel', tempToken: string, mfaEnabled: boolean } | { __typename: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type EnableMfaMutationVariables = Exact<{
  token: Scalars['String'];
  method?: InputMaybe<MfaMethodsEnum>;
}>;


export type EnableMfaMutation = { __typename?: 'Mutation', enableMfa: { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type SendMfaEmailCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type SendMfaEmailCodeMutation = { __typename?: 'Mutation', sendMfaEmailCode: boolean };

export type MfaAuthenticationMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type MfaAuthenticationMutation = { __typename?: 'Mutation', mfaAuthentication: { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type RefreshTokensMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokensMutation = { __typename?: 'Mutation', refreshTokens: { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type ResetPasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type UpdatePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type AttachDefaultStripePaymentMethodMutationVariables = Exact<{
  stripePaymentMethodId: Scalars['String'];
}>;


export type AttachDefaultStripePaymentMethodMutation = { __typename?: 'Mutation', attachDefaultStripePaymentMethod: { __typename?: 'Account', _id: string } };

export type DetachPaymentMethodFromCustomerMutationVariables = Exact<{
  stripePaymentMethodId: Scalars['String'];
}>;


export type DetachPaymentMethodFromCustomerMutation = { __typename?: 'Mutation', detachPaymentMethodFromCustomer: { __typename?: 'Account', _id: string } };

export type AttachStripePaymentMethodMutationVariables = Exact<{
  stripePaymentMethodId: Scalars['String'];
}>;


export type AttachStripePaymentMethodMutation = { __typename?: 'Mutation', attachStripePaymentMethod: { __typename?: 'StripeAccount', paymentMethods?: Array<{ __typename?: 'StripeAccountPaymentMethod', paymentMethodId: string, cardNumber: string, expiredMonth: number, expiredYear: number, cardBrand: string }> | null } };

export type ValidatePhoneNumberMutationVariables = Exact<{
  code: Scalars['String'];
  attribution?: InputMaybe<SignupAttributionInput>;
}>;


export type ValidatePhoneNumberMutation = { __typename?: 'Mutation', validatePhoneNumber: { __typename?: 'Account', _id: string, phone?: { __typename?: 'Phone', status: string } | null } };

export type RecordLastTouchAttributionMutationVariables = Exact<{
  attribution: AttributionInput;
}>;


export type RecordLastTouchAttributionMutation = { __typename?: 'Mutation', recordLastTouchAttribution: boolean };

export type UpdateEmailMutationVariables = Exact<{
  password: Scalars['String'];
  newEmail: Scalars['String'];
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateEmail: { __typename?: 'TokensModel', accessToken: string, refreshTokenExpiry?: string | null, refreshToken: string } };

export type UpdateSsoIdMutationVariables = Exact<{
  ssoId: Scalars['String'];
}>;


export type UpdateSsoIdMutation = { __typename?: 'Mutation', updateSSOId: { __typename?: 'Account', ssoId?: string | null } };

export type SendVerificationCodeMutationVariables = Exact<{
  phone: PhoneInput;
}>;


export type SendVerificationCodeMutation = { __typename?: 'Mutation', sendVerificationCode: { __typename?: 'Account', _id: string } };

export type SendEmailVerificationCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type SendEmailVerificationCodeMutation = { __typename?: 'Mutation', sendEmailVerificationCode: { __typename?: 'Account', _id: string } };

export type VerifyPhoneNumberAndUpdateAccountMutationVariables = Exact<{
  code: Scalars['String'];
  phone: PhoneInput;
}>;


export type VerifyPhoneNumberAndUpdateAccountMutation = { __typename?: 'Mutation', verifyPhoneNumberAndUpdateAccount: { __typename?: 'Account', _id: string } };

export type GenerateMagicLinkMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type GenerateMagicLinkMutation = { __typename?: 'Mutation', generateMagicLink: boolean };

export type GetTokenWithMagicLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type GetTokenWithMagicLinkMutation = { __typename?: 'Mutation', getTokenWithMagicLink: { __typename: 'MfaTempTokenModel', tempToken: string, mfaEnabled: boolean } | { __typename: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type SwitchAccountTypeMutationVariables = Exact<{
  input: SwitchAccountInput;
}>;


export type SwitchAccountTypeMutation = { __typename?: 'Mutation', switchAccountType: { __typename?: 'Account', _id: string, isSeeker: boolean, productSubscriptionId?: string | null, roleId: string, status: string, email: string, lastAccountTypeSwitchAt?: any | null } };

export type UpdateAccountLanguageMutationVariables = Exact<{
  language: Scalars['String'];
}>;


export type UpdateAccountLanguageMutation = { __typename?: 'Mutation', updateAccountLanguage: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, ssoId?: string | null, stripeCustomerId?: string | null, provider?: string | null, isSeeker: boolean, lastAccountTypeSwitchAt?: any | null, showAllBillingPlans?: boolean | null, language?: string | null, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } };

export type UpdateCurrentUserMutationVariables = Exact<{
  profileInput: ProfileInput;
}>;


export type UpdateCurrentUserMutation = { __typename?: 'Mutation', updateCurrentUser: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } };

export type GetAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountQuery = { __typename?: 'Query', getAccount: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, ssoId?: string | null, stripeCustomerId?: string | null, provider?: string | null, isSeeker: boolean, lastAccountTypeSwitchAt?: any | null, showAllBillingPlans?: boolean | null, language?: string | null, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } };

export type GetCurrentAccountProductSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentAccountProductSubscriptionQuery = { __typename?: 'Query', getCurrentAccountProductSubscription?: { __typename?: 'ProductSubscription', _id: string, status: string, currentPeriodEndAt: any, subscriptionProductId: string, subscriptionInactiveAt?: any | null, trialEndAt?: any | null, downgradeTo?: string | null, metadata?: any | null, schedule?: { __typename?: 'SubscriptionSchedule', scheduleId: string, nextPhasePriceId?: string | null, nextPhaseStart?: any | null, metadata?: any | null } | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', name: string, price: number, recurringType: string, stripeProductId: string, stripePriceId: string, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }> } } | null };

export type GetCurrentAccountTrialProductSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentAccountTrialProductSubscriptionsQuery = { __typename?: 'Query', getCurrentAccountTrialProductSubscriptions?: { __typename?: 'ProductSubscriptionsPayload', totalCount: number, collection: Array<{ __typename?: 'ProductSubscription', _id: string, status: string, currentPeriodEndAt: any, subscriptionProductId: string, subscriptionInactiveAt?: any | null, trialEndAt?: any | null, downgradeTo?: string | null, metadata?: any | null, schedule?: { __typename?: 'SubscriptionSchedule', scheduleId: string, nextPhasePriceId?: string | null, nextPhaseStart?: any | null, metadata?: any | null } | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', name: string, price: number, recurringType: string, stripeProductId: string, stripePriceId: string, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }> } }> } | null };

export type GetCurrentStripeAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentStripeAccountQuery = { __typename?: 'Query', getCurrentStripeAccount?: { __typename?: 'StripeAccount', paymentMethods?: Array<{ __typename?: 'StripeAccountPaymentMethod', paymentMethodId: string, cardNumber: string, expiredMonth: number, expiredYear: number, cardBrand: string }> | null } | null };

export type GetCurrentStripeAccountTransactionsQueryVariables = Exact<{
  flatPagination?: InputMaybe<FlatPaginationInput>;
}>;


export type GetCurrentStripeAccountTransactionsQuery = { __typename?: 'Query', getCurrentStripeAccountTransactions: { __typename?: 'StripeAccountTransactionsFlatPayload', hasMore: boolean, collection: Array<{ __typename?: 'StripeAccountTransaction', invoiceId: string, amount: number, dateOfCharge: any, invoiceName: string, invoicePdfUrl?: string | null, status: string }> } };

export type GenerateMfaQrCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateMfaQrCodeQuery = { __typename?: 'Query', generateMfaQrCode: { __typename?: 'GenerateQrCodeResult', qrCode: string } };

export type ObserveCurrentAccountProductSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ObserveCurrentAccountProductSubscriptionSubscription = { __typename?: 'Subscription', observeCurrentAccountProductSubscription: { __typename?: 'ProductsSubscriptionsObserveSubscriptionPayload', trigger: string, document: { __typename?: 'ProductSubscription', _id: string, status: string, currentPeriodEndAt: any, subscriptionProductId: string, subscriptionInactiveAt?: any | null, trialEndAt?: any | null, downgradeTo?: string | null, metadata?: any | null, schedule?: { __typename?: 'SubscriptionSchedule', scheduleId: string, nextPhasePriceId?: string | null, nextPhaseStart?: any | null, metadata?: any | null } | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', name: string, price: number, recurringType: string, stripeProductId: string, stripePriceId: string, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }> } } } };

export type ObserveCurrentAccountChangesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ObserveCurrentAccountChangesSubscription = { __typename?: 'Subscription', observeCurrentAccountChanges: { __typename?: 'ObserveAccountPayload', trigger: string, account: { __typename?: 'Account', _id: string, createdAt: any, email: string, status: string, ssoId?: string | null, stripeCustomerId?: string | null, provider?: string | null, isSeeker: boolean, lastAccountTypeSwitchAt?: any | null, showAllBillingPlans?: boolean | null, language?: string | null, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } } };

export type BrokerAlertConfigDetailsFragment = { __typename?: 'BrokerAlertConfig', _id: string, name: string, filter: { __typename?: 'BrokerAlertConfigFilter', projectStatuses?: Array<ProjectStatusesEnum> | null, buildingTypes?: Array<BuildingTypesEnum> | null, propertyTags?: Array<PropertyTagsEnum> | null, amenityIds?: Array<any> | null, marketAreaIds?: Array<any> | null, transactionType?: PropertyTransactionTypesEnum | null, priceRange?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, locationFilter?: { __typename?: 'BrokerAlertConfigLocationFilter', lat: number, lng: number, radiusToSearchInMiles: number } | null, unitNumberOfBathrooms?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, unitNumberOfBedrooms?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, unitNumberOfUnits?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, yearBuildRange?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, constructionDateRange?: { __typename?: 'BrokerAlertConfigConstructionDateRangeFilter', startDate: any, endDate: any } | null } };

export type CreateAlertConfigMutationVariables = Exact<{
  name: Scalars['String'];
  filter: CreateAlertConfigFilterInput;
}>;


export type CreateAlertConfigMutation = { __typename?: 'Mutation', createAlertConfig: { __typename?: 'BrokerAlertConfig', _id: string } };

export type UpdateAlertConfigMutationVariables = Exact<{
  alertConfigId: Scalars['ObjectId'];
  name: Scalars['String'];
  filter: CreateAlertConfigFilterInput;
}>;


export type UpdateAlertConfigMutation = { __typename?: 'Mutation', updateAlertConfig: { __typename?: 'BrokerAlertConfig', _id: string, name: string, filter: { __typename?: 'BrokerAlertConfigFilter', projectStatuses?: Array<ProjectStatusesEnum> | null, buildingTypes?: Array<BuildingTypesEnum> | null, propertyTags?: Array<PropertyTagsEnum> | null, amenityIds?: Array<any> | null, marketAreaIds?: Array<any> | null, transactionType?: PropertyTransactionTypesEnum | null, priceRange?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, locationFilter?: { __typename?: 'BrokerAlertConfigLocationFilter', lat: number, lng: number, radiusToSearchInMiles: number } | null, unitNumberOfBathrooms?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, unitNumberOfBedrooms?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, unitNumberOfUnits?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, yearBuildRange?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, constructionDateRange?: { __typename?: 'BrokerAlertConfigConstructionDateRangeFilter', startDate: any, endDate: any } | null } } };

export type SetHiddenStateToAlertItemMutationVariables = Exact<{
  alertItemId: Scalars['ObjectId'];
  isHidden: Scalars['Boolean'];
}>;


export type SetHiddenStateToAlertItemMutation = { __typename?: 'Mutation', setHiddenStateToAlertItem: { __typename?: 'BrokerAlertItem', _id: string, brokerAlertConfig: { __typename?: 'BrokerAlertConfig', _id: string, name: string }, property: { __typename?: 'Property', _id: string, name: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null } } };

export type RemoveAlertConfigMutationVariables = Exact<{
  alertConfigId: Scalars['ObjectId'];
}>;


export type RemoveAlertConfigMutation = { __typename?: 'Mutation', removeAlertConfig: { __typename?: 'BrokerAlertConfig', _id: string } };

export type GetAlertItemsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetAlertItemsFilterInput>;
  flatPagination?: InputMaybe<FlatPaginationInput>;
}>;


export type GetAlertItemsQuery = { __typename?: 'Query', getAlertItems: { __typename?: 'BrokerAlertItemPayload', totalCount: number, collection: Array<{ __typename?: 'BrokerAlertItem', _id: string, isHidden: boolean, brokerAlertConfig: { __typename?: 'BrokerAlertConfig', _id: string, name: string }, property: { __typename?: 'Property', _id: string, name: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null } }> } };

export type GetAlertConfigsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetAlertConfigsQuery = { __typename?: 'Query', getAlertConfigs: { __typename?: 'BrokerAlertConfigPayload', totalCount: number, collection: Array<{ __typename?: 'BrokerAlertConfig', _id: string, name: string }> } };

export type GetConfigAlertByIdQueryVariables = Exact<{
  alertConfigId: Scalars['ObjectId'];
}>;


export type GetConfigAlertByIdQuery = { __typename?: 'Query', getAlertConfigById: { __typename?: 'BrokerAlertConfig', _id: string, name: string, filter: { __typename?: 'BrokerAlertConfigFilter', projectStatuses?: Array<ProjectStatusesEnum> | null, buildingTypes?: Array<BuildingTypesEnum> | null, propertyTags?: Array<PropertyTagsEnum> | null, amenityIds?: Array<any> | null, marketAreaIds?: Array<any> | null, transactionType?: PropertyTransactionTypesEnum | null, priceRange?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, locationFilter?: { __typename?: 'BrokerAlertConfigLocationFilter', lat: number, lng: number, radiusToSearchInMiles: number } | null, unitNumberOfBathrooms?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, unitNumberOfBedrooms?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, unitNumberOfUnits?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, yearBuildRange?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, constructionDateRange?: { __typename?: 'BrokerAlertConfigConstructionDateRangeFilter', startDate: any, endDate: any } | null } } };

export type GetAlertConfigsCountQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetAlertConfigsCountQuery = { __typename?: 'Query', getAlertConfigs: { __typename?: 'BrokerAlertConfigPayload', totalCount: number } };

export type GetNumberOfNewAlertItemsQueryVariables = Exact<{
  range?: InputMaybe<DateRangeInput>;
}>;


export type GetNumberOfNewAlertItemsQuery = { __typename?: 'Query', getNumberOfNewAlertItems: number };

export type CurrentBrokerHasAlertConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentBrokerHasAlertConfigsQuery = { __typename?: 'Query', currentBrokerHasAlertConfigs: boolean };

export type ObserveBrokerAlertItemChangesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ObserveBrokerAlertItemChangesSubscription = { __typename?: 'Subscription', observeBrokerAlertItemChanges: { __typename?: 'ObserveBrokerAlertItemsPayload', trigger: string, document: { __typename?: 'BrokerAlertItem', _id: string, isHidden: boolean, brokerAlertConfig: { __typename?: 'BrokerAlertConfig', _id: string, name: string }, property: { __typename?: 'Property', _id: string, name: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null } } } };

export type AmenityFragment = { __typename?: 'Amenity', _id: string, createdAt: any, name: string, imageUrl?: string | null, isPrimary: boolean, imageFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null } | null };

export type GetAmenitiesQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetAmenitiesFilterInput>;
}>;


export type GetAmenitiesQuery = { __typename?: 'Query', getAmenities: { __typename?: 'AmenitiesPayload', totalCount: number, collection: Array<{ __typename?: 'Amenity', _id: string, createdAt: any, name: string, imageUrl?: string | null, isPrimary: boolean, imageFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null } | null }> } };

export type GetPropertyAmenitiesInPublicBrokerPortfolioQueryVariables = Exact<{
  brokerId: Scalars['ObjectId'];
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetAmenitiesFilterInput>;
}>;


export type GetPropertyAmenitiesInPublicBrokerPortfolioQuery = { __typename?: 'Query', getPropertyAmenitiesInPublicBrokerPortfolio: { __typename?: 'AmenitiesPayload', totalCount: number, collection: Array<{ __typename?: 'Amenity', _id: string, createdAt: any, name: string, imageUrl?: string | null, isPrimary: boolean, imageFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null } | null }> } };

export type CreateApiPluginUserMutationVariables = Exact<{
  referralCode: Scalars['String'];
}>;


export type CreateApiPluginUserMutation = { __typename?: 'Mutation', createApiPluginUser: { __typename?: 'ApiCredentialsUserResponse', _id: string, companyName?: string | null, referralCode?: string | null } };

export type GenerateNewApiTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateNewApiTokenMutation = { __typename?: 'Mutation', generateNewApiToken: { __typename?: 'TokenResponse', token: string } };

export type SetMyPluginUserDisabledMutationVariables = Exact<{
  apiCredentialsId: Scalars['String'];
  disabled: Scalars['Boolean'];
}>;


export type SetMyPluginUserDisabledMutation = { __typename?: 'Mutation', setMyPluginUserDisabled: { __typename?: 'ApiCredentialSafeDTO', _id: string, isActive: boolean, partnerDisabled?: boolean | null } };

export type GetAppBasicInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppBasicInfoQuery = { __typename?: 'Query', getApiCredentialsBasicInfo?: { __typename?: 'BasicInfoResponse', appId: string, hasKey: boolean, isActive?: boolean | null, referralCode?: string | null, type?: ApiCredentialsTypesEnum | null } | null };

export type GetMyApiPluginUsersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetMyApiPluginUsersQuery = { __typename?: 'Query', getMyApiPluginUsers: { __typename?: 'ApiPluginUsersPayload', totalCount: number, collection: Array<{ __typename?: 'ApiPluginUser', monthlyApiAccess?: number | null, account: { __typename?: 'Account', _id: string, email: string }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null }, apiCredentials?: { __typename?: 'ApiCredentialsPluginUserResponse', _id: string, isActive?: boolean | null, partnerDisabled?: boolean | null } | null }> } };

export type AcceptApiInvitationMutationVariables = Exact<{
  token: Scalars['String'];
  input: AcceptApiInvitationInput;
}>;


export type AcceptApiInvitationMutation = { __typename?: 'Mutation', acceptApiInvitation: { __typename: 'MfaTempTokenModel', tempToken: string, mfaEnabled: boolean } | { __typename: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type AcceptApiInvitationForAccountMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type AcceptApiInvitationForAccountMutation = { __typename?: 'Mutation', acceptApiInvitationForAccount: { __typename: 'MfaTempTokenModel', tempToken: string, mfaEnabled: boolean } | { __typename: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type ValidateApiInvitationQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type ValidateApiInvitationQuery = { __typename?: 'Query', validateApiInvitation: { __typename?: 'ApiInvitationValidation', isValid: boolean, status?: ApiInvitationStatusEnum | null, email?: string | null, companyName?: string | null, hasExistingAccount: boolean } };

export type MyPendingApiAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPendingApiAccessQuery = { __typename?: 'Query', myPendingApiAccess: boolean };

export type ApiMetricFragment = { __typename?: 'ApiMetric', _id: string, startDate: any, endDate: any, totalRequests: number, dataPoints: Array<{ __typename?: 'MetricDataPoint', timestamp: any, requestCount: number }> };

export type GetPluginUserOwnMonthlyApiUsageQueryVariables = Exact<{
  targetMonth: Scalars['Int'];
}>;


export type GetPluginUserOwnMonthlyApiUsageQuery = { __typename?: 'Query', getPluginUserOwnMonthlyApiUsage: number };

export type GetPluginUserOwnTotalApiUsageQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<PluginUserOwnTotalApiUsageFilterInput>;
}>;


export type GetPluginUserOwnTotalApiUsageQuery = { __typename?: 'Query', getPluginUserOwnTotalApiUsage: { __typename?: 'ApiMetricPayload', totalCount: number, collection: Array<{ __typename?: 'ApiMetric', _id: string, startDate: any, endDate: any, totalRequests: number, dataPoints: Array<{ __typename?: 'MetricDataPoint', timestamp: any, requestCount: number }> }> } };

export type GetPluginUserOwnApiQuotaStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPluginUserOwnApiQuotaStatusQuery = { __typename?: 'Query', getPluginUserOwnApiQuotaStatus: { __typename?: 'ApiQuotaStatusPayload', usage: number, limit: number, resetDate: any } };

export type VisitedPropertyFragment = { __typename?: 'Property', _id: string, name: string, status: string, projectStatus?: string | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', _id: string, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } };

export type PropertyVisitActivityFragment = { __typename?: 'PropertyVisitActivity', _id: string, type: string, createdAt: any, property: { __typename?: 'Property', _id: string, name: string, status: string, projectStatus?: string | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', _id: string, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } } };

export type NewPortfolioItemActivityFragment = { __typename?: 'NewPortfolioItemActivity', _id: string, type: string, createdAt: any, deleted: boolean, portfolioItem?: { __typename?: 'Portfolio', _id: string, status: string, deleted: boolean, property?: { __typename?: 'Property', _id: string, name: string, status: string, projectStatus?: string | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', _id: string, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } } | null, portfolioFolder?: { __typename?: 'Portfolio', _id: string, name?: string | null } | null } | null };

export type DeleteBrokerActivityByIdMutationVariables = Exact<{
  activityId: Scalars['ObjectId'];
}>;


export type DeleteBrokerActivityByIdMutation = { __typename?: 'Mutation', deleteBrokerActivityById: { __typename?: 'BrokerActivity', _id: string } };

export type GetPropertyVisitActivitiesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetPropertyVisitActivitiesQuery = { __typename?: 'Query', getPropertyVisitActivities: { __typename?: 'PropertyVisitActivitiesPayload', totalCount: number, collection: Array<{ __typename?: 'PropertyVisitActivity', _id: string, type: string, createdAt: any, property: { __typename?: 'Property', _id: string, name: string, status: string, projectStatus?: string | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', _id: string, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } } }> } };

export type GetBrokerNewPortfolioItemActivitiesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetBrokerNewPortfolioItemActivitiesQuery = { __typename?: 'Query', getBrokerNewPortfolioItemActivities: { __typename?: 'NewPortfolioItemActivitiesPayload', totalCount: number, collection: Array<{ __typename?: 'NewPortfolioItemActivity', _id: string, type: string, createdAt: any, deleted: boolean, portfolioItem?: { __typename?: 'Portfolio', _id: string, status: string, deleted: boolean, property?: { __typename?: 'Property', _id: string, name: string, status: string, projectStatus?: string | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', _id: string, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } } | null, portfolioFolder?: { __typename?: 'Portfolio', _id: string, name?: string | null } | null } | null }> } };

export type BrokerFragment = { __typename?: 'Broker', _id: string, createdAt: any, agencyName?: string | null, agencyWebsite?: string | null, description?: string | null, subscriptionType: string, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> } } | null } | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseJurisdictionCode?: string | null, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, createdAt: any, status: string, stripeDefaultPaymentMethodId?: string | null, stripeCustomerId?: string | null, ssoId?: string | null, provider?: string | null, isSeeker: boolean, lastAccountTypeSwitchAt?: any | null, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null };

export type UpdateCurrentBrokerMutationVariables = Exact<{
  input: UpdateBrokerInput;
}>;


export type UpdateCurrentBrokerMutation = { __typename?: 'Mutation', updateCurrentBroker: { __typename?: 'Broker', _id: string, createdAt: any, agencyName?: string | null, agencyWebsite?: string | null, description?: string | null, subscriptionType: string, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> } } | null } | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseJurisdictionCode?: string | null, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, createdAt: any, status: string, stripeDefaultPaymentMethodId?: string | null, stripeCustomerId?: string | null, ssoId?: string | null, provider?: string | null, isSeeker: boolean, lastAccountTypeSwitchAt?: any | null, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null } };

export type RegisterBrokerMutationVariables = Exact<{
  input: RegisterBrokerInput;
}>;


export type RegisterBrokerMutation = { __typename?: 'Mutation', registerBroker: { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type CreateBrokerMutationVariables = Exact<{
  input: CreateBrokerInput;
}>;


export type CreateBrokerMutation = { __typename?: 'Mutation', createBroker: { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type CreateBrokerSsoMutationVariables = Exact<{
  input: CreateBrokerSsoInput;
}>;


export type CreateBrokerSsoMutation = { __typename?: 'Mutation', createBrokerSSO: { __typename?: 'TokensModel', accessToken: string, refreshToken: string, refreshTokenExpiry?: string | null } };

export type SendMessageToAgentMutationVariables = Exact<{
  input: SendMessageToAgentInput;
}>;


export type SendMessageToAgentMutation = { __typename?: 'Mutation', sendMessageToAgent: boolean };

export type CreateSimpleBrokerMutationVariables = Exact<{
  input: CreateSimpleBrokerInput;
}>;


export type CreateSimpleBrokerMutation = { __typename?: 'Mutation', createSimpleBroker: { __typename?: 'Broker', _id: string, createdAt: any, agencyName?: string | null, agencyWebsite?: string | null, description?: string | null, subscriptionType: string, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> } } | null } | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseJurisdictionCode?: string | null, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, createdAt: any, status: string, stripeDefaultPaymentMethodId?: string | null, stripeCustomerId?: string | null, ssoId?: string | null, provider?: string | null, isSeeker: boolean, lastAccountTypeSwitchAt?: any | null, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null } };

export type GetCurrentBrokerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentBrokerQuery = { __typename?: 'Query', getCurrentBroker: { __typename?: 'Broker', _id: string, createdAt: any, agencyName?: string | null, agencyWebsite?: string | null, description?: string | null, subscriptionType: string, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> } } | null } | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseJurisdictionCode?: string | null, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, createdAt: any, status: string, stripeDefaultPaymentMethodId?: string | null, stripeCustomerId?: string | null, ssoId?: string | null, provider?: string | null, isSeeker: boolean, lastAccountTypeSwitchAt?: any | null, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null } };

export type GetBrokerByIdQueryVariables = Exact<{
  brokerId: Scalars['ObjectId'];
}>;


export type GetBrokerByIdQuery = { __typename?: 'Query', getBrokerById: { __typename?: 'Broker', _id: string, createdAt: any, agencyName?: string | null, agencyWebsite?: string | null, description?: string | null, subscriptionType: string, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> } } | null } | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseJurisdictionCode?: string | null, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, createdAt: any, status: string, stripeDefaultPaymentMethodId?: string | null, stripeCustomerId?: string | null, ssoId?: string | null, provider?: string | null, isSeeker: boolean, lastAccountTypeSwitchAt?: any | null, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null } };

export type GetSimpleBrokerByIdQueryVariables = Exact<{
  brokerId: Scalars['ObjectId'];
}>;


export type GetSimpleBrokerByIdQuery = { __typename?: 'Query', getBrokerById: { __typename?: 'Broker', _id: string, agencyName?: string | null, agencyWebsite?: string | null, account: { __typename?: 'Account', email: string, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null }, profile: { __typename?: 'Profile', firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } } };

export type GetBrokerForAccountManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrokerForAccountManagementQuery = { __typename?: 'Query', getBrokerForAccountManagement: { __typename?: 'Broker', _id: string, createdAt: any, agencyName?: string | null, agencyWebsite?: string | null, description?: string | null, subscriptionType: string, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> } } | null } | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseJurisdictionCode?: string | null, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, createdAt: any, status: string, stripeDefaultPaymentMethodId?: string | null, stripeCustomerId?: string | null, ssoId?: string | null, provider?: string | null, isSeeker: boolean, lastAccountTypeSwitchAt?: any | null, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null } };

export type AddressFragment = { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null };

export type FeaturedPortfolioCardFragment = { __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, overview?: string | null, propertyIds?: Array<string> | null, displayOrder?: number | null, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, type: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null };

export type AddFeaturedPortfolioToSavedMutationVariables = Exact<{
  portfolioId: Scalars['ObjectId'];
}>;


export type AddFeaturedPortfolioToSavedMutation = { __typename?: 'Mutation', addFeaturedPortfolioToSaved: { __typename?: 'BrokerSavedFeaturedPortfolio', _id: string, portfolioId: string } };

export type RemoveFeaturedPortfolioFromSavedMutationVariables = Exact<{
  brokerSavedFeaturedPortfolioId: Scalars['ObjectId'];
}>;


export type RemoveFeaturedPortfolioFromSavedMutation = { __typename?: 'Mutation', removeFeaturedPortfolioFromSaved: { __typename?: 'BrokerSavedFeaturedPortfolio', _id: string, portfolioId: string } };

export type CopyFeaturedPortfolioToBrokerPortfolioMutationVariables = Exact<{
  args: CopyFeaturedPortfolioToBrokerPortfolioArgs;
}>;


export type CopyFeaturedPortfolioToBrokerPortfolioMutation = { __typename?: 'Mutation', copyFeaturedPortfolioToBrokerPortfolio: { __typename?: 'CopyFeaturedPortfolioToBrokerPortfolioResult', _id: string, name: string, propertyCount: number } };

export type GetFeaturedPortfoliosQueryVariables = Exact<{
  filter?: InputMaybe<GetFeaturedPortfoliosFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetFeaturedPortfoliosQuery = { __typename?: 'Query', getFeaturedPortfolios: { __typename?: 'FeaturedPortfoliosPayload', totalCount: number, collection: Array<{ __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, overview?: string | null, propertyIds?: Array<string> | null, displayOrder?: number | null, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, type: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null }> } };

export type GetFeaturedPortfolioByIdQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
}>;


export type GetFeaturedPortfolioByIdQuery = { __typename?: 'Query', getFeaturedPortfolioById: { __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, overview?: string | null, propertyIds?: Array<string> | null, displayOrder?: number | null, visibility: FeaturedPortfolioVisibilityEnum, createdAt: any, updatedAt: any, coverImageFile?: { __typename?: 'File', _id: string, name: string, type: string, size: number, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null } };

export type GetFeaturedPortfolioPropertiesQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
  pagination?: InputMaybe<FlatPaginationInput>;
}>;


export type GetFeaturedPortfolioPropertiesQuery = { __typename?: 'Query', getFeaturedPortfolioProperties: { __typename?: 'FeaturedPortfolioPropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'PropertyDetail', _id: string, name: string, overview?: string | null, yearBuilt?: number | null, projectStatus?: string | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, publicUrl: string, type: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }> } | null, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBedroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBathroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null }> } };

export type GetFeaturedPortfolioMarketAreasQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
}>;


export type GetFeaturedPortfolioMarketAreasQuery = { __typename?: 'Query', getFeaturedPortfolioMarketAreas: Array<{ __typename?: 'MarketAreaCount', count: number, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null }> };

export type GetFeaturedPortfolioSummaryQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
}>;


export type GetFeaturedPortfolioSummaryQuery = { __typename?: 'Query', getFeaturedPortfolioSummary?: { __typename?: 'FeaturedPortfolioSummary', propertyCount: number, marketAreas: Array<{ __typename?: 'MarketAreaCount', count: number, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, completionYearRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null } | null };

export type GetSavedFeaturedPortfoliosQueryVariables = Exact<{
  filter?: InputMaybe<GetSavedFeaturedPortfoliosFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetSavedFeaturedPortfoliosQuery = { __typename?: 'Query', getSavedFeaturedPortfolios: { __typename?: 'BrokerSavedFeaturedPortfoliosPayload', totalCount: number, collection: Array<{ __typename?: 'BrokerSavedFeaturedPortfolio', _id: string, portfolioId: string, createdAt: any }> } };

export type GetSavedFeaturedPortfoliosWithDetailsQueryVariables = Exact<{
  filter?: InputMaybe<GetSavedFeaturedPortfoliosFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetSavedFeaturedPortfoliosWithDetailsQuery = { __typename?: 'Query', getSavedFeaturedPortfolios: { __typename?: 'BrokerSavedFeaturedPortfoliosPayload', totalCount: number, collection: Array<{ __typename?: 'BrokerSavedFeaturedPortfolio', _id: string, portfolioId: string, createdAt: any, portfolio?: { __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, overview?: string | null, propertyIds?: Array<string> | null, displayOrder?: number | null, coverImageFile?: { __typename?: 'File', _id: string, publicUrl: string, type: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null } | null }> } };

export type GetIsFeaturedPortfolioSavedQueryVariables = Exact<{
  portfolioId: Scalars['ObjectId'];
}>;


export type GetIsFeaturedPortfolioSavedQuery = { __typename?: 'Query', getIsFeaturedPortfolioSaved?: { __typename?: 'BrokerSavedFeaturedPortfolio', _id: string, portfolioId: string, createdAt: any } | null };

export type GetFeaturedPortfolioByIdPublicQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
}>;


export type GetFeaturedPortfolioByIdPublicQuery = { __typename?: 'Query', getFeaturedPortfolioByIdPublic: { __typename?: 'FeaturedPortfolio', _id: string, title: string, cardDescription?: string | null, overview?: string | null, propertyIds?: Array<string> | null, displayOrder?: number | null, visibility: FeaturedPortfolioVisibilityEnum, createdAt: any, updatedAt: any, coverImageFile?: { __typename?: 'File', _id: string, name: string, type: string, size: number, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null } };

export type GetFeaturedPortfolioPropertiesPublicQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
  pagination?: InputMaybe<FlatPaginationInput>;
}>;


export type GetFeaturedPortfolioPropertiesPublicQuery = { __typename?: 'Query', getFeaturedPortfolioPropertiesPublic: { __typename?: 'FeaturedPortfolioPropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'PropertyDetail', _id: string, name: string, overview?: string | null, yearBuilt?: number | null, projectStatus?: string | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, publicUrl: string, type: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }> } | null, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBedroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBathroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null }> } };

export type GetFeaturedPortfolioSummaryPublicQueryVariables = Exact<{
  featuredPortfolioId: Scalars['String'];
}>;


export type GetFeaturedPortfolioSummaryPublicQuery = { __typename?: 'Query', getFeaturedPortfolioSummaryPublic?: { __typename?: 'FeaturedPortfolioSummary', propertyCount: number, marketAreas: Array<{ __typename?: 'MarketAreaCount', count: number, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, completionYearRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null } | null };

export type GetFeaturedPropertiesQueryVariables = Exact<{
  filter?: InputMaybe<GetFeaturedPropertiesFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetFeaturedPropertiesQuery = { __typename?: 'Query', getFeaturedProperties: { __typename?: 'FeaturedPropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'FeaturedProperty', _id: string, title: string, shortOverview?: string | null, overview?: string | null, propertyId: string, displayOrder?: number | null, visibility: FeaturedPropertyVisibilityEnum, createdAt: any, updatedAt: any, coverImageFile?: { __typename?: 'File', _id: string, name: string, type: string, size: number, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null, property: { __typename?: 'Property', projectStatus?: string | null, yearBuilt?: number | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null } }> } };

export type GetFeaturedPropertyByIdQueryVariables = Exact<{
  featuredPropertyId: Scalars['String'];
}>;


export type GetFeaturedPropertyByIdQuery = { __typename?: 'Query', getFeaturedPropertyById: { __typename?: 'FeaturedProperty', _id: string, title: string, shortOverview?: string | null, overview?: string | null, propertyId: string, displayOrder?: number | null, visibility: FeaturedPropertyVisibilityEnum, createdAt: any, updatedAt: any, coverImageFile?: { __typename?: 'File', _id: string, name: string, type: string, size: number, publicUrl: string, thumbnailFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } | null } };

export type FileFragment = { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null };

export type UploadDraftFileMutationVariables = Exact<{
  input: FileUploadInput;
}>;


export type UploadDraftFileMutation = { __typename?: 'Mutation', uploadDraftFile: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null } };

export type RegisterIdxActivityMutationVariables = Exact<{
  idxId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
}>;


export type RegisterIdxActivityMutation = { __typename?: 'Mutation', registerIdxActivity: { __typename?: 'IdxActivity', idxId: any, propertyId: any, createdAt: any } };

export type GetIdxActivityQueryVariables = Exact<{
  idxId: Scalars['ObjectId'];
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type GetIdxActivityQuery = { __typename?: 'Query', getIdxActivity: { __typename?: 'IdxActivityPayload', collection: Array<{ __typename?: 'IdxActivityCollection', date: any, totalClicks: number, propertyClicks?: Array<{ __typename?: 'PropertyClick', propertyId: any, name: string, address?: string | null, clickCount: number }> | null }> } };

export type GetIdxEmbeddedPropertyFeedQueryVariables = Exact<{
  input: GetIdxEmbeddedPropertyFeedInput;
}>;


export type GetIdxEmbeddedPropertyFeedQuery = { __typename?: 'Query', getIdxEmbeddedPropertyFeed: { __typename?: 'IdxEmbeddedPropertyFeedData', idxFeed: { __typename?: 'IdxFeed', _id: string, accountId: any, name: string, portfolioFolderId?: any | null, propertiesPerPage?: number | null, propertyId?: any | null, type: string, searchBarContent?: string | null, showPropertyDownloads?: boolean | null, showCustomPropertyDownloads?: boolean | null }, broker: { __typename?: 'Broker', _id: string, createdAt: any, agencyName?: string | null, agencyWebsite?: string | null, description?: string | null, subscriptionType: string, preferredPropertySettings?: { __typename?: 'PreferredPropertySettings', radiusInMiles?: number | null, location?: { __typename?: 'Location', googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> } } | null } | null, license?: { __typename?: 'BrokerLicense', licenseNumber: string, licenseJurisdictionCode?: string | null, licenseStatus: string } | null, account: { __typename?: 'Account', _id: string, email: string, createdAt: any, status: string, stripeDefaultPaymentMethodId?: string | null, stripeCustomerId?: string | null, ssoId?: string | null, provider?: string | null, isSeeker: boolean, lastAccountTypeSwitchAt?: any | null, phone?: { __typename?: 'Phone', number?: string | null, status: string, dialCode?: string | null } | null }, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null }, idxSettings: { __typename?: 'IdxSettings', _id: string, accountId: any, websiteDomain?: string | null, showDashCredit?: boolean | null, branding: { __typename?: 'Branding', mainColor: string, textColor: string, backgroundColor: string } }, property: { __typename?: 'Property', _id: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, transactionType: PropertyTransactionTypesEnum, comingSoon?: boolean | null, interiorDesigner?: string | null, isMarkedAsVerified: boolean, landscapeArchitect?: string | null, leadArchitect?: string | null, localArchitect?: string | null, name: string, numberOfUnits?: number | null, numberOfTowers?: number | null, overview?: string | null, projectStatus?: string | null, projectDetails?: string | null, status: string, stories?: number | null, taxInformation?: string | null, website?: string | null, yearBuilt?: number | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', _id: string, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> } }, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, publicUrl: string, thumbnailFileUrl?: string | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, publicUrl: string, thumbnailFileUrl?: string | null, type: string }> }>, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null }, propertyAmenities: Array<{ __typename?: 'Amenity', _id: string, imageUrl?: string | null, name: string }> } };

export type GetIdxPortfolioFeedPropertiesQueryVariables = Exact<{
  input: GetIdxPortfolioFeedPropertiesInput;
}>;


export type GetIdxPortfolioFeedPropertiesQuery = { __typename?: 'Query', getIdxPortfolioFeedProperties: { __typename?: 'IdxPortfolioFeedPropertiesData', portfolioItemCount: number, broker: { __typename?: 'Broker', _id: string, agencyName?: string | null, agencyWebsite?: string | null, description?: string | null, account: { __typename?: 'Account', _id: string, email: string, phone?: { __typename?: 'Phone', dialCode?: string | null, number?: string | null } | null }, accountSubscription?: { __typename?: 'ProductSubscription', _id: string, status: string } | null, profile: { __typename?: 'Profile', _id: string, firstName: string, fullName: string, lastName?: string | null, avatarFile?: { __typename?: 'File', _id: string, publicUrl: string } | null } }, portfolioFolder: { __typename?: 'Portfolio', _id: string, name?: string | null }, portfolioItems: Array<{ __typename?: 'Portfolio', _id: string, property?: { __typename?: 'Property', _id: string, comingSoon?: boolean | null, isMarkedAsVerified: boolean, name: string, projectStatus?: string | null, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, status: string, yearBuilt?: number | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', max?: number | null, min?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', max?: number | null, min?: number | null } | null, location: { __typename?: 'Location', _id: string, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> } }, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null, priceRange?: { __typename?: 'MinMax', max?: number | null, min?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, type: string, publicUrl: string, thumbnailFileUrl?: string | null }> } | null } | null }> } };

export type GetMarketAreasForFilterQueryVariables = Exact<{
  input: GetMarketAreasForFilterInput;
}>;


export type GetMarketAreasForFilterQuery = { __typename?: 'Query', getMarketAreasForFilter: Array<{ __typename?: 'MarketArea', _id: string, name: string }> };

export type GetIdxSearchFeedPropertiesQueryVariables = Exact<{
  input: GetIdxSearchFeedPropertiesInput;
}>;


export type GetIdxSearchFeedPropertiesQuery = { __typename?: 'Query', getIdxSearchFeedProperties: { __typename?: 'IdxSearchFeedPropertiesData', properties: { __typename?: 'PropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'Property', _id: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, comingSoon?: boolean | null, isMarkedAsVerified: boolean, name: string, projectStatus?: string | null, status: string, yearBuilt?: number | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', _id: string, address?: { __typename?: 'Address', city?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> } }, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, type: string, publicUrl: string, thumbnailFileUrl?: string | null }> } | null }> } } };

export type GetIdxEmbeddedSearchBarFeedQueryVariables = Exact<{
  input: GetIdxEmbeddedSearchBarFeedInput;
}>;


export type GetIdxEmbeddedSearchBarFeedQuery = { __typename?: 'Query', getIdxEmbeddedSearchBarFeed: { __typename?: 'IdxEmbeddedSearchBarFeedData', idxFeed: { __typename?: 'IdxFeed', _id: string, accountId: any, name: string, type: string, propertiesPerPage?: number | null, searchBarContent?: string | null }, idxSettings: { __typename?: 'IdxSettings', _id: string, accountId: any, websiteDomain?: string | null, showDashCredit?: boolean | null, branding: { __typename?: 'Branding', mainColor: string, textColor: string, backgroundColor: string } } } };

export type GetIdxEmbeddedPortfolioFeedQueryVariables = Exact<{
  input: GetIdxEmbeddedPortfolioFeedInput;
}>;


export type GetIdxEmbeddedPortfolioFeedQuery = { __typename?: 'Query', getIdxEmbeddedPortfolioFeed: { __typename?: 'IdxEmbeddedPortfolioFeedData', idxFeed: { __typename?: 'IdxFeed', _id: string, accountId: any, name: string, portfolioFolderId?: any | null, propertiesPerPage?: number | null, portfolioContent?: string | null, propertyId?: any | null, type: string }, idxSettings: { __typename?: 'IdxSettings', _id: string, accountId: any, websiteDomain?: string | null, showDashCredit?: boolean | null, branding: { __typename?: 'Branding', mainColor: string, textColor: string, backgroundColor: string } } } };

export type GetIdxPropertyFilesQueryVariables = Exact<{
  input: GetIdxPropertyFilesInput;
}>;


export type GetIdxPropertyFilesQuery = { __typename?: 'Query', getIdxPropertyFiles: { __typename?: 'MediaFilesPayload', filesTotalCount: number, filesCollection?: Array<{ __typename?: 'Media', _id: string, sizeInBytes: number, mediaFolderId?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, type: string, createdAt: any }> }> | null } };

export type CreateIdxFeedMutationVariables = Exact<{
  input: CreateIdxFeedInput;
}>;


export type CreateIdxFeedMutation = { __typename?: 'Mutation', createIdxFeed: { __typename?: 'IdxFeed', _id: string, accountId: any, name: string, portfolioFolderId?: any | null, propertiesPerPage?: number | null, propertyId?: any | null, type: string, showPropertyDownloads?: boolean | null, showCustomPropertyDownloads?: boolean | null } };

export type UpdateIdxFeedMutationVariables = Exact<{
  input: UpdateIdxFeedInput;
}>;


export type UpdateIdxFeedMutation = { __typename?: 'Mutation', updateIdxFeed: { __typename?: 'IdxFeed', _id: string, name: string, portfolioFolderId?: any | null, marketAreaIds?: Array<any> | null, propertiesPerPage?: number | null, propertyId?: any | null, type: string, searchBarContent?: string | null, portfolioContent?: string | null, showPropertyDownloads?: boolean | null, showCustomPropertyDownloads?: boolean | null, counties?: Array<{ __typename?: 'Place', key: string, name: string, state: string }> | null, cities?: Array<{ __typename?: 'Place', key: string, name: string, state: string }> | null } };

export type DeleteIdxFeedMutationVariables = Exact<{
  idxFeedId: Scalars['ObjectId'];
}>;


export type DeleteIdxFeedMutation = { __typename?: 'Mutation', deleteIdxFeed: boolean };

export type GetIdxFeedListQueryVariables = Exact<{
  input: GetIdxFeedListInput;
}>;


export type GetIdxFeedListQuery = { __typename?: 'Query', getIdxFeedList: { __typename?: 'GetIdxFeedListPayload', totalCount: number, collection: Array<{ __typename?: 'IdxFeed', _id: string, accountId: any, name: string, portfolioFolderId?: any | null, propertiesPerPage?: number | null, propertyId?: any | null, type: string, searchBarContent?: string | null, portfolioContent?: string | null, showPropertyDownloads?: boolean | null, showCustomPropertyDownloads?: boolean | null }> } };

export type GetIdxFeedDetailsQueryVariables = Exact<{
  idxFeedId: Scalars['ObjectId'];
}>;


export type GetIdxFeedDetailsQuery = { __typename?: 'Query', getIdxFeedDetails: { __typename?: 'IdxFeed', _id: string, accountId: any, name: string, portfolioFolderId?: any | null, marketAreaIds?: Array<any> | null, propertiesPerPage?: number | null, propertyId?: any | null, type: string, searchBarContent?: string | null, portfolioContent?: string | null, showPropertyDownloads?: boolean | null, showCustomPropertyDownloads?: boolean | null, counties?: Array<{ __typename?: 'Place', key: string, name: string, state: string }> | null, cities?: Array<{ __typename?: 'Place', key: string, name: string, state: string }> | null } };

export type CreateIdxSettingsMutationVariables = Exact<{
  websiteDomain: Scalars['String'];
  branding: BrandingInput;
  showDashCredit: Scalars['Boolean'];
  isWixSite?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateIdxSettingsMutation = { __typename?: 'Mutation', createIdxSettings: { __typename?: 'IdxSettings', _id: string, accountId: any, websiteDomain?: string | null, showDashCredit?: boolean | null, isWixSite?: boolean | null, branding: { __typename?: 'Branding', mainColor: string, textColor: string, backgroundColor: string } } };

export type UpdateIdxSettingsMutationVariables = Exact<{
  input: UpdateIdxSettingsInput;
}>;


export type UpdateIdxSettingsMutation = { __typename?: 'Mutation', updateIdxSettings: { __typename?: 'IdxSettings', _id: string, accountId: any, websiteDomain?: string | null, showDashCredit?: boolean | null, isWixSite?: boolean | null, branding: { __typename?: 'Branding', mainColor: string, textColor: string, backgroundColor: string } } };

export type GetIdxSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIdxSettingsQuery = { __typename?: 'Query', getIdxSettings: { __typename?: 'IdxSettings', _id: string, accountId: any, websiteDomain?: string | null, showDashCredit?: boolean | null, isWixSite?: boolean | null, branding: { __typename?: 'Branding', mainColor: string, textColor: string, backgroundColor: string } } };

export type MarketAreaFragment = { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } };

export type CreateMarketAreaMutationVariables = Exact<{
  input: CreateMarketAreaInput;
}>;


export type CreateMarketAreaMutation = { __typename?: 'Mutation', createMarketArea: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } };

export type EditMarketAreaMutationVariables = Exact<{
  input: EditMarketAreaInput;
}>;


export type EditMarketAreaMutation = { __typename?: 'Mutation', editMarketArea: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } };

export type DeleteMarketAreaMutationVariables = Exact<{
  marketAreaId: Scalars['ObjectId'];
}>;


export type DeleteMarketAreaMutation = { __typename?: 'Mutation', deleteMarketArea: { __typename?: 'MarketArea', _id: string } };

export type GetMarketAreasQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetMarketAreasFilterInput>;
}>;


export type GetMarketAreasQuery = { __typename?: 'Query', getMarketAreas: { __typename?: 'MarketAreasPayload', totalCount: number, collection: Array<{ __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } }> } };

export type MediaFragment = { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> };

export type GetMediaFoldersAndFilesQueryVariables = Exact<{
  filter: GetMediaFoldersAndFilesFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetMediaFoldersAndFilesQuery = { __typename?: 'Query', getMediaFoldersAndFiles: { __typename?: 'MediaFilesAndFoldersPayload', filesTotalCount: number, foldersTotalCount: number, filesCollection?: Array<{ __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }> | null, foldersCollection: Array<{ __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }> } };

export type GetMediaFilesQueryVariables = Exact<{
  filter: GetMediaFoldersAndFilesFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetMediaFilesQuery = { __typename?: 'Query', getMediaFoldersAndFiles: { __typename?: 'MediaFilesAndFoldersPayload', filesTotalCount: number, filesCollection?: Array<{ __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }> | null } };

export type GetAllFoldersInPropertyQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
  mediaFolderId?: InputMaybe<Scalars['ObjectId']>;
}>;


export type GetAllFoldersInPropertyQuery = { __typename?: 'Query', getAllFoldersInProperty: Array<{ __typename?: 'Media', _id: string, folderName?: string | null, parentMediaFoldersIds?: Array<string> | null, mediaFolderId?: string | null, systemFolderType?: string | null }> };

export type GetTopLevelFoldersInPropertyQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetTopLevelFoldersInPropertyQuery = { __typename?: 'Query', getTopLevelFoldersInProperty: Array<{ __typename?: 'Media', _id: string, folderName?: string | null, systemFolderType?: string | null }> };

export type GetAllFilesInPropertyQueryVariables = Exact<{
  filter: GetAllFilesInPropertyFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetAllFilesInPropertyQuery = { __typename?: 'Query', getAllFilesInProperty: { __typename?: 'MediaFilesAndFoldersPayload', filesTotalCount: number, filesCollection?: Array<{ __typename?: 'Media', _id: string, sizeInBytes: number, mediaFolderId?: string | null, files: Array<{ __typename?: 'File', _id: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, type: string, createdAt: any }> }> | null } };

export type GetNumberOfAllMediaFilesToDownloadQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetNumberOfAllMediaFilesToDownloadQuery = { __typename?: 'Query', getAllFilesInProperty: { __typename?: 'MediaFilesAndFoldersPayload', filesTotalCount: number } };

export type GetSlideshowMediaByPropertyQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetSlideshowMediaByPropertyQuery = { __typename?: 'Query', getSlideshowMediaByProperty: Array<{ __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }> };

export type GetPropertySlideshowMediaInPublicBrokerPortfolioQueryVariables = Exact<{
  brokerId: Scalars['ObjectId'];
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
}>;


export type GetPropertySlideshowMediaInPublicBrokerPortfolioQuery = { __typename?: 'Query', getPropertySlideshowMediaInPublicBrokerPortfolio: Array<{ __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }> };

export type GetMediaFolderByIdQueryVariables = Exact<{
  folderId: Scalars['ObjectId'];
}>;


export type GetMediaFolderByIdQuery = { __typename?: 'Query', getMediaFolderById: { __typename?: 'Media', folderName?: string | null, foldersPathCollection?: Array<{ __typename?: 'FolderPathModel', _id: string, folderName: string }> | null } };

export type ObserveMediaChangesSubscriptionVariables = Exact<{
  filter: GetMediaFoldersAndFilesFilterInput;
}>;


export type ObserveMediaChangesSubscription = { __typename?: 'Subscription', observeMediaChanges: { __typename?: 'MediaObserveSubscriptionPayload', trigger: string, document: { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } } };

export type GetPlaceOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlaceOptionsQuery = { __typename?: 'Query', getPlaceOptions: { __typename?: 'PlaceOptionsPayload', counties: Array<{ __typename?: 'PlaceOption', key: string, name: string, state: string, count: number, countyKeys: Array<string>, cityKeys: Array<string> }>, cities: Array<{ __typename?: 'PlaceOption', key: string, name: string, state: string, count: number, countyKeys: Array<string>, cityKeys: Array<string> }>, marketAreas: Array<{ __typename?: 'MarketAreaPlaceOption', marketAreaId: any, count: number, countyKeys: Array<string>, cityKeys: Array<string> }> } };

export type CountPropertiesInPlacesQueryVariables = Exact<{
  input: PlaceTargetInput;
}>;


export type CountPropertiesInPlacesQuery = { __typename?: 'Query', countPropertiesInPlaces: number };

export type PortfolioMediaKitFragment = { __typename?: 'PortfolioMediaKit', _id: string, portfolioId: any, mediaId: any, createdAt: any, updatedAt: any, isAddedToMediaKit?: boolean | null };

export type SetPortfolioMediaKitMediaMutationVariables = Exact<{
  input: UpdateMediaKitInput;
}>;


export type SetPortfolioMediaKitMediaMutation = { __typename?: 'Mutation', setPortfolioMediaKitMedia: boolean };

export type AddAllMarketingFilesToPortfolioMutationVariables = Exact<{
  portfolioItemId: Scalars['String'];
}>;


export type AddAllMarketingFilesToPortfolioMutation = { __typename?: 'Mutation', addAllMarketingFilesToPortfolio: Array<{ __typename?: 'PortfolioMediaKit', _id: string, portfolioId: any, mediaId: any, createdAt: any, updatedAt: any, isAddedToMediaKit?: boolean | null }> };

export type RemoveAllMarketingFilesFromPortfolioMutationVariables = Exact<{
  portfolioItemId: Scalars['String'];
}>;


export type RemoveAllMarketingFilesFromPortfolioMutation = { __typename?: 'Mutation', removeAllMarketingFilesFromPortfolio: Array<{ __typename?: 'PortfolioMediaKit', _id: string, portfolioId: any, mediaId: any, createdAt: any, updatedAt: any, isAddedToMediaKit?: boolean | null }> };

export type GetPortfolioMediaKitItemsQueryVariables = Exact<{
  filter: GetPortfolioMediaKitItemsInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetPortfolioMediaKitItemsQuery = { __typename?: 'Query', getPortfolioMediaKitItems: { __typename?: 'MediaKitPayload', totalCount: number, collection: Array<{ __typename?: 'PortfolioMediaKit', _id: string, isAddedToMediaKit?: boolean | null, media?: { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null }> } };

export type BrokerReactionsStatsFragment = { __typename?: 'BrokerReactionsStats', negative: number, neutral: number, positive: number };

export type PortfolioReactionFragment = { __typename?: 'PortfolioReaction', _id: string, reaction: string, guestUser: { __typename?: 'GuestUser', _id: string, fullName?: string | null, email?: string | null } };

export type AddReactionByPortfolioAndPropertyMutationVariables = Exact<{
  portfolioId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
  reaction: PortfolioReactionsEnum;
  guestUserData?: InputMaybe<SetGuestUserDataArgs>;
}>;


export type AddReactionByPortfolioAndPropertyMutation = { __typename?: 'Mutation', addReactionByPortfolioAndProperty: { __typename?: 'PortfolioReaction', _id: string, reaction: string, guestUser: { __typename?: 'GuestUser', _id: string, fullName?: string | null, email?: string | null } } };

export type GetReactionsStatsForBrokerQueryVariables = Exact<{
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type GetReactionsStatsForBrokerQuery = { __typename?: 'Query', getReactionsStatsForBroker: { __typename?: 'BrokerReactionsStats', negative: number, neutral: number, positive: number } };

export type GetBrokerGuestUserQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetBrokerGuestUserQuery = { __typename?: 'Query', getBrokerGuestUser: { __typename?: 'GuestUserPayload', totalCount: number, collection: Array<{ __typename?: 'GuestUser', _id: string, fullName?: string | null, email?: string | null }> } };

export type GetPortfoliosWithReactionsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetPortfoliosWithReactionsFilter>;
}>;


export type GetPortfoliosWithReactionsQuery = { __typename?: 'Query', getPortfoliosWithReactions: { __typename?: 'PortfoliosPayload', totalCount: number, collection: Array<{ __typename?: 'Portfolio', _id: string, viewsCount: number, property?: { __typename?: 'Property', _id: string, name: string, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null } | null, reactions: { __typename?: 'BrokerReactionsStats', total: number, negative: number, positive: number, neutral: number } }> } };

export type GetGuestUserReactionsCountQueryVariables = Exact<{
  filter: GetPortfoliosWithReactionsFilter;
}>;


export type GetGuestUserReactionsCountQuery = { __typename?: 'Query', getGuestUserReactionsCount: number };

export type PortfolioBaseFragment = { __typename?: 'Portfolio', _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean };

export type PortfolioLocationsFieldsFragment = { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> };

export type PortfolioFragment = { __typename?: 'Portfolio', viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, isAddedMediaKit?: boolean | null, showPopup?: boolean | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null } | null, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null, locations?: { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> } | null };

export type PropertyListItemFragment = { __typename?: 'Property', _id: string, name: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null };

export type PortfolioListItemFragment = { __typename?: 'Portfolio', isAddedMediaKit?: boolean | null, viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, showPopup?: boolean | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', _id: string, name: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null } | null, locations?: { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> } | null };

export type PortfoliosByPublicFolderListItemFragment = { __typename?: 'Portfolio', viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', name: string, status: string, _id: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, priceRange?: { __typename?: 'MinMax', max?: number | null, min?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null } | null, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null };

export type PortfolioFolderItemFragment = { __typename?: 'Portfolio', viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', name: string, status: string, _id: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, priceRange?: { __typename?: 'MinMax', max?: number | null, min?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null } | null };

export type AddPropertyToPortfolioMutationVariables = Exact<{
  portfolioFolderId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
  status?: InputMaybe<BrokerPortfolioStatusesEnum>;
}>;


export type AddPropertyToPortfolioMutation = { __typename?: 'Mutation', addPropertyToPortfolio: { __typename?: 'Portfolio', _id: string } };

export type AddPropertiesToPortfolioMutationVariables = Exact<{
  portfolioFolderId: Scalars['ObjectId'];
  propertyIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type AddPropertiesToPortfolioMutation = { __typename?: 'Mutation', addPropertiesToPortfolio: { __typename?: 'Portfolio', _id: string } };

export type DeletePortfolioByIdMutationVariables = Exact<{
  portfolioId: Scalars['ObjectId'];
}>;


export type DeletePortfolioByIdMutation = { __typename?: 'Mutation', deletePortfolioById: Array<{ __typename?: 'Portfolio', _id: string }> };

export type EditPortfolioFolderNameMutationVariables = Exact<{
  name: Scalars['String'];
  portfolioFolderId: Scalars['ObjectId'];
}>;


export type EditPortfolioFolderNameMutation = { __typename?: 'Mutation', editPortfolioFolderName: { __typename?: 'Portfolio', _id: string, name?: string | null } };

export type MovePortfoliosMutationVariables = Exact<{
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  portfolioIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type MovePortfoliosMutation = { __typename?: 'Mutation', movePortfolios: { __typename?: 'Portfolio', _id: string } };

export type DeletePropertyFromPortfolioByIdMutationVariables = Exact<{
  portfolioFolderId: Scalars['ObjectId'];
  propertyId: Scalars['ObjectId'];
}>;


export type DeletePropertyFromPortfolioByIdMutation = { __typename?: 'Mutation', deletePropertyFromPortfolioById: { __typename?: 'Portfolio', _id: string } };

export type CreatePortfolioFolderMutationVariables = Exact<{
  name: Scalars['String'];
  locations?: InputMaybe<PlaceTargetInput>;
}>;


export type CreatePortfolioFolderMutation = { __typename?: 'Mutation', createPortfolioFolder: { __typename?: 'Portfolio', _id: string, name?: string | null, propertyId?: string | null } };

export type UpdatePortfolioLocationsMutationVariables = Exact<{
  portfolioFolderId: Scalars['ObjectId'];
  locations: PlaceTargetInput;
}>;


export type UpdatePortfolioLocationsMutation = { __typename?: 'Mutation', updatePortfolioLocations: { __typename?: 'Portfolio', _id: string, updatedAt: any, locations?: { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> } | null } };

export type CreateSinglePropertyPortfolioMutationVariables = Exact<{
  input: CreateSinglePropertyPortfolioInput;
}>;


export type CreateSinglePropertyPortfolioMutation = { __typename?: 'Mutation', createSinglePropertyPortfolio: { __typename?: 'Portfolio', _id: string, name?: string | null } };

export type ChangePortfolioStatusMutationVariables = Exact<{
  portfolioId: Scalars['ObjectId'];
  status: BrokerPortfolioStatusesEnum;
  isAddedMediaKit?: InputMaybe<Scalars['Boolean']>;
}>;


export type ChangePortfolioStatusMutation = { __typename?: 'Mutation', changePortfolioStatus: { __typename?: 'Portfolio', viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, isAddedMediaKit?: boolean | null, showPopup?: boolean | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null } | null, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null, locations?: { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> } | null } };

export type UpdatePortfolioPasswordMutationVariables = Exact<{
  password?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['ObjectId'];
}>;


export type UpdatePortfolioPasswordMutation = { __typename?: 'Mutation', updatePortfolioPassword: { __typename?: 'Portfolio', viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, isAddedMediaKit?: boolean | null, showPopup?: boolean | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null } | null, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null, locations?: { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> } | null } };

export type ManuallyRegisterPortfolioViewMutationVariables = Exact<{
  portfolioId: Scalars['ObjectId'];
}>;


export type ManuallyRegisterPortfolioViewMutation = { __typename?: 'Mutation', manuallyRegisterPortfolioView?: { __typename?: 'ViewHistory', _id: string } | null };

export type UpdateShowPopupOnPortfolioMutationVariables = Exact<{
  showPopup: Scalars['Boolean'];
  portfolioId: Scalars['ObjectId'];
}>;


export type UpdateShowPopupOnPortfolioMutation = { __typename?: 'Mutation', updateShowPopupOnPortfolio: { __typename?: 'Portfolio', viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, isAddedMediaKit?: boolean | null, showPopup?: boolean | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null } | null, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null, locations?: { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> } | null } };

export type UpdatePortfolioSettingsMutationVariables = Exact<{
  portfolioId: Scalars['ObjectId'];
  status?: InputMaybe<BrokerPortfolioStatusesEnum>;
  isAddedMediaKit?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  showPopup?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdatePortfolioSettingsMutation = { __typename?: 'Mutation', updatePortfolioSettings: { __typename?: 'Portfolio', viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, isAddedMediaKit?: boolean | null, showPopup?: boolean | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null } | null, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null, locations?: { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> } | null } };

export type GetPortfoliosQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type GetPortfoliosQuery = { __typename?: 'Query', getPortfolios: { __typename?: 'PortfoliosPayload', totalCount: number, collection: Array<{ __typename?: 'Portfolio', isAddedMediaKit?: boolean | null, viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, showPopup?: boolean | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null, property?: { __typename?: 'Property', _id: string, name: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null } | null, locations?: { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> } | null }> } };

export type GetPortfoliosCountQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  searchText?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<GetPortfoliosFilter>;
}>;


export type GetPortfoliosCountQuery = { __typename?: 'Query', getPortfolios: { __typename?: 'PortfoliosPayload', totalCount: number } };

export type GetPortfoliosTreeQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetPortfoliosTreeQuery = { __typename?: 'Query', getPortfoliosTree: { __typename?: 'PortfoliosTreePayload', totalCount: number, collection: Array<{ __typename?: 'PortfolioTree', _id: string, type: string, name?: string | null, propertyId?: string | null, property?: { __typename?: 'Property', _id: string, name: string } | null, items: Array<{ __typename?: 'Portfolio', _id: string, type: string, name?: string | null, property?: { __typename?: 'Property', _id: string, name: string } | null }> }> } };

export type GetAllPortfolioFoldersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPortfolioFoldersQuery = { __typename?: 'Query', getAllPortfolioFolders: Array<{ __typename?: 'Portfolio', _id: string, name?: string | null, portfolioPropertiesIds?: Array<any> | null, locations?: { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> } | null }> };

export type GetPortfolioFolderItemsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  portfolioFolderId: Scalars['ObjectId'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetPortfolioFolderItemsQuery = { __typename?: 'Query', getPortfolioFolderItems: { __typename?: 'PortfoliosPayload', totalCount: number, collection: Array<{ __typename?: 'Portfolio', isAddedMediaKit?: boolean | null, name?: string | null, viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, _id: string, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null, property?: { __typename?: 'Property', name: string, status: string, _id: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, priceRange?: { __typename?: 'MinMax', max?: number | null, min?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null } | null }> } };

export type GetPortfoliosByPublicFolderQueryVariables = Exact<{
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId: Scalars['ObjectId'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetPortfoliosByPublicFolderQuery = { __typename?: 'Query', getPortfoliosByPublicFolder: { __typename?: 'PortfoliosPayload', totalCount: number, collection: Array<{ __typename?: 'Portfolio', viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', name: string, status: string, _id: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, priceRange?: { __typename?: 'MinMax', max?: number | null, min?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null } | null, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null }> } };

export type GetPortfolioFolderItemsCountQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  portfolioFolderId: Scalars['ObjectId'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetPortfolioFolderItemsCountQuery = { __typename?: 'Query', getPortfolioFolderItems: { __typename?: 'PortfoliosPayload', totalCount: number } };

export type GetPortfolioFolderRootQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPortfolioFolderRootQuery = { __typename?: 'Query', getPortfolioFolderRoot: { __typename?: 'Portfolio', _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean } };

export type GetPortfolioFolderByIdQueryVariables = Exact<{
  portfolioFolderId: Scalars['ObjectId'];
}>;


export type GetPortfolioFolderByIdQuery = { __typename?: 'Query', getPortfolioFolderById: { __typename?: 'Portfolio', isAddedMediaKit?: boolean | null, showPopup?: boolean | null, viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null } | null, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null, locations?: { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> } | null } };

export type GetPortfolioItemByIdQueryVariables = Exact<{
  portfolioFolderId: Scalars['ObjectId'];
}>;


export type GetPortfolioItemByIdQuery = { __typename?: 'Query', getPortfolioFolderById: { __typename?: 'Portfolio', portfolioFolderId?: string | null, isAddedMediaKit?: boolean | null, property?: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null } | null } };

export type GetPortfolioFirstPublicPropertyQueryVariables = Exact<{
  password?: InputMaybe<Scalars['String']>;
  brokerId: Scalars['String'];
  portfolioFolderName: Scalars['String'];
}>;


export type GetPortfolioFirstPublicPropertyQuery = { __typename?: 'Query', getPortfolioFirstPublicProperty?: { __typename?: 'Portfolio', _id: string, portfolioFolderId?: string | null, brokerId: string, isAddedMediaKit?: boolean | null, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null, showPopup?: boolean | null } | null, property?: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null } | null } | null };

export type GetPortfolioPropertiesToCompareQueryVariables = Exact<{
  portfolioIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  portfolioFolderId: Scalars['ObjectId'];
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetPortfolioPropertiesToCompareQuery = { __typename?: 'Query', getPortfolioPropertiesToCompare: { __typename?: 'PropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'Property', _id: string, name: string, status: string, yearBuilt?: number | null, numberOfUnits?: number | null, buildingTypes: Array<BuildingTypesEnum>, projectStatus?: string | null, taxInformation?: string | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, marketArea?: { __typename?: 'MarketArea', _id: string, name: string } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null }> } };

export type GetBrokerViewedPortfoliosQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<BrokerViewedPortfoliosFilter>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
}>;


export type GetBrokerViewedPortfoliosQuery = { __typename?: 'Query', getBrokerViewedPortfolios: { __typename?: 'ViewHistoryPayload', totalCount: number, collection: Array<{ __typename?: 'ViewHistory', _id: string, createdAt: any, portfolio?: { __typename?: 'Portfolio', _id: string, name?: string | null, type: string, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null, property?: { __typename?: 'Property', _id: string, name: string } | null } | null }> } };

export type CurrentBrokerHasPortfoliosQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentBrokerHasPortfoliosQuery = { __typename?: 'Query', currentBrokerHasPortfolios: boolean };

export type GetPortfolioPasswordQueryVariables = Exact<{
  portfolioId: Scalars['ObjectId'];
}>;


export type GetPortfolioPasswordQuery = { __typename?: 'Query', getPortfolioPassword?: string | null };

export type CheckIfPortfolioHasMediaKitQueryVariables = Exact<{
  portfolioId: Scalars['ObjectId'];
}>;


export type CheckIfPortfolioHasMediaKitQuery = { __typename?: 'Query', checkIfPortfolioHasMediaKit: boolean };

export type GetUserPublicPortfolioFoldersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPublicPortfolioFoldersQuery = { __typename?: 'Query', getUserPublicPortfolioFolders: Array<{ __typename?: 'Portfolio', _id: string, name?: string | null }> };

export type GetPortfolioFolderItemsBulkQueryVariables = Exact<{
  folderIds: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
  limitPerFolder?: InputMaybe<Scalars['Int']>;
}>;


export type GetPortfolioFolderItemsBulkQuery = { __typename?: 'Query', getPortfolioFolderItemsBulk: Array<{ __typename?: 'PortfolioFolderItemsGroup', folderId: string, totalCount: number, collection: Array<{ __typename?: 'Portfolio', viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', name: string, status: string, _id: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, priceRange?: { __typename?: 'MinMax', max?: number | null, min?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null } | null }> }> };

export type ObservePortfoliosChangesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ObservePortfoliosChangesSubscription = { __typename?: 'Subscription', observePortfoliosChanges: { __typename?: 'ObserveBrokerPortfolioPayload', trigger: string, document: { __typename?: 'Portfolio', viewsCount: number, withPassword: boolean, portfolioPropertiesIds?: Array<any> | null, isAddedMediaKit?: boolean | null, showPopup?: boolean | null, _id: string, name?: string | null, status: string, type: string, portfolioFolderId?: string | null, brokerId: string, updatedAt: any, createdAt: any, isParentRoot: boolean, property?: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null } | null, portfolioFolder?: { __typename?: 'Portfolio', name?: string | null } | null, locations?: { __typename?: 'PortfolioLocations', marketAreaIds: Array<any>, counties: Array<{ __typename?: 'Place', key: string, name: string, state: string }>, cities: Array<{ __typename?: 'Place', key: string, name: string, state: string }> } | null } } };

export type PropertyFragment = { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null };

export type PropertyAlertPreviewFragmentFragment = { __typename?: 'Property', _id: string, name: string, isMarkedAsVerified: boolean, projectStatus?: string | null, yearBuilt?: number | null, market?: string | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null };

export type PropertyChangelogFragment = { __typename?: 'PropertyChangelog', _id: string, type: string, createdAt: any, updatedAt: any, afterUpdate: { __typename: 'PropertyAboutChangelog' } | { __typename: 'PropertyAdditionalInformationChangelog' } | { __typename: 'PropertyDataReviewedChangelog' } | { __typename: 'PropertyDeveloperOrganizationChangelog' } | { __typename: 'PropertyFeaturesAndAmenitiesChangelog' } | { __typename: 'PropertyHighlightsChangelog' } | { __typename: 'PropertyInventoryUnitAddedChangelog' } | { __typename: 'PropertyInventoryUnitRemovedChangelog' } | { __typename: 'PropertyInventoryUnitUpdatedChangelog' } | { __typename: 'PropertyLocationChangelog' } | { __typename: 'PropertyMediaFilesMovedChangelog' } | { __typename: 'PropertyMediaRemovedChangelog' } | { __typename: 'PropertyMediaRenamedChangelog' } | { __typename: 'PropertyMediaUploadedChangelog', mediaFolderId: string, uploadedMediaId: string, folderName?: string | null } | { __typename: 'PropertyNameChangelog' } | { __typename: 'PropertyOrganizationSalesTeamsChangelog' } | { __typename: 'PropertyPriceChangelog' } | { __typename: 'PropertyVirtualToursChangelog' } | { __typename: 'PropertyWebsiteChangelog' }, property: { __typename?: 'Property', _id: string, name: string, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null } };

export type BrokerTrackedPropertyFragment = { __typename?: 'BrokerTrackedProperty', _id: string, property: { __typename?: 'Property', _id: string, name: string, numberOfUnits?: number | null, verifiedAt?: any | null, createdAt: any, yearBuilt?: number | null, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, projectStatus?: string | null, isMarkedAsVerified: boolean, constructionStartDate?: any | null, completionDate?: any | null, market?: string | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', files: Array<{ __typename?: 'File', name: string, type: string, publicUrl: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null } };

export type AddPropertyToTrackMutationVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type AddPropertyToTrackMutation = { __typename?: 'Mutation', addPropertyToTrack: { __typename?: 'BrokerTrackedProperty', _id: string } };

export type RemovePropertyFromTrackedMutationVariables = Exact<{
  brokerTrackedPropertyId: Scalars['ObjectId'];
}>;


export type RemovePropertyFromTrackedMutation = { __typename?: 'Mutation', removePropertyFromTracked: { __typename?: 'BrokerTrackedProperty', _id: string } };

export type GetPropertiesForInputQueryQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<GetBrokerPropertiesFilterInput>;
}>;


export type GetPropertiesForInputQueryQuery = { __typename?: 'Query', getBrokerProperties: { __typename?: 'PropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'Property', _id: string, name: string }> } };

export type GetBrokerPropertiesForListQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<GetBrokerPropertiesFilterInput>;
}>;


export type GetBrokerPropertiesForListQuery = { __typename?: 'Query', getBrokerProperties: { __typename?: 'PropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'Property', _id: string, name: string, numberOfUnits?: number | null, projectStatus?: string | null, yearBuilt?: number | null, cmsStatus?: string | null, lastUpdatedAtByChangelog?: any | null, lastChangelogType?: PropertyChangelogTypesEnum | null, createdAt: any, buildingTypes: Array<BuildingTypesEnum>, completionDate?: any | null, constructionStartDate?: any | null, verifiedAt?: any | null, market?: string | null, isMarkedAsVerified: boolean, averageBathroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBedroomsNumber?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, type: string, publicUrl: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, location: { __typename?: 'Location', geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null } | null } }> } };

export type GetBrokerPropertiesForMapQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  filter?: InputMaybe<GetBrokerPropertiesFilterInput>;
}>;


export type GetBrokerPropertiesForMapQuery = { __typename?: 'Query', getBrokerProperties: { __typename?: 'PropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'Property', _id: string, name: string, numberOfUnits?: number | null, projectStatus?: string | null, yearBuilt?: number | null, createdAt: any, buildingTypes: Array<BuildingTypesEnum>, completionDate?: any | null, constructionStartDate?: any | null, verifiedAt?: any | null, market?: string | null, isMarkedAsVerified: boolean, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, type: string, publicUrl: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, location: { __typename?: 'Location', geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } }> } };

export type GetPropertyByIdQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetPropertyByIdQuery = { __typename?: 'Query', getPropertyById: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null } };

export type GetPublicBrokerPortfolioQueryVariables = Exact<{
  brokerId: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderName?: InputMaybe<Scalars['String']>;
  portfolioName: Scalars['String'];
}>;


export type GetPublicBrokerPortfolioQuery = { __typename?: 'Query', getPublicBrokerPortfolio: { __typename?: 'Portfolio', _id: string, portfolioFolderId?: string | null, isAddedMediaKit?: boolean | null, brokerId: string, property?: { __typename?: 'Property', _id: string, market?: string | null, name: string, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, stories?: number | null, projectStatus?: string | null, cmsStatus?: string | null, transactionType: PropertyTransactionTypesEnum, yearBuilt?: number | null, numberOfTowers?: number | null, numberOfUnits?: number | null, landscapeArchitect?: string | null, localArchitect?: string | null, interiorDesigner?: string | null, leadArchitect?: string | null, overview?: string | null, hasChangelog: boolean, lastUpdatedAtByChangelog?: any | null, projectDetails?: string | null, taxInformation?: string | null, constructionStartDate?: any | null, slideshowMediaFolderId?: string | null, defaultInventoryDetails?: string | null, mainPropertyMediaId?: string | null, availableUnitsNumber: number, completionDate?: any | null, website?: string | null, primaryOrganizationId?: string | null, organizationIds?: Array<string> | null, salesGalleryStatus?: SalesGalleryStatusesEnum | null, salesGalleryAddress?: string | null, status: string, createdAt: any, updatedAt: any, amenityIds?: Array<string> | null, verifiedAt?: any | null, isMarkedAsVerified: boolean, contactEmail?: string | null, brandedFilesReady?: boolean | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, cheapestUnit?: { __typename?: 'Unit', startingPrice?: number | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null } } | null, slideshowMedia: Array<{ __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> }>, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, primaryOrganization?: { __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null } | null, organizations?: Array<{ __typename?: 'Organization', _id: string, name: string, website?: string | null, logoUrl?: string | null }> | null, location: { __typename?: 'Location', _id: string, googlePlaceId: string, geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, workingHours?: { __typename?: 'WorkingHours', monday?: { __typename?: 'WorkingRange', from: any, to: any } | null, tuesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, wednesday?: { __typename?: 'WorkingRange', from: any, to: any } | null, thursday?: { __typename?: 'WorkingRange', from: any, to: any } | null, friday?: { __typename?: 'WorkingRange', from: any, to: any } | null, saturday?: { __typename?: 'WorkingRange', from: any, to: any } | null, sunday?: { __typename?: 'WorkingRange', from: any, to: any } | null } | null, salesGalleryHours?: { __typename?: 'LocalTimeHours', monday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, tuesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, wednesday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, thursday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, friday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, saturday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null, sunday?: { __typename?: 'LocalTimeRange', from: string, to: string } | null } | null, saleTeams?: Array<{ __typename?: 'PropertySaleTeam', saleTeamId: string, saleAssociateIds?: Array<string> | null, saleDirectorId?: string | null, contactUrl?: string | null, commission?: number | null, saleTeam: { __typename?: 'SaleTeam', _id: string, website?: string | null, name: string, phone?: { __typename?: 'SalesTeamPhone', dialCode: string, number: string } | null, logoFile?: { __typename?: 'File', publicUrl: string } | null }, saleAssociates?: Array<{ __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } }> | null, saleDirector?: { __typename: 'OrganizationUser', _id: string, internalSaleTeamId?: string | null, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | { __typename: 'SaleTeamUser', _id: string, saleTeamId: string, profile: { __typename?: 'Profile', _id: string, firstName: string, lastName?: string | null } } | null }> | null, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, contactPhone?: { __typename?: 'ContactPhone', dialCode: string, number: string } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, virtualTourLinks?: Array<{ __typename?: 'VirtualTourLink', url: string, label?: string | null }> | null } | null } };

export type GetPropertyChangelogsQueryVariables = Exact<{
  filter: GetPropertyChangelogsFilterInput;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetPropertyChangelogsQuery = { __typename?: 'Query', getPropertyChangelogs: { __typename?: 'PropertyChangelogsPayload', totalCount: number, collection: Array<{ __typename?: 'PropertyChangelog', _id: string, type: string, createdAt: any, updatedAt: any, afterUpdate: { __typename: 'PropertyAboutChangelog' } | { __typename: 'PropertyAdditionalInformationChangelog' } | { __typename: 'PropertyDataReviewedChangelog' } | { __typename: 'PropertyDeveloperOrganizationChangelog' } | { __typename: 'PropertyFeaturesAndAmenitiesChangelog' } | { __typename: 'PropertyHighlightsChangelog' } | { __typename: 'PropertyInventoryUnitAddedChangelog' } | { __typename: 'PropertyInventoryUnitRemovedChangelog' } | { __typename: 'PropertyInventoryUnitUpdatedChangelog' } | { __typename: 'PropertyLocationChangelog' } | { __typename: 'PropertyMediaFilesMovedChangelog' } | { __typename: 'PropertyMediaRemovedChangelog' } | { __typename: 'PropertyMediaRenamedChangelog' } | { __typename: 'PropertyMediaUploadedChangelog', mediaFolderId: string, uploadedMediaId: string, folderName?: string | null } | { __typename: 'PropertyNameChangelog' } | { __typename: 'PropertyOrganizationSalesTeamsChangelog' } | { __typename: 'PropertyPriceChangelog' } | { __typename: 'PropertyVirtualToursChangelog' } | { __typename: 'PropertyWebsiteChangelog' }, property: { __typename?: 'Property', _id: string, name: string, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null } }> } };

export type GetPortfolioPropertiesChangelogsQueryVariables = Exact<{
  filter: GetPortfolioPropertiesChangelogsFilterInput;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetPortfolioPropertiesChangelogsQuery = { __typename?: 'Query', getPortfolioPropertiesChangelogs: { __typename?: 'PropertyChangelogsPayload', totalCount: number, collection: Array<{ __typename?: 'PropertyChangelog', _id: string, type: string, createdAt: any, updatedAt: any, afterUpdate: { __typename: 'PropertyAboutChangelog' } | { __typename: 'PropertyAdditionalInformationChangelog' } | { __typename: 'PropertyDataReviewedChangelog' } | { __typename: 'PropertyDeveloperOrganizationChangelog' } | { __typename: 'PropertyFeaturesAndAmenitiesChangelog' } | { __typename: 'PropertyHighlightsChangelog' } | { __typename: 'PropertyInventoryUnitAddedChangelog' } | { __typename: 'PropertyInventoryUnitRemovedChangelog' } | { __typename: 'PropertyInventoryUnitUpdatedChangelog' } | { __typename: 'PropertyLocationChangelog' } | { __typename: 'PropertyMediaFilesMovedChangelog' } | { __typename: 'PropertyMediaRemovedChangelog' } | { __typename: 'PropertyMediaRenamedChangelog' } | { __typename: 'PropertyMediaUploadedChangelog', mediaFolderId: string, uploadedMediaId: string, folderName?: string | null } | { __typename: 'PropertyNameChangelog' } | { __typename: 'PropertyOrganizationSalesTeamsChangelog' } | { __typename: 'PropertyPriceChangelog' } | { __typename: 'PropertyVirtualToursChangelog' } | { __typename: 'PropertyWebsiteChangelog' }, property: { __typename?: 'Property', _id: string, name: string, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, updatedAt: any, folderName?: string | null, type: string, mediaFolderId?: string | null, sizeInBytes: number, mediaItemsCount: number, propertyId: string, files: Array<{ __typename?: 'File', _id: string, type: string, name: string, publicUrl: string, s3Key: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null } }> } };

export type GetNumberOfPortfolioPropertiesChangelogsQueryVariables = Exact<{
  dateRange?: InputMaybe<PartialDateRangeInput>;
}>;


export type GetNumberOfPortfolioPropertiesChangelogsQuery = { __typename?: 'Query', getNumberOfPortfolioPropertiesChangelogs: number };

export type GetUniqPropertiesAmenitiesQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetUniqPropertiesAmenitiesQuery = { __typename?: 'Query', getUniqPropertiesAmenities: Array<string> };

export type GetTrackedPropertiesQueryVariables = Exact<{
  filter: GetTrackedPropertiesFilterInput;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetTrackedPropertiesQuery = { __typename?: 'Query', getTrackedProperties: { __typename?: 'BrokerTrackedPropertiesPayload', totalCount: number, collection: Array<{ __typename?: 'BrokerTrackedProperty', _id: string, property: { __typename?: 'Property', _id: string, name: string, numberOfUnits?: number | null, verifiedAt?: any | null, createdAt: any, yearBuilt?: number | null, buildingTypes: Array<BuildingTypesEnum>, propertyTags?: Array<PropertyTagsEnum> | null, projectStatus?: string | null, isMarkedAsVerified: boolean, constructionStartDate?: any | null, completionDate?: any | null, market?: string | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, location: { __typename?: 'Location', address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null }, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', files: Array<{ __typename?: 'File', name: string, type: string, publicUrl: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null } }> } };

export type GetIsPropertyTrackedQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetIsPropertyTrackedQuery = { __typename?: 'Query', getIsPropertyTracked?: { __typename?: 'BrokerTrackedProperty', _id: string } | null };

export type GetTrackedPropertiesCountQueryVariables = Exact<{
  filter?: InputMaybe<GetTrackedPropertiesFilterInput>;
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetTrackedPropertiesCountQuery = { __typename?: 'Query', getTrackedProperties: { __typename?: 'BrokerTrackedPropertiesPayload', totalCount: number } };

export type GetTrackedPropertyIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrackedPropertyIdsQuery = { __typename?: 'Query', getTrackedPropertyIds: Array<{ __typename?: 'TrackedPropertyId', _id: string, propertyId: string }> };

export type GetUniqPropertiesMarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUniqPropertiesMarketsQuery = { __typename?: 'Query', getUniqPropertiesMarkets: Array<{ __typename?: 'UnitPropertyMarket', _id: string, name: string }> };

export type ObservePropertiesChangesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ObservePropertiesChangesSubscription = { __typename?: 'Subscription', observePropertiesChanges: { __typename?: 'ObservePropertyPayload', trigger: string, document: { __typename?: 'Property', _id: string, status: string, name: string, location: { __typename?: 'Location', _id: string, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null, zipCode?: string | null } | null } } } };

export type RecommendationCardPropertyFragment = { __typename?: 'Property', _id: string, name: string, numberOfUnits?: number | null, projectStatus?: string | null, yearBuilt?: number | null, cmsStatus?: string | null, createdAt: any, buildingTypes: Array<BuildingTypesEnum>, completionDate?: any | null, constructionStartDate?: any | null, verifiedAt?: any | null, market?: string | null, isMarkedAsVerified: boolean, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, type: string, publicUrl: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, location: { __typename?: 'Location', geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null } | null } };

export type SimilarPropertiesQueryVariables = Exact<{
  propertyId: Scalars['ID'];
}>;


export type SimilarPropertiesQuery = { __typename?: 'Query', similarProperties: Array<{ __typename?: 'Property', _id: string, name: string, numberOfUnits?: number | null, projectStatus?: string | null, yearBuilt?: number | null, cmsStatus?: string | null, createdAt: any, buildingTypes: Array<BuildingTypesEnum>, completionDate?: any | null, constructionStartDate?: any | null, verifiedAt?: any | null, market?: string | null, isMarkedAsVerified: boolean, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, type: string, publicUrl: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, location: { __typename?: 'Location', geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null } | null } }> };

export type RecommendedPropertiesQueryVariables = Exact<{
  excludePropertyIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type RecommendedPropertiesQuery = { __typename?: 'Query', recommendedProperties: Array<{ __typename?: 'Property', _id: string, name: string, numberOfUnits?: number | null, projectStatus?: string | null, yearBuilt?: number | null, cmsStatus?: string | null, createdAt: any, buildingTypes: Array<BuildingTypesEnum>, completionDate?: any | null, constructionStartDate?: any | null, verifiedAt?: any | null, market?: string | null, isMarkedAsVerified: boolean, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, type: string, publicUrl: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, location: { __typename?: 'Location', geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null } | null } }> };

export type GlobalSearchQueryVariables = Exact<{
  query: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
}>;


export type GlobalSearchQuery = { __typename?: 'Query', globalSearch: { __typename?: 'SearchIndexPayload', totalCount: number, collection: Array<{ __typename?: 'SearchIndex', _id: string, refId: string, type: SearchIndexTypeEnum, subtype: SearchIndexSubtypeEnum, refs?: { __typename?: 'SearchIndexRefs', propertyId?: any | null, locationId?: any | null, organizationId?: any | null, marketAreaId?: any | null, stateId?: any | null } | null, search: { __typename?: 'SearchIndexSearch', primaryTokens: Array<string>, secondaryTokens: Array<string> }, display: { __typename?: 'SearchIndexDisplay', title: string, subtitle?: string | null }, meta: { __typename?: 'SearchIndexMeta', isActive: boolean, popularityScore?: number | null, updatedAt?: any | null } }> } };

export type StateFragment = { __typename?: 'State', _id: string, code: string, name: string };

export type GetUsStatesQueryVariables = Exact<{
  filter?: InputMaybe<GetStatesFilterInput>;
}>;


export type GetUsStatesQuery = { __typename?: 'Query', getUSStates: Array<{ __typename?: 'State', _id: string, code: string, name: string }> };

export type GetUsStateByNameQueryVariables = Exact<{
  stateName: Scalars['String'];
}>;


export type GetUsStateByNameQuery = { __typename?: 'Query', getUSStateByName: { __typename?: 'State', _id: string, code: string, name: string } };

export type SubscriptionProductFragment = { __typename?: 'SubscriptionProduct', _id: string, name: string, price: number, stripePriceId: string, stripeProductId: string, recurringType: string, trial?: number | null, deleted: boolean, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }>, coupons?: Array<{ __typename?: 'SubscriptionProductCoupon', percentOff?: number | null, active?: boolean | null, amountOff?: number | null }> | null };

export type ProductSubscriptionFragment = { __typename?: 'ProductSubscription', _id: string, status: string, currentPeriodEndAt: any, subscriptionProductId: string, subscriptionInactiveAt?: any | null, trialEndAt?: any | null, downgradeTo?: string | null, metadata?: any | null, schedule?: { __typename?: 'SubscriptionSchedule', scheduleId: string, nextPhasePriceId?: string | null, nextPhaseStart?: any | null, metadata?: any | null } | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', name: string, price: number, recurringType: string, stripeProductId: string, stripePriceId: string, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }> } };

export type ProductSubscriptionPaymentFragment = { __typename?: 'ProductSubscriptionPayment', clientSecret?: string | null, paymentStatus?: string | null };

export type CreateProductSubscriptionMutationVariables = Exact<{
  input: CreateProductSubscriptionInput;
}>;


export type CreateProductSubscriptionMutation = { __typename?: 'Mutation', createProductSubscription: { __typename?: 'ProductSubscriptionPayload', productSubscription: { __typename?: 'ProductSubscription', _id: string, status: string, currentPeriodEndAt: any, subscriptionProductId: string, subscriptionInactiveAt?: any | null, trialEndAt?: any | null, downgradeTo?: string | null, metadata?: any | null, schedule?: { __typename?: 'SubscriptionSchedule', scheduleId: string, nextPhasePriceId?: string | null, nextPhaseStart?: any | null, metadata?: any | null } | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', name: string, price: number, recurringType: string, stripeProductId: string, stripePriceId: string, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }> } }, productSubscriptionPayment?: { __typename?: 'ProductSubscriptionPayment', clientSecret?: string | null, paymentStatus?: string | null } | null } };

export type CancelProductSubscriptionMutationVariables = Exact<{
  input: CancelProductSubscriptionInput;
}>;


export type CancelProductSubscriptionMutation = { __typename?: 'Mutation', cancelProductSubscription: { __typename?: 'ProductSubscription', _id: string, status: string, currentPeriodEndAt: any, subscriptionProductId: string, subscriptionInactiveAt?: any | null, trialEndAt?: any | null, downgradeTo?: string | null, metadata?: any | null, schedule?: { __typename?: 'SubscriptionSchedule', scheduleId: string, nextPhasePriceId?: string | null, nextPhaseStart?: any | null, metadata?: any | null } | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', name: string, price: number, recurringType: string, stripeProductId: string, stripePriceId: string, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }> } } };

export type ChangeCurrentProductSubscriptionMutationVariables = Exact<{
  input: UpdateProductSubscriptionInput;
}>;


export type ChangeCurrentProductSubscriptionMutation = { __typename?: 'Mutation', changeCurrentProductSubscription: { __typename?: 'ProductSubscriptionPayload', productSubscription: { __typename?: 'ProductSubscription', _id: string, status: string, currentPeriodEndAt: any, subscriptionProductId: string, subscriptionInactiveAt?: any | null, trialEndAt?: any | null, downgradeTo?: string | null, metadata?: any | null, schedule?: { __typename?: 'SubscriptionSchedule', scheduleId: string, nextPhasePriceId?: string | null, nextPhaseStart?: any | null, metadata?: any | null } | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', name: string, price: number, recurringType: string, stripeProductId: string, stripePriceId: string, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }> } }, productSubscriptionPayment?: { __typename?: 'ProductSubscriptionPayment', clientSecret?: string | null, paymentStatus?: string | null } | null } };

export type ScheduleDowngradeMutationVariables = Exact<{
  input: ScheduleDowngradeInput;
}>;


export type ScheduleDowngradeMutation = { __typename?: 'Mutation', scheduleDowngrade: { __typename?: 'SubscriptionSchedule', nextPhasePriceId?: string | null, nextPhaseStart?: any | null, scheduleId: string } };

export type CancelScheduledDowngradeMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelScheduledDowngradeMutation = { __typename?: 'Mutation', cancelScheduledDowngrade: { __typename?: 'ProductSubscription', _id: string, status: string, currentPeriodEndAt: any, subscriptionProductId: string, subscriptionInactiveAt?: any | null, trialEndAt?: any | null, downgradeTo?: string | null, metadata?: any | null, schedule?: { __typename?: 'SubscriptionSchedule', scheduleId: string, nextPhasePriceId?: string | null, nextPhaseStart?: any | null, metadata?: any | null } | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', name: string, price: number, recurringType: string, stripeProductId: string, stripePriceId: string, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }> } } };

export type CreateCheckoutSessionMutationVariables = Exact<{
  input: CreateCheckoutSessionInput;
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession: { __typename?: 'CreateCheckoutSessionPayload', sessionUrl: string } };

export type RetryProductSubscriptionChargeMutationVariables = Exact<{ [key: string]: never; }>;


export type RetryProductSubscriptionChargeMutation = { __typename?: 'Mutation', retryProductSubscriptionCharge: { __typename?: 'ProductSubscriptionPayload', productSubscription: { __typename?: 'ProductSubscription', _id: string, status: string, currentPeriodEndAt: any, subscriptionProductId: string, subscriptionInactiveAt?: any | null, trialEndAt?: any | null, downgradeTo?: string | null, metadata?: any | null, schedule?: { __typename?: 'SubscriptionSchedule', scheduleId: string, nextPhasePriceId?: string | null, nextPhaseStart?: any | null, metadata?: any | null } | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', name: string, price: number, recurringType: string, stripeProductId: string, stripePriceId: string, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }> } }, productSubscriptionPayment?: { __typename?: 'ProductSubscriptionPayment', clientSecret?: string | null, paymentStatus?: string | null } | null } };

export type RenewProductSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type RenewProductSubscriptionMutation = { __typename?: 'Mutation', renewProductSubscription: { __typename?: 'ProductSubscriptionPayload', productSubscription: { __typename?: 'ProductSubscription', _id: string, status: string, currentPeriodEndAt: any, subscriptionProductId: string, subscriptionInactiveAt?: any | null, trialEndAt?: any | null, downgradeTo?: string | null, metadata?: any | null, schedule?: { __typename?: 'SubscriptionSchedule', scheduleId: string, nextPhasePriceId?: string | null, nextPhaseStart?: any | null, metadata?: any | null } | null, subscriptionProduct: { __typename?: 'SubscriptionProduct', name: string, price: number, recurringType: string, stripeProductId: string, stripePriceId: string, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }> } }, productSubscriptionPayment?: { __typename?: 'ProductSubscriptionPayment', clientSecret?: string | null, paymentStatus?: string | null } | null } };

export type ValidateCouponMutationVariables = Exact<{
  args: ValidateCouponInput;
}>;


export type ValidateCouponMutation = { __typename?: 'Mutation', validateCoupon: { __typename?: 'ValidateCouponPayload', isValid: boolean, invalidMessageType?: string | null, coupon?: { __typename?: 'SubscriptionProductCoupon', stripeCouponId: string, percentOff?: number | null, active?: boolean | null, code?: string | null, amountOff?: number | null, description?: string | null, duration: string, duration_in_months?: number | null } | null } };

export type GetSubscriptionProductsQueryVariables = Exact<{
  filter?: InputMaybe<GetSubscriptionProductsFilterInput>;
}>;


export type GetSubscriptionProductsQuery = { __typename?: 'Query', getSubscriptionProducts: Array<{ __typename?: 'SubscriptionProduct', _id: string, name: string, price: number, stripePriceId: string, stripeProductId: string, recurringType: string, trial?: number | null, deleted: boolean, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }>, coupons?: Array<{ __typename?: 'SubscriptionProductCoupon', percentOff?: number | null, active?: boolean | null, amountOff?: number | null }> | null }> };

export type GetCheckoutSessionDetailsQueryVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type GetCheckoutSessionDetailsQuery = { __typename?: 'Query', getCheckoutSessionDetails: { __typename?: 'CheckoutSessionDetails', customerName: string, totalAmount: number, status: string, trialEndAt?: number | null } };

export type GetPreviewInvoiceQueryVariables = Exact<{
  input: GetPreviewInvoiceInput;
}>;


export type GetPreviewInvoiceQuery = { __typename?: 'Query', getPreviewInvoice: { __typename?: 'PreviewInvoicePayload', amountDue: number, dueDateMillis: number, items: Array<{ __typename?: 'PreviewInvoiceItem', amount: number, description: string, id: string }>, coupon?: { __typename?: 'InvoiceCoupon', name: string, amountOff?: number | null, percentOff?: number | null } | null } };

export type CanUserTrialForProductQueryVariables = Exact<{
  input: CanUserTrialForProductInput;
}>;


export type CanUserTrialForProductQuery = { __typename?: 'Query', canUserTrialForProduct: boolean };

export type ObserveSubscriptionProductsChangesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ObserveSubscriptionProductsChangesSubscription = { __typename?: 'Subscription', observeSubscriptionProductsChanges: { __typename?: 'SubscriptionProductsObserveSubscriptionPayload', trigger: string, document: { __typename?: 'SubscriptionProduct', _id: string, name: string, price: number, stripePriceId: string, stripeProductId: string, recurringType: string, trial?: number | null, deleted: boolean, legacy?: boolean | null, features: Array<{ __typename?: 'SubscriptionProductFeature', active: boolean, feature: string }>, coupons?: Array<{ __typename?: 'SubscriptionProductCoupon', percentOff?: number | null, active?: boolean | null, amountOff?: number | null }> | null } } };

export type GetTrendingListQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type GetTrendingListQuery = { __typename?: 'Query', getTrendingList?: { __typename?: 'TrendingList', _id: string, periodStart: any, periodEnd: any, type: string, items: Array<{ __typename?: 'TrendingListItem', propertyId?: string | null, property?: { __typename?: 'Property', _id: string, name: string, numberOfUnits?: number | null, projectStatus?: string | null, yearBuilt?: number | null, cmsStatus?: string | null, lastUpdatedAtByChangelog?: any | null, lastChangelogType?: PropertyChangelogTypesEnum | null, createdAt: any, buildingTypes: Array<BuildingTypesEnum>, completionDate?: any | null, constructionStartDate?: any | null, verifiedAt?: any | null, market?: string | null, isMarkedAsVerified: boolean, averageBathroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, averageBedroomsNumberValue?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null, mainPropertyMediaFile?: { __typename?: 'Media', _id: string, files: Array<{ __typename?: 'File', _id: string, type: string, publicUrl: string, thumbnailFileUrl?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null }> } | null, priceRange?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, amenityNames?: Array<{ __typename?: 'AmenityName', name: string }> | null, marketArea?: { __typename?: 'MarketArea', _id: string, createdAt: any, name: string, state: { __typename?: 'State', _id: string, code: string, name: string } } | null, location: { __typename?: 'Location', geoLocation: { __typename?: 'GeoLocationJSON', coordinates: Array<number> }, address?: { __typename?: 'Address', city?: string | null, county?: string | null, state?: string | null, street?: string | null } | null } } | null }> } | null };

export type UnitFragment = { __typename?: 'Unit', _id: string, createdAt: any, floorPlanFileId?: string | null, highestPrice?: number | null, startingPrice?: number | null, customRooms?: string | null, name: string, inventoryType: string, updatedAt: any, updatedBy?: string | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageTotalSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageInteriorSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageExteriorSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, floorPlanFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null } | null };

export type GetUnitsQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetUnitsFilterInput>;
}>;


export type GetUnitsQuery = { __typename?: 'Query', getUnits: { __typename?: 'UnitsPayload', totalCount: number, collection: Array<{ __typename?: 'Unit', _id: string, createdAt: any, floorPlanFileId?: string | null, highestPrice?: number | null, startingPrice?: number | null, customRooms?: string | null, name: string, inventoryType: string, updatedAt: any, updatedBy?: string | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageTotalSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageInteriorSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageExteriorSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, floorPlanFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null } | null }> } };

export type GetUnitsCountQueryVariables = Exact<{
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetUnitsFilterInput>;
}>;


export type GetUnitsCountQuery = { __typename?: 'Query', getUnits: { __typename?: 'UnitsPayload', totalCount: number } };

export type GetPropertyUnitsInPublicBrokerPortfolioQueryVariables = Exact<{
  brokerId: Scalars['ObjectId'];
  password?: InputMaybe<Scalars['String']>;
  portfolioFolderId?: InputMaybe<Scalars['ObjectId']>;
  propertyId: Scalars['ObjectId'];
  sort?: InputMaybe<Array<SortInput> | SortInput>;
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<GetUnitsFilterInput>;
}>;


export type GetPropertyUnitsInPublicBrokerPortfolioQuery = { __typename?: 'Query', getPropertyUnitsInPublicBrokerPortfolio: { __typename?: 'UnitsPayload', totalCount: number, collection: Array<{ __typename?: 'Unit', _id: string, createdAt: any, floorPlanFileId?: string | null, highestPrice?: number | null, startingPrice?: number | null, customRooms?: string | null, name: string, inventoryType: string, updatedAt: any, updatedBy?: string | null, averageBathroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageBedroomsNumber: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageTotalSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageInteriorSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, averageExteriorSqft: { __typename?: 'MinMaxRange', min: number, max?: number | null }, floorPlanFile?: { __typename?: 'File', _id: string, name: string, size: number, type: string, s3Key: string, publicUrl: string, thumbnailFileUrl?: string | null, status: string, updatedAt: any, updatedBy?: string | null, createdAt: any, createdBy?: string | null, deleted: boolean, deletedAt?: any | null, deletedBy?: string | null, thumbnailFile?: { __typename?: 'File', publicUrl: string } | null } | null }> } };

export type GetPropertyUnitsSqftRangeQueryVariables = Exact<{
  propertyId: Scalars['ObjectId'];
}>;


export type GetPropertyUnitsSqftRangeQuery = { __typename?: 'Query', getPropertyUnitsSqftRange?: { __typename?: 'MinMaxRangePayload', min?: number | null, max?: number | null } | null };

export const TokensModelFragmentDoc = gql`
    fragment TokensModel on TokensModel {
  accessToken
  refreshToken
  refreshTokenExpiry
}
    `;
export const AccountFragmentDoc = gql`
    fragment Account on Account {
  _id
  createdAt
  phone {
    number
    status
    dialCode
  }
  email
  status
  ssoId
  stripeCustomerId
  provider
  isSeeker
  lastAccountTypeSwitchAt
  showAllBillingPlans
  language
  profile {
    _id
    firstName
    lastName
  }
}
    `;
export const StripeAccountFragmentDoc = gql`
    fragment StripeAccount on StripeAccount {
  paymentMethods {
    paymentMethodId
    cardNumber
    expiredMonth
    expiredYear
    cardBrand
  }
}
    `;
export const BrokerAlertConfigDetailsFragmentDoc = gql`
    fragment BrokerAlertConfigDetails on BrokerAlertConfig {
  _id
  name
  filter {
    priceRange {
      min
      max
    }
    locationFilter {
      lat
      lng
      radiusToSearchInMiles
    }
    unitNumberOfBathrooms {
      min
      max
    }
    unitNumberOfBedrooms {
      min
      max
    }
    unitNumberOfUnits {
      min
      max
    }
    yearBuildRange {
      min
      max
    }
    projectStatuses
    constructionDateRange {
      startDate
      endDate
    }
    buildingTypes
    propertyTags
    amenityIds
    marketAreaIds
    transactionType
  }
}
    `;
export const FileFragmentDoc = gql`
    fragment File on File {
  _id
  name
  size
  type
  s3Key
  publicUrl
  thumbnailFileUrl
  status
  updatedAt
  updatedBy
  createdAt
  createdBy
  deleted
  deletedAt
  deletedBy
  thumbnailFile {
    publicUrl
  }
}
    `;
export const AmenityFragmentDoc = gql`
    fragment Amenity on Amenity {
  _id
  createdAt
  name
  imageUrl
  imageFile {
    ...File
  }
  isPrimary
}
    ${FileFragmentDoc}`;
export const ApiMetricFragmentDoc = gql`
    fragment ApiMetric on ApiMetric {
  _id
  startDate
  endDate
  totalRequests
  dataPoints {
    timestamp
    requestCount
  }
}
    `;
export const MediaFragmentDoc = gql`
    fragment Media on Media {
  _id
  updatedAt
  files {
    _id
    type
    name
    publicUrl
    s3Key
    thumbnailFileUrl
    thumbnailFile {
      publicUrl
    }
  }
  folderName
  type
  mediaFolderId
  sizeInBytes
  mediaItemsCount
  propertyId
}
    `;
export const VisitedPropertyFragmentDoc = gql`
    fragment VisitedProperty on Property {
  _id
  name
  status
  projectStatus
  mainPropertyMediaFile {
    ...Media
  }
  priceRange {
    min
    max
  }
  location {
    _id
    address {
      city
      county
      state
      street
      zipCode
    }
  }
}
    ${MediaFragmentDoc}`;
export const PropertyVisitActivityFragmentDoc = gql`
    fragment PropertyVisitActivity on PropertyVisitActivity {
  _id
  property {
    ...VisitedProperty
  }
  type
  createdAt
}
    ${VisitedPropertyFragmentDoc}`;
export const NewPortfolioItemActivityFragmentDoc = gql`
    fragment NewPortfolioItemActivity on NewPortfolioItemActivity {
  _id
  type
  createdAt
  deleted
  portfolioItem {
    _id
    status
    deleted
    property {
      ...VisitedProperty
    }
    portfolioFolder {
      _id
      name
    }
  }
}
    ${VisitedPropertyFragmentDoc}`;
export const BrokerFragmentDoc = gql`
    fragment Broker on Broker {
  _id
  createdAt
  agencyName
  agencyWebsite
  description
  subscriptionType
  preferredPropertySettings {
    radiusInMiles
    location {
      googlePlaceId
      geoLocation {
        coordinates
      }
    }
  }
  license {
    licenseNumber
    licenseJurisdictionCode
    licenseStatus
  }
  account {
    _id
    phone {
      number
      status
      dialCode
    }
    email
    createdAt
    status
    stripeDefaultPaymentMethodId
    stripeCustomerId
    ssoId
    provider
    isSeeker
    lastAccountTypeSwitchAt
  }
  profile {
    _id
    firstName
    lastName
    avatarFile {
      _id
      publicUrl
    }
  }
  workingHours {
    monday {
      from
      to
    }
    tuesday {
      from
      to
    }
    wednesday {
      from
      to
    }
    thursday {
      from
      to
    }
    friday {
      from
      to
    }
    saturday {
      from
      to
    }
    sunday {
      from
      to
    }
  }
}
    `;
export const FeaturedPortfolioCardFragmentDoc = gql`
    fragment FeaturedPortfolioCard on FeaturedPortfolio {
  _id
  title
  cardDescription
  overview
  coverImageFile {
    _id
    publicUrl
    type
    thumbnailFile {
      _id
      publicUrl
    }
  }
  propertyIds
  displayOrder
}
    `;
export const PortfolioMediaKitFragmentDoc = gql`
    fragment PortfolioMediaKit on PortfolioMediaKit {
  _id
  portfolioId
  mediaId
  createdAt
  updatedAt
  mediaId
  isAddedToMediaKit
}
    `;
export const BrokerReactionsStatsFragmentDoc = gql`
    fragment BrokerReactionsStats on BrokerReactionsStats {
  negative
  neutral
  positive
}
    `;
export const PortfolioReactionFragmentDoc = gql`
    fragment PortfolioReaction on PortfolioReaction {
  _id
  reaction
  guestUser {
    _id
    fullName
    email
  }
}
    `;
export const PortfolioBaseFragmentDoc = gql`
    fragment PortfolioBase on Portfolio {
  _id
  name
  status
  type
  portfolioFolderId
  brokerId
  updatedAt
  createdAt
  isParentRoot
}
    `;
export const StateFragmentDoc = gql`
    fragment State on State {
  _id
  code
  name
}
    `;
export const MarketAreaFragmentDoc = gql`
    fragment MarketArea on MarketArea {
  _id
  createdAt
  name
  state {
    ...State
  }
}
    ${StateFragmentDoc}`;
export const PropertyFragmentDoc = gql`
    fragment Property on Property {
  _id
  market
  marketArea {
    ...MarketArea
  }
  name
  buildingTypes
  propertyTags
  stories
  projectStatus
  cmsStatus
  transactionType
  yearBuilt
  numberOfTowers
  numberOfUnits
  landscapeArchitect
  localArchitect
  interiorDesigner
  leadArchitect
  overview
  hasChangelog
  lastUpdatedAtByChangelog
  projectDetails
  taxInformation
  constructionStartDate
  slideshowMediaFolderId
  defaultInventoryDetails
  mainPropertyMediaId
  availableUnitsNumber
  mainPropertyMediaFile {
    _id
    files {
      thumbnailFile {
        publicUrl
      }
    }
  }
  cheapestUnit {
    averageBathroomsNumber {
      min
      max
    }
    averageBedroomsNumber {
      min
      max
    }
    startingPrice
  }
  mainPropertyMediaFile {
    _id
    files {
      ...File
    }
  }
  slideshowMedia {
    _id
    files {
      ...File
    }
  }
  constructionStartDate
  slideshowMediaFolderId
  completionDate
  priceRange {
    min
    max
  }
  website
  primaryOrganizationId
  primaryOrganization {
    _id
    name
    website
    logoUrl
  }
  organizationIds
  organizations {
    _id
    name
    website
    logoUrl
  }
  location {
    _id
    googlePlaceId
    geoLocation {
      coordinates
    }
    address {
      city
      county
      state
      street
      zipCode
    }
  }
  workingHours {
    monday {
      from
      to
    }
    tuesday {
      from
      to
    }
    wednesday {
      from
      to
    }
    thursday {
      from
      to
    }
    friday {
      from
      to
    }
    saturday {
      from
      to
    }
    sunday {
      from
      to
    }
  }
  salesGalleryStatus
  salesGalleryAddress
  salesGalleryHours {
    monday {
      from
      to
    }
    tuesday {
      from
      to
    }
    wednesday {
      from
      to
    }
    thursday {
      from
      to
    }
    friday {
      from
      to
    }
    saturday {
      from
      to
    }
    sunday {
      from
      to
    }
  }
  saleTeams {
    saleTeamId
    saleTeam {
      _id
      website
      name
      phone {
        dialCode
        number
      }
      logoFile {
        publicUrl
      }
    }
    saleAssociateIds
    saleAssociates {
      __typename
      ... on SaleTeamUser {
        _id
        saleTeamId
        profile {
          _id
          firstName
          lastName
        }
      }
      ... on OrganizationUser {
        _id
        internalSaleTeamId
        profile {
          _id
          firstName
          lastName
        }
      }
    }
    saleDirectorId
    saleDirector {
      __typename
      ... on SaleTeamUser {
        _id
        saleTeamId
        profile {
          _id
          firstName
          lastName
        }
      }
      ... on OrganizationUser {
        _id
        internalSaleTeamId
        profile {
          _id
          firstName
          lastName
        }
      }
    }
    contactUrl
    commission
  }
  status
  createdAt
  updatedAt
  amenityIds
  verifiedAt
  averageBathroomsNumberValue {
    min
    max
  }
  averageBedroomsNumberValue {
    min
    max
  }
  availableUnitsNumber
  numberOfUnits
  isMarkedAsVerified
  contactPhone {
    dialCode
    number
  }
  amenityNames {
    name
  }
  contactEmail
  virtualTourLinks {
    url
    label
  }
  brandedFilesReady
}
    ${MarketAreaFragmentDoc}
${FileFragmentDoc}`;
export const PortfolioLocationsFieldsFragmentDoc = gql`
    fragment PortfolioLocationsFields on PortfolioLocations {
  marketAreaIds
  counties {
    key
    name
    state
  }
  cities {
    key
    name
    state
  }
}
    `;
export const PortfolioFragmentDoc = gql`
    fragment Portfolio on Portfolio {
  ...PortfolioBase
  property {
    ...Property
    averageBathroomsNumberValue {
      min
      max
    }
    averageBedroomsNumberValue {
      min
      max
    }
  }
  viewsCount
  withPassword
  portfolioPropertiesIds
  isAddedMediaKit
  showPopup
  portfolioFolder {
    name
  }
  locations {
    ...PortfolioLocationsFields
  }
}
    ${PortfolioBaseFragmentDoc}
${PropertyFragmentDoc}
${PortfolioLocationsFieldsFragmentDoc}`;
export const PropertyListItemFragmentDoc = gql`
    fragment PropertyListItem on Property {
  _id
  name
  mainPropertyMediaFile {
    _id
    files {
      ...File
    }
  }
  location {
    _id
    googlePlaceId
    geoLocation {
      coordinates
    }
    address {
      city
      county
      state
      street
      zipCode
    }
  }
  isMarkedAsVerified
  projectStatus
  yearBuilt
  market
  marketArea {
    ...MarketArea
  }
  averageBathroomsNumberValue {
    min
    max
  }
  averageBedroomsNumberValue {
    min
    max
  }
}
    ${FileFragmentDoc}
${MarketAreaFragmentDoc}`;
export const PortfolioListItemFragmentDoc = gql`
    fragment PortfolioListItem on Portfolio {
  ...PortfolioBase
  isAddedMediaKit
  property {
    ...PropertyListItem
    averageBathroomsNumberValue {
      min
      max
    }
    averageBedroomsNumberValue {
      min
      max
    }
  }
  viewsCount
  withPassword
  portfolioPropertiesIds
  showPopup
  locations {
    ...PortfolioLocationsFields
  }
}
    ${PortfolioBaseFragmentDoc}
${PropertyListItemFragmentDoc}
${PortfolioLocationsFieldsFragmentDoc}`;
export const PortfoliosByPublicFolderListItemFragmentDoc = gql`
    fragment PortfoliosByPublicFolderListItem on Portfolio {
  ...PortfolioBase
  property {
    name
    priceRange {
      max
      min
    }
    status
    ...PropertyListItem
  }
  viewsCount
  withPassword
  portfolioPropertiesIds
  portfolioFolder {
    name
  }
}
    ${PortfolioBaseFragmentDoc}
${PropertyListItemFragmentDoc}`;
export const PortfolioFolderItemFragmentDoc = gql`
    fragment PortfolioFolderItem on Portfolio {
  ...PortfolioBase
  property {
    name
    priceRange {
      max
      min
    }
    status
    ...PropertyListItem
  }
  viewsCount
  withPassword
  portfolioPropertiesIds
}
    ${PortfolioBaseFragmentDoc}
${PropertyListItemFragmentDoc}`;
export const PropertyAlertPreviewFragmentFragmentDoc = gql`
    fragment PropertyAlertPreviewFragment on Property {
  _id
  name
  cheapestUnit {
    averageBathroomsNumber {
      min
      max
    }
    averageBedroomsNumber {
      min
      max
    }
    startingPrice
  }
  mainPropertyMediaFile {
    _id
    files {
      ...File
    }
  }
  priceRange {
    min
    max
  }
  location {
    _id
    googlePlaceId
    geoLocation {
      coordinates
    }
    address {
      city
      county
      state
      street
      zipCode
    }
  }
  averageBathroomsNumberValue {
    min
    max
  }
  averageBedroomsNumberValue {
    min
    max
  }
  isMarkedAsVerified
  projectStatus
  yearBuilt
  market
}
    ${FileFragmentDoc}`;
export const PropertyChangelogFragmentDoc = gql`
    fragment PropertyChangelog on PropertyChangelog {
  _id
  type
  createdAt
  updatedAt
  afterUpdate {
    __typename
    ... on PropertyMediaUploadedChangelog {
      mediaFolderId
      uploadedMediaId
      folderName
    }
  }
  property {
    _id
    name
    mainPropertyMediaFile {
      ...Media
    }
  }
}
    ${MediaFragmentDoc}`;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  city
  county
  state
  street
  zipCode
}
    `;
export const BrokerTrackedPropertyFragmentDoc = gql`
    fragment BrokerTrackedProperty on BrokerTrackedProperty {
  _id
  property {
    _id
    name
    numberOfUnits
    verifiedAt
    createdAt
    yearBuilt
    buildingTypes
    propertyTags
    projectStatus
    isMarkedAsVerified
    constructionStartDate
    completionDate
    market
    marketArea {
      ...MarketArea
    }
    amenityNames {
      name
    }
    priceRange {
      min
      max
    }
    location {
      address {
        ...Address
      }
    }
    averageBathroomsNumberValue {
      min
      max
    }
    averageBedroomsNumberValue {
      min
      max
    }
    mainPropertyMediaFile {
      files {
        name
        type
        publicUrl
        thumbnailFileUrl
        thumbnailFile {
          publicUrl
        }
      }
    }
  }
}
    ${MarketAreaFragmentDoc}
${AddressFragmentDoc}`;
export const RecommendationCardPropertyFragmentDoc = gql`
    fragment RecommendationCardProperty on Property {
  _id
  name
  averageBathroomsNumberValue {
    min
    max
  }
  averageBedroomsNumberValue {
    min
    max
  }
  mainPropertyMediaFile {
    _id
    files {
      _id
      type
      publicUrl
      thumbnailFileUrl
      thumbnailFile {
        publicUrl
      }
    }
  }
  priceRange {
    min
    max
  }
  numberOfUnits
  projectStatus
  yearBuilt
  cmsStatus
  createdAt
  buildingTypes
  completionDate
  constructionStartDate
  amenityNames {
    name
  }
  verifiedAt
  market
  marketArea {
    ...MarketArea
  }
  location {
    geoLocation {
      coordinates
    }
    address {
      city
      county
      state
      street
    }
  }
  isMarkedAsVerified
}
    ${MarketAreaFragmentDoc}`;
export const SubscriptionProductFragmentDoc = gql`
    fragment SubscriptionProduct on SubscriptionProduct {
  _id
  name
  price
  stripePriceId
  stripeProductId
  recurringType
  features {
    active
    feature
  }
  coupons {
    percentOff
    active
    amountOff
  }
  trial
  deleted
  legacy
}
    `;
export const ProductSubscriptionFragmentDoc = gql`
    fragment ProductSubscription on ProductSubscription {
  _id
  status
  currentPeriodEndAt
  subscriptionProductId
  subscriptionInactiveAt
  trialEndAt
  downgradeTo
  metadata
  schedule {
    scheduleId
    nextPhasePriceId
    nextPhaseStart
    metadata
  }
  subscriptionProduct {
    name
    price
    recurringType
    stripeProductId
    stripePriceId
    legacy
    features {
      active
      feature
    }
  }
}
    `;
export const ProductSubscriptionPaymentFragmentDoc = gql`
    fragment ProductSubscriptionPayment on ProductSubscriptionPayment {
  clientSecret
  paymentStatus
}
    `;
export const UnitFragmentDoc = gql`
    fragment Unit on Unit {
  _id
  averageBathroomsNumber {
    min
    max
  }
  averageBedroomsNumber {
    min
    max
  }
  createdAt
  floorPlanFileId
  highestPrice
  averageTotalSqft {
    min
    max
  }
  averageInteriorSqft {
    min
    max
  }
  averageExteriorSqft {
    min
    max
  }
  startingPrice
  customRooms
  name
  inventoryType
  updatedAt
  updatedBy
  floorPlanFile {
    ...File
  }
}
    ${FileFragmentDoc}`;
export const AuthorizationDocument = gql`
    mutation authorization($email: String!, $password: String!) {
  authorization(email: $email, password: $password) {
    __typename
    ... on TokensModel {
      ...TokensModel
    }
    ... on MfaTempTokenModel {
      tempToken
      mfaEnabled
    }
  }
}
    ${TokensModelFragmentDoc}`;
export type AuthorizationMutationFn = Apollo.MutationFunction<AuthorizationMutation, AuthorizationMutationVariables>;

/**
 * __useAuthorizationMutation__
 *
 * To run a mutation, you first call `useAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authorizationMutation, { data, loading, error }] = useAuthorizationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<AuthorizationMutation, AuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthorizationMutation, AuthorizationMutationVariables>(AuthorizationDocument, options);
      }
export type AuthorizationMutationHookResult = ReturnType<typeof useAuthorizationMutation>;
export type AuthorizationMutationResult = Apollo.MutationResult<AuthorizationMutation>;
export type AuthorizationMutationOptions = Apollo.BaseMutationOptions<AuthorizationMutation, AuthorizationMutationVariables>;
export const EnableMfaDocument = gql`
    mutation enableMfa($token: String!, $method: MfaMethodsEnum) {
  enableMfa(token: $token, method: $method) {
    ...TokensModel
  }
}
    ${TokensModelFragmentDoc}`;
export type EnableMfaMutationFn = Apollo.MutationFunction<EnableMfaMutation, EnableMfaMutationVariables>;

/**
 * __useEnableMfaMutation__
 *
 * To run a mutation, you first call `useEnableMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableMfaMutation, { data, loading, error }] = useEnableMfaMutation({
 *   variables: {
 *      token: // value for 'token'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useEnableMfaMutation(baseOptions?: Apollo.MutationHookOptions<EnableMfaMutation, EnableMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableMfaMutation, EnableMfaMutationVariables>(EnableMfaDocument, options);
      }
export type EnableMfaMutationHookResult = ReturnType<typeof useEnableMfaMutation>;
export type EnableMfaMutationResult = Apollo.MutationResult<EnableMfaMutation>;
export type EnableMfaMutationOptions = Apollo.BaseMutationOptions<EnableMfaMutation, EnableMfaMutationVariables>;
export const SendMfaEmailCodeDocument = gql`
    mutation sendMfaEmailCode {
  sendMfaEmailCode
}
    `;
export type SendMfaEmailCodeMutationFn = Apollo.MutationFunction<SendMfaEmailCodeMutation, SendMfaEmailCodeMutationVariables>;

/**
 * __useSendMfaEmailCodeMutation__
 *
 * To run a mutation, you first call `useSendMfaEmailCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMfaEmailCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMfaEmailCodeMutation, { data, loading, error }] = useSendMfaEmailCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendMfaEmailCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendMfaEmailCodeMutation, SendMfaEmailCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMfaEmailCodeMutation, SendMfaEmailCodeMutationVariables>(SendMfaEmailCodeDocument, options);
      }
export type SendMfaEmailCodeMutationHookResult = ReturnType<typeof useSendMfaEmailCodeMutation>;
export type SendMfaEmailCodeMutationResult = Apollo.MutationResult<SendMfaEmailCodeMutation>;
export type SendMfaEmailCodeMutationOptions = Apollo.BaseMutationOptions<SendMfaEmailCodeMutation, SendMfaEmailCodeMutationVariables>;
export const MfaAuthenticationDocument = gql`
    mutation mfaAuthentication($token: String!) {
  mfaAuthentication(token: $token) {
    ...TokensModel
  }
}
    ${TokensModelFragmentDoc}`;
export type MfaAuthenticationMutationFn = Apollo.MutationFunction<MfaAuthenticationMutation, MfaAuthenticationMutationVariables>;

/**
 * __useMfaAuthenticationMutation__
 *
 * To run a mutation, you first call `useMfaAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfaAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfaAuthenticationMutation, { data, loading, error }] = useMfaAuthenticationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useMfaAuthenticationMutation(baseOptions?: Apollo.MutationHookOptions<MfaAuthenticationMutation, MfaAuthenticationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfaAuthenticationMutation, MfaAuthenticationMutationVariables>(MfaAuthenticationDocument, options);
      }
export type MfaAuthenticationMutationHookResult = ReturnType<typeof useMfaAuthenticationMutation>;
export type MfaAuthenticationMutationResult = Apollo.MutationResult<MfaAuthenticationMutation>;
export type MfaAuthenticationMutationOptions = Apollo.BaseMutationOptions<MfaAuthenticationMutation, MfaAuthenticationMutationVariables>;
export const RefreshTokensDocument = gql`
    mutation refreshTokens {
  refreshTokens {
    ...TokensModel
  }
}
    ${TokensModelFragmentDoc}`;
export type RefreshTokensMutationFn = Apollo.MutationFunction<RefreshTokensMutation, RefreshTokensMutationVariables>;

/**
 * __useRefreshTokensMutation__
 *
 * To run a mutation, you first call `useRefreshTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokensMutation, { data, loading, error }] = useRefreshTokensMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokensMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokensMutation, RefreshTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokensMutation, RefreshTokensMutationVariables>(RefreshTokensDocument, options);
      }
export type RefreshTokensMutationHookResult = ReturnType<typeof useRefreshTokensMutation>;
export type RefreshTokensMutationResult = Apollo.MutationResult<RefreshTokensMutation>;
export type RefreshTokensMutationOptions = Apollo.BaseMutationOptions<RefreshTokensMutation, RefreshTokensMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($newPassword: String!) {
  resetPassword(newPassword: $newPassword)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($oldPassword: String!, $newPassword: String!) {
  updatePassword(oldPassword: $oldPassword, newPassword: $newPassword)
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const AttachDefaultStripePaymentMethodDocument = gql`
    mutation attachDefaultStripePaymentMethod($stripePaymentMethodId: String!) {
  attachDefaultStripePaymentMethod(stripePaymentMethodId: $stripePaymentMethodId) {
    _id
  }
}
    `;
export type AttachDefaultStripePaymentMethodMutationFn = Apollo.MutationFunction<AttachDefaultStripePaymentMethodMutation, AttachDefaultStripePaymentMethodMutationVariables>;

/**
 * __useAttachDefaultStripePaymentMethodMutation__
 *
 * To run a mutation, you first call `useAttachDefaultStripePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachDefaultStripePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachDefaultStripePaymentMethodMutation, { data, loading, error }] = useAttachDefaultStripePaymentMethodMutation({
 *   variables: {
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useAttachDefaultStripePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<AttachDefaultStripePaymentMethodMutation, AttachDefaultStripePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachDefaultStripePaymentMethodMutation, AttachDefaultStripePaymentMethodMutationVariables>(AttachDefaultStripePaymentMethodDocument, options);
      }
export type AttachDefaultStripePaymentMethodMutationHookResult = ReturnType<typeof useAttachDefaultStripePaymentMethodMutation>;
export type AttachDefaultStripePaymentMethodMutationResult = Apollo.MutationResult<AttachDefaultStripePaymentMethodMutation>;
export type AttachDefaultStripePaymentMethodMutationOptions = Apollo.BaseMutationOptions<AttachDefaultStripePaymentMethodMutation, AttachDefaultStripePaymentMethodMutationVariables>;
export const DetachPaymentMethodFromCustomerDocument = gql`
    mutation detachPaymentMethodFromCustomer($stripePaymentMethodId: String!) {
  detachPaymentMethodFromCustomer(stripePaymentMethodId: $stripePaymentMethodId) {
    _id
  }
}
    `;
export type DetachPaymentMethodFromCustomerMutationFn = Apollo.MutationFunction<DetachPaymentMethodFromCustomerMutation, DetachPaymentMethodFromCustomerMutationVariables>;

/**
 * __useDetachPaymentMethodFromCustomerMutation__
 *
 * To run a mutation, you first call `useDetachPaymentMethodFromCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachPaymentMethodFromCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachPaymentMethodFromCustomerMutation, { data, loading, error }] = useDetachPaymentMethodFromCustomerMutation({
 *   variables: {
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useDetachPaymentMethodFromCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DetachPaymentMethodFromCustomerMutation, DetachPaymentMethodFromCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachPaymentMethodFromCustomerMutation, DetachPaymentMethodFromCustomerMutationVariables>(DetachPaymentMethodFromCustomerDocument, options);
      }
export type DetachPaymentMethodFromCustomerMutationHookResult = ReturnType<typeof useDetachPaymentMethodFromCustomerMutation>;
export type DetachPaymentMethodFromCustomerMutationResult = Apollo.MutationResult<DetachPaymentMethodFromCustomerMutation>;
export type DetachPaymentMethodFromCustomerMutationOptions = Apollo.BaseMutationOptions<DetachPaymentMethodFromCustomerMutation, DetachPaymentMethodFromCustomerMutationVariables>;
export const AttachStripePaymentMethodDocument = gql`
    mutation attachStripePaymentMethod($stripePaymentMethodId: String!) {
  attachStripePaymentMethod(stripePaymentMethodId: $stripePaymentMethodId) {
    paymentMethods {
      paymentMethodId
      cardNumber
      expiredMonth
      expiredYear
      cardBrand
    }
  }
}
    `;
export type AttachStripePaymentMethodMutationFn = Apollo.MutationFunction<AttachStripePaymentMethodMutation, AttachStripePaymentMethodMutationVariables>;

/**
 * __useAttachStripePaymentMethodMutation__
 *
 * To run a mutation, you first call `useAttachStripePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachStripePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachStripePaymentMethodMutation, { data, loading, error }] = useAttachStripePaymentMethodMutation({
 *   variables: {
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useAttachStripePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<AttachStripePaymentMethodMutation, AttachStripePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachStripePaymentMethodMutation, AttachStripePaymentMethodMutationVariables>(AttachStripePaymentMethodDocument, options);
      }
export type AttachStripePaymentMethodMutationHookResult = ReturnType<typeof useAttachStripePaymentMethodMutation>;
export type AttachStripePaymentMethodMutationResult = Apollo.MutationResult<AttachStripePaymentMethodMutation>;
export type AttachStripePaymentMethodMutationOptions = Apollo.BaseMutationOptions<AttachStripePaymentMethodMutation, AttachStripePaymentMethodMutationVariables>;
export const ValidatePhoneNumberDocument = gql`
    mutation validatePhoneNumber($code: String!, $attribution: SignupAttributionInput) {
  validatePhoneNumber(code: $code, attribution: $attribution) {
    _id
    phone {
      status
    }
  }
}
    `;
export type ValidatePhoneNumberMutationFn = Apollo.MutationFunction<ValidatePhoneNumberMutation, ValidatePhoneNumberMutationVariables>;

/**
 * __useValidatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useValidatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePhoneNumberMutation, { data, loading, error }] = useValidatePhoneNumberMutation({
 *   variables: {
 *      code: // value for 'code'
 *      attribution: // value for 'attribution'
 *   },
 * });
 */
export function useValidatePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ValidatePhoneNumberMutation, ValidatePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidatePhoneNumberMutation, ValidatePhoneNumberMutationVariables>(ValidatePhoneNumberDocument, options);
      }
export type ValidatePhoneNumberMutationHookResult = ReturnType<typeof useValidatePhoneNumberMutation>;
export type ValidatePhoneNumberMutationResult = Apollo.MutationResult<ValidatePhoneNumberMutation>;
export type ValidatePhoneNumberMutationOptions = Apollo.BaseMutationOptions<ValidatePhoneNumberMutation, ValidatePhoneNumberMutationVariables>;
export const RecordLastTouchAttributionDocument = gql`
    mutation recordLastTouchAttribution($attribution: AttributionInput!) {
  recordLastTouchAttribution(attribution: $attribution)
}
    `;
export type RecordLastTouchAttributionMutationFn = Apollo.MutationFunction<RecordLastTouchAttributionMutation, RecordLastTouchAttributionMutationVariables>;

/**
 * __useRecordLastTouchAttributionMutation__
 *
 * To run a mutation, you first call `useRecordLastTouchAttributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordLastTouchAttributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordLastTouchAttributionMutation, { data, loading, error }] = useRecordLastTouchAttributionMutation({
 *   variables: {
 *      attribution: // value for 'attribution'
 *   },
 * });
 */
export function useRecordLastTouchAttributionMutation(baseOptions?: Apollo.MutationHookOptions<RecordLastTouchAttributionMutation, RecordLastTouchAttributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordLastTouchAttributionMutation, RecordLastTouchAttributionMutationVariables>(RecordLastTouchAttributionDocument, options);
      }
export type RecordLastTouchAttributionMutationHookResult = ReturnType<typeof useRecordLastTouchAttributionMutation>;
export type RecordLastTouchAttributionMutationResult = Apollo.MutationResult<RecordLastTouchAttributionMutation>;
export type RecordLastTouchAttributionMutationOptions = Apollo.BaseMutationOptions<RecordLastTouchAttributionMutation, RecordLastTouchAttributionMutationVariables>;
export const UpdateEmailDocument = gql`
    mutation updateEmail($password: String!, $newEmail: String!) {
  updateEmail(password: $password, newEmail: $newEmail) {
    accessToken
    refreshTokenExpiry
    refreshToken
  }
}
    `;
export type UpdateEmailMutationFn = Apollo.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>;

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      password: // value for 'password'
 *      newEmail: // value for 'newEmail'
 *   },
 * });
 */
export function useUpdateEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMutation, UpdateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, options);
      }
export type UpdateEmailMutationHookResult = ReturnType<typeof useUpdateEmailMutation>;
export type UpdateEmailMutationResult = Apollo.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const UpdateSsoIdDocument = gql`
    mutation updateSSOId($ssoId: String!) {
  updateSSOId(ssoId: $ssoId) {
    ssoId
  }
}
    `;
export type UpdateSsoIdMutationFn = Apollo.MutationFunction<UpdateSsoIdMutation, UpdateSsoIdMutationVariables>;

/**
 * __useUpdateSsoIdMutation__
 *
 * To run a mutation, you first call `useUpdateSsoIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSsoIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSsoIdMutation, { data, loading, error }] = useUpdateSsoIdMutation({
 *   variables: {
 *      ssoId: // value for 'ssoId'
 *   },
 * });
 */
export function useUpdateSsoIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSsoIdMutation, UpdateSsoIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSsoIdMutation, UpdateSsoIdMutationVariables>(UpdateSsoIdDocument, options);
      }
export type UpdateSsoIdMutationHookResult = ReturnType<typeof useUpdateSsoIdMutation>;
export type UpdateSsoIdMutationResult = Apollo.MutationResult<UpdateSsoIdMutation>;
export type UpdateSsoIdMutationOptions = Apollo.BaseMutationOptions<UpdateSsoIdMutation, UpdateSsoIdMutationVariables>;
export const SendVerificationCodeDocument = gql`
    mutation sendVerificationCode($phone: PhoneInput!) {
  sendVerificationCode(phone: $phone) {
    _id
  }
}
    `;
export type SendVerificationCodeMutationFn = Apollo.MutationFunction<SendVerificationCodeMutation, SendVerificationCodeMutationVariables>;

/**
 * __useSendVerificationCodeMutation__
 *
 * To run a mutation, you first call `useSendVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerificationCodeMutation, { data, loading, error }] = useSendVerificationCodeMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useSendVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendVerificationCodeMutation, SendVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVerificationCodeMutation, SendVerificationCodeMutationVariables>(SendVerificationCodeDocument, options);
      }
export type SendVerificationCodeMutationHookResult = ReturnType<typeof useSendVerificationCodeMutation>;
export type SendVerificationCodeMutationResult = Apollo.MutationResult<SendVerificationCodeMutation>;
export type SendVerificationCodeMutationOptions = Apollo.BaseMutationOptions<SendVerificationCodeMutation, SendVerificationCodeMutationVariables>;
export const SendEmailVerificationCodeDocument = gql`
    mutation sendEmailVerificationCode {
  sendEmailVerificationCode {
    _id
  }
}
    `;
export type SendEmailVerificationCodeMutationFn = Apollo.MutationFunction<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>;

/**
 * __useSendEmailVerificationCodeMutation__
 *
 * To run a mutation, you first call `useSendEmailVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailVerificationCodeMutation, { data, loading, error }] = useSendEmailVerificationCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendEmailVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>(SendEmailVerificationCodeDocument, options);
      }
export type SendEmailVerificationCodeMutationHookResult = ReturnType<typeof useSendEmailVerificationCodeMutation>;
export type SendEmailVerificationCodeMutationResult = Apollo.MutationResult<SendEmailVerificationCodeMutation>;
export type SendEmailVerificationCodeMutationOptions = Apollo.BaseMutationOptions<SendEmailVerificationCodeMutation, SendEmailVerificationCodeMutationVariables>;
export const VerifyPhoneNumberAndUpdateAccountDocument = gql`
    mutation verifyPhoneNumberAndUpdateAccount($code: String!, $phone: PhoneInput!) {
  verifyPhoneNumberAndUpdateAccount(code: $code, phone: $phone) {
    _id
  }
}
    `;
export type VerifyPhoneNumberAndUpdateAccountMutationFn = Apollo.MutationFunction<VerifyPhoneNumberAndUpdateAccountMutation, VerifyPhoneNumberAndUpdateAccountMutationVariables>;

/**
 * __useVerifyPhoneNumberAndUpdateAccountMutation__
 *
 * To run a mutation, you first call `useVerifyPhoneNumberAndUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPhoneNumberAndUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPhoneNumberAndUpdateAccountMutation, { data, loading, error }] = useVerifyPhoneNumberAndUpdateAccountMutation({
 *   variables: {
 *      code: // value for 'code'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useVerifyPhoneNumberAndUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPhoneNumberAndUpdateAccountMutation, VerifyPhoneNumberAndUpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPhoneNumberAndUpdateAccountMutation, VerifyPhoneNumberAndUpdateAccountMutationVariables>(VerifyPhoneNumberAndUpdateAccountDocument, options);
      }
export type VerifyPhoneNumberAndUpdateAccountMutationHookResult = ReturnType<typeof useVerifyPhoneNumberAndUpdateAccountMutation>;
export type VerifyPhoneNumberAndUpdateAccountMutationResult = Apollo.MutationResult<VerifyPhoneNumberAndUpdateAccountMutation>;
export type VerifyPhoneNumberAndUpdateAccountMutationOptions = Apollo.BaseMutationOptions<VerifyPhoneNumberAndUpdateAccountMutation, VerifyPhoneNumberAndUpdateAccountMutationVariables>;
export const GenerateMagicLinkDocument = gql`
    mutation generateMagicLink($email: String!) {
  generateMagicLink(email: $email)
}
    `;
export type GenerateMagicLinkMutationFn = Apollo.MutationFunction<GenerateMagicLinkMutation, GenerateMagicLinkMutationVariables>;

/**
 * __useGenerateMagicLinkMutation__
 *
 * To run a mutation, you first call `useGenerateMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMagicLinkMutation, { data, loading, error }] = useGenerateMagicLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGenerateMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMagicLinkMutation, GenerateMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMagicLinkMutation, GenerateMagicLinkMutationVariables>(GenerateMagicLinkDocument, options);
      }
export type GenerateMagicLinkMutationHookResult = ReturnType<typeof useGenerateMagicLinkMutation>;
export type GenerateMagicLinkMutationResult = Apollo.MutationResult<GenerateMagicLinkMutation>;
export type GenerateMagicLinkMutationOptions = Apollo.BaseMutationOptions<GenerateMagicLinkMutation, GenerateMagicLinkMutationVariables>;
export const GetTokenWithMagicLinkDocument = gql`
    mutation getTokenWithMagicLink {
  getTokenWithMagicLink {
    __typename
    ... on TokensModel {
      ...TokensModel
    }
    ... on MfaTempTokenModel {
      tempToken
      mfaEnabled
    }
  }
}
    ${TokensModelFragmentDoc}`;
export type GetTokenWithMagicLinkMutationFn = Apollo.MutationFunction<GetTokenWithMagicLinkMutation, GetTokenWithMagicLinkMutationVariables>;

/**
 * __useGetTokenWithMagicLinkMutation__
 *
 * To run a mutation, you first call `useGetTokenWithMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetTokenWithMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getTokenWithMagicLinkMutation, { data, loading, error }] = useGetTokenWithMagicLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetTokenWithMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetTokenWithMagicLinkMutation, GetTokenWithMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetTokenWithMagicLinkMutation, GetTokenWithMagicLinkMutationVariables>(GetTokenWithMagicLinkDocument, options);
      }
export type GetTokenWithMagicLinkMutationHookResult = ReturnType<typeof useGetTokenWithMagicLinkMutation>;
export type GetTokenWithMagicLinkMutationResult = Apollo.MutationResult<GetTokenWithMagicLinkMutation>;
export type GetTokenWithMagicLinkMutationOptions = Apollo.BaseMutationOptions<GetTokenWithMagicLinkMutation, GetTokenWithMagicLinkMutationVariables>;
export const SwitchAccountTypeDocument = gql`
    mutation switchAccountType($input: SwitchAccountInput!) {
  switchAccountType(input: $input) {
    _id
    isSeeker
    productSubscriptionId
    roleId
    status
    email
    lastAccountTypeSwitchAt
  }
}
    `;
export type SwitchAccountTypeMutationFn = Apollo.MutationFunction<SwitchAccountTypeMutation, SwitchAccountTypeMutationVariables>;

/**
 * __useSwitchAccountTypeMutation__
 *
 * To run a mutation, you first call `useSwitchAccountTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchAccountTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchAccountTypeMutation, { data, loading, error }] = useSwitchAccountTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchAccountTypeMutation(baseOptions?: Apollo.MutationHookOptions<SwitchAccountTypeMutation, SwitchAccountTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchAccountTypeMutation, SwitchAccountTypeMutationVariables>(SwitchAccountTypeDocument, options);
      }
export type SwitchAccountTypeMutationHookResult = ReturnType<typeof useSwitchAccountTypeMutation>;
export type SwitchAccountTypeMutationResult = Apollo.MutationResult<SwitchAccountTypeMutation>;
export type SwitchAccountTypeMutationOptions = Apollo.BaseMutationOptions<SwitchAccountTypeMutation, SwitchAccountTypeMutationVariables>;
export const UpdateAccountLanguageDocument = gql`
    mutation updateAccountLanguage($language: String!) {
  updateAccountLanguage(language: $language) {
    ...Account
  }
}
    ${AccountFragmentDoc}`;
export type UpdateAccountLanguageMutationFn = Apollo.MutationFunction<UpdateAccountLanguageMutation, UpdateAccountLanguageMutationVariables>;

/**
 * __useUpdateAccountLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateAccountLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountLanguageMutation, { data, loading, error }] = useUpdateAccountLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateAccountLanguageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountLanguageMutation, UpdateAccountLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountLanguageMutation, UpdateAccountLanguageMutationVariables>(UpdateAccountLanguageDocument, options);
      }
export type UpdateAccountLanguageMutationHookResult = ReturnType<typeof useUpdateAccountLanguageMutation>;
export type UpdateAccountLanguageMutationResult = Apollo.MutationResult<UpdateAccountLanguageMutation>;
export type UpdateAccountLanguageMutationOptions = Apollo.BaseMutationOptions<UpdateAccountLanguageMutation, UpdateAccountLanguageMutationVariables>;
export const UpdateCurrentUserDocument = gql`
    mutation updateCurrentUser($profileInput: ProfileInput!) {
  updateCurrentUser(profileInput: $profileInput) {
    _id
    firstName
    lastName
  }
}
    `;
export type UpdateCurrentUserMutationFn = Apollo.MutationFunction<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>;

/**
 * __useUpdateCurrentUserMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserMutation, { data, loading, error }] = useUpdateCurrentUserMutation({
 *   variables: {
 *      profileInput: // value for 'profileInput'
 *   },
 * });
 */
export function useUpdateCurrentUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>(UpdateCurrentUserDocument, options);
      }
export type UpdateCurrentUserMutationHookResult = ReturnType<typeof useUpdateCurrentUserMutation>;
export type UpdateCurrentUserMutationResult = Apollo.MutationResult<UpdateCurrentUserMutation>;
export type UpdateCurrentUserMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>;
export const GetAccountDocument = gql`
    query getAccount {
  getAccount {
    ...Account
  }
}
    ${AccountFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountSuspenseQueryHookResult = ReturnType<typeof useGetAccountSuspenseQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetCurrentAccountProductSubscriptionDocument = gql`
    query getCurrentAccountProductSubscription {
  getCurrentAccountProductSubscription {
    ...ProductSubscription
  }
}
    ${ProductSubscriptionFragmentDoc}`;

/**
 * __useGetCurrentAccountProductSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetCurrentAccountProductSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentAccountProductSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentAccountProductSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentAccountProductSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentAccountProductSubscriptionQuery, GetCurrentAccountProductSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentAccountProductSubscriptionQuery, GetCurrentAccountProductSubscriptionQueryVariables>(GetCurrentAccountProductSubscriptionDocument, options);
      }
export function useGetCurrentAccountProductSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentAccountProductSubscriptionQuery, GetCurrentAccountProductSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentAccountProductSubscriptionQuery, GetCurrentAccountProductSubscriptionQueryVariables>(GetCurrentAccountProductSubscriptionDocument, options);
        }
export function useGetCurrentAccountProductSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentAccountProductSubscriptionQuery, GetCurrentAccountProductSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentAccountProductSubscriptionQuery, GetCurrentAccountProductSubscriptionQueryVariables>(GetCurrentAccountProductSubscriptionDocument, options);
        }
export type GetCurrentAccountProductSubscriptionQueryHookResult = ReturnType<typeof useGetCurrentAccountProductSubscriptionQuery>;
export type GetCurrentAccountProductSubscriptionLazyQueryHookResult = ReturnType<typeof useGetCurrentAccountProductSubscriptionLazyQuery>;
export type GetCurrentAccountProductSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetCurrentAccountProductSubscriptionSuspenseQuery>;
export type GetCurrentAccountProductSubscriptionQueryResult = Apollo.QueryResult<GetCurrentAccountProductSubscriptionQuery, GetCurrentAccountProductSubscriptionQueryVariables>;
export const GetCurrentAccountTrialProductSubscriptionsDocument = gql`
    query getCurrentAccountTrialProductSubscriptions {
  getCurrentAccountTrialProductSubscriptions {
    totalCount
    collection {
      ...ProductSubscription
    }
  }
}
    ${ProductSubscriptionFragmentDoc}`;

/**
 * __useGetCurrentAccountTrialProductSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetCurrentAccountTrialProductSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentAccountTrialProductSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentAccountTrialProductSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentAccountTrialProductSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentAccountTrialProductSubscriptionsQuery, GetCurrentAccountTrialProductSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentAccountTrialProductSubscriptionsQuery, GetCurrentAccountTrialProductSubscriptionsQueryVariables>(GetCurrentAccountTrialProductSubscriptionsDocument, options);
      }
export function useGetCurrentAccountTrialProductSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentAccountTrialProductSubscriptionsQuery, GetCurrentAccountTrialProductSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentAccountTrialProductSubscriptionsQuery, GetCurrentAccountTrialProductSubscriptionsQueryVariables>(GetCurrentAccountTrialProductSubscriptionsDocument, options);
        }
export function useGetCurrentAccountTrialProductSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentAccountTrialProductSubscriptionsQuery, GetCurrentAccountTrialProductSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentAccountTrialProductSubscriptionsQuery, GetCurrentAccountTrialProductSubscriptionsQueryVariables>(GetCurrentAccountTrialProductSubscriptionsDocument, options);
        }
export type GetCurrentAccountTrialProductSubscriptionsQueryHookResult = ReturnType<typeof useGetCurrentAccountTrialProductSubscriptionsQuery>;
export type GetCurrentAccountTrialProductSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetCurrentAccountTrialProductSubscriptionsLazyQuery>;
export type GetCurrentAccountTrialProductSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentAccountTrialProductSubscriptionsSuspenseQuery>;
export type GetCurrentAccountTrialProductSubscriptionsQueryResult = Apollo.QueryResult<GetCurrentAccountTrialProductSubscriptionsQuery, GetCurrentAccountTrialProductSubscriptionsQueryVariables>;
export const GetCurrentStripeAccountDocument = gql`
    query getCurrentStripeAccount {
  getCurrentStripeAccount {
    ...StripeAccount
  }
}
    ${StripeAccountFragmentDoc}`;

/**
 * __useGetCurrentStripeAccountQuery__
 *
 * To run a query within a React component, call `useGetCurrentStripeAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentStripeAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentStripeAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentStripeAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentStripeAccountQuery, GetCurrentStripeAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentStripeAccountQuery, GetCurrentStripeAccountQueryVariables>(GetCurrentStripeAccountDocument, options);
      }
export function useGetCurrentStripeAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentStripeAccountQuery, GetCurrentStripeAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentStripeAccountQuery, GetCurrentStripeAccountQueryVariables>(GetCurrentStripeAccountDocument, options);
        }
export function useGetCurrentStripeAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentStripeAccountQuery, GetCurrentStripeAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentStripeAccountQuery, GetCurrentStripeAccountQueryVariables>(GetCurrentStripeAccountDocument, options);
        }
export type GetCurrentStripeAccountQueryHookResult = ReturnType<typeof useGetCurrentStripeAccountQuery>;
export type GetCurrentStripeAccountLazyQueryHookResult = ReturnType<typeof useGetCurrentStripeAccountLazyQuery>;
export type GetCurrentStripeAccountSuspenseQueryHookResult = ReturnType<typeof useGetCurrentStripeAccountSuspenseQuery>;
export type GetCurrentStripeAccountQueryResult = Apollo.QueryResult<GetCurrentStripeAccountQuery, GetCurrentStripeAccountQueryVariables>;
export const GetCurrentStripeAccountTransactionsDocument = gql`
    query getCurrentStripeAccountTransactions($flatPagination: FlatPaginationInput) {
  getCurrentStripeAccountTransactions(flatPagination: $flatPagination) {
    collection {
      invoiceId
      amount
      dateOfCharge
      invoiceName
      invoicePdfUrl
      status
    }
    hasMore
  }
}
    `;

/**
 * __useGetCurrentStripeAccountTransactionsQuery__
 *
 * To run a query within a React component, call `useGetCurrentStripeAccountTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentStripeAccountTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentStripeAccountTransactionsQuery({
 *   variables: {
 *      flatPagination: // value for 'flatPagination'
 *   },
 * });
 */
export function useGetCurrentStripeAccountTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentStripeAccountTransactionsQuery, GetCurrentStripeAccountTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentStripeAccountTransactionsQuery, GetCurrentStripeAccountTransactionsQueryVariables>(GetCurrentStripeAccountTransactionsDocument, options);
      }
export function useGetCurrentStripeAccountTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentStripeAccountTransactionsQuery, GetCurrentStripeAccountTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentStripeAccountTransactionsQuery, GetCurrentStripeAccountTransactionsQueryVariables>(GetCurrentStripeAccountTransactionsDocument, options);
        }
export function useGetCurrentStripeAccountTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentStripeAccountTransactionsQuery, GetCurrentStripeAccountTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentStripeAccountTransactionsQuery, GetCurrentStripeAccountTransactionsQueryVariables>(GetCurrentStripeAccountTransactionsDocument, options);
        }
export type GetCurrentStripeAccountTransactionsQueryHookResult = ReturnType<typeof useGetCurrentStripeAccountTransactionsQuery>;
export type GetCurrentStripeAccountTransactionsLazyQueryHookResult = ReturnType<typeof useGetCurrentStripeAccountTransactionsLazyQuery>;
export type GetCurrentStripeAccountTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentStripeAccountTransactionsSuspenseQuery>;
export type GetCurrentStripeAccountTransactionsQueryResult = Apollo.QueryResult<GetCurrentStripeAccountTransactionsQuery, GetCurrentStripeAccountTransactionsQueryVariables>;
export const GenerateMfaQrCodeDocument = gql`
    query generateMfaQrCode {
  generateMfaQrCode {
    qrCode
  }
}
    `;

/**
 * __useGenerateMfaQrCodeQuery__
 *
 * To run a query within a React component, call `useGenerateMfaQrCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateMfaQrCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateMfaQrCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateMfaQrCodeQuery(baseOptions?: Apollo.QueryHookOptions<GenerateMfaQrCodeQuery, GenerateMfaQrCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateMfaQrCodeQuery, GenerateMfaQrCodeQueryVariables>(GenerateMfaQrCodeDocument, options);
      }
export function useGenerateMfaQrCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateMfaQrCodeQuery, GenerateMfaQrCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateMfaQrCodeQuery, GenerateMfaQrCodeQueryVariables>(GenerateMfaQrCodeDocument, options);
        }
export function useGenerateMfaQrCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateMfaQrCodeQuery, GenerateMfaQrCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateMfaQrCodeQuery, GenerateMfaQrCodeQueryVariables>(GenerateMfaQrCodeDocument, options);
        }
export type GenerateMfaQrCodeQueryHookResult = ReturnType<typeof useGenerateMfaQrCodeQuery>;
export type GenerateMfaQrCodeLazyQueryHookResult = ReturnType<typeof useGenerateMfaQrCodeLazyQuery>;
export type GenerateMfaQrCodeSuspenseQueryHookResult = ReturnType<typeof useGenerateMfaQrCodeSuspenseQuery>;
export type GenerateMfaQrCodeQueryResult = Apollo.QueryResult<GenerateMfaQrCodeQuery, GenerateMfaQrCodeQueryVariables>;
export const ObserveCurrentAccountProductSubscriptionDocument = gql`
    subscription observeCurrentAccountProductSubscription {
  observeCurrentAccountProductSubscription {
    trigger
    document {
      ...ProductSubscription
    }
  }
}
    ${ProductSubscriptionFragmentDoc}`;

/**
 * __useObserveCurrentAccountProductSubscriptionSubscription__
 *
 * To run a query within a React component, call `useObserveCurrentAccountProductSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObserveCurrentAccountProductSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObserveCurrentAccountProductSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useObserveCurrentAccountProductSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ObserveCurrentAccountProductSubscriptionSubscription, ObserveCurrentAccountProductSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObserveCurrentAccountProductSubscriptionSubscription, ObserveCurrentAccountProductSubscriptionSubscriptionVariables>(ObserveCurrentAccountProductSubscriptionDocument, options);
      }
export type ObserveCurrentAccountProductSubscriptionSubscriptionHookResult = ReturnType<typeof useObserveCurrentAccountProductSubscriptionSubscription>;
export type ObserveCurrentAccountProductSubscriptionSubscriptionResult = Apollo.SubscriptionResult<ObserveCurrentAccountProductSubscriptionSubscription>;
export const ObserveCurrentAccountChangesDocument = gql`
    subscription observeCurrentAccountChanges {
  observeCurrentAccountChanges {
    trigger
    account {
      ...Account
    }
  }
}
    ${AccountFragmentDoc}`;

/**
 * __useObserveCurrentAccountChangesSubscription__
 *
 * To run a query within a React component, call `useObserveCurrentAccountChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObserveCurrentAccountChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObserveCurrentAccountChangesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useObserveCurrentAccountChangesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ObserveCurrentAccountChangesSubscription, ObserveCurrentAccountChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObserveCurrentAccountChangesSubscription, ObserveCurrentAccountChangesSubscriptionVariables>(ObserveCurrentAccountChangesDocument, options);
      }
export type ObserveCurrentAccountChangesSubscriptionHookResult = ReturnType<typeof useObserveCurrentAccountChangesSubscription>;
export type ObserveCurrentAccountChangesSubscriptionResult = Apollo.SubscriptionResult<ObserveCurrentAccountChangesSubscription>;
export const CreateAlertConfigDocument = gql`
    mutation createAlertConfig($name: String!, $filter: CreateAlertConfigFilterInput!) {
  createAlertConfig(name: $name, filter: $filter) {
    _id
  }
}
    `;
export type CreateAlertConfigMutationFn = Apollo.MutationFunction<CreateAlertConfigMutation, CreateAlertConfigMutationVariables>;

/**
 * __useCreateAlertConfigMutation__
 *
 * To run a mutation, you first call `useCreateAlertConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertConfigMutation, { data, loading, error }] = useCreateAlertConfigMutation({
 *   variables: {
 *      name: // value for 'name'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreateAlertConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlertConfigMutation, CreateAlertConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlertConfigMutation, CreateAlertConfigMutationVariables>(CreateAlertConfigDocument, options);
      }
export type CreateAlertConfigMutationHookResult = ReturnType<typeof useCreateAlertConfigMutation>;
export type CreateAlertConfigMutationResult = Apollo.MutationResult<CreateAlertConfigMutation>;
export type CreateAlertConfigMutationOptions = Apollo.BaseMutationOptions<CreateAlertConfigMutation, CreateAlertConfigMutationVariables>;
export const UpdateAlertConfigDocument = gql`
    mutation updateAlertConfig($alertConfigId: ObjectId!, $name: String!, $filter: CreateAlertConfigFilterInput!) {
  updateAlertConfig(alertConfigId: $alertConfigId, name: $name, filter: $filter) {
    ...BrokerAlertConfigDetails
  }
}
    ${BrokerAlertConfigDetailsFragmentDoc}`;
export type UpdateAlertConfigMutationFn = Apollo.MutationFunction<UpdateAlertConfigMutation, UpdateAlertConfigMutationVariables>;

/**
 * __useUpdateAlertConfigMutation__
 *
 * To run a mutation, you first call `useUpdateAlertConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertConfigMutation, { data, loading, error }] = useUpdateAlertConfigMutation({
 *   variables: {
 *      alertConfigId: // value for 'alertConfigId'
 *      name: // value for 'name'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdateAlertConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlertConfigMutation, UpdateAlertConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlertConfigMutation, UpdateAlertConfigMutationVariables>(UpdateAlertConfigDocument, options);
      }
export type UpdateAlertConfigMutationHookResult = ReturnType<typeof useUpdateAlertConfigMutation>;
export type UpdateAlertConfigMutationResult = Apollo.MutationResult<UpdateAlertConfigMutation>;
export type UpdateAlertConfigMutationOptions = Apollo.BaseMutationOptions<UpdateAlertConfigMutation, UpdateAlertConfigMutationVariables>;
export const SetHiddenStateToAlertItemDocument = gql`
    mutation setHiddenStateToAlertItem($alertItemId: ObjectId!, $isHidden: Boolean!) {
  setHiddenStateToAlertItem(alertItemId: $alertItemId, isHidden: $isHidden) {
    _id
    brokerAlertConfig {
      _id
      name
    }
    property {
      ...PropertyAlertPreviewFragment
    }
  }
}
    ${PropertyAlertPreviewFragmentFragmentDoc}`;
export type SetHiddenStateToAlertItemMutationFn = Apollo.MutationFunction<SetHiddenStateToAlertItemMutation, SetHiddenStateToAlertItemMutationVariables>;

/**
 * __useSetHiddenStateToAlertItemMutation__
 *
 * To run a mutation, you first call `useSetHiddenStateToAlertItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHiddenStateToAlertItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHiddenStateToAlertItemMutation, { data, loading, error }] = useSetHiddenStateToAlertItemMutation({
 *   variables: {
 *      alertItemId: // value for 'alertItemId'
 *      isHidden: // value for 'isHidden'
 *   },
 * });
 */
export function useSetHiddenStateToAlertItemMutation(baseOptions?: Apollo.MutationHookOptions<SetHiddenStateToAlertItemMutation, SetHiddenStateToAlertItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHiddenStateToAlertItemMutation, SetHiddenStateToAlertItemMutationVariables>(SetHiddenStateToAlertItemDocument, options);
      }
export type SetHiddenStateToAlertItemMutationHookResult = ReturnType<typeof useSetHiddenStateToAlertItemMutation>;
export type SetHiddenStateToAlertItemMutationResult = Apollo.MutationResult<SetHiddenStateToAlertItemMutation>;
export type SetHiddenStateToAlertItemMutationOptions = Apollo.BaseMutationOptions<SetHiddenStateToAlertItemMutation, SetHiddenStateToAlertItemMutationVariables>;
export const RemoveAlertConfigDocument = gql`
    mutation removeAlertConfig($alertConfigId: ObjectId!) {
  removeAlertConfig(alertConfigId: $alertConfigId) {
    _id
  }
}
    `;
export type RemoveAlertConfigMutationFn = Apollo.MutationFunction<RemoveAlertConfigMutation, RemoveAlertConfigMutationVariables>;

/**
 * __useRemoveAlertConfigMutation__
 *
 * To run a mutation, you first call `useRemoveAlertConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAlertConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAlertConfigMutation, { data, loading, error }] = useRemoveAlertConfigMutation({
 *   variables: {
 *      alertConfigId: // value for 'alertConfigId'
 *   },
 * });
 */
export function useRemoveAlertConfigMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAlertConfigMutation, RemoveAlertConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAlertConfigMutation, RemoveAlertConfigMutationVariables>(RemoveAlertConfigDocument, options);
      }
export type RemoveAlertConfigMutationHookResult = ReturnType<typeof useRemoveAlertConfigMutation>;
export type RemoveAlertConfigMutationResult = Apollo.MutationResult<RemoveAlertConfigMutation>;
export type RemoveAlertConfigMutationOptions = Apollo.BaseMutationOptions<RemoveAlertConfigMutation, RemoveAlertConfigMutationVariables>;
export const GetAlertItemsDocument = gql`
    query getAlertItems($sort: [SortInput!], $pagination: PaginationInput, $filter: GetAlertItemsFilterInput, $flatPagination: FlatPaginationInput) {
  getAlertItems(
    sort: $sort
    pagination: $pagination
    filter: $filter
    flatPagination: $flatPagination
  ) {
    totalCount
    collection {
      _id
      isHidden
      brokerAlertConfig {
        _id
        name
      }
      property {
        ...PropertyAlertPreviewFragment
      }
    }
  }
}
    ${PropertyAlertPreviewFragmentFragmentDoc}`;

/**
 * __useGetAlertItemsQuery__
 *
 * To run a query within a React component, call `useGetAlertItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertItemsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      flatPagination: // value for 'flatPagination'
 *   },
 * });
 */
export function useGetAlertItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetAlertItemsQuery, GetAlertItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertItemsQuery, GetAlertItemsQueryVariables>(GetAlertItemsDocument, options);
      }
export function useGetAlertItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertItemsQuery, GetAlertItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertItemsQuery, GetAlertItemsQueryVariables>(GetAlertItemsDocument, options);
        }
export function useGetAlertItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlertItemsQuery, GetAlertItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlertItemsQuery, GetAlertItemsQueryVariables>(GetAlertItemsDocument, options);
        }
export type GetAlertItemsQueryHookResult = ReturnType<typeof useGetAlertItemsQuery>;
export type GetAlertItemsLazyQueryHookResult = ReturnType<typeof useGetAlertItemsLazyQuery>;
export type GetAlertItemsSuspenseQueryHookResult = ReturnType<typeof useGetAlertItemsSuspenseQuery>;
export type GetAlertItemsQueryResult = Apollo.QueryResult<GetAlertItemsQuery, GetAlertItemsQueryVariables>;
export const GetAlertConfigsDocument = gql`
    query getAlertConfigs($searchText: String, $sort: [SortInput!], $pagination: PaginationInput) {
  getAlertConfigs(sort: $sort, pagination: $pagination, searchText: $searchText) {
    totalCount
    collection {
      _id
      name
    }
  }
}
    `;

/**
 * __useGetAlertConfigsQuery__
 *
 * To run a query within a React component, call `useGetAlertConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertConfigsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAlertConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetAlertConfigsQuery, GetAlertConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertConfigsQuery, GetAlertConfigsQueryVariables>(GetAlertConfigsDocument, options);
      }
export function useGetAlertConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertConfigsQuery, GetAlertConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertConfigsQuery, GetAlertConfigsQueryVariables>(GetAlertConfigsDocument, options);
        }
export function useGetAlertConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlertConfigsQuery, GetAlertConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlertConfigsQuery, GetAlertConfigsQueryVariables>(GetAlertConfigsDocument, options);
        }
export type GetAlertConfigsQueryHookResult = ReturnType<typeof useGetAlertConfigsQuery>;
export type GetAlertConfigsLazyQueryHookResult = ReturnType<typeof useGetAlertConfigsLazyQuery>;
export type GetAlertConfigsSuspenseQueryHookResult = ReturnType<typeof useGetAlertConfigsSuspenseQuery>;
export type GetAlertConfigsQueryResult = Apollo.QueryResult<GetAlertConfigsQuery, GetAlertConfigsQueryVariables>;
export const GetConfigAlertByIdDocument = gql`
    query getConfigAlertById($alertConfigId: ObjectId!) {
  getAlertConfigById(alertConfigId: $alertConfigId) {
    ...BrokerAlertConfigDetails
  }
}
    ${BrokerAlertConfigDetailsFragmentDoc}`;

/**
 * __useGetConfigAlertByIdQuery__
 *
 * To run a query within a React component, call `useGetConfigAlertByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigAlertByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigAlertByIdQuery({
 *   variables: {
 *      alertConfigId: // value for 'alertConfigId'
 *   },
 * });
 */
export function useGetConfigAlertByIdQuery(baseOptions: Apollo.QueryHookOptions<GetConfigAlertByIdQuery, GetConfigAlertByIdQueryVariables> & ({ variables: GetConfigAlertByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigAlertByIdQuery, GetConfigAlertByIdQueryVariables>(GetConfigAlertByIdDocument, options);
      }
export function useGetConfigAlertByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigAlertByIdQuery, GetConfigAlertByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigAlertByIdQuery, GetConfigAlertByIdQueryVariables>(GetConfigAlertByIdDocument, options);
        }
export function useGetConfigAlertByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConfigAlertByIdQuery, GetConfigAlertByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConfigAlertByIdQuery, GetConfigAlertByIdQueryVariables>(GetConfigAlertByIdDocument, options);
        }
export type GetConfigAlertByIdQueryHookResult = ReturnType<typeof useGetConfigAlertByIdQuery>;
export type GetConfigAlertByIdLazyQueryHookResult = ReturnType<typeof useGetConfigAlertByIdLazyQuery>;
export type GetConfigAlertByIdSuspenseQueryHookResult = ReturnType<typeof useGetConfigAlertByIdSuspenseQuery>;
export type GetConfigAlertByIdQueryResult = Apollo.QueryResult<GetConfigAlertByIdQuery, GetConfigAlertByIdQueryVariables>;
export const GetAlertConfigsCountDocument = gql`
    query getAlertConfigsCount($searchText: String, $sort: [SortInput!], $pagination: PaginationInput) {
  getAlertConfigs(sort: $sort, pagination: $pagination, searchText: $searchText) {
    totalCount
  }
}
    `;

/**
 * __useGetAlertConfigsCountQuery__
 *
 * To run a query within a React component, call `useGetAlertConfigsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertConfigsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertConfigsCountQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAlertConfigsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetAlertConfigsCountQuery, GetAlertConfigsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertConfigsCountQuery, GetAlertConfigsCountQueryVariables>(GetAlertConfigsCountDocument, options);
      }
export function useGetAlertConfigsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertConfigsCountQuery, GetAlertConfigsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertConfigsCountQuery, GetAlertConfigsCountQueryVariables>(GetAlertConfigsCountDocument, options);
        }
export function useGetAlertConfigsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlertConfigsCountQuery, GetAlertConfigsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlertConfigsCountQuery, GetAlertConfigsCountQueryVariables>(GetAlertConfigsCountDocument, options);
        }
export type GetAlertConfigsCountQueryHookResult = ReturnType<typeof useGetAlertConfigsCountQuery>;
export type GetAlertConfigsCountLazyQueryHookResult = ReturnType<typeof useGetAlertConfigsCountLazyQuery>;
export type GetAlertConfigsCountSuspenseQueryHookResult = ReturnType<typeof useGetAlertConfigsCountSuspenseQuery>;
export type GetAlertConfigsCountQueryResult = Apollo.QueryResult<GetAlertConfigsCountQuery, GetAlertConfigsCountQueryVariables>;
export const GetNumberOfNewAlertItemsDocument = gql`
    query getNumberOfNewAlertItems($range: DateRangeInput) {
  getNumberOfNewAlertItems(range: $range)
}
    `;

/**
 * __useGetNumberOfNewAlertItemsQuery__
 *
 * To run a query within a React component, call `useGetNumberOfNewAlertItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfNewAlertItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfNewAlertItemsQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetNumberOfNewAlertItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfNewAlertItemsQuery, GetNumberOfNewAlertItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfNewAlertItemsQuery, GetNumberOfNewAlertItemsQueryVariables>(GetNumberOfNewAlertItemsDocument, options);
      }
export function useGetNumberOfNewAlertItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfNewAlertItemsQuery, GetNumberOfNewAlertItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfNewAlertItemsQuery, GetNumberOfNewAlertItemsQueryVariables>(GetNumberOfNewAlertItemsDocument, options);
        }
export function useGetNumberOfNewAlertItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfNewAlertItemsQuery, GetNumberOfNewAlertItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfNewAlertItemsQuery, GetNumberOfNewAlertItemsQueryVariables>(GetNumberOfNewAlertItemsDocument, options);
        }
export type GetNumberOfNewAlertItemsQueryHookResult = ReturnType<typeof useGetNumberOfNewAlertItemsQuery>;
export type GetNumberOfNewAlertItemsLazyQueryHookResult = ReturnType<typeof useGetNumberOfNewAlertItemsLazyQuery>;
export type GetNumberOfNewAlertItemsSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfNewAlertItemsSuspenseQuery>;
export type GetNumberOfNewAlertItemsQueryResult = Apollo.QueryResult<GetNumberOfNewAlertItemsQuery, GetNumberOfNewAlertItemsQueryVariables>;
export const CurrentBrokerHasAlertConfigsDocument = gql`
    query currentBrokerHasAlertConfigs {
  currentBrokerHasAlertConfigs
}
    `;

/**
 * __useCurrentBrokerHasAlertConfigsQuery__
 *
 * To run a query within a React component, call `useCurrentBrokerHasAlertConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBrokerHasAlertConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBrokerHasAlertConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentBrokerHasAlertConfigsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentBrokerHasAlertConfigsQuery, CurrentBrokerHasAlertConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentBrokerHasAlertConfigsQuery, CurrentBrokerHasAlertConfigsQueryVariables>(CurrentBrokerHasAlertConfigsDocument, options);
      }
export function useCurrentBrokerHasAlertConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentBrokerHasAlertConfigsQuery, CurrentBrokerHasAlertConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentBrokerHasAlertConfigsQuery, CurrentBrokerHasAlertConfigsQueryVariables>(CurrentBrokerHasAlertConfigsDocument, options);
        }
export function useCurrentBrokerHasAlertConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentBrokerHasAlertConfigsQuery, CurrentBrokerHasAlertConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentBrokerHasAlertConfigsQuery, CurrentBrokerHasAlertConfigsQueryVariables>(CurrentBrokerHasAlertConfigsDocument, options);
        }
export type CurrentBrokerHasAlertConfigsQueryHookResult = ReturnType<typeof useCurrentBrokerHasAlertConfigsQuery>;
export type CurrentBrokerHasAlertConfigsLazyQueryHookResult = ReturnType<typeof useCurrentBrokerHasAlertConfigsLazyQuery>;
export type CurrentBrokerHasAlertConfigsSuspenseQueryHookResult = ReturnType<typeof useCurrentBrokerHasAlertConfigsSuspenseQuery>;
export type CurrentBrokerHasAlertConfigsQueryResult = Apollo.QueryResult<CurrentBrokerHasAlertConfigsQuery, CurrentBrokerHasAlertConfigsQueryVariables>;
export const ObserveBrokerAlertItemChangesDocument = gql`
    subscription observeBrokerAlertItemChanges {
  observeBrokerAlertItemChanges {
    trigger
    document {
      _id
      isHidden
      brokerAlertConfig {
        _id
        name
      }
      property {
        ...PropertyAlertPreviewFragment
      }
    }
  }
}
    ${PropertyAlertPreviewFragmentFragmentDoc}`;

/**
 * __useObserveBrokerAlertItemChangesSubscription__
 *
 * To run a query within a React component, call `useObserveBrokerAlertItemChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObserveBrokerAlertItemChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObserveBrokerAlertItemChangesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useObserveBrokerAlertItemChangesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ObserveBrokerAlertItemChangesSubscription, ObserveBrokerAlertItemChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObserveBrokerAlertItemChangesSubscription, ObserveBrokerAlertItemChangesSubscriptionVariables>(ObserveBrokerAlertItemChangesDocument, options);
      }
export type ObserveBrokerAlertItemChangesSubscriptionHookResult = ReturnType<typeof useObserveBrokerAlertItemChangesSubscription>;
export type ObserveBrokerAlertItemChangesSubscriptionResult = Apollo.SubscriptionResult<ObserveBrokerAlertItemChangesSubscription>;
export const GetAmenitiesDocument = gql`
    query getAmenities($sort: [SortInput!], $pagination: PaginationInput, $filter: GetAmenitiesFilterInput) {
  getAmenities(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
    collection {
      ...Amenity
    }
  }
}
    ${AmenityFragmentDoc}`;

/**
 * __useGetAmenitiesQuery__
 *
 * To run a query within a React component, call `useGetAmenitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmenitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmenitiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAmenitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAmenitiesQuery, GetAmenitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmenitiesQuery, GetAmenitiesQueryVariables>(GetAmenitiesDocument, options);
      }
export function useGetAmenitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmenitiesQuery, GetAmenitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmenitiesQuery, GetAmenitiesQueryVariables>(GetAmenitiesDocument, options);
        }
export function useGetAmenitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAmenitiesQuery, GetAmenitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAmenitiesQuery, GetAmenitiesQueryVariables>(GetAmenitiesDocument, options);
        }
export type GetAmenitiesQueryHookResult = ReturnType<typeof useGetAmenitiesQuery>;
export type GetAmenitiesLazyQueryHookResult = ReturnType<typeof useGetAmenitiesLazyQuery>;
export type GetAmenitiesSuspenseQueryHookResult = ReturnType<typeof useGetAmenitiesSuspenseQuery>;
export type GetAmenitiesQueryResult = Apollo.QueryResult<GetAmenitiesQuery, GetAmenitiesQueryVariables>;
export const GetPropertyAmenitiesInPublicBrokerPortfolioDocument = gql`
    query getPropertyAmenitiesInPublicBrokerPortfolio($brokerId: ObjectId!, $password: String, $portfolioFolderId: ObjectId, $propertyId: ObjectId!, $sort: [SortInput!], $pagination: PaginationInput, $filter: GetAmenitiesFilterInput) {
  getPropertyAmenitiesInPublicBrokerPortfolio(
    brokerId: $brokerId
    password: $password
    portfolioFolderId: $portfolioFolderId
    propertyId: $propertyId
    sort: $sort
    pagination: $pagination
    filter: $filter
  ) {
    totalCount
    collection {
      ...Amenity
    }
  }
}
    ${AmenityFragmentDoc}`;

/**
 * __useGetPropertyAmenitiesInPublicBrokerPortfolioQuery__
 *
 * To run a query within a React component, call `useGetPropertyAmenitiesInPublicBrokerPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyAmenitiesInPublicBrokerPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyAmenitiesInPublicBrokerPortfolioQuery({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *      password: // value for 'password'
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      propertyId: // value for 'propertyId'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPropertyAmenitiesInPublicBrokerPortfolioQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyAmenitiesInPublicBrokerPortfolioQuery, GetPropertyAmenitiesInPublicBrokerPortfolioQueryVariables> & ({ variables: GetPropertyAmenitiesInPublicBrokerPortfolioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyAmenitiesInPublicBrokerPortfolioQuery, GetPropertyAmenitiesInPublicBrokerPortfolioQueryVariables>(GetPropertyAmenitiesInPublicBrokerPortfolioDocument, options);
      }
export function useGetPropertyAmenitiesInPublicBrokerPortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyAmenitiesInPublicBrokerPortfolioQuery, GetPropertyAmenitiesInPublicBrokerPortfolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyAmenitiesInPublicBrokerPortfolioQuery, GetPropertyAmenitiesInPublicBrokerPortfolioQueryVariables>(GetPropertyAmenitiesInPublicBrokerPortfolioDocument, options);
        }
export function useGetPropertyAmenitiesInPublicBrokerPortfolioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyAmenitiesInPublicBrokerPortfolioQuery, GetPropertyAmenitiesInPublicBrokerPortfolioQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyAmenitiesInPublicBrokerPortfolioQuery, GetPropertyAmenitiesInPublicBrokerPortfolioQueryVariables>(GetPropertyAmenitiesInPublicBrokerPortfolioDocument, options);
        }
export type GetPropertyAmenitiesInPublicBrokerPortfolioQueryHookResult = ReturnType<typeof useGetPropertyAmenitiesInPublicBrokerPortfolioQuery>;
export type GetPropertyAmenitiesInPublicBrokerPortfolioLazyQueryHookResult = ReturnType<typeof useGetPropertyAmenitiesInPublicBrokerPortfolioLazyQuery>;
export type GetPropertyAmenitiesInPublicBrokerPortfolioSuspenseQueryHookResult = ReturnType<typeof useGetPropertyAmenitiesInPublicBrokerPortfolioSuspenseQuery>;
export type GetPropertyAmenitiesInPublicBrokerPortfolioQueryResult = Apollo.QueryResult<GetPropertyAmenitiesInPublicBrokerPortfolioQuery, GetPropertyAmenitiesInPublicBrokerPortfolioQueryVariables>;
export const CreateApiPluginUserDocument = gql`
    mutation createApiPluginUser($referralCode: String!) {
  createApiPluginUser(referralCode: $referralCode) {
    _id
    companyName
    referralCode
  }
}
    `;
export type CreateApiPluginUserMutationFn = Apollo.MutationFunction<CreateApiPluginUserMutation, CreateApiPluginUserMutationVariables>;

/**
 * __useCreateApiPluginUserMutation__
 *
 * To run a mutation, you first call `useCreateApiPluginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiPluginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiPluginUserMutation, { data, loading, error }] = useCreateApiPluginUserMutation({
 *   variables: {
 *      referralCode: // value for 'referralCode'
 *   },
 * });
 */
export function useCreateApiPluginUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiPluginUserMutation, CreateApiPluginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiPluginUserMutation, CreateApiPluginUserMutationVariables>(CreateApiPluginUserDocument, options);
      }
export type CreateApiPluginUserMutationHookResult = ReturnType<typeof useCreateApiPluginUserMutation>;
export type CreateApiPluginUserMutationResult = Apollo.MutationResult<CreateApiPluginUserMutation>;
export type CreateApiPluginUserMutationOptions = Apollo.BaseMutationOptions<CreateApiPluginUserMutation, CreateApiPluginUserMutationVariables>;
export const GenerateNewApiTokenDocument = gql`
    mutation generateNewApiToken {
  generateNewApiToken {
    token
  }
}
    `;
export type GenerateNewApiTokenMutationFn = Apollo.MutationFunction<GenerateNewApiTokenMutation, GenerateNewApiTokenMutationVariables>;

/**
 * __useGenerateNewApiTokenMutation__
 *
 * To run a mutation, you first call `useGenerateNewApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateNewApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateNewApiTokenMutation, { data, loading, error }] = useGenerateNewApiTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateNewApiTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateNewApiTokenMutation, GenerateNewApiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateNewApiTokenMutation, GenerateNewApiTokenMutationVariables>(GenerateNewApiTokenDocument, options);
      }
export type GenerateNewApiTokenMutationHookResult = ReturnType<typeof useGenerateNewApiTokenMutation>;
export type GenerateNewApiTokenMutationResult = Apollo.MutationResult<GenerateNewApiTokenMutation>;
export type GenerateNewApiTokenMutationOptions = Apollo.BaseMutationOptions<GenerateNewApiTokenMutation, GenerateNewApiTokenMutationVariables>;
export const SetMyPluginUserDisabledDocument = gql`
    mutation setMyPluginUserDisabled($apiCredentialsId: String!, $disabled: Boolean!) {
  setMyPluginUserDisabled(
    apiCredentialsId: $apiCredentialsId
    disabled: $disabled
  ) {
    _id
    isActive
    partnerDisabled
  }
}
    `;
export type SetMyPluginUserDisabledMutationFn = Apollo.MutationFunction<SetMyPluginUserDisabledMutation, SetMyPluginUserDisabledMutationVariables>;

/**
 * __useSetMyPluginUserDisabledMutation__
 *
 * To run a mutation, you first call `useSetMyPluginUserDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyPluginUserDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyPluginUserDisabledMutation, { data, loading, error }] = useSetMyPluginUserDisabledMutation({
 *   variables: {
 *      apiCredentialsId: // value for 'apiCredentialsId'
 *      disabled: // value for 'disabled'
 *   },
 * });
 */
export function useSetMyPluginUserDisabledMutation(baseOptions?: Apollo.MutationHookOptions<SetMyPluginUserDisabledMutation, SetMyPluginUserDisabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyPluginUserDisabledMutation, SetMyPluginUserDisabledMutationVariables>(SetMyPluginUserDisabledDocument, options);
      }
export type SetMyPluginUserDisabledMutationHookResult = ReturnType<typeof useSetMyPluginUserDisabledMutation>;
export type SetMyPluginUserDisabledMutationResult = Apollo.MutationResult<SetMyPluginUserDisabledMutation>;
export type SetMyPluginUserDisabledMutationOptions = Apollo.BaseMutationOptions<SetMyPluginUserDisabledMutation, SetMyPluginUserDisabledMutationVariables>;
export const GetAppBasicInfoDocument = gql`
    query getAppBasicInfo {
  getApiCredentialsBasicInfo {
    appId
    hasKey
    isActive
    referralCode
    type
  }
}
    `;

/**
 * __useGetAppBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetAppBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppBasicInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppBasicInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetAppBasicInfoQuery, GetAppBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppBasicInfoQuery, GetAppBasicInfoQueryVariables>(GetAppBasicInfoDocument, options);
      }
export function useGetAppBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppBasicInfoQuery, GetAppBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppBasicInfoQuery, GetAppBasicInfoQueryVariables>(GetAppBasicInfoDocument, options);
        }
export function useGetAppBasicInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppBasicInfoQuery, GetAppBasicInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppBasicInfoQuery, GetAppBasicInfoQueryVariables>(GetAppBasicInfoDocument, options);
        }
export type GetAppBasicInfoQueryHookResult = ReturnType<typeof useGetAppBasicInfoQuery>;
export type GetAppBasicInfoLazyQueryHookResult = ReturnType<typeof useGetAppBasicInfoLazyQuery>;
export type GetAppBasicInfoSuspenseQueryHookResult = ReturnType<typeof useGetAppBasicInfoSuspenseQuery>;
export type GetAppBasicInfoQueryResult = Apollo.QueryResult<GetAppBasicInfoQuery, GetAppBasicInfoQueryVariables>;
export const GetMyApiPluginUsersDocument = gql`
    query getMyApiPluginUsers($pagination: PaginationInput) {
  getMyApiPluginUsers(pagination: $pagination) {
    collection {
      account {
        _id
        email
      }
      profile {
        _id
        firstName
        lastName
      }
      apiCredentials {
        _id
        isActive
        partnerDisabled
      }
      monthlyApiAccess
    }
    totalCount
  }
}
    `;

/**
 * __useGetMyApiPluginUsersQuery__
 *
 * To run a query within a React component, call `useGetMyApiPluginUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyApiPluginUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyApiPluginUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMyApiPluginUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetMyApiPluginUsersQuery, GetMyApiPluginUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyApiPluginUsersQuery, GetMyApiPluginUsersQueryVariables>(GetMyApiPluginUsersDocument, options);
      }
export function useGetMyApiPluginUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyApiPluginUsersQuery, GetMyApiPluginUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyApiPluginUsersQuery, GetMyApiPluginUsersQueryVariables>(GetMyApiPluginUsersDocument, options);
        }
export function useGetMyApiPluginUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyApiPluginUsersQuery, GetMyApiPluginUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyApiPluginUsersQuery, GetMyApiPluginUsersQueryVariables>(GetMyApiPluginUsersDocument, options);
        }
export type GetMyApiPluginUsersQueryHookResult = ReturnType<typeof useGetMyApiPluginUsersQuery>;
export type GetMyApiPluginUsersLazyQueryHookResult = ReturnType<typeof useGetMyApiPluginUsersLazyQuery>;
export type GetMyApiPluginUsersSuspenseQueryHookResult = ReturnType<typeof useGetMyApiPluginUsersSuspenseQuery>;
export type GetMyApiPluginUsersQueryResult = Apollo.QueryResult<GetMyApiPluginUsersQuery, GetMyApiPluginUsersQueryVariables>;
export const AcceptApiInvitationDocument = gql`
    mutation AcceptApiInvitation($token: String!, $input: AcceptApiInvitationInput!) {
  acceptApiInvitation(token: $token, input: $input) {
    __typename
    ... on TokensModel {
      ...TokensModel
    }
    ... on MfaTempTokenModel {
      tempToken
      mfaEnabled
    }
  }
}
    ${TokensModelFragmentDoc}`;
export type AcceptApiInvitationMutationFn = Apollo.MutationFunction<AcceptApiInvitationMutation, AcceptApiInvitationMutationVariables>;

/**
 * __useAcceptApiInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptApiInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptApiInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptApiInvitationMutation, { data, loading, error }] = useAcceptApiInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptApiInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptApiInvitationMutation, AcceptApiInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptApiInvitationMutation, AcceptApiInvitationMutationVariables>(AcceptApiInvitationDocument, options);
      }
export type AcceptApiInvitationMutationHookResult = ReturnType<typeof useAcceptApiInvitationMutation>;
export type AcceptApiInvitationMutationResult = Apollo.MutationResult<AcceptApiInvitationMutation>;
export type AcceptApiInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptApiInvitationMutation, AcceptApiInvitationMutationVariables>;
export const AcceptApiInvitationForAccountDocument = gql`
    mutation AcceptApiInvitationForAccount($token: String!) {
  acceptApiInvitationForAccount(token: $token) {
    __typename
    ... on TokensModel {
      ...TokensModel
    }
    ... on MfaTempTokenModel {
      tempToken
      mfaEnabled
    }
  }
}
    ${TokensModelFragmentDoc}`;
export type AcceptApiInvitationForAccountMutationFn = Apollo.MutationFunction<AcceptApiInvitationForAccountMutation, AcceptApiInvitationForAccountMutationVariables>;

/**
 * __useAcceptApiInvitationForAccountMutation__
 *
 * To run a mutation, you first call `useAcceptApiInvitationForAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptApiInvitationForAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptApiInvitationForAccountMutation, { data, loading, error }] = useAcceptApiInvitationForAccountMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptApiInvitationForAccountMutation(baseOptions?: Apollo.MutationHookOptions<AcceptApiInvitationForAccountMutation, AcceptApiInvitationForAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptApiInvitationForAccountMutation, AcceptApiInvitationForAccountMutationVariables>(AcceptApiInvitationForAccountDocument, options);
      }
export type AcceptApiInvitationForAccountMutationHookResult = ReturnType<typeof useAcceptApiInvitationForAccountMutation>;
export type AcceptApiInvitationForAccountMutationResult = Apollo.MutationResult<AcceptApiInvitationForAccountMutation>;
export type AcceptApiInvitationForAccountMutationOptions = Apollo.BaseMutationOptions<AcceptApiInvitationForAccountMutation, AcceptApiInvitationForAccountMutationVariables>;
export const ValidateApiInvitationDocument = gql`
    query ValidateApiInvitation($token: String!) {
  validateApiInvitation(token: $token) {
    isValid
    status
    email
    companyName
    hasExistingAccount
  }
}
    `;

/**
 * __useValidateApiInvitationQuery__
 *
 * To run a query within a React component, call `useValidateApiInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateApiInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateApiInvitationQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateApiInvitationQuery(baseOptions: Apollo.QueryHookOptions<ValidateApiInvitationQuery, ValidateApiInvitationQueryVariables> & ({ variables: ValidateApiInvitationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateApiInvitationQuery, ValidateApiInvitationQueryVariables>(ValidateApiInvitationDocument, options);
      }
export function useValidateApiInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateApiInvitationQuery, ValidateApiInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateApiInvitationQuery, ValidateApiInvitationQueryVariables>(ValidateApiInvitationDocument, options);
        }
export function useValidateApiInvitationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateApiInvitationQuery, ValidateApiInvitationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateApiInvitationQuery, ValidateApiInvitationQueryVariables>(ValidateApiInvitationDocument, options);
        }
export type ValidateApiInvitationQueryHookResult = ReturnType<typeof useValidateApiInvitationQuery>;
export type ValidateApiInvitationLazyQueryHookResult = ReturnType<typeof useValidateApiInvitationLazyQuery>;
export type ValidateApiInvitationSuspenseQueryHookResult = ReturnType<typeof useValidateApiInvitationSuspenseQuery>;
export type ValidateApiInvitationQueryResult = Apollo.QueryResult<ValidateApiInvitationQuery, ValidateApiInvitationQueryVariables>;
export const MyPendingApiAccessDocument = gql`
    query MyPendingApiAccess {
  myPendingApiAccess
}
    `;

/**
 * __useMyPendingApiAccessQuery__
 *
 * To run a query within a React component, call `useMyPendingApiAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPendingApiAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPendingApiAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPendingApiAccessQuery(baseOptions?: Apollo.QueryHookOptions<MyPendingApiAccessQuery, MyPendingApiAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPendingApiAccessQuery, MyPendingApiAccessQueryVariables>(MyPendingApiAccessDocument, options);
      }
export function useMyPendingApiAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPendingApiAccessQuery, MyPendingApiAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPendingApiAccessQuery, MyPendingApiAccessQueryVariables>(MyPendingApiAccessDocument, options);
        }
export function useMyPendingApiAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPendingApiAccessQuery, MyPendingApiAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPendingApiAccessQuery, MyPendingApiAccessQueryVariables>(MyPendingApiAccessDocument, options);
        }
export type MyPendingApiAccessQueryHookResult = ReturnType<typeof useMyPendingApiAccessQuery>;
export type MyPendingApiAccessLazyQueryHookResult = ReturnType<typeof useMyPendingApiAccessLazyQuery>;
export type MyPendingApiAccessSuspenseQueryHookResult = ReturnType<typeof useMyPendingApiAccessSuspenseQuery>;
export type MyPendingApiAccessQueryResult = Apollo.QueryResult<MyPendingApiAccessQuery, MyPendingApiAccessQueryVariables>;
export const GetPluginUserOwnMonthlyApiUsageDocument = gql`
    query getPluginUserOwnMonthlyApiUsage($targetMonth: Int!) {
  getPluginUserOwnMonthlyApiUsage(targetMonth: $targetMonth)
}
    `;

/**
 * __useGetPluginUserOwnMonthlyApiUsageQuery__
 *
 * To run a query within a React component, call `useGetPluginUserOwnMonthlyApiUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPluginUserOwnMonthlyApiUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPluginUserOwnMonthlyApiUsageQuery({
 *   variables: {
 *      targetMonth: // value for 'targetMonth'
 *   },
 * });
 */
export function useGetPluginUserOwnMonthlyApiUsageQuery(baseOptions: Apollo.QueryHookOptions<GetPluginUserOwnMonthlyApiUsageQuery, GetPluginUserOwnMonthlyApiUsageQueryVariables> & ({ variables: GetPluginUserOwnMonthlyApiUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPluginUserOwnMonthlyApiUsageQuery, GetPluginUserOwnMonthlyApiUsageQueryVariables>(GetPluginUserOwnMonthlyApiUsageDocument, options);
      }
export function useGetPluginUserOwnMonthlyApiUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPluginUserOwnMonthlyApiUsageQuery, GetPluginUserOwnMonthlyApiUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPluginUserOwnMonthlyApiUsageQuery, GetPluginUserOwnMonthlyApiUsageQueryVariables>(GetPluginUserOwnMonthlyApiUsageDocument, options);
        }
export function useGetPluginUserOwnMonthlyApiUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPluginUserOwnMonthlyApiUsageQuery, GetPluginUserOwnMonthlyApiUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPluginUserOwnMonthlyApiUsageQuery, GetPluginUserOwnMonthlyApiUsageQueryVariables>(GetPluginUserOwnMonthlyApiUsageDocument, options);
        }
export type GetPluginUserOwnMonthlyApiUsageQueryHookResult = ReturnType<typeof useGetPluginUserOwnMonthlyApiUsageQuery>;
export type GetPluginUserOwnMonthlyApiUsageLazyQueryHookResult = ReturnType<typeof useGetPluginUserOwnMonthlyApiUsageLazyQuery>;
export type GetPluginUserOwnMonthlyApiUsageSuspenseQueryHookResult = ReturnType<typeof useGetPluginUserOwnMonthlyApiUsageSuspenseQuery>;
export type GetPluginUserOwnMonthlyApiUsageQueryResult = Apollo.QueryResult<GetPluginUserOwnMonthlyApiUsageQuery, GetPluginUserOwnMonthlyApiUsageQueryVariables>;
export const GetPluginUserOwnTotalApiUsageDocument = gql`
    query getPluginUserOwnTotalApiUsage($pagination: PaginationInput, $filter: PluginUserOwnTotalApiUsageFilterInput) {
  getPluginUserOwnTotalApiUsage(pagination: $pagination, filter: $filter) {
    collection {
      ...ApiMetric
    }
    totalCount
  }
}
    ${ApiMetricFragmentDoc}`;

/**
 * __useGetPluginUserOwnTotalApiUsageQuery__
 *
 * To run a query within a React component, call `useGetPluginUserOwnTotalApiUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPluginUserOwnTotalApiUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPluginUserOwnTotalApiUsageQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPluginUserOwnTotalApiUsageQuery(baseOptions?: Apollo.QueryHookOptions<GetPluginUserOwnTotalApiUsageQuery, GetPluginUserOwnTotalApiUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPluginUserOwnTotalApiUsageQuery, GetPluginUserOwnTotalApiUsageQueryVariables>(GetPluginUserOwnTotalApiUsageDocument, options);
      }
export function useGetPluginUserOwnTotalApiUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPluginUserOwnTotalApiUsageQuery, GetPluginUserOwnTotalApiUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPluginUserOwnTotalApiUsageQuery, GetPluginUserOwnTotalApiUsageQueryVariables>(GetPluginUserOwnTotalApiUsageDocument, options);
        }
export function useGetPluginUserOwnTotalApiUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPluginUserOwnTotalApiUsageQuery, GetPluginUserOwnTotalApiUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPluginUserOwnTotalApiUsageQuery, GetPluginUserOwnTotalApiUsageQueryVariables>(GetPluginUserOwnTotalApiUsageDocument, options);
        }
export type GetPluginUserOwnTotalApiUsageQueryHookResult = ReturnType<typeof useGetPluginUserOwnTotalApiUsageQuery>;
export type GetPluginUserOwnTotalApiUsageLazyQueryHookResult = ReturnType<typeof useGetPluginUserOwnTotalApiUsageLazyQuery>;
export type GetPluginUserOwnTotalApiUsageSuspenseQueryHookResult = ReturnType<typeof useGetPluginUserOwnTotalApiUsageSuspenseQuery>;
export type GetPluginUserOwnTotalApiUsageQueryResult = Apollo.QueryResult<GetPluginUserOwnTotalApiUsageQuery, GetPluginUserOwnTotalApiUsageQueryVariables>;
export const GetPluginUserOwnApiQuotaStatusDocument = gql`
    query getPluginUserOwnApiQuotaStatus {
  getPluginUserOwnApiQuotaStatus {
    usage
    limit
    resetDate
  }
}
    `;

/**
 * __useGetPluginUserOwnApiQuotaStatusQuery__
 *
 * To run a query within a React component, call `useGetPluginUserOwnApiQuotaStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPluginUserOwnApiQuotaStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPluginUserOwnApiQuotaStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPluginUserOwnApiQuotaStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetPluginUserOwnApiQuotaStatusQuery, GetPluginUserOwnApiQuotaStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPluginUserOwnApiQuotaStatusQuery, GetPluginUserOwnApiQuotaStatusQueryVariables>(GetPluginUserOwnApiQuotaStatusDocument, options);
      }
export function useGetPluginUserOwnApiQuotaStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPluginUserOwnApiQuotaStatusQuery, GetPluginUserOwnApiQuotaStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPluginUserOwnApiQuotaStatusQuery, GetPluginUserOwnApiQuotaStatusQueryVariables>(GetPluginUserOwnApiQuotaStatusDocument, options);
        }
export function useGetPluginUserOwnApiQuotaStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPluginUserOwnApiQuotaStatusQuery, GetPluginUserOwnApiQuotaStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPluginUserOwnApiQuotaStatusQuery, GetPluginUserOwnApiQuotaStatusQueryVariables>(GetPluginUserOwnApiQuotaStatusDocument, options);
        }
export type GetPluginUserOwnApiQuotaStatusQueryHookResult = ReturnType<typeof useGetPluginUserOwnApiQuotaStatusQuery>;
export type GetPluginUserOwnApiQuotaStatusLazyQueryHookResult = ReturnType<typeof useGetPluginUserOwnApiQuotaStatusLazyQuery>;
export type GetPluginUserOwnApiQuotaStatusSuspenseQueryHookResult = ReturnType<typeof useGetPluginUserOwnApiQuotaStatusSuspenseQuery>;
export type GetPluginUserOwnApiQuotaStatusQueryResult = Apollo.QueryResult<GetPluginUserOwnApiQuotaStatusQuery, GetPluginUserOwnApiQuotaStatusQueryVariables>;
export const DeleteBrokerActivityByIdDocument = gql`
    mutation deleteBrokerActivityById($activityId: ObjectId!) {
  deleteBrokerActivityById(activityId: $activityId) {
    _id
  }
}
    `;
export type DeleteBrokerActivityByIdMutationFn = Apollo.MutationFunction<DeleteBrokerActivityByIdMutation, DeleteBrokerActivityByIdMutationVariables>;

/**
 * __useDeleteBrokerActivityByIdMutation__
 *
 * To run a mutation, you first call `useDeleteBrokerActivityByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrokerActivityByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrokerActivityByIdMutation, { data, loading, error }] = useDeleteBrokerActivityByIdMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useDeleteBrokerActivityByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBrokerActivityByIdMutation, DeleteBrokerActivityByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBrokerActivityByIdMutation, DeleteBrokerActivityByIdMutationVariables>(DeleteBrokerActivityByIdDocument, options);
      }
export type DeleteBrokerActivityByIdMutationHookResult = ReturnType<typeof useDeleteBrokerActivityByIdMutation>;
export type DeleteBrokerActivityByIdMutationResult = Apollo.MutationResult<DeleteBrokerActivityByIdMutation>;
export type DeleteBrokerActivityByIdMutationOptions = Apollo.BaseMutationOptions<DeleteBrokerActivityByIdMutation, DeleteBrokerActivityByIdMutationVariables>;
export const GetPropertyVisitActivitiesDocument = gql`
    query getPropertyVisitActivities($pagination: PaginationInput, $sort: [SortInput!]) {
  getPropertyVisitActivities(pagination: $pagination, sort: $sort) {
    collection {
      ...PropertyVisitActivity
    }
    totalCount
  }
}
    ${PropertyVisitActivityFragmentDoc}`;

/**
 * __useGetPropertyVisitActivitiesQuery__
 *
 * To run a query within a React component, call `useGetPropertyVisitActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyVisitActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyVisitActivitiesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPropertyVisitActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertyVisitActivitiesQuery, GetPropertyVisitActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyVisitActivitiesQuery, GetPropertyVisitActivitiesQueryVariables>(GetPropertyVisitActivitiesDocument, options);
      }
export function useGetPropertyVisitActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyVisitActivitiesQuery, GetPropertyVisitActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyVisitActivitiesQuery, GetPropertyVisitActivitiesQueryVariables>(GetPropertyVisitActivitiesDocument, options);
        }
export function useGetPropertyVisitActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyVisitActivitiesQuery, GetPropertyVisitActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyVisitActivitiesQuery, GetPropertyVisitActivitiesQueryVariables>(GetPropertyVisitActivitiesDocument, options);
        }
export type GetPropertyVisitActivitiesQueryHookResult = ReturnType<typeof useGetPropertyVisitActivitiesQuery>;
export type GetPropertyVisitActivitiesLazyQueryHookResult = ReturnType<typeof useGetPropertyVisitActivitiesLazyQuery>;
export type GetPropertyVisitActivitiesSuspenseQueryHookResult = ReturnType<typeof useGetPropertyVisitActivitiesSuspenseQuery>;
export type GetPropertyVisitActivitiesQueryResult = Apollo.QueryResult<GetPropertyVisitActivitiesQuery, GetPropertyVisitActivitiesQueryVariables>;
export const GetBrokerNewPortfolioItemActivitiesDocument = gql`
    query getBrokerNewPortfolioItemActivities($pagination: PaginationInput, $sort: [SortInput!]) {
  getBrokerNewPortfolioItemActivities(pagination: $pagination, sort: $sort) {
    collection {
      ...NewPortfolioItemActivity
    }
    totalCount
  }
}
    ${NewPortfolioItemActivityFragmentDoc}`;

/**
 * __useGetBrokerNewPortfolioItemActivitiesQuery__
 *
 * To run a query within a React component, call `useGetBrokerNewPortfolioItemActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerNewPortfolioItemActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerNewPortfolioItemActivitiesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetBrokerNewPortfolioItemActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetBrokerNewPortfolioItemActivitiesQuery, GetBrokerNewPortfolioItemActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokerNewPortfolioItemActivitiesQuery, GetBrokerNewPortfolioItemActivitiesQueryVariables>(GetBrokerNewPortfolioItemActivitiesDocument, options);
      }
export function useGetBrokerNewPortfolioItemActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokerNewPortfolioItemActivitiesQuery, GetBrokerNewPortfolioItemActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokerNewPortfolioItemActivitiesQuery, GetBrokerNewPortfolioItemActivitiesQueryVariables>(GetBrokerNewPortfolioItemActivitiesDocument, options);
        }
export function useGetBrokerNewPortfolioItemActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrokerNewPortfolioItemActivitiesQuery, GetBrokerNewPortfolioItemActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrokerNewPortfolioItemActivitiesQuery, GetBrokerNewPortfolioItemActivitiesQueryVariables>(GetBrokerNewPortfolioItemActivitiesDocument, options);
        }
export type GetBrokerNewPortfolioItemActivitiesQueryHookResult = ReturnType<typeof useGetBrokerNewPortfolioItemActivitiesQuery>;
export type GetBrokerNewPortfolioItemActivitiesLazyQueryHookResult = ReturnType<typeof useGetBrokerNewPortfolioItemActivitiesLazyQuery>;
export type GetBrokerNewPortfolioItemActivitiesSuspenseQueryHookResult = ReturnType<typeof useGetBrokerNewPortfolioItemActivitiesSuspenseQuery>;
export type GetBrokerNewPortfolioItemActivitiesQueryResult = Apollo.QueryResult<GetBrokerNewPortfolioItemActivitiesQuery, GetBrokerNewPortfolioItemActivitiesQueryVariables>;
export const UpdateCurrentBrokerDocument = gql`
    mutation updateCurrentBroker($input: UpdateBrokerInput!) {
  updateCurrentBroker(input: $input) {
    ...Broker
  }
}
    ${BrokerFragmentDoc}`;
export type UpdateCurrentBrokerMutationFn = Apollo.MutationFunction<UpdateCurrentBrokerMutation, UpdateCurrentBrokerMutationVariables>;

/**
 * __useUpdateCurrentBrokerMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentBrokerMutation, { data, loading, error }] = useUpdateCurrentBrokerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrentBrokerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentBrokerMutation, UpdateCurrentBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentBrokerMutation, UpdateCurrentBrokerMutationVariables>(UpdateCurrentBrokerDocument, options);
      }
export type UpdateCurrentBrokerMutationHookResult = ReturnType<typeof useUpdateCurrentBrokerMutation>;
export type UpdateCurrentBrokerMutationResult = Apollo.MutationResult<UpdateCurrentBrokerMutation>;
export type UpdateCurrentBrokerMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentBrokerMutation, UpdateCurrentBrokerMutationVariables>;
export const RegisterBrokerDocument = gql`
    mutation registerBroker($input: RegisterBrokerInput!) {
  registerBroker(input: $input) {
    accessToken
    refreshToken
    refreshTokenExpiry
  }
}
    `;
export type RegisterBrokerMutationFn = Apollo.MutationFunction<RegisterBrokerMutation, RegisterBrokerMutationVariables>;

/**
 * __useRegisterBrokerMutation__
 *
 * To run a mutation, you first call `useRegisterBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerBrokerMutation, { data, loading, error }] = useRegisterBrokerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterBrokerMutation(baseOptions?: Apollo.MutationHookOptions<RegisterBrokerMutation, RegisterBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterBrokerMutation, RegisterBrokerMutationVariables>(RegisterBrokerDocument, options);
      }
export type RegisterBrokerMutationHookResult = ReturnType<typeof useRegisterBrokerMutation>;
export type RegisterBrokerMutationResult = Apollo.MutationResult<RegisterBrokerMutation>;
export type RegisterBrokerMutationOptions = Apollo.BaseMutationOptions<RegisterBrokerMutation, RegisterBrokerMutationVariables>;
export const CreateBrokerDocument = gql`
    mutation createBroker($input: CreateBrokerInput!) {
  createBroker(input: $input) {
    accessToken
    refreshToken
    refreshTokenExpiry
  }
}
    `;
export type CreateBrokerMutationFn = Apollo.MutationFunction<CreateBrokerMutation, CreateBrokerMutationVariables>;

/**
 * __useCreateBrokerMutation__
 *
 * To run a mutation, you first call `useCreateBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrokerMutation, { data, loading, error }] = useCreateBrokerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrokerMutation(baseOptions?: Apollo.MutationHookOptions<CreateBrokerMutation, CreateBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBrokerMutation, CreateBrokerMutationVariables>(CreateBrokerDocument, options);
      }
export type CreateBrokerMutationHookResult = ReturnType<typeof useCreateBrokerMutation>;
export type CreateBrokerMutationResult = Apollo.MutationResult<CreateBrokerMutation>;
export type CreateBrokerMutationOptions = Apollo.BaseMutationOptions<CreateBrokerMutation, CreateBrokerMutationVariables>;
export const CreateBrokerSsoDocument = gql`
    mutation createBrokerSSO($input: CreateBrokerSSOInput!) {
  createBrokerSSO(input: $input) {
    accessToken
    refreshToken
    refreshTokenExpiry
  }
}
    `;
export type CreateBrokerSsoMutationFn = Apollo.MutationFunction<CreateBrokerSsoMutation, CreateBrokerSsoMutationVariables>;

/**
 * __useCreateBrokerSsoMutation__
 *
 * To run a mutation, you first call `useCreateBrokerSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrokerSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrokerSsoMutation, { data, loading, error }] = useCreateBrokerSsoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrokerSsoMutation(baseOptions?: Apollo.MutationHookOptions<CreateBrokerSsoMutation, CreateBrokerSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBrokerSsoMutation, CreateBrokerSsoMutationVariables>(CreateBrokerSsoDocument, options);
      }
export type CreateBrokerSsoMutationHookResult = ReturnType<typeof useCreateBrokerSsoMutation>;
export type CreateBrokerSsoMutationResult = Apollo.MutationResult<CreateBrokerSsoMutation>;
export type CreateBrokerSsoMutationOptions = Apollo.BaseMutationOptions<CreateBrokerSsoMutation, CreateBrokerSsoMutationVariables>;
export const SendMessageToAgentDocument = gql`
    mutation sendMessageToAgent($input: SendMessageToAgentInput!) {
  sendMessageToAgent(input: $input)
}
    `;
export type SendMessageToAgentMutationFn = Apollo.MutationFunction<SendMessageToAgentMutation, SendMessageToAgentMutationVariables>;

/**
 * __useSendMessageToAgentMutation__
 *
 * To run a mutation, you first call `useSendMessageToAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageToAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageToAgentMutation, { data, loading, error }] = useSendMessageToAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMessageToAgentMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageToAgentMutation, SendMessageToAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageToAgentMutation, SendMessageToAgentMutationVariables>(SendMessageToAgentDocument, options);
      }
export type SendMessageToAgentMutationHookResult = ReturnType<typeof useSendMessageToAgentMutation>;
export type SendMessageToAgentMutationResult = Apollo.MutationResult<SendMessageToAgentMutation>;
export type SendMessageToAgentMutationOptions = Apollo.BaseMutationOptions<SendMessageToAgentMutation, SendMessageToAgentMutationVariables>;
export const CreateSimpleBrokerDocument = gql`
    mutation createSimpleBroker($input: CreateSimpleBrokerInput!) {
  createSimpleBroker(input: $input) {
    ...Broker
  }
}
    ${BrokerFragmentDoc}`;
export type CreateSimpleBrokerMutationFn = Apollo.MutationFunction<CreateSimpleBrokerMutation, CreateSimpleBrokerMutationVariables>;

/**
 * __useCreateSimpleBrokerMutation__
 *
 * To run a mutation, you first call `useCreateSimpleBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSimpleBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSimpleBrokerMutation, { data, loading, error }] = useCreateSimpleBrokerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSimpleBrokerMutation(baseOptions?: Apollo.MutationHookOptions<CreateSimpleBrokerMutation, CreateSimpleBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSimpleBrokerMutation, CreateSimpleBrokerMutationVariables>(CreateSimpleBrokerDocument, options);
      }
export type CreateSimpleBrokerMutationHookResult = ReturnType<typeof useCreateSimpleBrokerMutation>;
export type CreateSimpleBrokerMutationResult = Apollo.MutationResult<CreateSimpleBrokerMutation>;
export type CreateSimpleBrokerMutationOptions = Apollo.BaseMutationOptions<CreateSimpleBrokerMutation, CreateSimpleBrokerMutationVariables>;
export const GetCurrentBrokerDocument = gql`
    query getCurrentBroker {
  getCurrentBroker {
    ...Broker
  }
}
    ${BrokerFragmentDoc}`;

/**
 * __useGetCurrentBrokerQuery__
 *
 * To run a query within a React component, call `useGetCurrentBrokerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentBrokerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentBrokerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentBrokerQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentBrokerQuery, GetCurrentBrokerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentBrokerQuery, GetCurrentBrokerQueryVariables>(GetCurrentBrokerDocument, options);
      }
export function useGetCurrentBrokerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentBrokerQuery, GetCurrentBrokerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentBrokerQuery, GetCurrentBrokerQueryVariables>(GetCurrentBrokerDocument, options);
        }
export function useGetCurrentBrokerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentBrokerQuery, GetCurrentBrokerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentBrokerQuery, GetCurrentBrokerQueryVariables>(GetCurrentBrokerDocument, options);
        }
export type GetCurrentBrokerQueryHookResult = ReturnType<typeof useGetCurrentBrokerQuery>;
export type GetCurrentBrokerLazyQueryHookResult = ReturnType<typeof useGetCurrentBrokerLazyQuery>;
export type GetCurrentBrokerSuspenseQueryHookResult = ReturnType<typeof useGetCurrentBrokerSuspenseQuery>;
export type GetCurrentBrokerQueryResult = Apollo.QueryResult<GetCurrentBrokerQuery, GetCurrentBrokerQueryVariables>;
export const GetBrokerByIdDocument = gql`
    query getBrokerById($brokerId: ObjectId!) {
  getBrokerById(brokerId: $brokerId) {
    ...Broker
  }
}
    ${BrokerFragmentDoc}`;

/**
 * __useGetBrokerByIdQuery__
 *
 * To run a query within a React component, call `useGetBrokerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerByIdQuery({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *   },
 * });
 */
export function useGetBrokerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBrokerByIdQuery, GetBrokerByIdQueryVariables> & ({ variables: GetBrokerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokerByIdQuery, GetBrokerByIdQueryVariables>(GetBrokerByIdDocument, options);
      }
export function useGetBrokerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokerByIdQuery, GetBrokerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokerByIdQuery, GetBrokerByIdQueryVariables>(GetBrokerByIdDocument, options);
        }
export function useGetBrokerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrokerByIdQuery, GetBrokerByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrokerByIdQuery, GetBrokerByIdQueryVariables>(GetBrokerByIdDocument, options);
        }
export type GetBrokerByIdQueryHookResult = ReturnType<typeof useGetBrokerByIdQuery>;
export type GetBrokerByIdLazyQueryHookResult = ReturnType<typeof useGetBrokerByIdLazyQuery>;
export type GetBrokerByIdSuspenseQueryHookResult = ReturnType<typeof useGetBrokerByIdSuspenseQuery>;
export type GetBrokerByIdQueryResult = Apollo.QueryResult<GetBrokerByIdQuery, GetBrokerByIdQueryVariables>;
export const GetSimpleBrokerByIdDocument = gql`
    query getSimpleBrokerById($brokerId: ObjectId!) {
  getBrokerById(brokerId: $brokerId) {
    _id
    agencyName
    agencyWebsite
    account {
      email
      phone {
        number
        status
        dialCode
      }
    }
    profile {
      firstName
      lastName
      avatarFile {
        _id
        publicUrl
      }
    }
  }
}
    `;

/**
 * __useGetSimpleBrokerByIdQuery__
 *
 * To run a query within a React component, call `useGetSimpleBrokerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleBrokerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleBrokerByIdQuery({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *   },
 * });
 */
export function useGetSimpleBrokerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSimpleBrokerByIdQuery, GetSimpleBrokerByIdQueryVariables> & ({ variables: GetSimpleBrokerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimpleBrokerByIdQuery, GetSimpleBrokerByIdQueryVariables>(GetSimpleBrokerByIdDocument, options);
      }
export function useGetSimpleBrokerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleBrokerByIdQuery, GetSimpleBrokerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimpleBrokerByIdQuery, GetSimpleBrokerByIdQueryVariables>(GetSimpleBrokerByIdDocument, options);
        }
export function useGetSimpleBrokerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSimpleBrokerByIdQuery, GetSimpleBrokerByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSimpleBrokerByIdQuery, GetSimpleBrokerByIdQueryVariables>(GetSimpleBrokerByIdDocument, options);
        }
export type GetSimpleBrokerByIdQueryHookResult = ReturnType<typeof useGetSimpleBrokerByIdQuery>;
export type GetSimpleBrokerByIdLazyQueryHookResult = ReturnType<typeof useGetSimpleBrokerByIdLazyQuery>;
export type GetSimpleBrokerByIdSuspenseQueryHookResult = ReturnType<typeof useGetSimpleBrokerByIdSuspenseQuery>;
export type GetSimpleBrokerByIdQueryResult = Apollo.QueryResult<GetSimpleBrokerByIdQuery, GetSimpleBrokerByIdQueryVariables>;
export const GetBrokerForAccountManagementDocument = gql`
    query getBrokerForAccountManagement {
  getBrokerForAccountManagement {
    ...Broker
  }
}
    ${BrokerFragmentDoc}`;

/**
 * __useGetBrokerForAccountManagementQuery__
 *
 * To run a query within a React component, call `useGetBrokerForAccountManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerForAccountManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerForAccountManagementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrokerForAccountManagementQuery(baseOptions?: Apollo.QueryHookOptions<GetBrokerForAccountManagementQuery, GetBrokerForAccountManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokerForAccountManagementQuery, GetBrokerForAccountManagementQueryVariables>(GetBrokerForAccountManagementDocument, options);
      }
export function useGetBrokerForAccountManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokerForAccountManagementQuery, GetBrokerForAccountManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokerForAccountManagementQuery, GetBrokerForAccountManagementQueryVariables>(GetBrokerForAccountManagementDocument, options);
        }
export function useGetBrokerForAccountManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrokerForAccountManagementQuery, GetBrokerForAccountManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrokerForAccountManagementQuery, GetBrokerForAccountManagementQueryVariables>(GetBrokerForAccountManagementDocument, options);
        }
export type GetBrokerForAccountManagementQueryHookResult = ReturnType<typeof useGetBrokerForAccountManagementQuery>;
export type GetBrokerForAccountManagementLazyQueryHookResult = ReturnType<typeof useGetBrokerForAccountManagementLazyQuery>;
export type GetBrokerForAccountManagementSuspenseQueryHookResult = ReturnType<typeof useGetBrokerForAccountManagementSuspenseQuery>;
export type GetBrokerForAccountManagementQueryResult = Apollo.QueryResult<GetBrokerForAccountManagementQuery, GetBrokerForAccountManagementQueryVariables>;
export const AddFeaturedPortfolioToSavedDocument = gql`
    mutation addFeaturedPortfolioToSaved($portfolioId: ObjectId!) {
  addFeaturedPortfolioToSaved(portfolioId: $portfolioId) {
    _id
    portfolioId
  }
}
    `;
export type AddFeaturedPortfolioToSavedMutationFn = Apollo.MutationFunction<AddFeaturedPortfolioToSavedMutation, AddFeaturedPortfolioToSavedMutationVariables>;

/**
 * __useAddFeaturedPortfolioToSavedMutation__
 *
 * To run a mutation, you first call `useAddFeaturedPortfolioToSavedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeaturedPortfolioToSavedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeaturedPortfolioToSavedMutation, { data, loading, error }] = useAddFeaturedPortfolioToSavedMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useAddFeaturedPortfolioToSavedMutation(baseOptions?: Apollo.MutationHookOptions<AddFeaturedPortfolioToSavedMutation, AddFeaturedPortfolioToSavedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFeaturedPortfolioToSavedMutation, AddFeaturedPortfolioToSavedMutationVariables>(AddFeaturedPortfolioToSavedDocument, options);
      }
export type AddFeaturedPortfolioToSavedMutationHookResult = ReturnType<typeof useAddFeaturedPortfolioToSavedMutation>;
export type AddFeaturedPortfolioToSavedMutationResult = Apollo.MutationResult<AddFeaturedPortfolioToSavedMutation>;
export type AddFeaturedPortfolioToSavedMutationOptions = Apollo.BaseMutationOptions<AddFeaturedPortfolioToSavedMutation, AddFeaturedPortfolioToSavedMutationVariables>;
export const RemoveFeaturedPortfolioFromSavedDocument = gql`
    mutation removeFeaturedPortfolioFromSaved($brokerSavedFeaturedPortfolioId: ObjectId!) {
  removeFeaturedPortfolioFromSaved(
    brokerSavedFeaturedPortfolioId: $brokerSavedFeaturedPortfolioId
  ) {
    _id
    portfolioId
  }
}
    `;
export type RemoveFeaturedPortfolioFromSavedMutationFn = Apollo.MutationFunction<RemoveFeaturedPortfolioFromSavedMutation, RemoveFeaturedPortfolioFromSavedMutationVariables>;

/**
 * __useRemoveFeaturedPortfolioFromSavedMutation__
 *
 * To run a mutation, you first call `useRemoveFeaturedPortfolioFromSavedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFeaturedPortfolioFromSavedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFeaturedPortfolioFromSavedMutation, { data, loading, error }] = useRemoveFeaturedPortfolioFromSavedMutation({
 *   variables: {
 *      brokerSavedFeaturedPortfolioId: // value for 'brokerSavedFeaturedPortfolioId'
 *   },
 * });
 */
export function useRemoveFeaturedPortfolioFromSavedMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFeaturedPortfolioFromSavedMutation, RemoveFeaturedPortfolioFromSavedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFeaturedPortfolioFromSavedMutation, RemoveFeaturedPortfolioFromSavedMutationVariables>(RemoveFeaturedPortfolioFromSavedDocument, options);
      }
export type RemoveFeaturedPortfolioFromSavedMutationHookResult = ReturnType<typeof useRemoveFeaturedPortfolioFromSavedMutation>;
export type RemoveFeaturedPortfolioFromSavedMutationResult = Apollo.MutationResult<RemoveFeaturedPortfolioFromSavedMutation>;
export type RemoveFeaturedPortfolioFromSavedMutationOptions = Apollo.BaseMutationOptions<RemoveFeaturedPortfolioFromSavedMutation, RemoveFeaturedPortfolioFromSavedMutationVariables>;
export const CopyFeaturedPortfolioToBrokerPortfolioDocument = gql`
    mutation copyFeaturedPortfolioToBrokerPortfolio($args: CopyFeaturedPortfolioToBrokerPortfolioArgs!) {
  copyFeaturedPortfolioToBrokerPortfolio(args: $args) {
    _id
    name
    propertyCount
  }
}
    `;
export type CopyFeaturedPortfolioToBrokerPortfolioMutationFn = Apollo.MutationFunction<CopyFeaturedPortfolioToBrokerPortfolioMutation, CopyFeaturedPortfolioToBrokerPortfolioMutationVariables>;

/**
 * __useCopyFeaturedPortfolioToBrokerPortfolioMutation__
 *
 * To run a mutation, you first call `useCopyFeaturedPortfolioToBrokerPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyFeaturedPortfolioToBrokerPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyFeaturedPortfolioToBrokerPortfolioMutation, { data, loading, error }] = useCopyFeaturedPortfolioToBrokerPortfolioMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCopyFeaturedPortfolioToBrokerPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<CopyFeaturedPortfolioToBrokerPortfolioMutation, CopyFeaturedPortfolioToBrokerPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyFeaturedPortfolioToBrokerPortfolioMutation, CopyFeaturedPortfolioToBrokerPortfolioMutationVariables>(CopyFeaturedPortfolioToBrokerPortfolioDocument, options);
      }
export type CopyFeaturedPortfolioToBrokerPortfolioMutationHookResult = ReturnType<typeof useCopyFeaturedPortfolioToBrokerPortfolioMutation>;
export type CopyFeaturedPortfolioToBrokerPortfolioMutationResult = Apollo.MutationResult<CopyFeaturedPortfolioToBrokerPortfolioMutation>;
export type CopyFeaturedPortfolioToBrokerPortfolioMutationOptions = Apollo.BaseMutationOptions<CopyFeaturedPortfolioToBrokerPortfolioMutation, CopyFeaturedPortfolioToBrokerPortfolioMutationVariables>;
export const GetFeaturedPortfoliosDocument = gql`
    query getFeaturedPortfolios($filter: GetFeaturedPortfoliosFilter, $pagination: PaginationInput, $sort: [SortInput!], $searchText: String) {
  getFeaturedPortfolios(
    filter: $filter
    pagination: $pagination
    sort: $sort
    searchText: $searchText
  ) {
    collection {
      ...FeaturedPortfolioCard
    }
    totalCount
  }
}
    ${FeaturedPortfolioCardFragmentDoc}`;

/**
 * __useGetFeaturedPortfoliosQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfoliosQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetFeaturedPortfoliosQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>(GetFeaturedPortfoliosDocument, options);
      }
export function useGetFeaturedPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>(GetFeaturedPortfoliosDocument, options);
        }
export function useGetFeaturedPortfoliosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>(GetFeaturedPortfoliosDocument, options);
        }
export type GetFeaturedPortfoliosQueryHookResult = ReturnType<typeof useGetFeaturedPortfoliosQuery>;
export type GetFeaturedPortfoliosLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfoliosLazyQuery>;
export type GetFeaturedPortfoliosSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedPortfoliosSuspenseQuery>;
export type GetFeaturedPortfoliosQueryResult = Apollo.QueryResult<GetFeaturedPortfoliosQuery, GetFeaturedPortfoliosQueryVariables>;
export const GetFeaturedPortfolioByIdDocument = gql`
    query getFeaturedPortfolioById($featuredPortfolioId: String!) {
  getFeaturedPortfolioById(featuredPortfolioId: $featuredPortfolioId) {
    _id
    title
    cardDescription
    overview
    coverImageFile {
      _id
      name
      type
      size
      publicUrl
      thumbnailFile {
        _id
        publicUrl
      }
    }
    propertyIds
    displayOrder
    visibility
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetFeaturedPortfolioByIdQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioByIdQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *   },
 * });
 */
export function useGetFeaturedPortfolioByIdQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables> & ({ variables: GetFeaturedPortfolioByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables>(GetFeaturedPortfolioByIdDocument, options);
      }
export function useGetFeaturedPortfolioByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables>(GetFeaturedPortfolioByIdDocument, options);
        }
export function useGetFeaturedPortfolioByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables>(GetFeaturedPortfolioByIdDocument, options);
        }
export type GetFeaturedPortfolioByIdQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioByIdQuery>;
export type GetFeaturedPortfolioByIdLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioByIdLazyQuery>;
export type GetFeaturedPortfolioByIdSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioByIdSuspenseQuery>;
export type GetFeaturedPortfolioByIdQueryResult = Apollo.QueryResult<GetFeaturedPortfolioByIdQuery, GetFeaturedPortfolioByIdQueryVariables>;
export const GetFeaturedPortfolioPropertiesDocument = gql`
    query getFeaturedPortfolioProperties($featuredPortfolioId: String!, $pagination: FlatPaginationInput) {
  getFeaturedPortfolioProperties(
    featuredPortfolioId: $featuredPortfolioId
    pagination: $pagination
  ) {
    collection {
      _id
      name
      overview
      yearBuilt
      projectStatus
      mainPropertyMediaFile {
        _id
        files {
          _id
          publicUrl
          type
          thumbnailFile {
            _id
            publicUrl
          }
        }
      }
      marketArea {
        _id
        name
      }
      priceRange {
        min
        max
      }
      averageBedroomsNumber {
        min
        max
      }
      averageBathroomsNumber {
        min
        max
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetFeaturedPortfolioPropertiesQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioPropertiesQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetFeaturedPortfolioPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables> & ({ variables: GetFeaturedPortfolioPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables>(GetFeaturedPortfolioPropertiesDocument, options);
      }
export function useGetFeaturedPortfolioPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables>(GetFeaturedPortfolioPropertiesDocument, options);
        }
export function useGetFeaturedPortfolioPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables>(GetFeaturedPortfolioPropertiesDocument, options);
        }
export type GetFeaturedPortfolioPropertiesQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioPropertiesQuery>;
export type GetFeaturedPortfolioPropertiesLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioPropertiesLazyQuery>;
export type GetFeaturedPortfolioPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioPropertiesSuspenseQuery>;
export type GetFeaturedPortfolioPropertiesQueryResult = Apollo.QueryResult<GetFeaturedPortfolioPropertiesQuery, GetFeaturedPortfolioPropertiesQueryVariables>;
export const GetFeaturedPortfolioMarketAreasDocument = gql`
    query getFeaturedPortfolioMarketAreas($featuredPortfolioId: String!) {
  getFeaturedPortfolioMarketAreas(featuredPortfolioId: $featuredPortfolioId) {
    marketArea {
      _id
      name
    }
    count
  }
}
    `;

/**
 * __useGetFeaturedPortfolioMarketAreasQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioMarketAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioMarketAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioMarketAreasQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *   },
 * });
 */
export function useGetFeaturedPortfolioMarketAreasQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables> & ({ variables: GetFeaturedPortfolioMarketAreasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables>(GetFeaturedPortfolioMarketAreasDocument, options);
      }
export function useGetFeaturedPortfolioMarketAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables>(GetFeaturedPortfolioMarketAreasDocument, options);
        }
export function useGetFeaturedPortfolioMarketAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables>(GetFeaturedPortfolioMarketAreasDocument, options);
        }
export type GetFeaturedPortfolioMarketAreasQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioMarketAreasQuery>;
export type GetFeaturedPortfolioMarketAreasLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioMarketAreasLazyQuery>;
export type GetFeaturedPortfolioMarketAreasSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioMarketAreasSuspenseQuery>;
export type GetFeaturedPortfolioMarketAreasQueryResult = Apollo.QueryResult<GetFeaturedPortfolioMarketAreasQuery, GetFeaturedPortfolioMarketAreasQueryVariables>;
export const GetFeaturedPortfolioSummaryDocument = gql`
    query getFeaturedPortfolioSummary($featuredPortfolioId: String!) {
  getFeaturedPortfolioSummary(featuredPortfolioId: $featuredPortfolioId) {
    marketAreas {
      marketArea {
        _id
        name
      }
      count
    }
    priceRange {
      min
      max
    }
    completionYearRange {
      min
      max
    }
    propertyCount
  }
}
    `;

/**
 * __useGetFeaturedPortfolioSummaryQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioSummaryQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *   },
 * });
 */
export function useGetFeaturedPortfolioSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables> & ({ variables: GetFeaturedPortfolioSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables>(GetFeaturedPortfolioSummaryDocument, options);
      }
export function useGetFeaturedPortfolioSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables>(GetFeaturedPortfolioSummaryDocument, options);
        }
export function useGetFeaturedPortfolioSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables>(GetFeaturedPortfolioSummaryDocument, options);
        }
export type GetFeaturedPortfolioSummaryQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioSummaryQuery>;
export type GetFeaturedPortfolioSummaryLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioSummaryLazyQuery>;
export type GetFeaturedPortfolioSummarySuspenseQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioSummarySuspenseQuery>;
export type GetFeaturedPortfolioSummaryQueryResult = Apollo.QueryResult<GetFeaturedPortfolioSummaryQuery, GetFeaturedPortfolioSummaryQueryVariables>;
export const GetSavedFeaturedPortfoliosDocument = gql`
    query getSavedFeaturedPortfolios($filter: GetSavedFeaturedPortfoliosFilterInput, $pagination: PaginationInput, $sort: [SortInput!]) {
  getSavedFeaturedPortfolios(
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    collection {
      _id
      portfolioId
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useGetSavedFeaturedPortfoliosQuery__
 *
 * To run a query within a React component, call `useGetSavedFeaturedPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedFeaturedPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedFeaturedPortfoliosQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSavedFeaturedPortfoliosQuery(baseOptions?: Apollo.QueryHookOptions<GetSavedFeaturedPortfoliosQuery, GetSavedFeaturedPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedFeaturedPortfoliosQuery, GetSavedFeaturedPortfoliosQueryVariables>(GetSavedFeaturedPortfoliosDocument, options);
      }
export function useGetSavedFeaturedPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedFeaturedPortfoliosQuery, GetSavedFeaturedPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedFeaturedPortfoliosQuery, GetSavedFeaturedPortfoliosQueryVariables>(GetSavedFeaturedPortfoliosDocument, options);
        }
export function useGetSavedFeaturedPortfoliosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedFeaturedPortfoliosQuery, GetSavedFeaturedPortfoliosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavedFeaturedPortfoliosQuery, GetSavedFeaturedPortfoliosQueryVariables>(GetSavedFeaturedPortfoliosDocument, options);
        }
export type GetSavedFeaturedPortfoliosQueryHookResult = ReturnType<typeof useGetSavedFeaturedPortfoliosQuery>;
export type GetSavedFeaturedPortfoliosLazyQueryHookResult = ReturnType<typeof useGetSavedFeaturedPortfoliosLazyQuery>;
export type GetSavedFeaturedPortfoliosSuspenseQueryHookResult = ReturnType<typeof useGetSavedFeaturedPortfoliosSuspenseQuery>;
export type GetSavedFeaturedPortfoliosQueryResult = Apollo.QueryResult<GetSavedFeaturedPortfoliosQuery, GetSavedFeaturedPortfoliosQueryVariables>;
export const GetSavedFeaturedPortfoliosWithDetailsDocument = gql`
    query getSavedFeaturedPortfoliosWithDetails($filter: GetSavedFeaturedPortfoliosFilterInput, $pagination: PaginationInput, $sort: [SortInput!]) {
  getSavedFeaturedPortfolios(
    filter: $filter
    pagination: $pagination
    sort: $sort
  ) {
    collection {
      _id
      portfolioId
      createdAt
      portfolio {
        ...FeaturedPortfolioCard
      }
    }
    totalCount
  }
}
    ${FeaturedPortfolioCardFragmentDoc}`;

/**
 * __useGetSavedFeaturedPortfoliosWithDetailsQuery__
 *
 * To run a query within a React component, call `useGetSavedFeaturedPortfoliosWithDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedFeaturedPortfoliosWithDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedFeaturedPortfoliosWithDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSavedFeaturedPortfoliosWithDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetSavedFeaturedPortfoliosWithDetailsQuery, GetSavedFeaturedPortfoliosWithDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedFeaturedPortfoliosWithDetailsQuery, GetSavedFeaturedPortfoliosWithDetailsQueryVariables>(GetSavedFeaturedPortfoliosWithDetailsDocument, options);
      }
export function useGetSavedFeaturedPortfoliosWithDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedFeaturedPortfoliosWithDetailsQuery, GetSavedFeaturedPortfoliosWithDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedFeaturedPortfoliosWithDetailsQuery, GetSavedFeaturedPortfoliosWithDetailsQueryVariables>(GetSavedFeaturedPortfoliosWithDetailsDocument, options);
        }
export function useGetSavedFeaturedPortfoliosWithDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedFeaturedPortfoliosWithDetailsQuery, GetSavedFeaturedPortfoliosWithDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavedFeaturedPortfoliosWithDetailsQuery, GetSavedFeaturedPortfoliosWithDetailsQueryVariables>(GetSavedFeaturedPortfoliosWithDetailsDocument, options);
        }
export type GetSavedFeaturedPortfoliosWithDetailsQueryHookResult = ReturnType<typeof useGetSavedFeaturedPortfoliosWithDetailsQuery>;
export type GetSavedFeaturedPortfoliosWithDetailsLazyQueryHookResult = ReturnType<typeof useGetSavedFeaturedPortfoliosWithDetailsLazyQuery>;
export type GetSavedFeaturedPortfoliosWithDetailsSuspenseQueryHookResult = ReturnType<typeof useGetSavedFeaturedPortfoliosWithDetailsSuspenseQuery>;
export type GetSavedFeaturedPortfoliosWithDetailsQueryResult = Apollo.QueryResult<GetSavedFeaturedPortfoliosWithDetailsQuery, GetSavedFeaturedPortfoliosWithDetailsQueryVariables>;
export const GetIsFeaturedPortfolioSavedDocument = gql`
    query getIsFeaturedPortfolioSaved($portfolioId: ObjectId!) {
  getIsFeaturedPortfolioSaved(portfolioId: $portfolioId) {
    _id
    portfolioId
    createdAt
  }
}
    `;

/**
 * __useGetIsFeaturedPortfolioSavedQuery__
 *
 * To run a query within a React component, call `useGetIsFeaturedPortfolioSavedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsFeaturedPortfolioSavedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsFeaturedPortfolioSavedQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useGetIsFeaturedPortfolioSavedQuery(baseOptions: Apollo.QueryHookOptions<GetIsFeaturedPortfolioSavedQuery, GetIsFeaturedPortfolioSavedQueryVariables> & ({ variables: GetIsFeaturedPortfolioSavedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsFeaturedPortfolioSavedQuery, GetIsFeaturedPortfolioSavedQueryVariables>(GetIsFeaturedPortfolioSavedDocument, options);
      }
export function useGetIsFeaturedPortfolioSavedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsFeaturedPortfolioSavedQuery, GetIsFeaturedPortfolioSavedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsFeaturedPortfolioSavedQuery, GetIsFeaturedPortfolioSavedQueryVariables>(GetIsFeaturedPortfolioSavedDocument, options);
        }
export function useGetIsFeaturedPortfolioSavedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsFeaturedPortfolioSavedQuery, GetIsFeaturedPortfolioSavedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsFeaturedPortfolioSavedQuery, GetIsFeaturedPortfolioSavedQueryVariables>(GetIsFeaturedPortfolioSavedDocument, options);
        }
export type GetIsFeaturedPortfolioSavedQueryHookResult = ReturnType<typeof useGetIsFeaturedPortfolioSavedQuery>;
export type GetIsFeaturedPortfolioSavedLazyQueryHookResult = ReturnType<typeof useGetIsFeaturedPortfolioSavedLazyQuery>;
export type GetIsFeaturedPortfolioSavedSuspenseQueryHookResult = ReturnType<typeof useGetIsFeaturedPortfolioSavedSuspenseQuery>;
export type GetIsFeaturedPortfolioSavedQueryResult = Apollo.QueryResult<GetIsFeaturedPortfolioSavedQuery, GetIsFeaturedPortfolioSavedQueryVariables>;
export const GetFeaturedPortfolioByIdPublicDocument = gql`
    query getFeaturedPortfolioByIdPublic($featuredPortfolioId: String!) {
  getFeaturedPortfolioByIdPublic(featuredPortfolioId: $featuredPortfolioId) {
    _id
    title
    cardDescription
    overview
    coverImageFile {
      _id
      name
      type
      size
      publicUrl
      thumbnailFile {
        _id
        publicUrl
      }
    }
    propertyIds
    displayOrder
    visibility
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetFeaturedPortfolioByIdPublicQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioByIdPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioByIdPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioByIdPublicQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *   },
 * });
 */
export function useGetFeaturedPortfolioByIdPublicQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioByIdPublicQuery, GetFeaturedPortfolioByIdPublicQueryVariables> & ({ variables: GetFeaturedPortfolioByIdPublicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioByIdPublicQuery, GetFeaturedPortfolioByIdPublicQueryVariables>(GetFeaturedPortfolioByIdPublicDocument, options);
      }
export function useGetFeaturedPortfolioByIdPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioByIdPublicQuery, GetFeaturedPortfolioByIdPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioByIdPublicQuery, GetFeaturedPortfolioByIdPublicQueryVariables>(GetFeaturedPortfolioByIdPublicDocument, options);
        }
export function useGetFeaturedPortfolioByIdPublicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedPortfolioByIdPublicQuery, GetFeaturedPortfolioByIdPublicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedPortfolioByIdPublicQuery, GetFeaturedPortfolioByIdPublicQueryVariables>(GetFeaturedPortfolioByIdPublicDocument, options);
        }
export type GetFeaturedPortfolioByIdPublicQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioByIdPublicQuery>;
export type GetFeaturedPortfolioByIdPublicLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioByIdPublicLazyQuery>;
export type GetFeaturedPortfolioByIdPublicSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioByIdPublicSuspenseQuery>;
export type GetFeaturedPortfolioByIdPublicQueryResult = Apollo.QueryResult<GetFeaturedPortfolioByIdPublicQuery, GetFeaturedPortfolioByIdPublicQueryVariables>;
export const GetFeaturedPortfolioPropertiesPublicDocument = gql`
    query getFeaturedPortfolioPropertiesPublic($featuredPortfolioId: String!, $pagination: FlatPaginationInput) {
  getFeaturedPortfolioPropertiesPublic(
    featuredPortfolioId: $featuredPortfolioId
    pagination: $pagination
  ) {
    collection {
      _id
      name
      overview
      yearBuilt
      projectStatus
      mainPropertyMediaFile {
        _id
        files {
          _id
          publicUrl
          type
          thumbnailFile {
            _id
            publicUrl
          }
        }
      }
      marketArea {
        _id
        name
      }
      priceRange {
        min
        max
      }
      averageBedroomsNumber {
        min
        max
      }
      averageBathroomsNumber {
        min
        max
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetFeaturedPortfolioPropertiesPublicQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioPropertiesPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioPropertiesPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioPropertiesPublicQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetFeaturedPortfolioPropertiesPublicQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioPropertiesPublicQuery, GetFeaturedPortfolioPropertiesPublicQueryVariables> & ({ variables: GetFeaturedPortfolioPropertiesPublicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioPropertiesPublicQuery, GetFeaturedPortfolioPropertiesPublicQueryVariables>(GetFeaturedPortfolioPropertiesPublicDocument, options);
      }
export function useGetFeaturedPortfolioPropertiesPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioPropertiesPublicQuery, GetFeaturedPortfolioPropertiesPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioPropertiesPublicQuery, GetFeaturedPortfolioPropertiesPublicQueryVariables>(GetFeaturedPortfolioPropertiesPublicDocument, options);
        }
export function useGetFeaturedPortfolioPropertiesPublicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedPortfolioPropertiesPublicQuery, GetFeaturedPortfolioPropertiesPublicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedPortfolioPropertiesPublicQuery, GetFeaturedPortfolioPropertiesPublicQueryVariables>(GetFeaturedPortfolioPropertiesPublicDocument, options);
        }
export type GetFeaturedPortfolioPropertiesPublicQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioPropertiesPublicQuery>;
export type GetFeaturedPortfolioPropertiesPublicLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioPropertiesPublicLazyQuery>;
export type GetFeaturedPortfolioPropertiesPublicSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioPropertiesPublicSuspenseQuery>;
export type GetFeaturedPortfolioPropertiesPublicQueryResult = Apollo.QueryResult<GetFeaturedPortfolioPropertiesPublicQuery, GetFeaturedPortfolioPropertiesPublicQueryVariables>;
export const GetFeaturedPortfolioSummaryPublicDocument = gql`
    query getFeaturedPortfolioSummaryPublic($featuredPortfolioId: String!) {
  getFeaturedPortfolioSummaryPublic(featuredPortfolioId: $featuredPortfolioId) {
    marketAreas {
      marketArea {
        _id
        name
      }
      count
    }
    priceRange {
      min
      max
    }
    completionYearRange {
      min
      max
    }
    propertyCount
  }
}
    `;

/**
 * __useGetFeaturedPortfolioSummaryPublicQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPortfolioSummaryPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPortfolioSummaryPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPortfolioSummaryPublicQuery({
 *   variables: {
 *      featuredPortfolioId: // value for 'featuredPortfolioId'
 *   },
 * });
 */
export function useGetFeaturedPortfolioSummaryPublicQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPortfolioSummaryPublicQuery, GetFeaturedPortfolioSummaryPublicQueryVariables> & ({ variables: GetFeaturedPortfolioSummaryPublicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPortfolioSummaryPublicQuery, GetFeaturedPortfolioSummaryPublicQueryVariables>(GetFeaturedPortfolioSummaryPublicDocument, options);
      }
export function useGetFeaturedPortfolioSummaryPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPortfolioSummaryPublicQuery, GetFeaturedPortfolioSummaryPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPortfolioSummaryPublicQuery, GetFeaturedPortfolioSummaryPublicQueryVariables>(GetFeaturedPortfolioSummaryPublicDocument, options);
        }
export function useGetFeaturedPortfolioSummaryPublicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedPortfolioSummaryPublicQuery, GetFeaturedPortfolioSummaryPublicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedPortfolioSummaryPublicQuery, GetFeaturedPortfolioSummaryPublicQueryVariables>(GetFeaturedPortfolioSummaryPublicDocument, options);
        }
export type GetFeaturedPortfolioSummaryPublicQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioSummaryPublicQuery>;
export type GetFeaturedPortfolioSummaryPublicLazyQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioSummaryPublicLazyQuery>;
export type GetFeaturedPortfolioSummaryPublicSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedPortfolioSummaryPublicSuspenseQuery>;
export type GetFeaturedPortfolioSummaryPublicQueryResult = Apollo.QueryResult<GetFeaturedPortfolioSummaryPublicQuery, GetFeaturedPortfolioSummaryPublicQueryVariables>;
export const GetFeaturedPropertiesDocument = gql`
    query getFeaturedProperties($filter: GetFeaturedPropertiesFilter, $pagination: PaginationInput, $sort: [SortInput!], $searchText: String) {
  getFeaturedProperties(
    filter: $filter
    pagination: $pagination
    sort: $sort
    searchText: $searchText
  ) {
    collection {
      _id
      title
      shortOverview
      overview
      coverImageFile {
        _id
        name
        type
        size
        publicUrl
        thumbnailFile {
          _id
          publicUrl
        }
      }
      propertyId
      property {
        priceRange {
          min
          max
        }
        marketArea {
          ...MarketArea
        }
        projectStatus
        yearBuilt
      }
      displayOrder
      visibility
      createdAt
      updatedAt
    }
    totalCount
  }
}
    ${MarketAreaFragmentDoc}`;

/**
 * __useGetFeaturedPropertiesQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPropertiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetFeaturedPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>(GetFeaturedPropertiesDocument, options);
      }
export function useGetFeaturedPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>(GetFeaturedPropertiesDocument, options);
        }
export function useGetFeaturedPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>(GetFeaturedPropertiesDocument, options);
        }
export type GetFeaturedPropertiesQueryHookResult = ReturnType<typeof useGetFeaturedPropertiesQuery>;
export type GetFeaturedPropertiesLazyQueryHookResult = ReturnType<typeof useGetFeaturedPropertiesLazyQuery>;
export type GetFeaturedPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedPropertiesSuspenseQuery>;
export type GetFeaturedPropertiesQueryResult = Apollo.QueryResult<GetFeaturedPropertiesQuery, GetFeaturedPropertiesQueryVariables>;
export const GetFeaturedPropertyByIdDocument = gql`
    query getFeaturedPropertyById($featuredPropertyId: String!) {
  getFeaturedPropertyById(featuredPropertyId: $featuredPropertyId) {
    _id
    title
    shortOverview
    overview
    coverImageFile {
      _id
      name
      type
      size
      publicUrl
      thumbnailFile {
        _id
        publicUrl
      }
    }
    propertyId
    displayOrder
    visibility
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetFeaturedPropertyByIdQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPropertyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPropertyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPropertyByIdQuery({
 *   variables: {
 *      featuredPropertyId: // value for 'featuredPropertyId'
 *   },
 * });
 */
export function useGetFeaturedPropertyByIdQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables> & ({ variables: GetFeaturedPropertyByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables>(GetFeaturedPropertyByIdDocument, options);
      }
export function useGetFeaturedPropertyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables>(GetFeaturedPropertyByIdDocument, options);
        }
export function useGetFeaturedPropertyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables>(GetFeaturedPropertyByIdDocument, options);
        }
export type GetFeaturedPropertyByIdQueryHookResult = ReturnType<typeof useGetFeaturedPropertyByIdQuery>;
export type GetFeaturedPropertyByIdLazyQueryHookResult = ReturnType<typeof useGetFeaturedPropertyByIdLazyQuery>;
export type GetFeaturedPropertyByIdSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedPropertyByIdSuspenseQuery>;
export type GetFeaturedPropertyByIdQueryResult = Apollo.QueryResult<GetFeaturedPropertyByIdQuery, GetFeaturedPropertyByIdQueryVariables>;
export const UploadDraftFileDocument = gql`
    mutation uploadDraftFile($input: FileUploadInput!) {
  uploadDraftFile(input: $input) {
    ...File
  }
}
    ${FileFragmentDoc}`;
export type UploadDraftFileMutationFn = Apollo.MutationFunction<UploadDraftFileMutation, UploadDraftFileMutationVariables>;

/**
 * __useUploadDraftFileMutation__
 *
 * To run a mutation, you first call `useUploadDraftFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDraftFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDraftFileMutation, { data, loading, error }] = useUploadDraftFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadDraftFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadDraftFileMutation, UploadDraftFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDraftFileMutation, UploadDraftFileMutationVariables>(UploadDraftFileDocument, options);
      }
export type UploadDraftFileMutationHookResult = ReturnType<typeof useUploadDraftFileMutation>;
export type UploadDraftFileMutationResult = Apollo.MutationResult<UploadDraftFileMutation>;
export type UploadDraftFileMutationOptions = Apollo.BaseMutationOptions<UploadDraftFileMutation, UploadDraftFileMutationVariables>;
export const RegisterIdxActivityDocument = gql`
    mutation registerIdxActivity($idxId: ObjectId!, $propertyId: ObjectId!) {
  registerIdxActivity(idxId: $idxId, propertyId: $propertyId) {
    idxId
    propertyId
    createdAt
  }
}
    `;
export type RegisterIdxActivityMutationFn = Apollo.MutationFunction<RegisterIdxActivityMutation, RegisterIdxActivityMutationVariables>;

/**
 * __useRegisterIdxActivityMutation__
 *
 * To run a mutation, you first call `useRegisterIdxActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterIdxActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerIdxActivityMutation, { data, loading, error }] = useRegisterIdxActivityMutation({
 *   variables: {
 *      idxId: // value for 'idxId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useRegisterIdxActivityMutation(baseOptions?: Apollo.MutationHookOptions<RegisterIdxActivityMutation, RegisterIdxActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterIdxActivityMutation, RegisterIdxActivityMutationVariables>(RegisterIdxActivityDocument, options);
      }
export type RegisterIdxActivityMutationHookResult = ReturnType<typeof useRegisterIdxActivityMutation>;
export type RegisterIdxActivityMutationResult = Apollo.MutationResult<RegisterIdxActivityMutation>;
export type RegisterIdxActivityMutationOptions = Apollo.BaseMutationOptions<RegisterIdxActivityMutation, RegisterIdxActivityMutationVariables>;
export const GetIdxActivityDocument = gql`
    query getIdxActivity($idxId: ObjectId!, $dateRange: DateRangeInput) {
  getIdxActivity(idxId: $idxId, dateRange: $dateRange) {
    collection {
      date
      totalClicks
      propertyClicks {
        propertyId
        name
        address
        clickCount
      }
    }
  }
}
    `;

/**
 * __useGetIdxActivityQuery__
 *
 * To run a query within a React component, call `useGetIdxActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdxActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdxActivityQuery({
 *   variables: {
 *      idxId: // value for 'idxId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetIdxActivityQuery(baseOptions: Apollo.QueryHookOptions<GetIdxActivityQuery, GetIdxActivityQueryVariables> & ({ variables: GetIdxActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdxActivityQuery, GetIdxActivityQueryVariables>(GetIdxActivityDocument, options);
      }
export function useGetIdxActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdxActivityQuery, GetIdxActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdxActivityQuery, GetIdxActivityQueryVariables>(GetIdxActivityDocument, options);
        }
export function useGetIdxActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdxActivityQuery, GetIdxActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdxActivityQuery, GetIdxActivityQueryVariables>(GetIdxActivityDocument, options);
        }
export type GetIdxActivityQueryHookResult = ReturnType<typeof useGetIdxActivityQuery>;
export type GetIdxActivityLazyQueryHookResult = ReturnType<typeof useGetIdxActivityLazyQuery>;
export type GetIdxActivitySuspenseQueryHookResult = ReturnType<typeof useGetIdxActivitySuspenseQuery>;
export type GetIdxActivityQueryResult = Apollo.QueryResult<GetIdxActivityQuery, GetIdxActivityQueryVariables>;
export const GetIdxEmbeddedPropertyFeedDocument = gql`
    query GetIdxEmbeddedPropertyFeed($input: GetIdxEmbeddedPropertyFeedInput!) {
  getIdxEmbeddedPropertyFeed(input: $input) {
    idxFeed {
      _id
      accountId
      name
      portfolioFolderId
      propertiesPerPage
      propertyId
      type
      searchBarContent
      showPropertyDownloads
      showCustomPropertyDownloads
    }
    broker {
      ...Broker
    }
    idxSettings {
      _id
      accountId
      websiteDomain
      branding {
        mainColor
        textColor
        backgroundColor
      }
      showDashCredit
    }
    property {
      _id
      averageBathroomsNumberValue {
        min
        max
      }
      averageBedroomsNumberValue {
        min
        max
      }
      buildingTypes
      propertyTags
      transactionType
      comingSoon
      interiorDesigner
      isMarkedAsVerified
      landscapeArchitect
      leadArchitect
      localArchitect
      location {
        _id
        address {
          city
          state
          street
          zipCode
        }
        geoLocation {
          coordinates
        }
      }
      marketArea {
        _id
        name
      }
      mainPropertyMediaFile {
        _id
        files {
          _id
          publicUrl
          thumbnailFileUrl
        }
      }
      name
      numberOfUnits
      numberOfTowers
      overview
      priceRange {
        min
        max
      }
      projectStatus
      projectDetails
      slideshowMedia {
        _id
        files {
          _id
          name
          publicUrl
          thumbnailFileUrl
          type
        }
      }
      status
      stories
      taxInformation
      virtualTourLinks {
        url
        label
      }
      website
      yearBuilt
    }
    propertyAmenities {
      _id
      imageUrl
      name
    }
  }
}
    ${BrokerFragmentDoc}`;

/**
 * __useGetIdxEmbeddedPropertyFeedQuery__
 *
 * To run a query within a React component, call `useGetIdxEmbeddedPropertyFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdxEmbeddedPropertyFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdxEmbeddedPropertyFeedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIdxEmbeddedPropertyFeedQuery(baseOptions: Apollo.QueryHookOptions<GetIdxEmbeddedPropertyFeedQuery, GetIdxEmbeddedPropertyFeedQueryVariables> & ({ variables: GetIdxEmbeddedPropertyFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdxEmbeddedPropertyFeedQuery, GetIdxEmbeddedPropertyFeedQueryVariables>(GetIdxEmbeddedPropertyFeedDocument, options);
      }
export function useGetIdxEmbeddedPropertyFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdxEmbeddedPropertyFeedQuery, GetIdxEmbeddedPropertyFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdxEmbeddedPropertyFeedQuery, GetIdxEmbeddedPropertyFeedQueryVariables>(GetIdxEmbeddedPropertyFeedDocument, options);
        }
export function useGetIdxEmbeddedPropertyFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdxEmbeddedPropertyFeedQuery, GetIdxEmbeddedPropertyFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdxEmbeddedPropertyFeedQuery, GetIdxEmbeddedPropertyFeedQueryVariables>(GetIdxEmbeddedPropertyFeedDocument, options);
        }
export type GetIdxEmbeddedPropertyFeedQueryHookResult = ReturnType<typeof useGetIdxEmbeddedPropertyFeedQuery>;
export type GetIdxEmbeddedPropertyFeedLazyQueryHookResult = ReturnType<typeof useGetIdxEmbeddedPropertyFeedLazyQuery>;
export type GetIdxEmbeddedPropertyFeedSuspenseQueryHookResult = ReturnType<typeof useGetIdxEmbeddedPropertyFeedSuspenseQuery>;
export type GetIdxEmbeddedPropertyFeedQueryResult = Apollo.QueryResult<GetIdxEmbeddedPropertyFeedQuery, GetIdxEmbeddedPropertyFeedQueryVariables>;
export const GetIdxPortfolioFeedPropertiesDocument = gql`
    query GetIdxPortfolioFeedProperties($input: GetIdxPortfolioFeedPropertiesInput!) {
  getIdxPortfolioFeedProperties(input: $input) {
    broker {
      _id
      account {
        _id
        email
        phone {
          dialCode
          number
        }
      }
      accountSubscription {
        _id
        status
      }
      agencyName
      agencyWebsite
      description
      profile {
        _id
        avatarFile {
          _id
          publicUrl
        }
        firstName
        fullName
        lastName
      }
    }
    portfolioFolder {
      _id
      name
    }
    portfolioItemCount
    portfolioItems {
      _id
      property {
        _id
        averageBathroomsNumberValue {
          max
          min
        }
        averageBedroomsNumberValue {
          max
          min
        }
        comingSoon
        isMarkedAsVerified
        location {
          _id
          address {
            city
            state
            street
            zipCode
          }
          geoLocation {
            coordinates
          }
        }
        marketArea {
          _id
          name
        }
        name
        priceRange {
          max
          min
        }
        projectStatus
        buildingTypes
        propertyTags
        mainPropertyMediaFile {
          _id
          files {
            _id
            type
            publicUrl
            thumbnailFileUrl
          }
        }
        status
        yearBuilt
      }
    }
  }
}
    `;

/**
 * __useGetIdxPortfolioFeedPropertiesQuery__
 *
 * To run a query within a React component, call `useGetIdxPortfolioFeedPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdxPortfolioFeedPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdxPortfolioFeedPropertiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIdxPortfolioFeedPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetIdxPortfolioFeedPropertiesQuery, GetIdxPortfolioFeedPropertiesQueryVariables> & ({ variables: GetIdxPortfolioFeedPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdxPortfolioFeedPropertiesQuery, GetIdxPortfolioFeedPropertiesQueryVariables>(GetIdxPortfolioFeedPropertiesDocument, options);
      }
export function useGetIdxPortfolioFeedPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdxPortfolioFeedPropertiesQuery, GetIdxPortfolioFeedPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdxPortfolioFeedPropertiesQuery, GetIdxPortfolioFeedPropertiesQueryVariables>(GetIdxPortfolioFeedPropertiesDocument, options);
        }
export function useGetIdxPortfolioFeedPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdxPortfolioFeedPropertiesQuery, GetIdxPortfolioFeedPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdxPortfolioFeedPropertiesQuery, GetIdxPortfolioFeedPropertiesQueryVariables>(GetIdxPortfolioFeedPropertiesDocument, options);
        }
export type GetIdxPortfolioFeedPropertiesQueryHookResult = ReturnType<typeof useGetIdxPortfolioFeedPropertiesQuery>;
export type GetIdxPortfolioFeedPropertiesLazyQueryHookResult = ReturnType<typeof useGetIdxPortfolioFeedPropertiesLazyQuery>;
export type GetIdxPortfolioFeedPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetIdxPortfolioFeedPropertiesSuspenseQuery>;
export type GetIdxPortfolioFeedPropertiesQueryResult = Apollo.QueryResult<GetIdxPortfolioFeedPropertiesQuery, GetIdxPortfolioFeedPropertiesQueryVariables>;
export const GetMarketAreasForFilterDocument = gql`
    query GetMarketAreasForFilter($input: GetMarketAreasForFilterInput!) {
  getMarketAreasForFilter(input: $input) {
    _id
    name
  }
}
    `;

/**
 * __useGetMarketAreasForFilterQuery__
 *
 * To run a query within a React component, call `useGetMarketAreasForFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketAreasForFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketAreasForFilterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMarketAreasForFilterQuery(baseOptions: Apollo.QueryHookOptions<GetMarketAreasForFilterQuery, GetMarketAreasForFilterQueryVariables> & ({ variables: GetMarketAreasForFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketAreasForFilterQuery, GetMarketAreasForFilterQueryVariables>(GetMarketAreasForFilterDocument, options);
      }
export function useGetMarketAreasForFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketAreasForFilterQuery, GetMarketAreasForFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketAreasForFilterQuery, GetMarketAreasForFilterQueryVariables>(GetMarketAreasForFilterDocument, options);
        }
export function useGetMarketAreasForFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMarketAreasForFilterQuery, GetMarketAreasForFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMarketAreasForFilterQuery, GetMarketAreasForFilterQueryVariables>(GetMarketAreasForFilterDocument, options);
        }
export type GetMarketAreasForFilterQueryHookResult = ReturnType<typeof useGetMarketAreasForFilterQuery>;
export type GetMarketAreasForFilterLazyQueryHookResult = ReturnType<typeof useGetMarketAreasForFilterLazyQuery>;
export type GetMarketAreasForFilterSuspenseQueryHookResult = ReturnType<typeof useGetMarketAreasForFilterSuspenseQuery>;
export type GetMarketAreasForFilterQueryResult = Apollo.QueryResult<GetMarketAreasForFilterQuery, GetMarketAreasForFilterQueryVariables>;
export const GetIdxSearchFeedPropertiesDocument = gql`
    query GetIdxSearchFeedProperties($input: GetIdxSearchFeedPropertiesInput!) {
  getIdxSearchFeedProperties(input: $input) {
    properties {
      collection {
        _id
        averageBathroomsNumberValue {
          min
          max
        }
        averageBedroomsNumberValue {
          min
          max
        }
        buildingTypes
        propertyTags
        comingSoon
        isMarkedAsVerified
        location {
          _id
          address {
            city
            state
            street
            zipCode
          }
          geoLocation {
            coordinates
          }
        }
        marketArea {
          _id
          name
        }
        name
        priceRange {
          min
          max
        }
        projectStatus
        mainPropertyMediaFile {
          _id
          files {
            _id
            type
            publicUrl
            thumbnailFileUrl
          }
        }
        status
        yearBuilt
      }
      totalCount
    }
  }
}
    `;

/**
 * __useGetIdxSearchFeedPropertiesQuery__
 *
 * To run a query within a React component, call `useGetIdxSearchFeedPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdxSearchFeedPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdxSearchFeedPropertiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIdxSearchFeedPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetIdxSearchFeedPropertiesQuery, GetIdxSearchFeedPropertiesQueryVariables> & ({ variables: GetIdxSearchFeedPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdxSearchFeedPropertiesQuery, GetIdxSearchFeedPropertiesQueryVariables>(GetIdxSearchFeedPropertiesDocument, options);
      }
export function useGetIdxSearchFeedPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdxSearchFeedPropertiesQuery, GetIdxSearchFeedPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdxSearchFeedPropertiesQuery, GetIdxSearchFeedPropertiesQueryVariables>(GetIdxSearchFeedPropertiesDocument, options);
        }
export function useGetIdxSearchFeedPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdxSearchFeedPropertiesQuery, GetIdxSearchFeedPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdxSearchFeedPropertiesQuery, GetIdxSearchFeedPropertiesQueryVariables>(GetIdxSearchFeedPropertiesDocument, options);
        }
export type GetIdxSearchFeedPropertiesQueryHookResult = ReturnType<typeof useGetIdxSearchFeedPropertiesQuery>;
export type GetIdxSearchFeedPropertiesLazyQueryHookResult = ReturnType<typeof useGetIdxSearchFeedPropertiesLazyQuery>;
export type GetIdxSearchFeedPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetIdxSearchFeedPropertiesSuspenseQuery>;
export type GetIdxSearchFeedPropertiesQueryResult = Apollo.QueryResult<GetIdxSearchFeedPropertiesQuery, GetIdxSearchFeedPropertiesQueryVariables>;
export const GetIdxEmbeddedSearchBarFeedDocument = gql`
    query GetIdxEmbeddedSearchBarFeed($input: GetIdxEmbeddedSearchBarFeedInput!) {
  getIdxEmbeddedSearchBarFeed(input: $input) {
    idxFeed {
      _id
      accountId
      name
      type
      propertiesPerPage
      searchBarContent
    }
    idxSettings {
      _id
      accountId
      websiteDomain
      branding {
        mainColor
        textColor
        backgroundColor
      }
      showDashCredit
    }
  }
}
    `;

/**
 * __useGetIdxEmbeddedSearchBarFeedQuery__
 *
 * To run a query within a React component, call `useGetIdxEmbeddedSearchBarFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdxEmbeddedSearchBarFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdxEmbeddedSearchBarFeedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIdxEmbeddedSearchBarFeedQuery(baseOptions: Apollo.QueryHookOptions<GetIdxEmbeddedSearchBarFeedQuery, GetIdxEmbeddedSearchBarFeedQueryVariables> & ({ variables: GetIdxEmbeddedSearchBarFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdxEmbeddedSearchBarFeedQuery, GetIdxEmbeddedSearchBarFeedQueryVariables>(GetIdxEmbeddedSearchBarFeedDocument, options);
      }
export function useGetIdxEmbeddedSearchBarFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdxEmbeddedSearchBarFeedQuery, GetIdxEmbeddedSearchBarFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdxEmbeddedSearchBarFeedQuery, GetIdxEmbeddedSearchBarFeedQueryVariables>(GetIdxEmbeddedSearchBarFeedDocument, options);
        }
export function useGetIdxEmbeddedSearchBarFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdxEmbeddedSearchBarFeedQuery, GetIdxEmbeddedSearchBarFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdxEmbeddedSearchBarFeedQuery, GetIdxEmbeddedSearchBarFeedQueryVariables>(GetIdxEmbeddedSearchBarFeedDocument, options);
        }
export type GetIdxEmbeddedSearchBarFeedQueryHookResult = ReturnType<typeof useGetIdxEmbeddedSearchBarFeedQuery>;
export type GetIdxEmbeddedSearchBarFeedLazyQueryHookResult = ReturnType<typeof useGetIdxEmbeddedSearchBarFeedLazyQuery>;
export type GetIdxEmbeddedSearchBarFeedSuspenseQueryHookResult = ReturnType<typeof useGetIdxEmbeddedSearchBarFeedSuspenseQuery>;
export type GetIdxEmbeddedSearchBarFeedQueryResult = Apollo.QueryResult<GetIdxEmbeddedSearchBarFeedQuery, GetIdxEmbeddedSearchBarFeedQueryVariables>;
export const GetIdxEmbeddedPortfolioFeedDocument = gql`
    query GetIdxEmbeddedPortfolioFeed($input: GetIdxEmbeddedPortfolioFeedInput!) {
  getIdxEmbeddedPortfolioFeed(input: $input) {
    idxFeed {
      _id
      accountId
      name
      portfolioFolderId
      propertiesPerPage
      portfolioContent
      propertyId
      type
    }
    idxSettings {
      _id
      accountId
      websiteDomain
      branding {
        mainColor
        textColor
        backgroundColor
      }
      showDashCredit
    }
  }
}
    `;

/**
 * __useGetIdxEmbeddedPortfolioFeedQuery__
 *
 * To run a query within a React component, call `useGetIdxEmbeddedPortfolioFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdxEmbeddedPortfolioFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdxEmbeddedPortfolioFeedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIdxEmbeddedPortfolioFeedQuery(baseOptions: Apollo.QueryHookOptions<GetIdxEmbeddedPortfolioFeedQuery, GetIdxEmbeddedPortfolioFeedQueryVariables> & ({ variables: GetIdxEmbeddedPortfolioFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdxEmbeddedPortfolioFeedQuery, GetIdxEmbeddedPortfolioFeedQueryVariables>(GetIdxEmbeddedPortfolioFeedDocument, options);
      }
export function useGetIdxEmbeddedPortfolioFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdxEmbeddedPortfolioFeedQuery, GetIdxEmbeddedPortfolioFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdxEmbeddedPortfolioFeedQuery, GetIdxEmbeddedPortfolioFeedQueryVariables>(GetIdxEmbeddedPortfolioFeedDocument, options);
        }
export function useGetIdxEmbeddedPortfolioFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdxEmbeddedPortfolioFeedQuery, GetIdxEmbeddedPortfolioFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdxEmbeddedPortfolioFeedQuery, GetIdxEmbeddedPortfolioFeedQueryVariables>(GetIdxEmbeddedPortfolioFeedDocument, options);
        }
export type GetIdxEmbeddedPortfolioFeedQueryHookResult = ReturnType<typeof useGetIdxEmbeddedPortfolioFeedQuery>;
export type GetIdxEmbeddedPortfolioFeedLazyQueryHookResult = ReturnType<typeof useGetIdxEmbeddedPortfolioFeedLazyQuery>;
export type GetIdxEmbeddedPortfolioFeedSuspenseQueryHookResult = ReturnType<typeof useGetIdxEmbeddedPortfolioFeedSuspenseQuery>;
export type GetIdxEmbeddedPortfolioFeedQueryResult = Apollo.QueryResult<GetIdxEmbeddedPortfolioFeedQuery, GetIdxEmbeddedPortfolioFeedQueryVariables>;
export const GetIdxPropertyFilesDocument = gql`
    query GetIdxPropertyFiles($input: GetIdxPropertyFilesInput!) {
  getIdxPropertyFiles(input: $input) {
    filesCollection {
      _id
      files {
        _id
        name
        publicUrl
        s3Key
        thumbnailFileUrl
        type
        createdAt
      }
      sizeInBytes
      mediaFolderId
    }
    filesTotalCount
  }
}
    `;

/**
 * __useGetIdxPropertyFilesQuery__
 *
 * To run a query within a React component, call `useGetIdxPropertyFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdxPropertyFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdxPropertyFilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIdxPropertyFilesQuery(baseOptions: Apollo.QueryHookOptions<GetIdxPropertyFilesQuery, GetIdxPropertyFilesQueryVariables> & ({ variables: GetIdxPropertyFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdxPropertyFilesQuery, GetIdxPropertyFilesQueryVariables>(GetIdxPropertyFilesDocument, options);
      }
export function useGetIdxPropertyFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdxPropertyFilesQuery, GetIdxPropertyFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdxPropertyFilesQuery, GetIdxPropertyFilesQueryVariables>(GetIdxPropertyFilesDocument, options);
        }
export function useGetIdxPropertyFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdxPropertyFilesQuery, GetIdxPropertyFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdxPropertyFilesQuery, GetIdxPropertyFilesQueryVariables>(GetIdxPropertyFilesDocument, options);
        }
export type GetIdxPropertyFilesQueryHookResult = ReturnType<typeof useGetIdxPropertyFilesQuery>;
export type GetIdxPropertyFilesLazyQueryHookResult = ReturnType<typeof useGetIdxPropertyFilesLazyQuery>;
export type GetIdxPropertyFilesSuspenseQueryHookResult = ReturnType<typeof useGetIdxPropertyFilesSuspenseQuery>;
export type GetIdxPropertyFilesQueryResult = Apollo.QueryResult<GetIdxPropertyFilesQuery, GetIdxPropertyFilesQueryVariables>;
export const CreateIdxFeedDocument = gql`
    mutation CreateIDXFeed($input: CreateIdxFeedInput!) {
  createIdxFeed(input: $input) {
    _id
    accountId
    name
    portfolioFolderId
    propertiesPerPage
    propertyId
    type
    showPropertyDownloads
    showCustomPropertyDownloads
  }
}
    `;
export type CreateIdxFeedMutationFn = Apollo.MutationFunction<CreateIdxFeedMutation, CreateIdxFeedMutationVariables>;

/**
 * __useCreateIdxFeedMutation__
 *
 * To run a mutation, you first call `useCreateIdxFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdxFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdxFeedMutation, { data, loading, error }] = useCreateIdxFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIdxFeedMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdxFeedMutation, CreateIdxFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdxFeedMutation, CreateIdxFeedMutationVariables>(CreateIdxFeedDocument, options);
      }
export type CreateIdxFeedMutationHookResult = ReturnType<typeof useCreateIdxFeedMutation>;
export type CreateIdxFeedMutationResult = Apollo.MutationResult<CreateIdxFeedMutation>;
export type CreateIdxFeedMutationOptions = Apollo.BaseMutationOptions<CreateIdxFeedMutation, CreateIdxFeedMutationVariables>;
export const UpdateIdxFeedDocument = gql`
    mutation UpdateIDXFeed($input: UpdateIdxFeedInput!) {
  updateIdxFeed(input: $input) {
    _id
    name
    portfolioFolderId
    marketAreaIds
    counties {
      key
      name
      state
    }
    cities {
      key
      name
      state
    }
    propertiesPerPage
    propertyId
    type
    searchBarContent
    portfolioContent
    showPropertyDownloads
    showCustomPropertyDownloads
  }
}
    `;
export type UpdateIdxFeedMutationFn = Apollo.MutationFunction<UpdateIdxFeedMutation, UpdateIdxFeedMutationVariables>;

/**
 * __useUpdateIdxFeedMutation__
 *
 * To run a mutation, you first call `useUpdateIdxFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdxFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdxFeedMutation, { data, loading, error }] = useUpdateIdxFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdxFeedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdxFeedMutation, UpdateIdxFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdxFeedMutation, UpdateIdxFeedMutationVariables>(UpdateIdxFeedDocument, options);
      }
export type UpdateIdxFeedMutationHookResult = ReturnType<typeof useUpdateIdxFeedMutation>;
export type UpdateIdxFeedMutationResult = Apollo.MutationResult<UpdateIdxFeedMutation>;
export type UpdateIdxFeedMutationOptions = Apollo.BaseMutationOptions<UpdateIdxFeedMutation, UpdateIdxFeedMutationVariables>;
export const DeleteIdxFeedDocument = gql`
    mutation DeleteIdxFeed($idxFeedId: ObjectId!) {
  deleteIdxFeed(idxFeedId: $idxFeedId)
}
    `;
export type DeleteIdxFeedMutationFn = Apollo.MutationFunction<DeleteIdxFeedMutation, DeleteIdxFeedMutationVariables>;

/**
 * __useDeleteIdxFeedMutation__
 *
 * To run a mutation, you first call `useDeleteIdxFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIdxFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIdxFeedMutation, { data, loading, error }] = useDeleteIdxFeedMutation({
 *   variables: {
 *      idxFeedId: // value for 'idxFeedId'
 *   },
 * });
 */
export function useDeleteIdxFeedMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIdxFeedMutation, DeleteIdxFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIdxFeedMutation, DeleteIdxFeedMutationVariables>(DeleteIdxFeedDocument, options);
      }
export type DeleteIdxFeedMutationHookResult = ReturnType<typeof useDeleteIdxFeedMutation>;
export type DeleteIdxFeedMutationResult = Apollo.MutationResult<DeleteIdxFeedMutation>;
export type DeleteIdxFeedMutationOptions = Apollo.BaseMutationOptions<DeleteIdxFeedMutation, DeleteIdxFeedMutationVariables>;
export const GetIdxFeedListDocument = gql`
    query GetIdxFeedList($input: GetIdxFeedListInput!) {
  getIdxFeedList(input: $input) {
    collection {
      _id
      accountId
      name
      portfolioFolderId
      propertiesPerPage
      propertyId
      type
      searchBarContent
      portfolioContent
      showPropertyDownloads
      showCustomPropertyDownloads
    }
    totalCount
  }
}
    `;

/**
 * __useGetIdxFeedListQuery__
 *
 * To run a query within a React component, call `useGetIdxFeedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdxFeedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdxFeedListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIdxFeedListQuery(baseOptions: Apollo.QueryHookOptions<GetIdxFeedListQuery, GetIdxFeedListQueryVariables> & ({ variables: GetIdxFeedListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdxFeedListQuery, GetIdxFeedListQueryVariables>(GetIdxFeedListDocument, options);
      }
export function useGetIdxFeedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdxFeedListQuery, GetIdxFeedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdxFeedListQuery, GetIdxFeedListQueryVariables>(GetIdxFeedListDocument, options);
        }
export function useGetIdxFeedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdxFeedListQuery, GetIdxFeedListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdxFeedListQuery, GetIdxFeedListQueryVariables>(GetIdxFeedListDocument, options);
        }
export type GetIdxFeedListQueryHookResult = ReturnType<typeof useGetIdxFeedListQuery>;
export type GetIdxFeedListLazyQueryHookResult = ReturnType<typeof useGetIdxFeedListLazyQuery>;
export type GetIdxFeedListSuspenseQueryHookResult = ReturnType<typeof useGetIdxFeedListSuspenseQuery>;
export type GetIdxFeedListQueryResult = Apollo.QueryResult<GetIdxFeedListQuery, GetIdxFeedListQueryVariables>;
export const GetIdxFeedDetailsDocument = gql`
    query GetIdxFeedDetails($idxFeedId: ObjectId!) {
  getIdxFeedDetails(idxFeedId: $idxFeedId) {
    _id
    accountId
    name
    portfolioFolderId
    marketAreaIds
    counties {
      key
      name
      state
    }
    cities {
      key
      name
      state
    }
    propertiesPerPage
    propertyId
    type
    searchBarContent
    portfolioContent
    showPropertyDownloads
    showCustomPropertyDownloads
  }
}
    `;

/**
 * __useGetIdxFeedDetailsQuery__
 *
 * To run a query within a React component, call `useGetIdxFeedDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdxFeedDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdxFeedDetailsQuery({
 *   variables: {
 *      idxFeedId: // value for 'idxFeedId'
 *   },
 * });
 */
export function useGetIdxFeedDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetIdxFeedDetailsQuery, GetIdxFeedDetailsQueryVariables> & ({ variables: GetIdxFeedDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdxFeedDetailsQuery, GetIdxFeedDetailsQueryVariables>(GetIdxFeedDetailsDocument, options);
      }
export function useGetIdxFeedDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdxFeedDetailsQuery, GetIdxFeedDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdxFeedDetailsQuery, GetIdxFeedDetailsQueryVariables>(GetIdxFeedDetailsDocument, options);
        }
export function useGetIdxFeedDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdxFeedDetailsQuery, GetIdxFeedDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdxFeedDetailsQuery, GetIdxFeedDetailsQueryVariables>(GetIdxFeedDetailsDocument, options);
        }
export type GetIdxFeedDetailsQueryHookResult = ReturnType<typeof useGetIdxFeedDetailsQuery>;
export type GetIdxFeedDetailsLazyQueryHookResult = ReturnType<typeof useGetIdxFeedDetailsLazyQuery>;
export type GetIdxFeedDetailsSuspenseQueryHookResult = ReturnType<typeof useGetIdxFeedDetailsSuspenseQuery>;
export type GetIdxFeedDetailsQueryResult = Apollo.QueryResult<GetIdxFeedDetailsQuery, GetIdxFeedDetailsQueryVariables>;
export const CreateIdxSettingsDocument = gql`
    mutation CreateIDXSettings($websiteDomain: String!, $branding: BrandingInput!, $showDashCredit: Boolean!, $isWixSite: Boolean) {
  createIdxSettings(
    websiteDomain: $websiteDomain
    branding: $branding
    showDashCredit: $showDashCredit
    isWixSite: $isWixSite
  ) {
    _id
    accountId
    websiteDomain
    branding {
      mainColor
      textColor
      backgroundColor
    }
    showDashCredit
    isWixSite
  }
}
    `;
export type CreateIdxSettingsMutationFn = Apollo.MutationFunction<CreateIdxSettingsMutation, CreateIdxSettingsMutationVariables>;

/**
 * __useCreateIdxSettingsMutation__
 *
 * To run a mutation, you first call `useCreateIdxSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdxSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdxSettingsMutation, { data, loading, error }] = useCreateIdxSettingsMutation({
 *   variables: {
 *      websiteDomain: // value for 'websiteDomain'
 *      branding: // value for 'branding'
 *      showDashCredit: // value for 'showDashCredit'
 *      isWixSite: // value for 'isWixSite'
 *   },
 * });
 */
export function useCreateIdxSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdxSettingsMutation, CreateIdxSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdxSettingsMutation, CreateIdxSettingsMutationVariables>(CreateIdxSettingsDocument, options);
      }
export type CreateIdxSettingsMutationHookResult = ReturnType<typeof useCreateIdxSettingsMutation>;
export type CreateIdxSettingsMutationResult = Apollo.MutationResult<CreateIdxSettingsMutation>;
export type CreateIdxSettingsMutationOptions = Apollo.BaseMutationOptions<CreateIdxSettingsMutation, CreateIdxSettingsMutationVariables>;
export const UpdateIdxSettingsDocument = gql`
    mutation UpdateIDXSettings($input: UpdateIdxSettingsInput!) {
  updateIdxSettings(input: $input) {
    _id
    accountId
    websiteDomain
    branding {
      mainColor
      textColor
      backgroundColor
    }
    showDashCredit
    isWixSite
  }
}
    `;
export type UpdateIdxSettingsMutationFn = Apollo.MutationFunction<UpdateIdxSettingsMutation, UpdateIdxSettingsMutationVariables>;

/**
 * __useUpdateIdxSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateIdxSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdxSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdxSettingsMutation, { data, loading, error }] = useUpdateIdxSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdxSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdxSettingsMutation, UpdateIdxSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdxSettingsMutation, UpdateIdxSettingsMutationVariables>(UpdateIdxSettingsDocument, options);
      }
export type UpdateIdxSettingsMutationHookResult = ReturnType<typeof useUpdateIdxSettingsMutation>;
export type UpdateIdxSettingsMutationResult = Apollo.MutationResult<UpdateIdxSettingsMutation>;
export type UpdateIdxSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateIdxSettingsMutation, UpdateIdxSettingsMutationVariables>;
export const GetIdxSettingsDocument = gql`
    query GetIDXSettings {
  getIdxSettings {
    _id
    accountId
    websiteDomain
    branding {
      mainColor
      textColor
      backgroundColor
    }
    showDashCredit
    isWixSite
  }
}
    `;

/**
 * __useGetIdxSettingsQuery__
 *
 * To run a query within a React component, call `useGetIdxSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdxSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdxSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIdxSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetIdxSettingsQuery, GetIdxSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdxSettingsQuery, GetIdxSettingsQueryVariables>(GetIdxSettingsDocument, options);
      }
export function useGetIdxSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdxSettingsQuery, GetIdxSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdxSettingsQuery, GetIdxSettingsQueryVariables>(GetIdxSettingsDocument, options);
        }
export function useGetIdxSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdxSettingsQuery, GetIdxSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdxSettingsQuery, GetIdxSettingsQueryVariables>(GetIdxSettingsDocument, options);
        }
export type GetIdxSettingsQueryHookResult = ReturnType<typeof useGetIdxSettingsQuery>;
export type GetIdxSettingsLazyQueryHookResult = ReturnType<typeof useGetIdxSettingsLazyQuery>;
export type GetIdxSettingsSuspenseQueryHookResult = ReturnType<typeof useGetIdxSettingsSuspenseQuery>;
export type GetIdxSettingsQueryResult = Apollo.QueryResult<GetIdxSettingsQuery, GetIdxSettingsQueryVariables>;
export const CreateMarketAreaDocument = gql`
    mutation createMarketArea($input: CreateMarketAreaInput!) {
  createMarketArea(input: $input) {
    ...MarketArea
  }
}
    ${MarketAreaFragmentDoc}`;
export type CreateMarketAreaMutationFn = Apollo.MutationFunction<CreateMarketAreaMutation, CreateMarketAreaMutationVariables>;

/**
 * __useCreateMarketAreaMutation__
 *
 * To run a mutation, you first call `useCreateMarketAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarketAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarketAreaMutation, { data, loading, error }] = useCreateMarketAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarketAreaMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarketAreaMutation, CreateMarketAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarketAreaMutation, CreateMarketAreaMutationVariables>(CreateMarketAreaDocument, options);
      }
export type CreateMarketAreaMutationHookResult = ReturnType<typeof useCreateMarketAreaMutation>;
export type CreateMarketAreaMutationResult = Apollo.MutationResult<CreateMarketAreaMutation>;
export type CreateMarketAreaMutationOptions = Apollo.BaseMutationOptions<CreateMarketAreaMutation, CreateMarketAreaMutationVariables>;
export const EditMarketAreaDocument = gql`
    mutation editMarketArea($input: EditMarketAreaInput!) {
  editMarketArea(input: $input) {
    ...MarketArea
  }
}
    ${MarketAreaFragmentDoc}`;
export type EditMarketAreaMutationFn = Apollo.MutationFunction<EditMarketAreaMutation, EditMarketAreaMutationVariables>;

/**
 * __useEditMarketAreaMutation__
 *
 * To run a mutation, you first call `useEditMarketAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMarketAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMarketAreaMutation, { data, loading, error }] = useEditMarketAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMarketAreaMutation(baseOptions?: Apollo.MutationHookOptions<EditMarketAreaMutation, EditMarketAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMarketAreaMutation, EditMarketAreaMutationVariables>(EditMarketAreaDocument, options);
      }
export type EditMarketAreaMutationHookResult = ReturnType<typeof useEditMarketAreaMutation>;
export type EditMarketAreaMutationResult = Apollo.MutationResult<EditMarketAreaMutation>;
export type EditMarketAreaMutationOptions = Apollo.BaseMutationOptions<EditMarketAreaMutation, EditMarketAreaMutationVariables>;
export const DeleteMarketAreaDocument = gql`
    mutation deleteMarketArea($marketAreaId: ObjectId!) {
  deleteMarketArea(marketAreaId: $marketAreaId) {
    _id
  }
}
    `;
export type DeleteMarketAreaMutationFn = Apollo.MutationFunction<DeleteMarketAreaMutation, DeleteMarketAreaMutationVariables>;

/**
 * __useDeleteMarketAreaMutation__
 *
 * To run a mutation, you first call `useDeleteMarketAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarketAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMarketAreaMutation, { data, loading, error }] = useDeleteMarketAreaMutation({
 *   variables: {
 *      marketAreaId: // value for 'marketAreaId'
 *   },
 * });
 */
export function useDeleteMarketAreaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMarketAreaMutation, DeleteMarketAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMarketAreaMutation, DeleteMarketAreaMutationVariables>(DeleteMarketAreaDocument, options);
      }
export type DeleteMarketAreaMutationHookResult = ReturnType<typeof useDeleteMarketAreaMutation>;
export type DeleteMarketAreaMutationResult = Apollo.MutationResult<DeleteMarketAreaMutation>;
export type DeleteMarketAreaMutationOptions = Apollo.BaseMutationOptions<DeleteMarketAreaMutation, DeleteMarketAreaMutationVariables>;
export const GetMarketAreasDocument = gql`
    query getMarketAreas($sort: [SortInput!], $pagination: PaginationInput, $filter: GetMarketAreasFilterInput) {
  getMarketAreas(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
    collection {
      ...MarketArea
    }
  }
}
    ${MarketAreaFragmentDoc}`;

/**
 * __useGetMarketAreasQuery__
 *
 * To run a query within a React component, call `useGetMarketAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketAreasQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMarketAreasQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketAreasQuery, GetMarketAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketAreasQuery, GetMarketAreasQueryVariables>(GetMarketAreasDocument, options);
      }
export function useGetMarketAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketAreasQuery, GetMarketAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketAreasQuery, GetMarketAreasQueryVariables>(GetMarketAreasDocument, options);
        }
export function useGetMarketAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMarketAreasQuery, GetMarketAreasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMarketAreasQuery, GetMarketAreasQueryVariables>(GetMarketAreasDocument, options);
        }
export type GetMarketAreasQueryHookResult = ReturnType<typeof useGetMarketAreasQuery>;
export type GetMarketAreasLazyQueryHookResult = ReturnType<typeof useGetMarketAreasLazyQuery>;
export type GetMarketAreasSuspenseQueryHookResult = ReturnType<typeof useGetMarketAreasSuspenseQuery>;
export type GetMarketAreasQueryResult = Apollo.QueryResult<GetMarketAreasQuery, GetMarketAreasQueryVariables>;
export const GetMediaFoldersAndFilesDocument = gql`
    query getMediaFoldersAndFiles($filter: GetMediaFoldersAndFilesFilterInput!, $pagination: PaginationInput, $sort: [SortInput!]) {
  getMediaFoldersAndFiles(filter: $filter, pagination: $pagination, sort: $sort) {
    filesCollection {
      ...Media
    }
    filesTotalCount
    foldersCollection {
      ...Media
    }
    foldersTotalCount
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useGetMediaFoldersAndFilesQuery__
 *
 * To run a query within a React component, call `useGetMediaFoldersAndFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaFoldersAndFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaFoldersAndFilesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMediaFoldersAndFilesQuery(baseOptions: Apollo.QueryHookOptions<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables> & ({ variables: GetMediaFoldersAndFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables>(GetMediaFoldersAndFilesDocument, options);
      }
export function useGetMediaFoldersAndFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables>(GetMediaFoldersAndFilesDocument, options);
        }
export function useGetMediaFoldersAndFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables>(GetMediaFoldersAndFilesDocument, options);
        }
export type GetMediaFoldersAndFilesQueryHookResult = ReturnType<typeof useGetMediaFoldersAndFilesQuery>;
export type GetMediaFoldersAndFilesLazyQueryHookResult = ReturnType<typeof useGetMediaFoldersAndFilesLazyQuery>;
export type GetMediaFoldersAndFilesSuspenseQueryHookResult = ReturnType<typeof useGetMediaFoldersAndFilesSuspenseQuery>;
export type GetMediaFoldersAndFilesQueryResult = Apollo.QueryResult<GetMediaFoldersAndFilesQuery, GetMediaFoldersAndFilesQueryVariables>;
export const GetMediaFilesDocument = gql`
    query getMediaFiles($filter: GetMediaFoldersAndFilesFilterInput!, $pagination: PaginationInput, $sort: [SortInput!]) {
  getMediaFoldersAndFiles(filter: $filter, pagination: $pagination, sort: $sort) {
    filesCollection {
      ...Media
    }
    filesTotalCount
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useGetMediaFilesQuery__
 *
 * To run a query within a React component, call `useGetMediaFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaFilesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMediaFilesQuery(baseOptions: Apollo.QueryHookOptions<GetMediaFilesQuery, GetMediaFilesQueryVariables> & ({ variables: GetMediaFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaFilesQuery, GetMediaFilesQueryVariables>(GetMediaFilesDocument, options);
      }
export function useGetMediaFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaFilesQuery, GetMediaFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaFilesQuery, GetMediaFilesQueryVariables>(GetMediaFilesDocument, options);
        }
export function useGetMediaFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMediaFilesQuery, GetMediaFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMediaFilesQuery, GetMediaFilesQueryVariables>(GetMediaFilesDocument, options);
        }
export type GetMediaFilesQueryHookResult = ReturnType<typeof useGetMediaFilesQuery>;
export type GetMediaFilesLazyQueryHookResult = ReturnType<typeof useGetMediaFilesLazyQuery>;
export type GetMediaFilesSuspenseQueryHookResult = ReturnType<typeof useGetMediaFilesSuspenseQuery>;
export type GetMediaFilesQueryResult = Apollo.QueryResult<GetMediaFilesQuery, GetMediaFilesQueryVariables>;
export const GetAllFoldersInPropertyDocument = gql`
    query getAllFoldersInProperty($propertyId: ObjectId!, $mediaFolderId: ObjectId) {
  getAllFoldersInProperty(propertyId: $propertyId, mediaFolderId: $mediaFolderId) {
    _id
    folderName
    parentMediaFoldersIds
    mediaFolderId
    systemFolderType
  }
}
    `;

/**
 * __useGetAllFoldersInPropertyQuery__
 *
 * To run a query within a React component, call `useGetAllFoldersInPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFoldersInPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFoldersInPropertyQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      mediaFolderId: // value for 'mediaFolderId'
 *   },
 * });
 */
export function useGetAllFoldersInPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables> & ({ variables: GetAllFoldersInPropertyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables>(GetAllFoldersInPropertyDocument, options);
      }
export function useGetAllFoldersInPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables>(GetAllFoldersInPropertyDocument, options);
        }
export function useGetAllFoldersInPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables>(GetAllFoldersInPropertyDocument, options);
        }
export type GetAllFoldersInPropertyQueryHookResult = ReturnType<typeof useGetAllFoldersInPropertyQuery>;
export type GetAllFoldersInPropertyLazyQueryHookResult = ReturnType<typeof useGetAllFoldersInPropertyLazyQuery>;
export type GetAllFoldersInPropertySuspenseQueryHookResult = ReturnType<typeof useGetAllFoldersInPropertySuspenseQuery>;
export type GetAllFoldersInPropertyQueryResult = Apollo.QueryResult<GetAllFoldersInPropertyQuery, GetAllFoldersInPropertyQueryVariables>;
export const GetTopLevelFoldersInPropertyDocument = gql`
    query getTopLevelFoldersInProperty($propertyId: ObjectId!) {
  getTopLevelFoldersInProperty(propertyId: $propertyId) {
    _id
    folderName
    systemFolderType
  }
}
    `;

/**
 * __useGetTopLevelFoldersInPropertyQuery__
 *
 * To run a query within a React component, call `useGetTopLevelFoldersInPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopLevelFoldersInPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopLevelFoldersInPropertyQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetTopLevelFoldersInPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables> & ({ variables: GetTopLevelFoldersInPropertyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables>(GetTopLevelFoldersInPropertyDocument, options);
      }
export function useGetTopLevelFoldersInPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables>(GetTopLevelFoldersInPropertyDocument, options);
        }
export function useGetTopLevelFoldersInPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables>(GetTopLevelFoldersInPropertyDocument, options);
        }
export type GetTopLevelFoldersInPropertyQueryHookResult = ReturnType<typeof useGetTopLevelFoldersInPropertyQuery>;
export type GetTopLevelFoldersInPropertyLazyQueryHookResult = ReturnType<typeof useGetTopLevelFoldersInPropertyLazyQuery>;
export type GetTopLevelFoldersInPropertySuspenseQueryHookResult = ReturnType<typeof useGetTopLevelFoldersInPropertySuspenseQuery>;
export type GetTopLevelFoldersInPropertyQueryResult = Apollo.QueryResult<GetTopLevelFoldersInPropertyQuery, GetTopLevelFoldersInPropertyQueryVariables>;
export const GetAllFilesInPropertyDocument = gql`
    query getAllFilesInProperty($filter: GetAllFilesInPropertyFilterInput!, $pagination: PaginationInput, $sort: [SortInput!]) {
  getAllFilesInProperty(filter: $filter, pagination: $pagination, sort: $sort) {
    filesCollection {
      _id
      files {
        _id
        name
        publicUrl
        s3Key
        thumbnailFileUrl
        type
        createdAt
      }
      sizeInBytes
      mediaFolderId
    }
    filesTotalCount
  }
}
    `;

/**
 * __useGetAllFilesInPropertyQuery__
 *
 * To run a query within a React component, call `useGetAllFilesInPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFilesInPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFilesInPropertyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAllFilesInPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables> & ({ variables: GetAllFilesInPropertyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables>(GetAllFilesInPropertyDocument, options);
      }
export function useGetAllFilesInPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables>(GetAllFilesInPropertyDocument, options);
        }
export function useGetAllFilesInPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables>(GetAllFilesInPropertyDocument, options);
        }
export type GetAllFilesInPropertyQueryHookResult = ReturnType<typeof useGetAllFilesInPropertyQuery>;
export type GetAllFilesInPropertyLazyQueryHookResult = ReturnType<typeof useGetAllFilesInPropertyLazyQuery>;
export type GetAllFilesInPropertySuspenseQueryHookResult = ReturnType<typeof useGetAllFilesInPropertySuspenseQuery>;
export type GetAllFilesInPropertyQueryResult = Apollo.QueryResult<GetAllFilesInPropertyQuery, GetAllFilesInPropertyQueryVariables>;
export const GetNumberOfAllMediaFilesToDownloadDocument = gql`
    query getNumberOfAllMediaFilesToDownload($propertyId: ObjectId!) {
  getAllFilesInProperty(filter: {propertyId: $propertyId}) {
    filesTotalCount
  }
}
    `;

/**
 * __useGetNumberOfAllMediaFilesToDownloadQuery__
 *
 * To run a query within a React component, call `useGetNumberOfAllMediaFilesToDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfAllMediaFilesToDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfAllMediaFilesToDownloadQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetNumberOfAllMediaFilesToDownloadQuery(baseOptions: Apollo.QueryHookOptions<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables> & ({ variables: GetNumberOfAllMediaFilesToDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables>(GetNumberOfAllMediaFilesToDownloadDocument, options);
      }
export function useGetNumberOfAllMediaFilesToDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables>(GetNumberOfAllMediaFilesToDownloadDocument, options);
        }
export function useGetNumberOfAllMediaFilesToDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables>(GetNumberOfAllMediaFilesToDownloadDocument, options);
        }
export type GetNumberOfAllMediaFilesToDownloadQueryHookResult = ReturnType<typeof useGetNumberOfAllMediaFilesToDownloadQuery>;
export type GetNumberOfAllMediaFilesToDownloadLazyQueryHookResult = ReturnType<typeof useGetNumberOfAllMediaFilesToDownloadLazyQuery>;
export type GetNumberOfAllMediaFilesToDownloadSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfAllMediaFilesToDownloadSuspenseQuery>;
export type GetNumberOfAllMediaFilesToDownloadQueryResult = Apollo.QueryResult<GetNumberOfAllMediaFilesToDownloadQuery, GetNumberOfAllMediaFilesToDownloadQueryVariables>;
export const GetSlideshowMediaByPropertyDocument = gql`
    query getSlideshowMediaByProperty($propertyId: ObjectId!) {
  getSlideshowMediaByProperty(propertyId: $propertyId) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useGetSlideshowMediaByPropertyQuery__
 *
 * To run a query within a React component, call `useGetSlideshowMediaByPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlideshowMediaByPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlideshowMediaByPropertyQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetSlideshowMediaByPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables> & ({ variables: GetSlideshowMediaByPropertyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables>(GetSlideshowMediaByPropertyDocument, options);
      }
export function useGetSlideshowMediaByPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables>(GetSlideshowMediaByPropertyDocument, options);
        }
export function useGetSlideshowMediaByPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables>(GetSlideshowMediaByPropertyDocument, options);
        }
export type GetSlideshowMediaByPropertyQueryHookResult = ReturnType<typeof useGetSlideshowMediaByPropertyQuery>;
export type GetSlideshowMediaByPropertyLazyQueryHookResult = ReturnType<typeof useGetSlideshowMediaByPropertyLazyQuery>;
export type GetSlideshowMediaByPropertySuspenseQueryHookResult = ReturnType<typeof useGetSlideshowMediaByPropertySuspenseQuery>;
export type GetSlideshowMediaByPropertyQueryResult = Apollo.QueryResult<GetSlideshowMediaByPropertyQuery, GetSlideshowMediaByPropertyQueryVariables>;
export const GetPropertySlideshowMediaInPublicBrokerPortfolioDocument = gql`
    query getPropertySlideshowMediaInPublicBrokerPortfolio($brokerId: ObjectId!, $password: String, $portfolioFolderId: ObjectId, $propertyId: ObjectId!) {
  getPropertySlideshowMediaInPublicBrokerPortfolio(
    brokerId: $brokerId
    password: $password
    portfolioFolderId: $portfolioFolderId
    propertyId: $propertyId
  ) {
    ...Media
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useGetPropertySlideshowMediaInPublicBrokerPortfolioQuery__
 *
 * To run a query within a React component, call `useGetPropertySlideshowMediaInPublicBrokerPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertySlideshowMediaInPublicBrokerPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertySlideshowMediaInPublicBrokerPortfolioQuery({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *      password: // value for 'password'
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropertySlideshowMediaInPublicBrokerPortfolioQuery(baseOptions: Apollo.QueryHookOptions<GetPropertySlideshowMediaInPublicBrokerPortfolioQuery, GetPropertySlideshowMediaInPublicBrokerPortfolioQueryVariables> & ({ variables: GetPropertySlideshowMediaInPublicBrokerPortfolioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertySlideshowMediaInPublicBrokerPortfolioQuery, GetPropertySlideshowMediaInPublicBrokerPortfolioQueryVariables>(GetPropertySlideshowMediaInPublicBrokerPortfolioDocument, options);
      }
export function useGetPropertySlideshowMediaInPublicBrokerPortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertySlideshowMediaInPublicBrokerPortfolioQuery, GetPropertySlideshowMediaInPublicBrokerPortfolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertySlideshowMediaInPublicBrokerPortfolioQuery, GetPropertySlideshowMediaInPublicBrokerPortfolioQueryVariables>(GetPropertySlideshowMediaInPublicBrokerPortfolioDocument, options);
        }
export function useGetPropertySlideshowMediaInPublicBrokerPortfolioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertySlideshowMediaInPublicBrokerPortfolioQuery, GetPropertySlideshowMediaInPublicBrokerPortfolioQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertySlideshowMediaInPublicBrokerPortfolioQuery, GetPropertySlideshowMediaInPublicBrokerPortfolioQueryVariables>(GetPropertySlideshowMediaInPublicBrokerPortfolioDocument, options);
        }
export type GetPropertySlideshowMediaInPublicBrokerPortfolioQueryHookResult = ReturnType<typeof useGetPropertySlideshowMediaInPublicBrokerPortfolioQuery>;
export type GetPropertySlideshowMediaInPublicBrokerPortfolioLazyQueryHookResult = ReturnType<typeof useGetPropertySlideshowMediaInPublicBrokerPortfolioLazyQuery>;
export type GetPropertySlideshowMediaInPublicBrokerPortfolioSuspenseQueryHookResult = ReturnType<typeof useGetPropertySlideshowMediaInPublicBrokerPortfolioSuspenseQuery>;
export type GetPropertySlideshowMediaInPublicBrokerPortfolioQueryResult = Apollo.QueryResult<GetPropertySlideshowMediaInPublicBrokerPortfolioQuery, GetPropertySlideshowMediaInPublicBrokerPortfolioQueryVariables>;
export const GetMediaFolderByIdDocument = gql`
    query getMediaFolderById($folderId: ObjectId!) {
  getMediaFolderById(folderId: $folderId) {
    folderName
    foldersPathCollection {
      _id
      folderName
    }
  }
}
    `;

/**
 * __useGetMediaFolderByIdQuery__
 *
 * To run a query within a React component, call `useGetMediaFolderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaFolderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaFolderByIdQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useGetMediaFolderByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables> & ({ variables: GetMediaFolderByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables>(GetMediaFolderByIdDocument, options);
      }
export function useGetMediaFolderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables>(GetMediaFolderByIdDocument, options);
        }
export function useGetMediaFolderByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables>(GetMediaFolderByIdDocument, options);
        }
export type GetMediaFolderByIdQueryHookResult = ReturnType<typeof useGetMediaFolderByIdQuery>;
export type GetMediaFolderByIdLazyQueryHookResult = ReturnType<typeof useGetMediaFolderByIdLazyQuery>;
export type GetMediaFolderByIdSuspenseQueryHookResult = ReturnType<typeof useGetMediaFolderByIdSuspenseQuery>;
export type GetMediaFolderByIdQueryResult = Apollo.QueryResult<GetMediaFolderByIdQuery, GetMediaFolderByIdQueryVariables>;
export const ObserveMediaChangesDocument = gql`
    subscription observeMediaChanges($filter: GetMediaFoldersAndFilesFilterInput!) {
  observeMediaChanges(filter: $filter) {
    trigger
    document {
      ...Media
    }
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useObserveMediaChangesSubscription__
 *
 * To run a query within a React component, call `useObserveMediaChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObserveMediaChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObserveMediaChangesSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useObserveMediaChangesSubscription(baseOptions: Apollo.SubscriptionHookOptions<ObserveMediaChangesSubscription, ObserveMediaChangesSubscriptionVariables> & ({ variables: ObserveMediaChangesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObserveMediaChangesSubscription, ObserveMediaChangesSubscriptionVariables>(ObserveMediaChangesDocument, options);
      }
export type ObserveMediaChangesSubscriptionHookResult = ReturnType<typeof useObserveMediaChangesSubscription>;
export type ObserveMediaChangesSubscriptionResult = Apollo.SubscriptionResult<ObserveMediaChangesSubscription>;
export const GetPlaceOptionsDocument = gql`
    query GetPlaceOptions {
  getPlaceOptions {
    counties {
      key
      name
      state
      count
      countyKeys
      cityKeys
    }
    cities {
      key
      name
      state
      count
      countyKeys
      cityKeys
    }
    marketAreas {
      marketAreaId
      count
      countyKeys
      cityKeys
    }
  }
}
    `;

/**
 * __useGetPlaceOptionsQuery__
 *
 * To run a query within a React component, call `useGetPlaceOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlaceOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPlaceOptionsQuery, GetPlaceOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaceOptionsQuery, GetPlaceOptionsQueryVariables>(GetPlaceOptionsDocument, options);
      }
export function useGetPlaceOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceOptionsQuery, GetPlaceOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaceOptionsQuery, GetPlaceOptionsQueryVariables>(GetPlaceOptionsDocument, options);
        }
export function useGetPlaceOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaceOptionsQuery, GetPlaceOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaceOptionsQuery, GetPlaceOptionsQueryVariables>(GetPlaceOptionsDocument, options);
        }
export type GetPlaceOptionsQueryHookResult = ReturnType<typeof useGetPlaceOptionsQuery>;
export type GetPlaceOptionsLazyQueryHookResult = ReturnType<typeof useGetPlaceOptionsLazyQuery>;
export type GetPlaceOptionsSuspenseQueryHookResult = ReturnType<typeof useGetPlaceOptionsSuspenseQuery>;
export type GetPlaceOptionsQueryResult = Apollo.QueryResult<GetPlaceOptionsQuery, GetPlaceOptionsQueryVariables>;
export const CountPropertiesInPlacesDocument = gql`
    query CountPropertiesInPlaces($input: PlaceTargetInput!) {
  countPropertiesInPlaces(input: $input)
}
    `;

/**
 * __useCountPropertiesInPlacesQuery__
 *
 * To run a query within a React component, call `useCountPropertiesInPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPropertiesInPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPropertiesInPlacesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCountPropertiesInPlacesQuery(baseOptions: Apollo.QueryHookOptions<CountPropertiesInPlacesQuery, CountPropertiesInPlacesQueryVariables> & ({ variables: CountPropertiesInPlacesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPropertiesInPlacesQuery, CountPropertiesInPlacesQueryVariables>(CountPropertiesInPlacesDocument, options);
      }
export function useCountPropertiesInPlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPropertiesInPlacesQuery, CountPropertiesInPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPropertiesInPlacesQuery, CountPropertiesInPlacesQueryVariables>(CountPropertiesInPlacesDocument, options);
        }
export function useCountPropertiesInPlacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountPropertiesInPlacesQuery, CountPropertiesInPlacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountPropertiesInPlacesQuery, CountPropertiesInPlacesQueryVariables>(CountPropertiesInPlacesDocument, options);
        }
export type CountPropertiesInPlacesQueryHookResult = ReturnType<typeof useCountPropertiesInPlacesQuery>;
export type CountPropertiesInPlacesLazyQueryHookResult = ReturnType<typeof useCountPropertiesInPlacesLazyQuery>;
export type CountPropertiesInPlacesSuspenseQueryHookResult = ReturnType<typeof useCountPropertiesInPlacesSuspenseQuery>;
export type CountPropertiesInPlacesQueryResult = Apollo.QueryResult<CountPropertiesInPlacesQuery, CountPropertiesInPlacesQueryVariables>;
export const SetPortfolioMediaKitMediaDocument = gql`
    mutation setPortfolioMediaKitMedia($input: UpdateMediaKitInput!) {
  setPortfolioMediaKitMedia(input: $input)
}
    `;
export type SetPortfolioMediaKitMediaMutationFn = Apollo.MutationFunction<SetPortfolioMediaKitMediaMutation, SetPortfolioMediaKitMediaMutationVariables>;

/**
 * __useSetPortfolioMediaKitMediaMutation__
 *
 * To run a mutation, you first call `useSetPortfolioMediaKitMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPortfolioMediaKitMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPortfolioMediaKitMediaMutation, { data, loading, error }] = useSetPortfolioMediaKitMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPortfolioMediaKitMediaMutation(baseOptions?: Apollo.MutationHookOptions<SetPortfolioMediaKitMediaMutation, SetPortfolioMediaKitMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPortfolioMediaKitMediaMutation, SetPortfolioMediaKitMediaMutationVariables>(SetPortfolioMediaKitMediaDocument, options);
      }
export type SetPortfolioMediaKitMediaMutationHookResult = ReturnType<typeof useSetPortfolioMediaKitMediaMutation>;
export type SetPortfolioMediaKitMediaMutationResult = Apollo.MutationResult<SetPortfolioMediaKitMediaMutation>;
export type SetPortfolioMediaKitMediaMutationOptions = Apollo.BaseMutationOptions<SetPortfolioMediaKitMediaMutation, SetPortfolioMediaKitMediaMutationVariables>;
export const AddAllMarketingFilesToPortfolioDocument = gql`
    mutation addAllMarketingFilesToPortfolio($portfolioItemId: String!) {
  addAllMarketingFilesToPortfolio(portfolioItemId: $portfolioItemId) {
    ...PortfolioMediaKit
  }
}
    ${PortfolioMediaKitFragmentDoc}`;
export type AddAllMarketingFilesToPortfolioMutationFn = Apollo.MutationFunction<AddAllMarketingFilesToPortfolioMutation, AddAllMarketingFilesToPortfolioMutationVariables>;

/**
 * __useAddAllMarketingFilesToPortfolioMutation__
 *
 * To run a mutation, you first call `useAddAllMarketingFilesToPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAllMarketingFilesToPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAllMarketingFilesToPortfolioMutation, { data, loading, error }] = useAddAllMarketingFilesToPortfolioMutation({
 *   variables: {
 *      portfolioItemId: // value for 'portfolioItemId'
 *   },
 * });
 */
export function useAddAllMarketingFilesToPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<AddAllMarketingFilesToPortfolioMutation, AddAllMarketingFilesToPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAllMarketingFilesToPortfolioMutation, AddAllMarketingFilesToPortfolioMutationVariables>(AddAllMarketingFilesToPortfolioDocument, options);
      }
export type AddAllMarketingFilesToPortfolioMutationHookResult = ReturnType<typeof useAddAllMarketingFilesToPortfolioMutation>;
export type AddAllMarketingFilesToPortfolioMutationResult = Apollo.MutationResult<AddAllMarketingFilesToPortfolioMutation>;
export type AddAllMarketingFilesToPortfolioMutationOptions = Apollo.BaseMutationOptions<AddAllMarketingFilesToPortfolioMutation, AddAllMarketingFilesToPortfolioMutationVariables>;
export const RemoveAllMarketingFilesFromPortfolioDocument = gql`
    mutation removeAllMarketingFilesFromPortfolio($portfolioItemId: String!) {
  removeAllMarketingFilesFromPortfolio(portfolioItemId: $portfolioItemId) {
    ...PortfolioMediaKit
  }
}
    ${PortfolioMediaKitFragmentDoc}`;
export type RemoveAllMarketingFilesFromPortfolioMutationFn = Apollo.MutationFunction<RemoveAllMarketingFilesFromPortfolioMutation, RemoveAllMarketingFilesFromPortfolioMutationVariables>;

/**
 * __useRemoveAllMarketingFilesFromPortfolioMutation__
 *
 * To run a mutation, you first call `useRemoveAllMarketingFilesFromPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllMarketingFilesFromPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllMarketingFilesFromPortfolioMutation, { data, loading, error }] = useRemoveAllMarketingFilesFromPortfolioMutation({
 *   variables: {
 *      portfolioItemId: // value for 'portfolioItemId'
 *   },
 * });
 */
export function useRemoveAllMarketingFilesFromPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAllMarketingFilesFromPortfolioMutation, RemoveAllMarketingFilesFromPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAllMarketingFilesFromPortfolioMutation, RemoveAllMarketingFilesFromPortfolioMutationVariables>(RemoveAllMarketingFilesFromPortfolioDocument, options);
      }
export type RemoveAllMarketingFilesFromPortfolioMutationHookResult = ReturnType<typeof useRemoveAllMarketingFilesFromPortfolioMutation>;
export type RemoveAllMarketingFilesFromPortfolioMutationResult = Apollo.MutationResult<RemoveAllMarketingFilesFromPortfolioMutation>;
export type RemoveAllMarketingFilesFromPortfolioMutationOptions = Apollo.BaseMutationOptions<RemoveAllMarketingFilesFromPortfolioMutation, RemoveAllMarketingFilesFromPortfolioMutationVariables>;
export const GetPortfolioMediaKitItemsDocument = gql`
    query getPortfolioMediaKitItems($filter: GetPortfolioMediaKitItemsInput!, $pagination: PaginationInput, $sort: [SortInput!]) {
  getPortfolioMediaKitItems(filter: $filter, pagination: $pagination, sort: $sort) {
    collection {
      _id
      isAddedToMediaKit
      media {
        ...Media
      }
    }
    totalCount
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useGetPortfolioMediaKitItemsQuery__
 *
 * To run a query within a React component, call `useGetPortfolioMediaKitItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioMediaKitItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioMediaKitItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPortfolioMediaKitItemsQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioMediaKitItemsQuery, GetPortfolioMediaKitItemsQueryVariables> & ({ variables: GetPortfolioMediaKitItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioMediaKitItemsQuery, GetPortfolioMediaKitItemsQueryVariables>(GetPortfolioMediaKitItemsDocument, options);
      }
export function useGetPortfolioMediaKitItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioMediaKitItemsQuery, GetPortfolioMediaKitItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioMediaKitItemsQuery, GetPortfolioMediaKitItemsQueryVariables>(GetPortfolioMediaKitItemsDocument, options);
        }
export function useGetPortfolioMediaKitItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioMediaKitItemsQuery, GetPortfolioMediaKitItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioMediaKitItemsQuery, GetPortfolioMediaKitItemsQueryVariables>(GetPortfolioMediaKitItemsDocument, options);
        }
export type GetPortfolioMediaKitItemsQueryHookResult = ReturnType<typeof useGetPortfolioMediaKitItemsQuery>;
export type GetPortfolioMediaKitItemsLazyQueryHookResult = ReturnType<typeof useGetPortfolioMediaKitItemsLazyQuery>;
export type GetPortfolioMediaKitItemsSuspenseQueryHookResult = ReturnType<typeof useGetPortfolioMediaKitItemsSuspenseQuery>;
export type GetPortfolioMediaKitItemsQueryResult = Apollo.QueryResult<GetPortfolioMediaKitItemsQuery, GetPortfolioMediaKitItemsQueryVariables>;
export const AddReactionByPortfolioAndPropertyDocument = gql`
    mutation addReactionByPortfolioAndProperty($portfolioId: ObjectId!, $propertyId: ObjectId!, $reaction: PortfolioReactionsEnum!, $guestUserData: SetGuestUserDataArgs) {
  addReactionByPortfolioAndProperty(
    propertyId: $propertyId
    portfolioId: $portfolioId
    reaction: $reaction
    guestUserData: $guestUserData
  ) {
    ...PortfolioReaction
  }
}
    ${PortfolioReactionFragmentDoc}`;
export type AddReactionByPortfolioAndPropertyMutationFn = Apollo.MutationFunction<AddReactionByPortfolioAndPropertyMutation, AddReactionByPortfolioAndPropertyMutationVariables>;

/**
 * __useAddReactionByPortfolioAndPropertyMutation__
 *
 * To run a mutation, you first call `useAddReactionByPortfolioAndPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionByPortfolioAndPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionByPortfolioAndPropertyMutation, { data, loading, error }] = useAddReactionByPortfolioAndPropertyMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      propertyId: // value for 'propertyId'
 *      reaction: // value for 'reaction'
 *      guestUserData: // value for 'guestUserData'
 *   },
 * });
 */
export function useAddReactionByPortfolioAndPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AddReactionByPortfolioAndPropertyMutation, AddReactionByPortfolioAndPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReactionByPortfolioAndPropertyMutation, AddReactionByPortfolioAndPropertyMutationVariables>(AddReactionByPortfolioAndPropertyDocument, options);
      }
export type AddReactionByPortfolioAndPropertyMutationHookResult = ReturnType<typeof useAddReactionByPortfolioAndPropertyMutation>;
export type AddReactionByPortfolioAndPropertyMutationResult = Apollo.MutationResult<AddReactionByPortfolioAndPropertyMutation>;
export type AddReactionByPortfolioAndPropertyMutationOptions = Apollo.BaseMutationOptions<AddReactionByPortfolioAndPropertyMutation, AddReactionByPortfolioAndPropertyMutationVariables>;
export const GetReactionsStatsForBrokerDocument = gql`
    query getReactionsStatsForBroker($dateRange: DateRangeInput) {
  getReactionsStatsForBroker(dateRange: $dateRange) {
    ...BrokerReactionsStats
  }
}
    ${BrokerReactionsStatsFragmentDoc}`;

/**
 * __useGetReactionsStatsForBrokerQuery__
 *
 * To run a query within a React component, call `useGetReactionsStatsForBrokerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReactionsStatsForBrokerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReactionsStatsForBrokerQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetReactionsStatsForBrokerQuery(baseOptions?: Apollo.QueryHookOptions<GetReactionsStatsForBrokerQuery, GetReactionsStatsForBrokerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReactionsStatsForBrokerQuery, GetReactionsStatsForBrokerQueryVariables>(GetReactionsStatsForBrokerDocument, options);
      }
export function useGetReactionsStatsForBrokerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReactionsStatsForBrokerQuery, GetReactionsStatsForBrokerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReactionsStatsForBrokerQuery, GetReactionsStatsForBrokerQueryVariables>(GetReactionsStatsForBrokerDocument, options);
        }
export function useGetReactionsStatsForBrokerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReactionsStatsForBrokerQuery, GetReactionsStatsForBrokerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReactionsStatsForBrokerQuery, GetReactionsStatsForBrokerQueryVariables>(GetReactionsStatsForBrokerDocument, options);
        }
export type GetReactionsStatsForBrokerQueryHookResult = ReturnType<typeof useGetReactionsStatsForBrokerQuery>;
export type GetReactionsStatsForBrokerLazyQueryHookResult = ReturnType<typeof useGetReactionsStatsForBrokerLazyQuery>;
export type GetReactionsStatsForBrokerSuspenseQueryHookResult = ReturnType<typeof useGetReactionsStatsForBrokerSuspenseQuery>;
export type GetReactionsStatsForBrokerQueryResult = Apollo.QueryResult<GetReactionsStatsForBrokerQuery, GetReactionsStatsForBrokerQueryVariables>;
export const GetBrokerGuestUserDocument = gql`
    query getBrokerGuestUser($sort: [SortInput!], $pagination: PaginationInput) {
  getBrokerGuestUser(pagination: $pagination, sort: $sort) {
    collection {
      _id
      fullName
      email
    }
    totalCount
  }
}
    `;

/**
 * __useGetBrokerGuestUserQuery__
 *
 * To run a query within a React component, call `useGetBrokerGuestUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerGuestUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerGuestUserQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetBrokerGuestUserQuery(baseOptions?: Apollo.QueryHookOptions<GetBrokerGuestUserQuery, GetBrokerGuestUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokerGuestUserQuery, GetBrokerGuestUserQueryVariables>(GetBrokerGuestUserDocument, options);
      }
export function useGetBrokerGuestUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokerGuestUserQuery, GetBrokerGuestUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokerGuestUserQuery, GetBrokerGuestUserQueryVariables>(GetBrokerGuestUserDocument, options);
        }
export function useGetBrokerGuestUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrokerGuestUserQuery, GetBrokerGuestUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrokerGuestUserQuery, GetBrokerGuestUserQueryVariables>(GetBrokerGuestUserDocument, options);
        }
export type GetBrokerGuestUserQueryHookResult = ReturnType<typeof useGetBrokerGuestUserQuery>;
export type GetBrokerGuestUserLazyQueryHookResult = ReturnType<typeof useGetBrokerGuestUserLazyQuery>;
export type GetBrokerGuestUserSuspenseQueryHookResult = ReturnType<typeof useGetBrokerGuestUserSuspenseQuery>;
export type GetBrokerGuestUserQueryResult = Apollo.QueryResult<GetBrokerGuestUserQuery, GetBrokerGuestUserQueryVariables>;
export const GetPortfoliosWithReactionsDocument = gql`
    query getPortfoliosWithReactions($sort: [SortInput!], $pagination: PaginationInput, $filter: GetPortfoliosWithReactionsFilter) {
  getPortfoliosWithReactions(
    pagination: $pagination
    filter: $filter
    sort: $sort
  ) {
    collection {
      _id
      property {
        _id
        name
        mainPropertyMediaFile {
          ...Media
        }
      }
      reactions {
        total
        negative
        positive
        neutral
      }
      viewsCount
    }
    totalCount
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useGetPortfoliosWithReactionsQuery__
 *
 * To run a query within a React component, call `useGetPortfoliosWithReactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfoliosWithReactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfoliosWithReactionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPortfoliosWithReactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPortfoliosWithReactionsQuery, GetPortfoliosWithReactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfoliosWithReactionsQuery, GetPortfoliosWithReactionsQueryVariables>(GetPortfoliosWithReactionsDocument, options);
      }
export function useGetPortfoliosWithReactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfoliosWithReactionsQuery, GetPortfoliosWithReactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfoliosWithReactionsQuery, GetPortfoliosWithReactionsQueryVariables>(GetPortfoliosWithReactionsDocument, options);
        }
export function useGetPortfoliosWithReactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfoliosWithReactionsQuery, GetPortfoliosWithReactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfoliosWithReactionsQuery, GetPortfoliosWithReactionsQueryVariables>(GetPortfoliosWithReactionsDocument, options);
        }
export type GetPortfoliosWithReactionsQueryHookResult = ReturnType<typeof useGetPortfoliosWithReactionsQuery>;
export type GetPortfoliosWithReactionsLazyQueryHookResult = ReturnType<typeof useGetPortfoliosWithReactionsLazyQuery>;
export type GetPortfoliosWithReactionsSuspenseQueryHookResult = ReturnType<typeof useGetPortfoliosWithReactionsSuspenseQuery>;
export type GetPortfoliosWithReactionsQueryResult = Apollo.QueryResult<GetPortfoliosWithReactionsQuery, GetPortfoliosWithReactionsQueryVariables>;
export const GetGuestUserReactionsCountDocument = gql`
    query getGuestUserReactionsCount($filter: GetPortfoliosWithReactionsFilter!) {
  getGuestUserReactionsCount(filter: $filter)
}
    `;

/**
 * __useGetGuestUserReactionsCountQuery__
 *
 * To run a query within a React component, call `useGetGuestUserReactionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestUserReactionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestUserReactionsCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetGuestUserReactionsCountQuery(baseOptions: Apollo.QueryHookOptions<GetGuestUserReactionsCountQuery, GetGuestUserReactionsCountQueryVariables> & ({ variables: GetGuestUserReactionsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestUserReactionsCountQuery, GetGuestUserReactionsCountQueryVariables>(GetGuestUserReactionsCountDocument, options);
      }
export function useGetGuestUserReactionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestUserReactionsCountQuery, GetGuestUserReactionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestUserReactionsCountQuery, GetGuestUserReactionsCountQueryVariables>(GetGuestUserReactionsCountDocument, options);
        }
export function useGetGuestUserReactionsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestUserReactionsCountQuery, GetGuestUserReactionsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuestUserReactionsCountQuery, GetGuestUserReactionsCountQueryVariables>(GetGuestUserReactionsCountDocument, options);
        }
export type GetGuestUserReactionsCountQueryHookResult = ReturnType<typeof useGetGuestUserReactionsCountQuery>;
export type GetGuestUserReactionsCountLazyQueryHookResult = ReturnType<typeof useGetGuestUserReactionsCountLazyQuery>;
export type GetGuestUserReactionsCountSuspenseQueryHookResult = ReturnType<typeof useGetGuestUserReactionsCountSuspenseQuery>;
export type GetGuestUserReactionsCountQueryResult = Apollo.QueryResult<GetGuestUserReactionsCountQuery, GetGuestUserReactionsCountQueryVariables>;
export const AddPropertyToPortfolioDocument = gql`
    mutation addPropertyToPortfolio($portfolioFolderId: ObjectId!, $propertyId: ObjectId!, $status: BrokerPortfolioStatusesEnum) {
  addPropertyToPortfolio(
    portfolioFolderId: $portfolioFolderId
    propertyId: $propertyId
    status: $status
  ) {
    _id
  }
}
    `;
export type AddPropertyToPortfolioMutationFn = Apollo.MutationFunction<AddPropertyToPortfolioMutation, AddPropertyToPortfolioMutationVariables>;

/**
 * __useAddPropertyToPortfolioMutation__
 *
 * To run a mutation, you first call `useAddPropertyToPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPropertyToPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPropertyToPortfolioMutation, { data, loading, error }] = useAddPropertyToPortfolioMutation({
 *   variables: {
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      propertyId: // value for 'propertyId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAddPropertyToPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<AddPropertyToPortfolioMutation, AddPropertyToPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPropertyToPortfolioMutation, AddPropertyToPortfolioMutationVariables>(AddPropertyToPortfolioDocument, options);
      }
export type AddPropertyToPortfolioMutationHookResult = ReturnType<typeof useAddPropertyToPortfolioMutation>;
export type AddPropertyToPortfolioMutationResult = Apollo.MutationResult<AddPropertyToPortfolioMutation>;
export type AddPropertyToPortfolioMutationOptions = Apollo.BaseMutationOptions<AddPropertyToPortfolioMutation, AddPropertyToPortfolioMutationVariables>;
export const AddPropertiesToPortfolioDocument = gql`
    mutation addPropertiesToPortfolio($portfolioFolderId: ObjectId!, $propertyIds: [ObjectId!]!) {
  addPropertiesToPortfolio(
    portfolioFolderId: $portfolioFolderId
    propertyIds: $propertyIds
  ) {
    _id
  }
}
    `;
export type AddPropertiesToPortfolioMutationFn = Apollo.MutationFunction<AddPropertiesToPortfolioMutation, AddPropertiesToPortfolioMutationVariables>;

/**
 * __useAddPropertiesToPortfolioMutation__
 *
 * To run a mutation, you first call `useAddPropertiesToPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPropertiesToPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPropertiesToPortfolioMutation, { data, loading, error }] = useAddPropertiesToPortfolioMutation({
 *   variables: {
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useAddPropertiesToPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<AddPropertiesToPortfolioMutation, AddPropertiesToPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPropertiesToPortfolioMutation, AddPropertiesToPortfolioMutationVariables>(AddPropertiesToPortfolioDocument, options);
      }
export type AddPropertiesToPortfolioMutationHookResult = ReturnType<typeof useAddPropertiesToPortfolioMutation>;
export type AddPropertiesToPortfolioMutationResult = Apollo.MutationResult<AddPropertiesToPortfolioMutation>;
export type AddPropertiesToPortfolioMutationOptions = Apollo.BaseMutationOptions<AddPropertiesToPortfolioMutation, AddPropertiesToPortfolioMutationVariables>;
export const DeletePortfolioByIdDocument = gql`
    mutation deletePortfolioById($portfolioId: ObjectId!) {
  deletePortfolioById(portfolioId: $portfolioId) {
    _id
  }
}
    `;
export type DeletePortfolioByIdMutationFn = Apollo.MutationFunction<DeletePortfolioByIdMutation, DeletePortfolioByIdMutationVariables>;

/**
 * __useDeletePortfolioByIdMutation__
 *
 * To run a mutation, you first call `useDeletePortfolioByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortfolioByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePortfolioByIdMutation, { data, loading, error }] = useDeletePortfolioByIdMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useDeletePortfolioByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeletePortfolioByIdMutation, DeletePortfolioByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePortfolioByIdMutation, DeletePortfolioByIdMutationVariables>(DeletePortfolioByIdDocument, options);
      }
export type DeletePortfolioByIdMutationHookResult = ReturnType<typeof useDeletePortfolioByIdMutation>;
export type DeletePortfolioByIdMutationResult = Apollo.MutationResult<DeletePortfolioByIdMutation>;
export type DeletePortfolioByIdMutationOptions = Apollo.BaseMutationOptions<DeletePortfolioByIdMutation, DeletePortfolioByIdMutationVariables>;
export const EditPortfolioFolderNameDocument = gql`
    mutation editPortfolioFolderName($name: String!, $portfolioFolderId: ObjectId!) {
  editPortfolioFolderName(name: $name, portfolioFolderId: $portfolioFolderId) {
    _id
    name
  }
}
    `;
export type EditPortfolioFolderNameMutationFn = Apollo.MutationFunction<EditPortfolioFolderNameMutation, EditPortfolioFolderNameMutationVariables>;

/**
 * __useEditPortfolioFolderNameMutation__
 *
 * To run a mutation, you first call `useEditPortfolioFolderNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPortfolioFolderNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPortfolioFolderNameMutation, { data, loading, error }] = useEditPortfolioFolderNameMutation({
 *   variables: {
 *      name: // value for 'name'
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *   },
 * });
 */
export function useEditPortfolioFolderNameMutation(baseOptions?: Apollo.MutationHookOptions<EditPortfolioFolderNameMutation, EditPortfolioFolderNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPortfolioFolderNameMutation, EditPortfolioFolderNameMutationVariables>(EditPortfolioFolderNameDocument, options);
      }
export type EditPortfolioFolderNameMutationHookResult = ReturnType<typeof useEditPortfolioFolderNameMutation>;
export type EditPortfolioFolderNameMutationResult = Apollo.MutationResult<EditPortfolioFolderNameMutation>;
export type EditPortfolioFolderNameMutationOptions = Apollo.BaseMutationOptions<EditPortfolioFolderNameMutation, EditPortfolioFolderNameMutationVariables>;
export const MovePortfoliosDocument = gql`
    mutation movePortfolios($portfolioFolderId: ObjectId, $portfolioIds: [ObjectId!]!) {
  movePortfolios(
    portfolioFolderId: $portfolioFolderId
    portfolioIds: $portfolioIds
  ) {
    _id
  }
}
    `;
export type MovePortfoliosMutationFn = Apollo.MutationFunction<MovePortfoliosMutation, MovePortfoliosMutationVariables>;

/**
 * __useMovePortfoliosMutation__
 *
 * To run a mutation, you first call `useMovePortfoliosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePortfoliosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePortfoliosMutation, { data, loading, error }] = useMovePortfoliosMutation({
 *   variables: {
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      portfolioIds: // value for 'portfolioIds'
 *   },
 * });
 */
export function useMovePortfoliosMutation(baseOptions?: Apollo.MutationHookOptions<MovePortfoliosMutation, MovePortfoliosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MovePortfoliosMutation, MovePortfoliosMutationVariables>(MovePortfoliosDocument, options);
      }
export type MovePortfoliosMutationHookResult = ReturnType<typeof useMovePortfoliosMutation>;
export type MovePortfoliosMutationResult = Apollo.MutationResult<MovePortfoliosMutation>;
export type MovePortfoliosMutationOptions = Apollo.BaseMutationOptions<MovePortfoliosMutation, MovePortfoliosMutationVariables>;
export const DeletePropertyFromPortfolioByIdDocument = gql`
    mutation deletePropertyFromPortfolioById($portfolioFolderId: ObjectId!, $propertyId: ObjectId!) {
  deletePropertyFromPortfolioById(
    portfolioFolderId: $portfolioFolderId
    propertyId: $propertyId
  ) {
    _id
  }
}
    `;
export type DeletePropertyFromPortfolioByIdMutationFn = Apollo.MutationFunction<DeletePropertyFromPortfolioByIdMutation, DeletePropertyFromPortfolioByIdMutationVariables>;

/**
 * __useDeletePropertyFromPortfolioByIdMutation__
 *
 * To run a mutation, you first call `useDeletePropertyFromPortfolioByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePropertyFromPortfolioByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePropertyFromPortfolioByIdMutation, { data, loading, error }] = useDeletePropertyFromPortfolioByIdMutation({
 *   variables: {
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useDeletePropertyFromPortfolioByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeletePropertyFromPortfolioByIdMutation, DeletePropertyFromPortfolioByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePropertyFromPortfolioByIdMutation, DeletePropertyFromPortfolioByIdMutationVariables>(DeletePropertyFromPortfolioByIdDocument, options);
      }
export type DeletePropertyFromPortfolioByIdMutationHookResult = ReturnType<typeof useDeletePropertyFromPortfolioByIdMutation>;
export type DeletePropertyFromPortfolioByIdMutationResult = Apollo.MutationResult<DeletePropertyFromPortfolioByIdMutation>;
export type DeletePropertyFromPortfolioByIdMutationOptions = Apollo.BaseMutationOptions<DeletePropertyFromPortfolioByIdMutation, DeletePropertyFromPortfolioByIdMutationVariables>;
export const CreatePortfolioFolderDocument = gql`
    mutation createPortfolioFolder($name: String!, $locations: PlaceTargetInput) {
  createPortfolioFolder(name: $name, locations: $locations) {
    _id
    name
    propertyId
  }
}
    `;
export type CreatePortfolioFolderMutationFn = Apollo.MutationFunction<CreatePortfolioFolderMutation, CreatePortfolioFolderMutationVariables>;

/**
 * __useCreatePortfolioFolderMutation__
 *
 * To run a mutation, you first call `useCreatePortfolioFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortfolioFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortfolioFolderMutation, { data, loading, error }] = useCreatePortfolioFolderMutation({
 *   variables: {
 *      name: // value for 'name'
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function useCreatePortfolioFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortfolioFolderMutation, CreatePortfolioFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortfolioFolderMutation, CreatePortfolioFolderMutationVariables>(CreatePortfolioFolderDocument, options);
      }
export type CreatePortfolioFolderMutationHookResult = ReturnType<typeof useCreatePortfolioFolderMutation>;
export type CreatePortfolioFolderMutationResult = Apollo.MutationResult<CreatePortfolioFolderMutation>;
export type CreatePortfolioFolderMutationOptions = Apollo.BaseMutationOptions<CreatePortfolioFolderMutation, CreatePortfolioFolderMutationVariables>;
export const UpdatePortfolioLocationsDocument = gql`
    mutation updatePortfolioLocations($portfolioFolderId: ObjectId!, $locations: PlaceTargetInput!) {
  updatePortfolioLocations(
    portfolioFolderId: $portfolioFolderId
    locations: $locations
  ) {
    _id
    updatedAt
    locations {
      ...PortfolioLocationsFields
    }
  }
}
    ${PortfolioLocationsFieldsFragmentDoc}`;
export type UpdatePortfolioLocationsMutationFn = Apollo.MutationFunction<UpdatePortfolioLocationsMutation, UpdatePortfolioLocationsMutationVariables>;

/**
 * __useUpdatePortfolioLocationsMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioLocationsMutation, { data, loading, error }] = useUpdatePortfolioLocationsMutation({
 *   variables: {
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function useUpdatePortfolioLocationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioLocationsMutation, UpdatePortfolioLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioLocationsMutation, UpdatePortfolioLocationsMutationVariables>(UpdatePortfolioLocationsDocument, options);
      }
export type UpdatePortfolioLocationsMutationHookResult = ReturnType<typeof useUpdatePortfolioLocationsMutation>;
export type UpdatePortfolioLocationsMutationResult = Apollo.MutationResult<UpdatePortfolioLocationsMutation>;
export type UpdatePortfolioLocationsMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioLocationsMutation, UpdatePortfolioLocationsMutationVariables>;
export const CreateSinglePropertyPortfolioDocument = gql`
    mutation createSinglePropertyPortfolio($input: CreateSinglePropertyPortfolioInput!) {
  createSinglePropertyPortfolio(input: $input) {
    _id
    name
  }
}
    `;
export type CreateSinglePropertyPortfolioMutationFn = Apollo.MutationFunction<CreateSinglePropertyPortfolioMutation, CreateSinglePropertyPortfolioMutationVariables>;

/**
 * __useCreateSinglePropertyPortfolioMutation__
 *
 * To run a mutation, you first call `useCreateSinglePropertyPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSinglePropertyPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSinglePropertyPortfolioMutation, { data, loading, error }] = useCreateSinglePropertyPortfolioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSinglePropertyPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<CreateSinglePropertyPortfolioMutation, CreateSinglePropertyPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSinglePropertyPortfolioMutation, CreateSinglePropertyPortfolioMutationVariables>(CreateSinglePropertyPortfolioDocument, options);
      }
export type CreateSinglePropertyPortfolioMutationHookResult = ReturnType<typeof useCreateSinglePropertyPortfolioMutation>;
export type CreateSinglePropertyPortfolioMutationResult = Apollo.MutationResult<CreateSinglePropertyPortfolioMutation>;
export type CreateSinglePropertyPortfolioMutationOptions = Apollo.BaseMutationOptions<CreateSinglePropertyPortfolioMutation, CreateSinglePropertyPortfolioMutationVariables>;
export const ChangePortfolioStatusDocument = gql`
    mutation changePortfolioStatus($portfolioId: ObjectId!, $status: BrokerPortfolioStatusesEnum!, $isAddedMediaKit: Boolean) {
  changePortfolioStatus(
    portfolioId: $portfolioId
    status: $status
    isAddedMediaKit: $isAddedMediaKit
  ) {
    ...Portfolio
  }
}
    ${PortfolioFragmentDoc}`;
export type ChangePortfolioStatusMutationFn = Apollo.MutationFunction<ChangePortfolioStatusMutation, ChangePortfolioStatusMutationVariables>;

/**
 * __useChangePortfolioStatusMutation__
 *
 * To run a mutation, you first call `useChangePortfolioStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePortfolioStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePortfolioStatusMutation, { data, loading, error }] = useChangePortfolioStatusMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      status: // value for 'status'
 *      isAddedMediaKit: // value for 'isAddedMediaKit'
 *   },
 * });
 */
export function useChangePortfolioStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangePortfolioStatusMutation, ChangePortfolioStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePortfolioStatusMutation, ChangePortfolioStatusMutationVariables>(ChangePortfolioStatusDocument, options);
      }
export type ChangePortfolioStatusMutationHookResult = ReturnType<typeof useChangePortfolioStatusMutation>;
export type ChangePortfolioStatusMutationResult = Apollo.MutationResult<ChangePortfolioStatusMutation>;
export type ChangePortfolioStatusMutationOptions = Apollo.BaseMutationOptions<ChangePortfolioStatusMutation, ChangePortfolioStatusMutationVariables>;
export const UpdatePortfolioPasswordDocument = gql`
    mutation updatePortfolioPassword($password: String, $portfolioId: ObjectId!) {
  updatePortfolioPassword(password: $password, portfolioId: $portfolioId) {
    ...Portfolio
  }
}
    ${PortfolioFragmentDoc}`;
export type UpdatePortfolioPasswordMutationFn = Apollo.MutationFunction<UpdatePortfolioPasswordMutation, UpdatePortfolioPasswordMutationVariables>;

/**
 * __useUpdatePortfolioPasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioPasswordMutation, { data, loading, error }] = useUpdatePortfolioPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useUpdatePortfolioPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioPasswordMutation, UpdatePortfolioPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioPasswordMutation, UpdatePortfolioPasswordMutationVariables>(UpdatePortfolioPasswordDocument, options);
      }
export type UpdatePortfolioPasswordMutationHookResult = ReturnType<typeof useUpdatePortfolioPasswordMutation>;
export type UpdatePortfolioPasswordMutationResult = Apollo.MutationResult<UpdatePortfolioPasswordMutation>;
export type UpdatePortfolioPasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioPasswordMutation, UpdatePortfolioPasswordMutationVariables>;
export const ManuallyRegisterPortfolioViewDocument = gql`
    mutation manuallyRegisterPortfolioView($portfolioId: ObjectId!) {
  manuallyRegisterPortfolioView(viewedPortfolioId: $portfolioId) {
    _id
  }
}
    `;
export type ManuallyRegisterPortfolioViewMutationFn = Apollo.MutationFunction<ManuallyRegisterPortfolioViewMutation, ManuallyRegisterPortfolioViewMutationVariables>;

/**
 * __useManuallyRegisterPortfolioViewMutation__
 *
 * To run a mutation, you first call `useManuallyRegisterPortfolioViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManuallyRegisterPortfolioViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manuallyRegisterPortfolioViewMutation, { data, loading, error }] = useManuallyRegisterPortfolioViewMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useManuallyRegisterPortfolioViewMutation(baseOptions?: Apollo.MutationHookOptions<ManuallyRegisterPortfolioViewMutation, ManuallyRegisterPortfolioViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManuallyRegisterPortfolioViewMutation, ManuallyRegisterPortfolioViewMutationVariables>(ManuallyRegisterPortfolioViewDocument, options);
      }
export type ManuallyRegisterPortfolioViewMutationHookResult = ReturnType<typeof useManuallyRegisterPortfolioViewMutation>;
export type ManuallyRegisterPortfolioViewMutationResult = Apollo.MutationResult<ManuallyRegisterPortfolioViewMutation>;
export type ManuallyRegisterPortfolioViewMutationOptions = Apollo.BaseMutationOptions<ManuallyRegisterPortfolioViewMutation, ManuallyRegisterPortfolioViewMutationVariables>;
export const UpdateShowPopupOnPortfolioDocument = gql`
    mutation updateShowPopupOnPortfolio($showPopup: Boolean!, $portfolioId: ObjectId!) {
  updateShowPopupOnPortfolio(showPopup: $showPopup, portfolioId: $portfolioId) {
    ...Portfolio
  }
}
    ${PortfolioFragmentDoc}`;
export type UpdateShowPopupOnPortfolioMutationFn = Apollo.MutationFunction<UpdateShowPopupOnPortfolioMutation, UpdateShowPopupOnPortfolioMutationVariables>;

/**
 * __useUpdateShowPopupOnPortfolioMutation__
 *
 * To run a mutation, you first call `useUpdateShowPopupOnPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShowPopupOnPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShowPopupOnPortfolioMutation, { data, loading, error }] = useUpdateShowPopupOnPortfolioMutation({
 *   variables: {
 *      showPopup: // value for 'showPopup'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useUpdateShowPopupOnPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShowPopupOnPortfolioMutation, UpdateShowPopupOnPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShowPopupOnPortfolioMutation, UpdateShowPopupOnPortfolioMutationVariables>(UpdateShowPopupOnPortfolioDocument, options);
      }
export type UpdateShowPopupOnPortfolioMutationHookResult = ReturnType<typeof useUpdateShowPopupOnPortfolioMutation>;
export type UpdateShowPopupOnPortfolioMutationResult = Apollo.MutationResult<UpdateShowPopupOnPortfolioMutation>;
export type UpdateShowPopupOnPortfolioMutationOptions = Apollo.BaseMutationOptions<UpdateShowPopupOnPortfolioMutation, UpdateShowPopupOnPortfolioMutationVariables>;
export const UpdatePortfolioSettingsDocument = gql`
    mutation updatePortfolioSettings($portfolioId: ObjectId!, $status: BrokerPortfolioStatusesEnum, $isAddedMediaKit: Boolean, $password: String, $showPopup: Boolean) {
  updatePortfolioSettings(
    portfolioId: $portfolioId
    status: $status
    isAddedMediaKit: $isAddedMediaKit
    password: $password
    showPopup: $showPopup
  ) {
    ...Portfolio
  }
}
    ${PortfolioFragmentDoc}`;
export type UpdatePortfolioSettingsMutationFn = Apollo.MutationFunction<UpdatePortfolioSettingsMutation, UpdatePortfolioSettingsMutationVariables>;

/**
 * __useUpdatePortfolioSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioSettingsMutation, { data, loading, error }] = useUpdatePortfolioSettingsMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      status: // value for 'status'
 *      isAddedMediaKit: // value for 'isAddedMediaKit'
 *      password: // value for 'password'
 *      showPopup: // value for 'showPopup'
 *   },
 * });
 */
export function useUpdatePortfolioSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioSettingsMutation, UpdatePortfolioSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioSettingsMutation, UpdatePortfolioSettingsMutationVariables>(UpdatePortfolioSettingsDocument, options);
      }
export type UpdatePortfolioSettingsMutationHookResult = ReturnType<typeof useUpdatePortfolioSettingsMutation>;
export type UpdatePortfolioSettingsMutationResult = Apollo.MutationResult<UpdatePortfolioSettingsMutation>;
export type UpdatePortfolioSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioSettingsMutation, UpdatePortfolioSettingsMutationVariables>;
export const GetPortfoliosDocument = gql`
    query getPortfolios($pagination: PaginationInput, $sort: [SortInput!], $searchText: String) {
  getPortfolios(pagination: $pagination, sort: $sort, searchText: $searchText) {
    collection {
      ...PortfolioListItem
      portfolioFolder {
        name
      }
    }
    totalCount
  }
}
    ${PortfolioListItemFragmentDoc}`;

/**
 * __useGetPortfoliosQuery__
 *
 * To run a query within a React component, call `useGetPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfoliosQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetPortfoliosQuery(baseOptions?: Apollo.QueryHookOptions<GetPortfoliosQuery, GetPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfoliosQuery, GetPortfoliosQueryVariables>(GetPortfoliosDocument, options);
      }
export function useGetPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfoliosQuery, GetPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfoliosQuery, GetPortfoliosQueryVariables>(GetPortfoliosDocument, options);
        }
export function useGetPortfoliosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfoliosQuery, GetPortfoliosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfoliosQuery, GetPortfoliosQueryVariables>(GetPortfoliosDocument, options);
        }
export type GetPortfoliosQueryHookResult = ReturnType<typeof useGetPortfoliosQuery>;
export type GetPortfoliosLazyQueryHookResult = ReturnType<typeof useGetPortfoliosLazyQuery>;
export type GetPortfoliosSuspenseQueryHookResult = ReturnType<typeof useGetPortfoliosSuspenseQuery>;
export type GetPortfoliosQueryResult = Apollo.QueryResult<GetPortfoliosQuery, GetPortfoliosQueryVariables>;
export const GetPortfoliosCountDocument = gql`
    query getPortfoliosCount($pagination: PaginationInput, $sort: [SortInput!], $searchText: String, $filter: GetPortfoliosFilter) {
  getPortfolios(
    pagination: $pagination
    sort: $sort
    searchText: $searchText
    filter: $filter
  ) {
    totalCount
  }
}
    `;

/**
 * __useGetPortfoliosCountQuery__
 *
 * To run a query within a React component, call `useGetPortfoliosCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfoliosCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfoliosCountQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      searchText: // value for 'searchText'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPortfoliosCountQuery(baseOptions?: Apollo.QueryHookOptions<GetPortfoliosCountQuery, GetPortfoliosCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfoliosCountQuery, GetPortfoliosCountQueryVariables>(GetPortfoliosCountDocument, options);
      }
export function useGetPortfoliosCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfoliosCountQuery, GetPortfoliosCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfoliosCountQuery, GetPortfoliosCountQueryVariables>(GetPortfoliosCountDocument, options);
        }
export function useGetPortfoliosCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfoliosCountQuery, GetPortfoliosCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfoliosCountQuery, GetPortfoliosCountQueryVariables>(GetPortfoliosCountDocument, options);
        }
export type GetPortfoliosCountQueryHookResult = ReturnType<typeof useGetPortfoliosCountQuery>;
export type GetPortfoliosCountLazyQueryHookResult = ReturnType<typeof useGetPortfoliosCountLazyQuery>;
export type GetPortfoliosCountSuspenseQueryHookResult = ReturnType<typeof useGetPortfoliosCountSuspenseQuery>;
export type GetPortfoliosCountQueryResult = Apollo.QueryResult<GetPortfoliosCountQuery, GetPortfoliosCountQueryVariables>;
export const GetPortfoliosTreeDocument = gql`
    query getPortfoliosTree($pagination: PaginationInput, $sort: [SortInput!]) {
  getPortfoliosTree(pagination: $pagination, sort: $sort) {
    collection {
      _id
      type
      name
      propertyId
      property {
        _id
        name
      }
      items {
        _id
        type
        name
        property {
          _id
          name
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetPortfoliosTreeQuery__
 *
 * To run a query within a React component, call `useGetPortfoliosTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfoliosTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfoliosTreeQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPortfoliosTreeQuery(baseOptions?: Apollo.QueryHookOptions<GetPortfoliosTreeQuery, GetPortfoliosTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfoliosTreeQuery, GetPortfoliosTreeQueryVariables>(GetPortfoliosTreeDocument, options);
      }
export function useGetPortfoliosTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfoliosTreeQuery, GetPortfoliosTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfoliosTreeQuery, GetPortfoliosTreeQueryVariables>(GetPortfoliosTreeDocument, options);
        }
export function useGetPortfoliosTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfoliosTreeQuery, GetPortfoliosTreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfoliosTreeQuery, GetPortfoliosTreeQueryVariables>(GetPortfoliosTreeDocument, options);
        }
export type GetPortfoliosTreeQueryHookResult = ReturnType<typeof useGetPortfoliosTreeQuery>;
export type GetPortfoliosTreeLazyQueryHookResult = ReturnType<typeof useGetPortfoliosTreeLazyQuery>;
export type GetPortfoliosTreeSuspenseQueryHookResult = ReturnType<typeof useGetPortfoliosTreeSuspenseQuery>;
export type GetPortfoliosTreeQueryResult = Apollo.QueryResult<GetPortfoliosTreeQuery, GetPortfoliosTreeQueryVariables>;
export const GetAllPortfolioFoldersDocument = gql`
    query getAllPortfolioFolders {
  getAllPortfolioFolders {
    _id
    name
    portfolioPropertiesIds
    locations {
      ...PortfolioLocationsFields
    }
  }
}
    ${PortfolioLocationsFieldsFragmentDoc}`;

/**
 * __useGetAllPortfolioFoldersQuery__
 *
 * To run a query within a React component, call `useGetAllPortfolioFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPortfolioFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPortfolioFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPortfolioFoldersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPortfolioFoldersQuery, GetAllPortfolioFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPortfolioFoldersQuery, GetAllPortfolioFoldersQueryVariables>(GetAllPortfolioFoldersDocument, options);
      }
export function useGetAllPortfolioFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPortfolioFoldersQuery, GetAllPortfolioFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPortfolioFoldersQuery, GetAllPortfolioFoldersQueryVariables>(GetAllPortfolioFoldersDocument, options);
        }
export function useGetAllPortfolioFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPortfolioFoldersQuery, GetAllPortfolioFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllPortfolioFoldersQuery, GetAllPortfolioFoldersQueryVariables>(GetAllPortfolioFoldersDocument, options);
        }
export type GetAllPortfolioFoldersQueryHookResult = ReturnType<typeof useGetAllPortfolioFoldersQuery>;
export type GetAllPortfolioFoldersLazyQueryHookResult = ReturnType<typeof useGetAllPortfolioFoldersLazyQuery>;
export type GetAllPortfolioFoldersSuspenseQueryHookResult = ReturnType<typeof useGetAllPortfolioFoldersSuspenseQuery>;
export type GetAllPortfolioFoldersQueryResult = Apollo.QueryResult<GetAllPortfolioFoldersQuery, GetAllPortfolioFoldersQueryVariables>;
export const GetPortfolioFolderItemsDocument = gql`
    query getPortfolioFolderItems($pagination: PaginationInput, $portfolioFolderId: ObjectId!, $search: String, $sort: [SortInput!]) {
  getPortfolioFolderItems(
    pagination: $pagination
    portfolioFolderId: $portfolioFolderId
    search: $search
    sort: $sort
  ) {
    collection {
      ...PortfolioFolderItem
      isAddedMediaKit
      name
      portfolioFolder {
        name
      }
    }
    totalCount
  }
}
    ${PortfolioFolderItemFragmentDoc}`;

/**
 * __useGetPortfolioFolderItemsQuery__
 *
 * To run a query within a React component, call `useGetPortfolioFolderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioFolderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioFolderItemsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPortfolioFolderItemsQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioFolderItemsQuery, GetPortfolioFolderItemsQueryVariables> & ({ variables: GetPortfolioFolderItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioFolderItemsQuery, GetPortfolioFolderItemsQueryVariables>(GetPortfolioFolderItemsDocument, options);
      }
export function useGetPortfolioFolderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioFolderItemsQuery, GetPortfolioFolderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioFolderItemsQuery, GetPortfolioFolderItemsQueryVariables>(GetPortfolioFolderItemsDocument, options);
        }
export function useGetPortfolioFolderItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioFolderItemsQuery, GetPortfolioFolderItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioFolderItemsQuery, GetPortfolioFolderItemsQueryVariables>(GetPortfolioFolderItemsDocument, options);
        }
export type GetPortfolioFolderItemsQueryHookResult = ReturnType<typeof useGetPortfolioFolderItemsQuery>;
export type GetPortfolioFolderItemsLazyQueryHookResult = ReturnType<typeof useGetPortfolioFolderItemsLazyQuery>;
export type GetPortfolioFolderItemsSuspenseQueryHookResult = ReturnType<typeof useGetPortfolioFolderItemsSuspenseQuery>;
export type GetPortfolioFolderItemsQueryResult = Apollo.QueryResult<GetPortfolioFolderItemsQuery, GetPortfolioFolderItemsQueryVariables>;
export const GetPortfoliosByPublicFolderDocument = gql`
    query getPortfoliosByPublicFolder($password: String, $portfolioFolderId: ObjectId!, $pagination: PaginationInput) {
  getPortfoliosByPublicFolder(
    password: $password
    portfolioFolderId: $portfolioFolderId
    pagination: $pagination
  ) {
    collection {
      ...PortfoliosByPublicFolderListItem
    }
    totalCount
  }
}
    ${PortfoliosByPublicFolderListItemFragmentDoc}`;

/**
 * __useGetPortfoliosByPublicFolderQuery__
 *
 * To run a query within a React component, call `useGetPortfoliosByPublicFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfoliosByPublicFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfoliosByPublicFolderQuery({
 *   variables: {
 *      password: // value for 'password'
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetPortfoliosByPublicFolderQuery(baseOptions: Apollo.QueryHookOptions<GetPortfoliosByPublicFolderQuery, GetPortfoliosByPublicFolderQueryVariables> & ({ variables: GetPortfoliosByPublicFolderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfoliosByPublicFolderQuery, GetPortfoliosByPublicFolderQueryVariables>(GetPortfoliosByPublicFolderDocument, options);
      }
export function useGetPortfoliosByPublicFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfoliosByPublicFolderQuery, GetPortfoliosByPublicFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfoliosByPublicFolderQuery, GetPortfoliosByPublicFolderQueryVariables>(GetPortfoliosByPublicFolderDocument, options);
        }
export function useGetPortfoliosByPublicFolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfoliosByPublicFolderQuery, GetPortfoliosByPublicFolderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfoliosByPublicFolderQuery, GetPortfoliosByPublicFolderQueryVariables>(GetPortfoliosByPublicFolderDocument, options);
        }
export type GetPortfoliosByPublicFolderQueryHookResult = ReturnType<typeof useGetPortfoliosByPublicFolderQuery>;
export type GetPortfoliosByPublicFolderLazyQueryHookResult = ReturnType<typeof useGetPortfoliosByPublicFolderLazyQuery>;
export type GetPortfoliosByPublicFolderSuspenseQueryHookResult = ReturnType<typeof useGetPortfoliosByPublicFolderSuspenseQuery>;
export type GetPortfoliosByPublicFolderQueryResult = Apollo.QueryResult<GetPortfoliosByPublicFolderQuery, GetPortfoliosByPublicFolderQueryVariables>;
export const GetPortfolioFolderItemsCountDocument = gql`
    query getPortfolioFolderItemsCount($pagination: PaginationInput, $portfolioFolderId: ObjectId!, $search: String, $sort: [SortInput!]) {
  getPortfolioFolderItems(
    pagination: $pagination
    portfolioFolderId: $portfolioFolderId
    search: $search
    sort: $sort
  ) {
    totalCount
  }
}
    `;

/**
 * __useGetPortfolioFolderItemsCountQuery__
 *
 * To run a query within a React component, call `useGetPortfolioFolderItemsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioFolderItemsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioFolderItemsCountQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPortfolioFolderItemsCountQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioFolderItemsCountQuery, GetPortfolioFolderItemsCountQueryVariables> & ({ variables: GetPortfolioFolderItemsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioFolderItemsCountQuery, GetPortfolioFolderItemsCountQueryVariables>(GetPortfolioFolderItemsCountDocument, options);
      }
export function useGetPortfolioFolderItemsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioFolderItemsCountQuery, GetPortfolioFolderItemsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioFolderItemsCountQuery, GetPortfolioFolderItemsCountQueryVariables>(GetPortfolioFolderItemsCountDocument, options);
        }
export function useGetPortfolioFolderItemsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioFolderItemsCountQuery, GetPortfolioFolderItemsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioFolderItemsCountQuery, GetPortfolioFolderItemsCountQueryVariables>(GetPortfolioFolderItemsCountDocument, options);
        }
export type GetPortfolioFolderItemsCountQueryHookResult = ReturnType<typeof useGetPortfolioFolderItemsCountQuery>;
export type GetPortfolioFolderItemsCountLazyQueryHookResult = ReturnType<typeof useGetPortfolioFolderItemsCountLazyQuery>;
export type GetPortfolioFolderItemsCountSuspenseQueryHookResult = ReturnType<typeof useGetPortfolioFolderItemsCountSuspenseQuery>;
export type GetPortfolioFolderItemsCountQueryResult = Apollo.QueryResult<GetPortfolioFolderItemsCountQuery, GetPortfolioFolderItemsCountQueryVariables>;
export const GetPortfolioFolderRootDocument = gql`
    query getPortfolioFolderRoot {
  getPortfolioFolderRoot {
    ...PortfolioBase
  }
}
    ${PortfolioBaseFragmentDoc}`;

/**
 * __useGetPortfolioFolderRootQuery__
 *
 * To run a query within a React component, call `useGetPortfolioFolderRootQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioFolderRootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioFolderRootQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPortfolioFolderRootQuery(baseOptions?: Apollo.QueryHookOptions<GetPortfolioFolderRootQuery, GetPortfolioFolderRootQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioFolderRootQuery, GetPortfolioFolderRootQueryVariables>(GetPortfolioFolderRootDocument, options);
      }
export function useGetPortfolioFolderRootLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioFolderRootQuery, GetPortfolioFolderRootQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioFolderRootQuery, GetPortfolioFolderRootQueryVariables>(GetPortfolioFolderRootDocument, options);
        }
export function useGetPortfolioFolderRootSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioFolderRootQuery, GetPortfolioFolderRootQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioFolderRootQuery, GetPortfolioFolderRootQueryVariables>(GetPortfolioFolderRootDocument, options);
        }
export type GetPortfolioFolderRootQueryHookResult = ReturnType<typeof useGetPortfolioFolderRootQuery>;
export type GetPortfolioFolderRootLazyQueryHookResult = ReturnType<typeof useGetPortfolioFolderRootLazyQuery>;
export type GetPortfolioFolderRootSuspenseQueryHookResult = ReturnType<typeof useGetPortfolioFolderRootSuspenseQuery>;
export type GetPortfolioFolderRootQueryResult = Apollo.QueryResult<GetPortfolioFolderRootQuery, GetPortfolioFolderRootQueryVariables>;
export const GetPortfolioFolderByIdDocument = gql`
    query getPortfolioFolderById($portfolioFolderId: ObjectId!) {
  getPortfolioFolderById(portfolioFolderId: $portfolioFolderId) {
    ...Portfolio
    isAddedMediaKit
    showPopup
  }
}
    ${PortfolioFragmentDoc}`;

/**
 * __useGetPortfolioFolderByIdQuery__
 *
 * To run a query within a React component, call `useGetPortfolioFolderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioFolderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioFolderByIdQuery({
 *   variables: {
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *   },
 * });
 */
export function useGetPortfolioFolderByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioFolderByIdQuery, GetPortfolioFolderByIdQueryVariables> & ({ variables: GetPortfolioFolderByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioFolderByIdQuery, GetPortfolioFolderByIdQueryVariables>(GetPortfolioFolderByIdDocument, options);
      }
export function useGetPortfolioFolderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioFolderByIdQuery, GetPortfolioFolderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioFolderByIdQuery, GetPortfolioFolderByIdQueryVariables>(GetPortfolioFolderByIdDocument, options);
        }
export function useGetPortfolioFolderByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioFolderByIdQuery, GetPortfolioFolderByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioFolderByIdQuery, GetPortfolioFolderByIdQueryVariables>(GetPortfolioFolderByIdDocument, options);
        }
export type GetPortfolioFolderByIdQueryHookResult = ReturnType<typeof useGetPortfolioFolderByIdQuery>;
export type GetPortfolioFolderByIdLazyQueryHookResult = ReturnType<typeof useGetPortfolioFolderByIdLazyQuery>;
export type GetPortfolioFolderByIdSuspenseQueryHookResult = ReturnType<typeof useGetPortfolioFolderByIdSuspenseQuery>;
export type GetPortfolioFolderByIdQueryResult = Apollo.QueryResult<GetPortfolioFolderByIdQuery, GetPortfolioFolderByIdQueryVariables>;
export const GetPortfolioItemByIdDocument = gql`
    query getPortfolioItemById($portfolioFolderId: ObjectId!) {
  getPortfolioFolderById(portfolioFolderId: $portfolioFolderId) {
    portfolioFolderId
    isAddedMediaKit
    property {
      ...Property
    }
  }
}
    ${PropertyFragmentDoc}`;

/**
 * __useGetPortfolioItemByIdQuery__
 *
 * To run a query within a React component, call `useGetPortfolioItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioItemByIdQuery({
 *   variables: {
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *   },
 * });
 */
export function useGetPortfolioItemByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioItemByIdQuery, GetPortfolioItemByIdQueryVariables> & ({ variables: GetPortfolioItemByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioItemByIdQuery, GetPortfolioItemByIdQueryVariables>(GetPortfolioItemByIdDocument, options);
      }
export function useGetPortfolioItemByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioItemByIdQuery, GetPortfolioItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioItemByIdQuery, GetPortfolioItemByIdQueryVariables>(GetPortfolioItemByIdDocument, options);
        }
export function useGetPortfolioItemByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioItemByIdQuery, GetPortfolioItemByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioItemByIdQuery, GetPortfolioItemByIdQueryVariables>(GetPortfolioItemByIdDocument, options);
        }
export type GetPortfolioItemByIdQueryHookResult = ReturnType<typeof useGetPortfolioItemByIdQuery>;
export type GetPortfolioItemByIdLazyQueryHookResult = ReturnType<typeof useGetPortfolioItemByIdLazyQuery>;
export type GetPortfolioItemByIdSuspenseQueryHookResult = ReturnType<typeof useGetPortfolioItemByIdSuspenseQuery>;
export type GetPortfolioItemByIdQueryResult = Apollo.QueryResult<GetPortfolioItemByIdQuery, GetPortfolioItemByIdQueryVariables>;
export const GetPortfolioFirstPublicPropertyDocument = gql`
    query getPortfolioFirstPublicProperty($password: String, $brokerId: String!, $portfolioFolderName: String!) {
  getPortfolioFirstPublicProperty(
    brokerId: $brokerId
    portfolioFolderName: $portfolioFolderName
    password: $password
  ) {
    _id
    portfolioFolderId
    brokerId
    isAddedMediaKit
    portfolioFolder {
      name
      showPopup
    }
    property {
      ...Property
    }
  }
}
    ${PropertyFragmentDoc}`;

/**
 * __useGetPortfolioFirstPublicPropertyQuery__
 *
 * To run a query within a React component, call `useGetPortfolioFirstPublicPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioFirstPublicPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioFirstPublicPropertyQuery({
 *   variables: {
 *      password: // value for 'password'
 *      brokerId: // value for 'brokerId'
 *      portfolioFolderName: // value for 'portfolioFolderName'
 *   },
 * });
 */
export function useGetPortfolioFirstPublicPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioFirstPublicPropertyQuery, GetPortfolioFirstPublicPropertyQueryVariables> & ({ variables: GetPortfolioFirstPublicPropertyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioFirstPublicPropertyQuery, GetPortfolioFirstPublicPropertyQueryVariables>(GetPortfolioFirstPublicPropertyDocument, options);
      }
export function useGetPortfolioFirstPublicPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioFirstPublicPropertyQuery, GetPortfolioFirstPublicPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioFirstPublicPropertyQuery, GetPortfolioFirstPublicPropertyQueryVariables>(GetPortfolioFirstPublicPropertyDocument, options);
        }
export function useGetPortfolioFirstPublicPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioFirstPublicPropertyQuery, GetPortfolioFirstPublicPropertyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioFirstPublicPropertyQuery, GetPortfolioFirstPublicPropertyQueryVariables>(GetPortfolioFirstPublicPropertyDocument, options);
        }
export type GetPortfolioFirstPublicPropertyQueryHookResult = ReturnType<typeof useGetPortfolioFirstPublicPropertyQuery>;
export type GetPortfolioFirstPublicPropertyLazyQueryHookResult = ReturnType<typeof useGetPortfolioFirstPublicPropertyLazyQuery>;
export type GetPortfolioFirstPublicPropertySuspenseQueryHookResult = ReturnType<typeof useGetPortfolioFirstPublicPropertySuspenseQuery>;
export type GetPortfolioFirstPublicPropertyQueryResult = Apollo.QueryResult<GetPortfolioFirstPublicPropertyQuery, GetPortfolioFirstPublicPropertyQueryVariables>;
export const GetPortfolioPropertiesToCompareDocument = gql`
    query getPortfolioPropertiesToCompare($portfolioIds: [ObjectId!]!, $portfolioFolderId: ObjectId!, $pagination: PaginationInput, $sort: [SortInput!]) {
  getPortfolioPropertiesToCompare(
    portfolioIds: $portfolioIds
    portfolioFolderId: $portfolioFolderId
    pagination: $pagination
    sort: $sort
  ) {
    collection {
      _id
      name
      mainPropertyMediaFile {
        _id
        files {
          ...File
        }
      }
      marketArea {
        _id
        name
      }
      status
      yearBuilt
      priceRange {
        min
        max
      }
      averageBedroomsNumberValue {
        min
        max
      }
      averageBathroomsNumberValue {
        min
        max
      }
      numberOfUnits
      buildingTypes
      projectStatus
      taxInformation
    }
    totalCount
  }
}
    ${FileFragmentDoc}`;

/**
 * __useGetPortfolioPropertiesToCompareQuery__
 *
 * To run a query within a React component, call `useGetPortfolioPropertiesToCompareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioPropertiesToCompareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioPropertiesToCompareQuery({
 *   variables: {
 *      portfolioIds: // value for 'portfolioIds'
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPortfolioPropertiesToCompareQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioPropertiesToCompareQuery, GetPortfolioPropertiesToCompareQueryVariables> & ({ variables: GetPortfolioPropertiesToCompareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioPropertiesToCompareQuery, GetPortfolioPropertiesToCompareQueryVariables>(GetPortfolioPropertiesToCompareDocument, options);
      }
export function useGetPortfolioPropertiesToCompareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioPropertiesToCompareQuery, GetPortfolioPropertiesToCompareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioPropertiesToCompareQuery, GetPortfolioPropertiesToCompareQueryVariables>(GetPortfolioPropertiesToCompareDocument, options);
        }
export function useGetPortfolioPropertiesToCompareSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioPropertiesToCompareQuery, GetPortfolioPropertiesToCompareQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioPropertiesToCompareQuery, GetPortfolioPropertiesToCompareQueryVariables>(GetPortfolioPropertiesToCompareDocument, options);
        }
export type GetPortfolioPropertiesToCompareQueryHookResult = ReturnType<typeof useGetPortfolioPropertiesToCompareQuery>;
export type GetPortfolioPropertiesToCompareLazyQueryHookResult = ReturnType<typeof useGetPortfolioPropertiesToCompareLazyQuery>;
export type GetPortfolioPropertiesToCompareSuspenseQueryHookResult = ReturnType<typeof useGetPortfolioPropertiesToCompareSuspenseQuery>;
export type GetPortfolioPropertiesToCompareQueryResult = Apollo.QueryResult<GetPortfolioPropertiesToCompareQuery, GetPortfolioPropertiesToCompareQueryVariables>;
export const GetBrokerViewedPortfoliosDocument = gql`
    query getBrokerViewedPortfolios($pagination: PaginationInput, $filter: BrokerViewedPortfoliosFilter, $sort: [SortInput!]) {
  getBrokerViewedPortfolios(pagination: $pagination, filter: $filter, sort: $sort) {
    collection {
      _id
      createdAt
      portfolio {
        _id
        name
        type
        portfolioFolder {
          name
        }
        property {
          _id
          name
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetBrokerViewedPortfoliosQuery__
 *
 * To run a query within a React component, call `useGetBrokerViewedPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerViewedPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerViewedPortfoliosQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetBrokerViewedPortfoliosQuery(baseOptions?: Apollo.QueryHookOptions<GetBrokerViewedPortfoliosQuery, GetBrokerViewedPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokerViewedPortfoliosQuery, GetBrokerViewedPortfoliosQueryVariables>(GetBrokerViewedPortfoliosDocument, options);
      }
export function useGetBrokerViewedPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokerViewedPortfoliosQuery, GetBrokerViewedPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokerViewedPortfoliosQuery, GetBrokerViewedPortfoliosQueryVariables>(GetBrokerViewedPortfoliosDocument, options);
        }
export function useGetBrokerViewedPortfoliosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrokerViewedPortfoliosQuery, GetBrokerViewedPortfoliosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrokerViewedPortfoliosQuery, GetBrokerViewedPortfoliosQueryVariables>(GetBrokerViewedPortfoliosDocument, options);
        }
export type GetBrokerViewedPortfoliosQueryHookResult = ReturnType<typeof useGetBrokerViewedPortfoliosQuery>;
export type GetBrokerViewedPortfoliosLazyQueryHookResult = ReturnType<typeof useGetBrokerViewedPortfoliosLazyQuery>;
export type GetBrokerViewedPortfoliosSuspenseQueryHookResult = ReturnType<typeof useGetBrokerViewedPortfoliosSuspenseQuery>;
export type GetBrokerViewedPortfoliosQueryResult = Apollo.QueryResult<GetBrokerViewedPortfoliosQuery, GetBrokerViewedPortfoliosQueryVariables>;
export const CurrentBrokerHasPortfoliosDocument = gql`
    query currentBrokerHasPortfolios {
  currentBrokerHasPortfolios
}
    `;

/**
 * __useCurrentBrokerHasPortfoliosQuery__
 *
 * To run a query within a React component, call `useCurrentBrokerHasPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBrokerHasPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBrokerHasPortfoliosQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentBrokerHasPortfoliosQuery(baseOptions?: Apollo.QueryHookOptions<CurrentBrokerHasPortfoliosQuery, CurrentBrokerHasPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentBrokerHasPortfoliosQuery, CurrentBrokerHasPortfoliosQueryVariables>(CurrentBrokerHasPortfoliosDocument, options);
      }
export function useCurrentBrokerHasPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentBrokerHasPortfoliosQuery, CurrentBrokerHasPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentBrokerHasPortfoliosQuery, CurrentBrokerHasPortfoliosQueryVariables>(CurrentBrokerHasPortfoliosDocument, options);
        }
export function useCurrentBrokerHasPortfoliosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentBrokerHasPortfoliosQuery, CurrentBrokerHasPortfoliosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentBrokerHasPortfoliosQuery, CurrentBrokerHasPortfoliosQueryVariables>(CurrentBrokerHasPortfoliosDocument, options);
        }
export type CurrentBrokerHasPortfoliosQueryHookResult = ReturnType<typeof useCurrentBrokerHasPortfoliosQuery>;
export type CurrentBrokerHasPortfoliosLazyQueryHookResult = ReturnType<typeof useCurrentBrokerHasPortfoliosLazyQuery>;
export type CurrentBrokerHasPortfoliosSuspenseQueryHookResult = ReturnType<typeof useCurrentBrokerHasPortfoliosSuspenseQuery>;
export type CurrentBrokerHasPortfoliosQueryResult = Apollo.QueryResult<CurrentBrokerHasPortfoliosQuery, CurrentBrokerHasPortfoliosQueryVariables>;
export const GetPortfolioPasswordDocument = gql`
    query getPortfolioPassword($portfolioId: ObjectId!) {
  getPortfolioPassword(portfolioId: $portfolioId)
}
    `;

/**
 * __useGetPortfolioPasswordQuery__
 *
 * To run a query within a React component, call `useGetPortfolioPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioPasswordQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useGetPortfolioPasswordQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioPasswordQuery, GetPortfolioPasswordQueryVariables> & ({ variables: GetPortfolioPasswordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioPasswordQuery, GetPortfolioPasswordQueryVariables>(GetPortfolioPasswordDocument, options);
      }
export function useGetPortfolioPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioPasswordQuery, GetPortfolioPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioPasswordQuery, GetPortfolioPasswordQueryVariables>(GetPortfolioPasswordDocument, options);
        }
export function useGetPortfolioPasswordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioPasswordQuery, GetPortfolioPasswordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioPasswordQuery, GetPortfolioPasswordQueryVariables>(GetPortfolioPasswordDocument, options);
        }
export type GetPortfolioPasswordQueryHookResult = ReturnType<typeof useGetPortfolioPasswordQuery>;
export type GetPortfolioPasswordLazyQueryHookResult = ReturnType<typeof useGetPortfolioPasswordLazyQuery>;
export type GetPortfolioPasswordSuspenseQueryHookResult = ReturnType<typeof useGetPortfolioPasswordSuspenseQuery>;
export type GetPortfolioPasswordQueryResult = Apollo.QueryResult<GetPortfolioPasswordQuery, GetPortfolioPasswordQueryVariables>;
export const CheckIfPortfolioHasMediaKitDocument = gql`
    query checkIfPortfolioHasMediaKit($portfolioId: ObjectId!) {
  checkIfPortfolioHasMediaKit(portfolioId: $portfolioId)
}
    `;

/**
 * __useCheckIfPortfolioHasMediaKitQuery__
 *
 * To run a query within a React component, call `useCheckIfPortfolioHasMediaKitQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfPortfolioHasMediaKitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfPortfolioHasMediaKitQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCheckIfPortfolioHasMediaKitQuery(baseOptions: Apollo.QueryHookOptions<CheckIfPortfolioHasMediaKitQuery, CheckIfPortfolioHasMediaKitQueryVariables> & ({ variables: CheckIfPortfolioHasMediaKitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfPortfolioHasMediaKitQuery, CheckIfPortfolioHasMediaKitQueryVariables>(CheckIfPortfolioHasMediaKitDocument, options);
      }
export function useCheckIfPortfolioHasMediaKitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfPortfolioHasMediaKitQuery, CheckIfPortfolioHasMediaKitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfPortfolioHasMediaKitQuery, CheckIfPortfolioHasMediaKitQueryVariables>(CheckIfPortfolioHasMediaKitDocument, options);
        }
export function useCheckIfPortfolioHasMediaKitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckIfPortfolioHasMediaKitQuery, CheckIfPortfolioHasMediaKitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckIfPortfolioHasMediaKitQuery, CheckIfPortfolioHasMediaKitQueryVariables>(CheckIfPortfolioHasMediaKitDocument, options);
        }
export type CheckIfPortfolioHasMediaKitQueryHookResult = ReturnType<typeof useCheckIfPortfolioHasMediaKitQuery>;
export type CheckIfPortfolioHasMediaKitLazyQueryHookResult = ReturnType<typeof useCheckIfPortfolioHasMediaKitLazyQuery>;
export type CheckIfPortfolioHasMediaKitSuspenseQueryHookResult = ReturnType<typeof useCheckIfPortfolioHasMediaKitSuspenseQuery>;
export type CheckIfPortfolioHasMediaKitQueryResult = Apollo.QueryResult<CheckIfPortfolioHasMediaKitQuery, CheckIfPortfolioHasMediaKitQueryVariables>;
export const GetUserPublicPortfolioFoldersDocument = gql`
    query getUserPublicPortfolioFolders {
  getUserPublicPortfolioFolders {
    _id
    name
  }
}
    `;

/**
 * __useGetUserPublicPortfolioFoldersQuery__
 *
 * To run a query within a React component, call `useGetUserPublicPortfolioFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPublicPortfolioFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPublicPortfolioFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPublicPortfolioFoldersQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPublicPortfolioFoldersQuery, GetUserPublicPortfolioFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPublicPortfolioFoldersQuery, GetUserPublicPortfolioFoldersQueryVariables>(GetUserPublicPortfolioFoldersDocument, options);
      }
export function useGetUserPublicPortfolioFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPublicPortfolioFoldersQuery, GetUserPublicPortfolioFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPublicPortfolioFoldersQuery, GetUserPublicPortfolioFoldersQueryVariables>(GetUserPublicPortfolioFoldersDocument, options);
        }
export function useGetUserPublicPortfolioFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPublicPortfolioFoldersQuery, GetUserPublicPortfolioFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPublicPortfolioFoldersQuery, GetUserPublicPortfolioFoldersQueryVariables>(GetUserPublicPortfolioFoldersDocument, options);
        }
export type GetUserPublicPortfolioFoldersQueryHookResult = ReturnType<typeof useGetUserPublicPortfolioFoldersQuery>;
export type GetUserPublicPortfolioFoldersLazyQueryHookResult = ReturnType<typeof useGetUserPublicPortfolioFoldersLazyQuery>;
export type GetUserPublicPortfolioFoldersSuspenseQueryHookResult = ReturnType<typeof useGetUserPublicPortfolioFoldersSuspenseQuery>;
export type GetUserPublicPortfolioFoldersQueryResult = Apollo.QueryResult<GetUserPublicPortfolioFoldersQuery, GetUserPublicPortfolioFoldersQueryVariables>;
export const GetPortfolioFolderItemsBulkDocument = gql`
    query getPortfolioFolderItemsBulk($folderIds: [ObjectId!]!, $limitPerFolder: Int) {
  getPortfolioFolderItemsBulk(
    folderIds: $folderIds
    limitPerFolder: $limitPerFolder
  ) {
    folderId
    totalCount
    collection {
      ...PortfolioFolderItem
    }
  }
}
    ${PortfolioFolderItemFragmentDoc}`;

/**
 * __useGetPortfolioFolderItemsBulkQuery__
 *
 * To run a query within a React component, call `useGetPortfolioFolderItemsBulkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioFolderItemsBulkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioFolderItemsBulkQuery({
 *   variables: {
 *      folderIds: // value for 'folderIds'
 *      limitPerFolder: // value for 'limitPerFolder'
 *   },
 * });
 */
export function useGetPortfolioFolderItemsBulkQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioFolderItemsBulkQuery, GetPortfolioFolderItemsBulkQueryVariables> & ({ variables: GetPortfolioFolderItemsBulkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioFolderItemsBulkQuery, GetPortfolioFolderItemsBulkQueryVariables>(GetPortfolioFolderItemsBulkDocument, options);
      }
export function useGetPortfolioFolderItemsBulkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioFolderItemsBulkQuery, GetPortfolioFolderItemsBulkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioFolderItemsBulkQuery, GetPortfolioFolderItemsBulkQueryVariables>(GetPortfolioFolderItemsBulkDocument, options);
        }
export function useGetPortfolioFolderItemsBulkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioFolderItemsBulkQuery, GetPortfolioFolderItemsBulkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioFolderItemsBulkQuery, GetPortfolioFolderItemsBulkQueryVariables>(GetPortfolioFolderItemsBulkDocument, options);
        }
export type GetPortfolioFolderItemsBulkQueryHookResult = ReturnType<typeof useGetPortfolioFolderItemsBulkQuery>;
export type GetPortfolioFolderItemsBulkLazyQueryHookResult = ReturnType<typeof useGetPortfolioFolderItemsBulkLazyQuery>;
export type GetPortfolioFolderItemsBulkSuspenseQueryHookResult = ReturnType<typeof useGetPortfolioFolderItemsBulkSuspenseQuery>;
export type GetPortfolioFolderItemsBulkQueryResult = Apollo.QueryResult<GetPortfolioFolderItemsBulkQuery, GetPortfolioFolderItemsBulkQueryVariables>;
export const ObservePortfoliosChangesDocument = gql`
    subscription observePortfoliosChanges {
  observePortfoliosChanges {
    trigger
    document {
      ...Portfolio
    }
  }
}
    ${PortfolioFragmentDoc}`;

/**
 * __useObservePortfoliosChangesSubscription__
 *
 * To run a query within a React component, call `useObservePortfoliosChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObservePortfoliosChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObservePortfoliosChangesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useObservePortfoliosChangesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ObservePortfoliosChangesSubscription, ObservePortfoliosChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObservePortfoliosChangesSubscription, ObservePortfoliosChangesSubscriptionVariables>(ObservePortfoliosChangesDocument, options);
      }
export type ObservePortfoliosChangesSubscriptionHookResult = ReturnType<typeof useObservePortfoliosChangesSubscription>;
export type ObservePortfoliosChangesSubscriptionResult = Apollo.SubscriptionResult<ObservePortfoliosChangesSubscription>;
export const AddPropertyToTrackDocument = gql`
    mutation addPropertyToTrack($propertyId: ObjectId!) {
  addPropertyToTrack(propertyId: $propertyId) {
    _id
  }
}
    `;
export type AddPropertyToTrackMutationFn = Apollo.MutationFunction<AddPropertyToTrackMutation, AddPropertyToTrackMutationVariables>;

/**
 * __useAddPropertyToTrackMutation__
 *
 * To run a mutation, you first call `useAddPropertyToTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPropertyToTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPropertyToTrackMutation, { data, loading, error }] = useAddPropertyToTrackMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useAddPropertyToTrackMutation(baseOptions?: Apollo.MutationHookOptions<AddPropertyToTrackMutation, AddPropertyToTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPropertyToTrackMutation, AddPropertyToTrackMutationVariables>(AddPropertyToTrackDocument, options);
      }
export type AddPropertyToTrackMutationHookResult = ReturnType<typeof useAddPropertyToTrackMutation>;
export type AddPropertyToTrackMutationResult = Apollo.MutationResult<AddPropertyToTrackMutation>;
export type AddPropertyToTrackMutationOptions = Apollo.BaseMutationOptions<AddPropertyToTrackMutation, AddPropertyToTrackMutationVariables>;
export const RemovePropertyFromTrackedDocument = gql`
    mutation removePropertyFromTracked($brokerTrackedPropertyId: ObjectId!) {
  removePropertyFromTracked(brokerTrackedPropertyId: $brokerTrackedPropertyId) {
    _id
  }
}
    `;
export type RemovePropertyFromTrackedMutationFn = Apollo.MutationFunction<RemovePropertyFromTrackedMutation, RemovePropertyFromTrackedMutationVariables>;

/**
 * __useRemovePropertyFromTrackedMutation__
 *
 * To run a mutation, you first call `useRemovePropertyFromTrackedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePropertyFromTrackedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePropertyFromTrackedMutation, { data, loading, error }] = useRemovePropertyFromTrackedMutation({
 *   variables: {
 *      brokerTrackedPropertyId: // value for 'brokerTrackedPropertyId'
 *   },
 * });
 */
export function useRemovePropertyFromTrackedMutation(baseOptions?: Apollo.MutationHookOptions<RemovePropertyFromTrackedMutation, RemovePropertyFromTrackedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePropertyFromTrackedMutation, RemovePropertyFromTrackedMutationVariables>(RemovePropertyFromTrackedDocument, options);
      }
export type RemovePropertyFromTrackedMutationHookResult = ReturnType<typeof useRemovePropertyFromTrackedMutation>;
export type RemovePropertyFromTrackedMutationResult = Apollo.MutationResult<RemovePropertyFromTrackedMutation>;
export type RemovePropertyFromTrackedMutationOptions = Apollo.BaseMutationOptions<RemovePropertyFromTrackedMutation, RemovePropertyFromTrackedMutationVariables>;
export const GetPropertiesForInputQueryDocument = gql`
    query getPropertiesForInputQuery($pagination: PaginationInput, $sort: [SortInput!], $filter: GetBrokerPropertiesFilterInput) {
  getBrokerProperties(pagination: $pagination, sort: $sort, filter: $filter) {
    collection {
      _id
      name
    }
    totalCount
  }
}
    `;

/**
 * __useGetPropertiesForInputQueryQuery__
 *
 * To run a query within a React component, call `useGetPropertiesForInputQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesForInputQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesForInputQueryQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPropertiesForInputQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertiesForInputQueryQuery, GetPropertiesForInputQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertiesForInputQueryQuery, GetPropertiesForInputQueryQueryVariables>(GetPropertiesForInputQueryDocument, options);
      }
export function useGetPropertiesForInputQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertiesForInputQueryQuery, GetPropertiesForInputQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertiesForInputQueryQuery, GetPropertiesForInputQueryQueryVariables>(GetPropertiesForInputQueryDocument, options);
        }
export function useGetPropertiesForInputQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertiesForInputQueryQuery, GetPropertiesForInputQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertiesForInputQueryQuery, GetPropertiesForInputQueryQueryVariables>(GetPropertiesForInputQueryDocument, options);
        }
export type GetPropertiesForInputQueryQueryHookResult = ReturnType<typeof useGetPropertiesForInputQueryQuery>;
export type GetPropertiesForInputQueryLazyQueryHookResult = ReturnType<typeof useGetPropertiesForInputQueryLazyQuery>;
export type GetPropertiesForInputQuerySuspenseQueryHookResult = ReturnType<typeof useGetPropertiesForInputQuerySuspenseQuery>;
export type GetPropertiesForInputQueryQueryResult = Apollo.QueryResult<GetPropertiesForInputQueryQuery, GetPropertiesForInputQueryQueryVariables>;
export const GetBrokerPropertiesForListDocument = gql`
    query getBrokerPropertiesForList($pagination: PaginationInput, $sort: [SortInput!], $filter: GetBrokerPropertiesFilterInput) {
  getBrokerProperties(pagination: $pagination, sort: $sort, filter: $filter) {
    collection {
      _id
      name
      averageBathroomsNumber {
        min
        max
      }
      averageBedroomsNumber {
        min
        max
      }
      averageBathroomsNumberValue {
        min
        max
      }
      averageBedroomsNumberValue {
        min
        max
      }
      mainPropertyMediaFile {
        _id
        files {
          _id
          type
          publicUrl
          thumbnailFileUrl
          thumbnailFile {
            publicUrl
          }
        }
      }
      priceRange {
        min
        max
      }
      numberOfUnits
      projectStatus
      yearBuilt
      cmsStatus
      lastUpdatedAtByChangelog
      lastChangelogType
      createdAt
      buildingTypes
      completionDate
      constructionStartDate
      amenityNames {
        name
      }
      verifiedAt
      market
      marketArea {
        ...MarketArea
      }
      location {
        geoLocation {
          coordinates
        }
        address {
          city
          county
          state
          street
        }
      }
      isMarkedAsVerified
    }
    totalCount
  }
}
    ${MarketAreaFragmentDoc}`;

/**
 * __useGetBrokerPropertiesForListQuery__
 *
 * To run a query within a React component, call `useGetBrokerPropertiesForListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerPropertiesForListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerPropertiesForListQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBrokerPropertiesForListQuery(baseOptions?: Apollo.QueryHookOptions<GetBrokerPropertiesForListQuery, GetBrokerPropertiesForListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokerPropertiesForListQuery, GetBrokerPropertiesForListQueryVariables>(GetBrokerPropertiesForListDocument, options);
      }
export function useGetBrokerPropertiesForListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokerPropertiesForListQuery, GetBrokerPropertiesForListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokerPropertiesForListQuery, GetBrokerPropertiesForListQueryVariables>(GetBrokerPropertiesForListDocument, options);
        }
export function useGetBrokerPropertiesForListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrokerPropertiesForListQuery, GetBrokerPropertiesForListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrokerPropertiesForListQuery, GetBrokerPropertiesForListQueryVariables>(GetBrokerPropertiesForListDocument, options);
        }
export type GetBrokerPropertiesForListQueryHookResult = ReturnType<typeof useGetBrokerPropertiesForListQuery>;
export type GetBrokerPropertiesForListLazyQueryHookResult = ReturnType<typeof useGetBrokerPropertiesForListLazyQuery>;
export type GetBrokerPropertiesForListSuspenseQueryHookResult = ReturnType<typeof useGetBrokerPropertiesForListSuspenseQuery>;
export type GetBrokerPropertiesForListQueryResult = Apollo.QueryResult<GetBrokerPropertiesForListQuery, GetBrokerPropertiesForListQueryVariables>;
export const GetBrokerPropertiesForMapDocument = gql`
    query getBrokerPropertiesForMap($pagination: PaginationInput, $sort: [SortInput!], $filter: GetBrokerPropertiesFilterInput) {
  getBrokerProperties(pagination: $pagination, sort: $sort, filter: $filter) {
    collection {
      _id
      name
      averageBathroomsNumberValue {
        min
        max
      }
      averageBedroomsNumberValue {
        min
        max
      }
      mainPropertyMediaFile {
        _id
        files {
          _id
          type
          publicUrl
          thumbnailFileUrl
          thumbnailFile {
            publicUrl
          }
        }
      }
      priceRange {
        min
        max
      }
      numberOfUnits
      projectStatus
      yearBuilt
      createdAt
      buildingTypes
      completionDate
      constructionStartDate
      verifiedAt
      market
      marketArea {
        ...MarketArea
      }
      location {
        geoLocation {
          coordinates
        }
        address {
          city
          county
          state
          street
          zipCode
        }
      }
      isMarkedAsVerified
    }
    totalCount
  }
}
    ${MarketAreaFragmentDoc}`;

/**
 * __useGetBrokerPropertiesForMapQuery__
 *
 * To run a query within a React component, call `useGetBrokerPropertiesForMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerPropertiesForMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerPropertiesForMapQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBrokerPropertiesForMapQuery(baseOptions?: Apollo.QueryHookOptions<GetBrokerPropertiesForMapQuery, GetBrokerPropertiesForMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokerPropertiesForMapQuery, GetBrokerPropertiesForMapQueryVariables>(GetBrokerPropertiesForMapDocument, options);
      }
export function useGetBrokerPropertiesForMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokerPropertiesForMapQuery, GetBrokerPropertiesForMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokerPropertiesForMapQuery, GetBrokerPropertiesForMapQueryVariables>(GetBrokerPropertiesForMapDocument, options);
        }
export function useGetBrokerPropertiesForMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrokerPropertiesForMapQuery, GetBrokerPropertiesForMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrokerPropertiesForMapQuery, GetBrokerPropertiesForMapQueryVariables>(GetBrokerPropertiesForMapDocument, options);
        }
export type GetBrokerPropertiesForMapQueryHookResult = ReturnType<typeof useGetBrokerPropertiesForMapQuery>;
export type GetBrokerPropertiesForMapLazyQueryHookResult = ReturnType<typeof useGetBrokerPropertiesForMapLazyQuery>;
export type GetBrokerPropertiesForMapSuspenseQueryHookResult = ReturnType<typeof useGetBrokerPropertiesForMapSuspenseQuery>;
export type GetBrokerPropertiesForMapQueryResult = Apollo.QueryResult<GetBrokerPropertiesForMapQuery, GetBrokerPropertiesForMapQueryVariables>;
export const GetPropertyByIdDocument = gql`
    query getPropertyById($propertyId: ObjectId!) {
  getPropertyById(propertyId: $propertyId) {
    ...Property
  }
}
    ${PropertyFragmentDoc}`;

/**
 * __useGetPropertyByIdQuery__
 *
 * To run a query within a React component, call `useGetPropertyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyByIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropertyByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyByIdQuery, GetPropertyByIdQueryVariables> & ({ variables: GetPropertyByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>(GetPropertyByIdDocument, options);
      }
export function useGetPropertyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>(GetPropertyByIdDocument, options);
        }
export function useGetPropertyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>(GetPropertyByIdDocument, options);
        }
export type GetPropertyByIdQueryHookResult = ReturnType<typeof useGetPropertyByIdQuery>;
export type GetPropertyByIdLazyQueryHookResult = ReturnType<typeof useGetPropertyByIdLazyQuery>;
export type GetPropertyByIdSuspenseQueryHookResult = ReturnType<typeof useGetPropertyByIdSuspenseQuery>;
export type GetPropertyByIdQueryResult = Apollo.QueryResult<GetPropertyByIdQuery, GetPropertyByIdQueryVariables>;
export const GetPublicBrokerPortfolioDocument = gql`
    query getPublicBrokerPortfolio($brokerId: String!, $password: String, $portfolioFolderName: String, $portfolioName: String!) {
  getPublicBrokerPortfolio(
    brokerId: $brokerId
    password: $password
    portfolioName: $portfolioName
    portfolioFolderName: $portfolioFolderName
  ) {
    _id
    portfolioFolderId
    isAddedMediaKit
    brokerId
    property {
      ...Property
    }
  }
}
    ${PropertyFragmentDoc}`;

/**
 * __useGetPublicBrokerPortfolioQuery__
 *
 * To run a query within a React component, call `useGetPublicBrokerPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicBrokerPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicBrokerPortfolioQuery({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *      password: // value for 'password'
 *      portfolioFolderName: // value for 'portfolioFolderName'
 *      portfolioName: // value for 'portfolioName'
 *   },
 * });
 */
export function useGetPublicBrokerPortfolioQuery(baseOptions: Apollo.QueryHookOptions<GetPublicBrokerPortfolioQuery, GetPublicBrokerPortfolioQueryVariables> & ({ variables: GetPublicBrokerPortfolioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicBrokerPortfolioQuery, GetPublicBrokerPortfolioQueryVariables>(GetPublicBrokerPortfolioDocument, options);
      }
export function useGetPublicBrokerPortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicBrokerPortfolioQuery, GetPublicBrokerPortfolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicBrokerPortfolioQuery, GetPublicBrokerPortfolioQueryVariables>(GetPublicBrokerPortfolioDocument, options);
        }
export function useGetPublicBrokerPortfolioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicBrokerPortfolioQuery, GetPublicBrokerPortfolioQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicBrokerPortfolioQuery, GetPublicBrokerPortfolioQueryVariables>(GetPublicBrokerPortfolioDocument, options);
        }
export type GetPublicBrokerPortfolioQueryHookResult = ReturnType<typeof useGetPublicBrokerPortfolioQuery>;
export type GetPublicBrokerPortfolioLazyQueryHookResult = ReturnType<typeof useGetPublicBrokerPortfolioLazyQuery>;
export type GetPublicBrokerPortfolioSuspenseQueryHookResult = ReturnType<typeof useGetPublicBrokerPortfolioSuspenseQuery>;
export type GetPublicBrokerPortfolioQueryResult = Apollo.QueryResult<GetPublicBrokerPortfolioQuery, GetPublicBrokerPortfolioQueryVariables>;
export const GetPropertyChangelogsDocument = gql`
    query getPropertyChangelogs($filter: GetPropertyChangelogsFilterInput!, $sort: [SortInput!], $pagination: PaginationInput) {
  getPropertyChangelogs(filter: $filter, sort: $sort, pagination: $pagination) {
    collection {
      ...PropertyChangelog
    }
    totalCount
  }
}
    ${PropertyChangelogFragmentDoc}`;

/**
 * __useGetPropertyChangelogsQuery__
 *
 * To run a query within a React component, call `useGetPropertyChangelogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyChangelogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyChangelogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetPropertyChangelogsQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables> & ({ variables: GetPropertyChangelogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables>(GetPropertyChangelogsDocument, options);
      }
export function useGetPropertyChangelogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables>(GetPropertyChangelogsDocument, options);
        }
export function useGetPropertyChangelogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables>(GetPropertyChangelogsDocument, options);
        }
export type GetPropertyChangelogsQueryHookResult = ReturnType<typeof useGetPropertyChangelogsQuery>;
export type GetPropertyChangelogsLazyQueryHookResult = ReturnType<typeof useGetPropertyChangelogsLazyQuery>;
export type GetPropertyChangelogsSuspenseQueryHookResult = ReturnType<typeof useGetPropertyChangelogsSuspenseQuery>;
export type GetPropertyChangelogsQueryResult = Apollo.QueryResult<GetPropertyChangelogsQuery, GetPropertyChangelogsQueryVariables>;
export const GetPortfolioPropertiesChangelogsDocument = gql`
    query getPortfolioPropertiesChangelogs($filter: GetPortfolioPropertiesChangelogsFilterInput!, $sort: [SortInput!], $pagination: PaginationInput) {
  getPortfolioPropertiesChangelogs(
    filter: $filter
    sort: $sort
    pagination: $pagination
  ) {
    collection {
      ...PropertyChangelog
    }
    totalCount
  }
}
    ${PropertyChangelogFragmentDoc}`;

/**
 * __useGetPortfolioPropertiesChangelogsQuery__
 *
 * To run a query within a React component, call `useGetPortfolioPropertiesChangelogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioPropertiesChangelogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioPropertiesChangelogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetPortfolioPropertiesChangelogsQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioPropertiesChangelogsQuery, GetPortfolioPropertiesChangelogsQueryVariables> & ({ variables: GetPortfolioPropertiesChangelogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioPropertiesChangelogsQuery, GetPortfolioPropertiesChangelogsQueryVariables>(GetPortfolioPropertiesChangelogsDocument, options);
      }
export function useGetPortfolioPropertiesChangelogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioPropertiesChangelogsQuery, GetPortfolioPropertiesChangelogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioPropertiesChangelogsQuery, GetPortfolioPropertiesChangelogsQueryVariables>(GetPortfolioPropertiesChangelogsDocument, options);
        }
export function useGetPortfolioPropertiesChangelogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioPropertiesChangelogsQuery, GetPortfolioPropertiesChangelogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioPropertiesChangelogsQuery, GetPortfolioPropertiesChangelogsQueryVariables>(GetPortfolioPropertiesChangelogsDocument, options);
        }
export type GetPortfolioPropertiesChangelogsQueryHookResult = ReturnType<typeof useGetPortfolioPropertiesChangelogsQuery>;
export type GetPortfolioPropertiesChangelogsLazyQueryHookResult = ReturnType<typeof useGetPortfolioPropertiesChangelogsLazyQuery>;
export type GetPortfolioPropertiesChangelogsSuspenseQueryHookResult = ReturnType<typeof useGetPortfolioPropertiesChangelogsSuspenseQuery>;
export type GetPortfolioPropertiesChangelogsQueryResult = Apollo.QueryResult<GetPortfolioPropertiesChangelogsQuery, GetPortfolioPropertiesChangelogsQueryVariables>;
export const GetNumberOfPortfolioPropertiesChangelogsDocument = gql`
    query getNumberOfPortfolioPropertiesChangelogs($dateRange: PartialDateRangeInput) {
  getNumberOfPortfolioPropertiesChangelogs(dateRange: $dateRange)
}
    `;

/**
 * __useGetNumberOfPortfolioPropertiesChangelogsQuery__
 *
 * To run a query within a React component, call `useGetNumberOfPortfolioPropertiesChangelogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfPortfolioPropertiesChangelogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfPortfolioPropertiesChangelogsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetNumberOfPortfolioPropertiesChangelogsQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfPortfolioPropertiesChangelogsQuery, GetNumberOfPortfolioPropertiesChangelogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfPortfolioPropertiesChangelogsQuery, GetNumberOfPortfolioPropertiesChangelogsQueryVariables>(GetNumberOfPortfolioPropertiesChangelogsDocument, options);
      }
export function useGetNumberOfPortfolioPropertiesChangelogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfPortfolioPropertiesChangelogsQuery, GetNumberOfPortfolioPropertiesChangelogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfPortfolioPropertiesChangelogsQuery, GetNumberOfPortfolioPropertiesChangelogsQueryVariables>(GetNumberOfPortfolioPropertiesChangelogsDocument, options);
        }
export function useGetNumberOfPortfolioPropertiesChangelogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfPortfolioPropertiesChangelogsQuery, GetNumberOfPortfolioPropertiesChangelogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfPortfolioPropertiesChangelogsQuery, GetNumberOfPortfolioPropertiesChangelogsQueryVariables>(GetNumberOfPortfolioPropertiesChangelogsDocument, options);
        }
export type GetNumberOfPortfolioPropertiesChangelogsQueryHookResult = ReturnType<typeof useGetNumberOfPortfolioPropertiesChangelogsQuery>;
export type GetNumberOfPortfolioPropertiesChangelogsLazyQueryHookResult = ReturnType<typeof useGetNumberOfPortfolioPropertiesChangelogsLazyQuery>;
export type GetNumberOfPortfolioPropertiesChangelogsSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfPortfolioPropertiesChangelogsSuspenseQuery>;
export type GetNumberOfPortfolioPropertiesChangelogsQueryResult = Apollo.QueryResult<GetNumberOfPortfolioPropertiesChangelogsQuery, GetNumberOfPortfolioPropertiesChangelogsQueryVariables>;
export const GetUniqPropertiesAmenitiesDocument = gql`
    query getUniqPropertiesAmenities($searchText: String, $sort: [SortInput!], $pagination: PaginationInput) {
  getUniqPropertiesAmenities(
    sort: $sort
    pagination: $pagination
    searchText: $searchText
  )
}
    `;

/**
 * __useGetUniqPropertiesAmenitiesQuery__
 *
 * To run a query within a React component, call `useGetUniqPropertiesAmenitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqPropertiesAmenitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqPropertiesAmenitiesQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetUniqPropertiesAmenitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetUniqPropertiesAmenitiesQuery, GetUniqPropertiesAmenitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniqPropertiesAmenitiesQuery, GetUniqPropertiesAmenitiesQueryVariables>(GetUniqPropertiesAmenitiesDocument, options);
      }
export function useGetUniqPropertiesAmenitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniqPropertiesAmenitiesQuery, GetUniqPropertiesAmenitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniqPropertiesAmenitiesQuery, GetUniqPropertiesAmenitiesQueryVariables>(GetUniqPropertiesAmenitiesDocument, options);
        }
export function useGetUniqPropertiesAmenitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniqPropertiesAmenitiesQuery, GetUniqPropertiesAmenitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniqPropertiesAmenitiesQuery, GetUniqPropertiesAmenitiesQueryVariables>(GetUniqPropertiesAmenitiesDocument, options);
        }
export type GetUniqPropertiesAmenitiesQueryHookResult = ReturnType<typeof useGetUniqPropertiesAmenitiesQuery>;
export type GetUniqPropertiesAmenitiesLazyQueryHookResult = ReturnType<typeof useGetUniqPropertiesAmenitiesLazyQuery>;
export type GetUniqPropertiesAmenitiesSuspenseQueryHookResult = ReturnType<typeof useGetUniqPropertiesAmenitiesSuspenseQuery>;
export type GetUniqPropertiesAmenitiesQueryResult = Apollo.QueryResult<GetUniqPropertiesAmenitiesQuery, GetUniqPropertiesAmenitiesQueryVariables>;
export const GetTrackedPropertiesDocument = gql`
    query getTrackedProperties($filter: GetTrackedPropertiesFilterInput!, $sort: [SortInput!], $pagination: PaginationInput) {
  getTrackedProperties(filter: $filter, sort: $sort, pagination: $pagination) {
    collection {
      ...BrokerTrackedProperty
    }
    totalCount
  }
}
    ${BrokerTrackedPropertyFragmentDoc}`;

/**
 * __useGetTrackedPropertiesQuery__
 *
 * To run a query within a React component, call `useGetTrackedPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackedPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackedPropertiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTrackedPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetTrackedPropertiesQuery, GetTrackedPropertiesQueryVariables> & ({ variables: GetTrackedPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackedPropertiesQuery, GetTrackedPropertiesQueryVariables>(GetTrackedPropertiesDocument, options);
      }
export function useGetTrackedPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackedPropertiesQuery, GetTrackedPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackedPropertiesQuery, GetTrackedPropertiesQueryVariables>(GetTrackedPropertiesDocument, options);
        }
export function useGetTrackedPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrackedPropertiesQuery, GetTrackedPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrackedPropertiesQuery, GetTrackedPropertiesQueryVariables>(GetTrackedPropertiesDocument, options);
        }
export type GetTrackedPropertiesQueryHookResult = ReturnType<typeof useGetTrackedPropertiesQuery>;
export type GetTrackedPropertiesLazyQueryHookResult = ReturnType<typeof useGetTrackedPropertiesLazyQuery>;
export type GetTrackedPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetTrackedPropertiesSuspenseQuery>;
export type GetTrackedPropertiesQueryResult = Apollo.QueryResult<GetTrackedPropertiesQuery, GetTrackedPropertiesQueryVariables>;
export const GetIsPropertyTrackedDocument = gql`
    query getIsPropertyTracked($propertyId: ObjectId!) {
  getIsPropertyTracked(propertyId: $propertyId) {
    _id
  }
}
    `;

/**
 * __useGetIsPropertyTrackedQuery__
 *
 * To run a query within a React component, call `useGetIsPropertyTrackedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsPropertyTrackedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsPropertyTrackedQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetIsPropertyTrackedQuery(baseOptions: Apollo.QueryHookOptions<GetIsPropertyTrackedQuery, GetIsPropertyTrackedQueryVariables> & ({ variables: GetIsPropertyTrackedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsPropertyTrackedQuery, GetIsPropertyTrackedQueryVariables>(GetIsPropertyTrackedDocument, options);
      }
export function useGetIsPropertyTrackedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsPropertyTrackedQuery, GetIsPropertyTrackedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsPropertyTrackedQuery, GetIsPropertyTrackedQueryVariables>(GetIsPropertyTrackedDocument, options);
        }
export function useGetIsPropertyTrackedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsPropertyTrackedQuery, GetIsPropertyTrackedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsPropertyTrackedQuery, GetIsPropertyTrackedQueryVariables>(GetIsPropertyTrackedDocument, options);
        }
export type GetIsPropertyTrackedQueryHookResult = ReturnType<typeof useGetIsPropertyTrackedQuery>;
export type GetIsPropertyTrackedLazyQueryHookResult = ReturnType<typeof useGetIsPropertyTrackedLazyQuery>;
export type GetIsPropertyTrackedSuspenseQueryHookResult = ReturnType<typeof useGetIsPropertyTrackedSuspenseQuery>;
export type GetIsPropertyTrackedQueryResult = Apollo.QueryResult<GetIsPropertyTrackedQuery, GetIsPropertyTrackedQueryVariables>;
export const GetTrackedPropertiesCountDocument = gql`
    query getTrackedPropertiesCount($filter: GetTrackedPropertiesFilterInput, $sort: [SortInput!], $pagination: PaginationInput) {
  getTrackedProperties(filter: $filter, sort: $sort, pagination: $pagination) {
    totalCount
  }
}
    `;

/**
 * __useGetTrackedPropertiesCountQuery__
 *
 * To run a query within a React component, call `useGetTrackedPropertiesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackedPropertiesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackedPropertiesCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTrackedPropertiesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetTrackedPropertiesCountQuery, GetTrackedPropertiesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackedPropertiesCountQuery, GetTrackedPropertiesCountQueryVariables>(GetTrackedPropertiesCountDocument, options);
      }
export function useGetTrackedPropertiesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackedPropertiesCountQuery, GetTrackedPropertiesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackedPropertiesCountQuery, GetTrackedPropertiesCountQueryVariables>(GetTrackedPropertiesCountDocument, options);
        }
export function useGetTrackedPropertiesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrackedPropertiesCountQuery, GetTrackedPropertiesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrackedPropertiesCountQuery, GetTrackedPropertiesCountQueryVariables>(GetTrackedPropertiesCountDocument, options);
        }
export type GetTrackedPropertiesCountQueryHookResult = ReturnType<typeof useGetTrackedPropertiesCountQuery>;
export type GetTrackedPropertiesCountLazyQueryHookResult = ReturnType<typeof useGetTrackedPropertiesCountLazyQuery>;
export type GetTrackedPropertiesCountSuspenseQueryHookResult = ReturnType<typeof useGetTrackedPropertiesCountSuspenseQuery>;
export type GetTrackedPropertiesCountQueryResult = Apollo.QueryResult<GetTrackedPropertiesCountQuery, GetTrackedPropertiesCountQueryVariables>;
export const GetTrackedPropertyIdsDocument = gql`
    query getTrackedPropertyIds {
  getTrackedPropertyIds {
    _id
    propertyId
  }
}
    `;

/**
 * __useGetTrackedPropertyIdsQuery__
 *
 * To run a query within a React component, call `useGetTrackedPropertyIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackedPropertyIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackedPropertyIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrackedPropertyIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetTrackedPropertyIdsQuery, GetTrackedPropertyIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackedPropertyIdsQuery, GetTrackedPropertyIdsQueryVariables>(GetTrackedPropertyIdsDocument, options);
      }
export function useGetTrackedPropertyIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackedPropertyIdsQuery, GetTrackedPropertyIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackedPropertyIdsQuery, GetTrackedPropertyIdsQueryVariables>(GetTrackedPropertyIdsDocument, options);
        }
export function useGetTrackedPropertyIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrackedPropertyIdsQuery, GetTrackedPropertyIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrackedPropertyIdsQuery, GetTrackedPropertyIdsQueryVariables>(GetTrackedPropertyIdsDocument, options);
        }
export type GetTrackedPropertyIdsQueryHookResult = ReturnType<typeof useGetTrackedPropertyIdsQuery>;
export type GetTrackedPropertyIdsLazyQueryHookResult = ReturnType<typeof useGetTrackedPropertyIdsLazyQuery>;
export type GetTrackedPropertyIdsSuspenseQueryHookResult = ReturnType<typeof useGetTrackedPropertyIdsSuspenseQuery>;
export type GetTrackedPropertyIdsQueryResult = Apollo.QueryResult<GetTrackedPropertyIdsQuery, GetTrackedPropertyIdsQueryVariables>;
export const GetUniqPropertiesMarketsDocument = gql`
    query getUniqPropertiesMarkets {
  getUniqPropertiesMarkets {
    _id
    name
  }
}
    `;

/**
 * __useGetUniqPropertiesMarketsQuery__
 *
 * To run a query within a React component, call `useGetUniqPropertiesMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqPropertiesMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqPropertiesMarketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUniqPropertiesMarketsQuery(baseOptions?: Apollo.QueryHookOptions<GetUniqPropertiesMarketsQuery, GetUniqPropertiesMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniqPropertiesMarketsQuery, GetUniqPropertiesMarketsQueryVariables>(GetUniqPropertiesMarketsDocument, options);
      }
export function useGetUniqPropertiesMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniqPropertiesMarketsQuery, GetUniqPropertiesMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniqPropertiesMarketsQuery, GetUniqPropertiesMarketsQueryVariables>(GetUniqPropertiesMarketsDocument, options);
        }
export function useGetUniqPropertiesMarketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniqPropertiesMarketsQuery, GetUniqPropertiesMarketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniqPropertiesMarketsQuery, GetUniqPropertiesMarketsQueryVariables>(GetUniqPropertiesMarketsDocument, options);
        }
export type GetUniqPropertiesMarketsQueryHookResult = ReturnType<typeof useGetUniqPropertiesMarketsQuery>;
export type GetUniqPropertiesMarketsLazyQueryHookResult = ReturnType<typeof useGetUniqPropertiesMarketsLazyQuery>;
export type GetUniqPropertiesMarketsSuspenseQueryHookResult = ReturnType<typeof useGetUniqPropertiesMarketsSuspenseQuery>;
export type GetUniqPropertiesMarketsQueryResult = Apollo.QueryResult<GetUniqPropertiesMarketsQuery, GetUniqPropertiesMarketsQueryVariables>;
export const ObservePropertiesChangesDocument = gql`
    subscription observePropertiesChanges {
  observePropertiesChanges {
    trigger
    document {
      _id
      status
      name
      location {
        _id
        address {
          city
          county
          state
          street
          zipCode
        }
      }
    }
  }
}
    `;

/**
 * __useObservePropertiesChangesSubscription__
 *
 * To run a query within a React component, call `useObservePropertiesChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObservePropertiesChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObservePropertiesChangesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useObservePropertiesChangesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ObservePropertiesChangesSubscription, ObservePropertiesChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObservePropertiesChangesSubscription, ObservePropertiesChangesSubscriptionVariables>(ObservePropertiesChangesDocument, options);
      }
export type ObservePropertiesChangesSubscriptionHookResult = ReturnType<typeof useObservePropertiesChangesSubscription>;
export type ObservePropertiesChangesSubscriptionResult = Apollo.SubscriptionResult<ObservePropertiesChangesSubscription>;
export const SimilarPropertiesDocument = gql`
    query similarProperties($propertyId: ID!) {
  similarProperties(propertyId: $propertyId) {
    ...RecommendationCardProperty
  }
}
    ${RecommendationCardPropertyFragmentDoc}`;

/**
 * __useSimilarPropertiesQuery__
 *
 * To run a query within a React component, call `useSimilarPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarPropertiesQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useSimilarPropertiesQuery(baseOptions: Apollo.QueryHookOptions<SimilarPropertiesQuery, SimilarPropertiesQueryVariables> & ({ variables: SimilarPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarPropertiesQuery, SimilarPropertiesQueryVariables>(SimilarPropertiesDocument, options);
      }
export function useSimilarPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarPropertiesQuery, SimilarPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarPropertiesQuery, SimilarPropertiesQueryVariables>(SimilarPropertiesDocument, options);
        }
export function useSimilarPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarPropertiesQuery, SimilarPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimilarPropertiesQuery, SimilarPropertiesQueryVariables>(SimilarPropertiesDocument, options);
        }
export type SimilarPropertiesQueryHookResult = ReturnType<typeof useSimilarPropertiesQuery>;
export type SimilarPropertiesLazyQueryHookResult = ReturnType<typeof useSimilarPropertiesLazyQuery>;
export type SimilarPropertiesSuspenseQueryHookResult = ReturnType<typeof useSimilarPropertiesSuspenseQuery>;
export type SimilarPropertiesQueryResult = Apollo.QueryResult<SimilarPropertiesQuery, SimilarPropertiesQueryVariables>;
export const RecommendedPropertiesDocument = gql`
    query recommendedProperties($excludePropertyIds: [ID!]) {
  recommendedProperties(excludePropertyIds: $excludePropertyIds) {
    ...RecommendationCardProperty
  }
}
    ${RecommendationCardPropertyFragmentDoc}`;

/**
 * __useRecommendedPropertiesQuery__
 *
 * To run a query within a React component, call `useRecommendedPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedPropertiesQuery({
 *   variables: {
 *      excludePropertyIds: // value for 'excludePropertyIds'
 *   },
 * });
 */
export function useRecommendedPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<RecommendedPropertiesQuery, RecommendedPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedPropertiesQuery, RecommendedPropertiesQueryVariables>(RecommendedPropertiesDocument, options);
      }
export function useRecommendedPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedPropertiesQuery, RecommendedPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedPropertiesQuery, RecommendedPropertiesQueryVariables>(RecommendedPropertiesDocument, options);
        }
export function useRecommendedPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendedPropertiesQuery, RecommendedPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendedPropertiesQuery, RecommendedPropertiesQueryVariables>(RecommendedPropertiesDocument, options);
        }
export type RecommendedPropertiesQueryHookResult = ReturnType<typeof useRecommendedPropertiesQuery>;
export type RecommendedPropertiesLazyQueryHookResult = ReturnType<typeof useRecommendedPropertiesLazyQuery>;
export type RecommendedPropertiesSuspenseQueryHookResult = ReturnType<typeof useRecommendedPropertiesSuspenseQuery>;
export type RecommendedPropertiesQueryResult = Apollo.QueryResult<RecommendedPropertiesQuery, RecommendedPropertiesQueryVariables>;
export const GlobalSearchDocument = gql`
    query globalSearch($query: String!, $limit: Int, $type: String) {
  globalSearch(query: $query, limit: $limit, type: $type) {
    collection {
      _id
      refId
      type
      subtype
      refs {
        propertyId
        locationId
        organizationId
        marketAreaId
        stateId
      }
      search {
        primaryTokens
        secondaryTokens
      }
      display {
        title
        subtitle
      }
      meta {
        isActive
        popularityScore
        updatedAt
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGlobalSearchQuery__
 *
 * To run a query within a React component, call `useGlobalSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGlobalSearchQuery(baseOptions: Apollo.QueryHookOptions<GlobalSearchQuery, GlobalSearchQueryVariables> & ({ variables: GlobalSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, options);
      }
export function useGlobalSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalSearchQuery, GlobalSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, options);
        }
export function useGlobalSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalSearchQuery, GlobalSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, options);
        }
export type GlobalSearchQueryHookResult = ReturnType<typeof useGlobalSearchQuery>;
export type GlobalSearchLazyQueryHookResult = ReturnType<typeof useGlobalSearchLazyQuery>;
export type GlobalSearchSuspenseQueryHookResult = ReturnType<typeof useGlobalSearchSuspenseQuery>;
export type GlobalSearchQueryResult = Apollo.QueryResult<GlobalSearchQuery, GlobalSearchQueryVariables>;
export const GetUsStatesDocument = gql`
    query getUSStates($filter: GetStatesFilterInput) {
  getUSStates(filter: $filter) {
    ...State
  }
}
    ${StateFragmentDoc}`;

/**
 * __useGetUsStatesQuery__
 *
 * To run a query within a React component, call `useGetUsStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsStatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUsStatesQuery(baseOptions?: Apollo.QueryHookOptions<GetUsStatesQuery, GetUsStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsStatesQuery, GetUsStatesQueryVariables>(GetUsStatesDocument, options);
      }
export function useGetUsStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsStatesQuery, GetUsStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsStatesQuery, GetUsStatesQueryVariables>(GetUsStatesDocument, options);
        }
export function useGetUsStatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsStatesQuery, GetUsStatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsStatesQuery, GetUsStatesQueryVariables>(GetUsStatesDocument, options);
        }
export type GetUsStatesQueryHookResult = ReturnType<typeof useGetUsStatesQuery>;
export type GetUsStatesLazyQueryHookResult = ReturnType<typeof useGetUsStatesLazyQuery>;
export type GetUsStatesSuspenseQueryHookResult = ReturnType<typeof useGetUsStatesSuspenseQuery>;
export type GetUsStatesQueryResult = Apollo.QueryResult<GetUsStatesQuery, GetUsStatesQueryVariables>;
export const GetUsStateByNameDocument = gql`
    query getUSStateByName($stateName: String!) {
  getUSStateByName(stateName: $stateName) {
    ...State
  }
}
    ${StateFragmentDoc}`;

/**
 * __useGetUsStateByNameQuery__
 *
 * To run a query within a React component, call `useGetUsStateByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsStateByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsStateByNameQuery({
 *   variables: {
 *      stateName: // value for 'stateName'
 *   },
 * });
 */
export function useGetUsStateByNameQuery(baseOptions: Apollo.QueryHookOptions<GetUsStateByNameQuery, GetUsStateByNameQueryVariables> & ({ variables: GetUsStateByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsStateByNameQuery, GetUsStateByNameQueryVariables>(GetUsStateByNameDocument, options);
      }
export function useGetUsStateByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsStateByNameQuery, GetUsStateByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsStateByNameQuery, GetUsStateByNameQueryVariables>(GetUsStateByNameDocument, options);
        }
export function useGetUsStateByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsStateByNameQuery, GetUsStateByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsStateByNameQuery, GetUsStateByNameQueryVariables>(GetUsStateByNameDocument, options);
        }
export type GetUsStateByNameQueryHookResult = ReturnType<typeof useGetUsStateByNameQuery>;
export type GetUsStateByNameLazyQueryHookResult = ReturnType<typeof useGetUsStateByNameLazyQuery>;
export type GetUsStateByNameSuspenseQueryHookResult = ReturnType<typeof useGetUsStateByNameSuspenseQuery>;
export type GetUsStateByNameQueryResult = Apollo.QueryResult<GetUsStateByNameQuery, GetUsStateByNameQueryVariables>;
export const CreateProductSubscriptionDocument = gql`
    mutation createProductSubscription($input: CreateProductSubscriptionInput!) {
  createProductSubscription(input: $input) {
    productSubscription {
      ...ProductSubscription
    }
    productSubscriptionPayment {
      ...ProductSubscriptionPayment
    }
  }
}
    ${ProductSubscriptionFragmentDoc}
${ProductSubscriptionPaymentFragmentDoc}`;
export type CreateProductSubscriptionMutationFn = Apollo.MutationFunction<CreateProductSubscriptionMutation, CreateProductSubscriptionMutationVariables>;

/**
 * __useCreateProductSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateProductSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductSubscriptionMutation, { data, loading, error }] = useCreateProductSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductSubscriptionMutation, CreateProductSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductSubscriptionMutation, CreateProductSubscriptionMutationVariables>(CreateProductSubscriptionDocument, options);
      }
export type CreateProductSubscriptionMutationHookResult = ReturnType<typeof useCreateProductSubscriptionMutation>;
export type CreateProductSubscriptionMutationResult = Apollo.MutationResult<CreateProductSubscriptionMutation>;
export type CreateProductSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateProductSubscriptionMutation, CreateProductSubscriptionMutationVariables>;
export const CancelProductSubscriptionDocument = gql`
    mutation cancelProductSubscription($input: CancelProductSubscriptionInput!) {
  cancelProductSubscription(input: $input) {
    ...ProductSubscription
  }
}
    ${ProductSubscriptionFragmentDoc}`;
export type CancelProductSubscriptionMutationFn = Apollo.MutationFunction<CancelProductSubscriptionMutation, CancelProductSubscriptionMutationVariables>;

/**
 * __useCancelProductSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelProductSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelProductSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelProductSubscriptionMutation, { data, loading, error }] = useCancelProductSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelProductSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelProductSubscriptionMutation, CancelProductSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelProductSubscriptionMutation, CancelProductSubscriptionMutationVariables>(CancelProductSubscriptionDocument, options);
      }
export type CancelProductSubscriptionMutationHookResult = ReturnType<typeof useCancelProductSubscriptionMutation>;
export type CancelProductSubscriptionMutationResult = Apollo.MutationResult<CancelProductSubscriptionMutation>;
export type CancelProductSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelProductSubscriptionMutation, CancelProductSubscriptionMutationVariables>;
export const ChangeCurrentProductSubscriptionDocument = gql`
    mutation changeCurrentProductSubscription($input: UpdateProductSubscriptionInput!) {
  changeCurrentProductSubscription(input: $input) {
    productSubscription {
      ...ProductSubscription
    }
    productSubscriptionPayment {
      ...ProductSubscriptionPayment
    }
  }
}
    ${ProductSubscriptionFragmentDoc}
${ProductSubscriptionPaymentFragmentDoc}`;
export type ChangeCurrentProductSubscriptionMutationFn = Apollo.MutationFunction<ChangeCurrentProductSubscriptionMutation, ChangeCurrentProductSubscriptionMutationVariables>;

/**
 * __useChangeCurrentProductSubscriptionMutation__
 *
 * To run a mutation, you first call `useChangeCurrentProductSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCurrentProductSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCurrentProductSubscriptionMutation, { data, loading, error }] = useChangeCurrentProductSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCurrentProductSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCurrentProductSubscriptionMutation, ChangeCurrentProductSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCurrentProductSubscriptionMutation, ChangeCurrentProductSubscriptionMutationVariables>(ChangeCurrentProductSubscriptionDocument, options);
      }
export type ChangeCurrentProductSubscriptionMutationHookResult = ReturnType<typeof useChangeCurrentProductSubscriptionMutation>;
export type ChangeCurrentProductSubscriptionMutationResult = Apollo.MutationResult<ChangeCurrentProductSubscriptionMutation>;
export type ChangeCurrentProductSubscriptionMutationOptions = Apollo.BaseMutationOptions<ChangeCurrentProductSubscriptionMutation, ChangeCurrentProductSubscriptionMutationVariables>;
export const ScheduleDowngradeDocument = gql`
    mutation scheduleDowngrade($input: ScheduleDowngradeInput!) {
  scheduleDowngrade(input: $input) {
    nextPhasePriceId
    nextPhaseStart
    scheduleId
  }
}
    `;
export type ScheduleDowngradeMutationFn = Apollo.MutationFunction<ScheduleDowngradeMutation, ScheduleDowngradeMutationVariables>;

/**
 * __useScheduleDowngradeMutation__
 *
 * To run a mutation, you first call `useScheduleDowngradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleDowngradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleDowngradeMutation, { data, loading, error }] = useScheduleDowngradeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleDowngradeMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleDowngradeMutation, ScheduleDowngradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleDowngradeMutation, ScheduleDowngradeMutationVariables>(ScheduleDowngradeDocument, options);
      }
export type ScheduleDowngradeMutationHookResult = ReturnType<typeof useScheduleDowngradeMutation>;
export type ScheduleDowngradeMutationResult = Apollo.MutationResult<ScheduleDowngradeMutation>;
export type ScheduleDowngradeMutationOptions = Apollo.BaseMutationOptions<ScheduleDowngradeMutation, ScheduleDowngradeMutationVariables>;
export const CancelScheduledDowngradeDocument = gql`
    mutation cancelScheduledDowngrade {
  cancelScheduledDowngrade {
    ...ProductSubscription
  }
}
    ${ProductSubscriptionFragmentDoc}`;
export type CancelScheduledDowngradeMutationFn = Apollo.MutationFunction<CancelScheduledDowngradeMutation, CancelScheduledDowngradeMutationVariables>;

/**
 * __useCancelScheduledDowngradeMutation__
 *
 * To run a mutation, you first call `useCancelScheduledDowngradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledDowngradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledDowngradeMutation, { data, loading, error }] = useCancelScheduledDowngradeMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelScheduledDowngradeMutation(baseOptions?: Apollo.MutationHookOptions<CancelScheduledDowngradeMutation, CancelScheduledDowngradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelScheduledDowngradeMutation, CancelScheduledDowngradeMutationVariables>(CancelScheduledDowngradeDocument, options);
      }
export type CancelScheduledDowngradeMutationHookResult = ReturnType<typeof useCancelScheduledDowngradeMutation>;
export type CancelScheduledDowngradeMutationResult = Apollo.MutationResult<CancelScheduledDowngradeMutation>;
export type CancelScheduledDowngradeMutationOptions = Apollo.BaseMutationOptions<CancelScheduledDowngradeMutation, CancelScheduledDowngradeMutationVariables>;
export const CreateCheckoutSessionDocument = gql`
    mutation createCheckoutSession($input: CreateCheckoutSessionInput!) {
  createCheckoutSession(input: $input) {
    sessionUrl
  }
}
    `;
export type CreateCheckoutSessionMutationFn = Apollo.MutationFunction<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;

/**
 * __useCreateCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutSessionMutation, { data, loading, error }] = useCreateCheckoutSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(CreateCheckoutSessionDocument, options);
      }
export type CreateCheckoutSessionMutationHookResult = ReturnType<typeof useCreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationResult = Apollo.MutationResult<CreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const RetryProductSubscriptionChargeDocument = gql`
    mutation retryProductSubscriptionCharge {
  retryProductSubscriptionCharge {
    productSubscription {
      ...ProductSubscription
    }
    productSubscriptionPayment {
      ...ProductSubscriptionPayment
    }
  }
}
    ${ProductSubscriptionFragmentDoc}
${ProductSubscriptionPaymentFragmentDoc}`;
export type RetryProductSubscriptionChargeMutationFn = Apollo.MutationFunction<RetryProductSubscriptionChargeMutation, RetryProductSubscriptionChargeMutationVariables>;

/**
 * __useRetryProductSubscriptionChargeMutation__
 *
 * To run a mutation, you first call `useRetryProductSubscriptionChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryProductSubscriptionChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryProductSubscriptionChargeMutation, { data, loading, error }] = useRetryProductSubscriptionChargeMutation({
 *   variables: {
 *   },
 * });
 */
export function useRetryProductSubscriptionChargeMutation(baseOptions?: Apollo.MutationHookOptions<RetryProductSubscriptionChargeMutation, RetryProductSubscriptionChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryProductSubscriptionChargeMutation, RetryProductSubscriptionChargeMutationVariables>(RetryProductSubscriptionChargeDocument, options);
      }
export type RetryProductSubscriptionChargeMutationHookResult = ReturnType<typeof useRetryProductSubscriptionChargeMutation>;
export type RetryProductSubscriptionChargeMutationResult = Apollo.MutationResult<RetryProductSubscriptionChargeMutation>;
export type RetryProductSubscriptionChargeMutationOptions = Apollo.BaseMutationOptions<RetryProductSubscriptionChargeMutation, RetryProductSubscriptionChargeMutationVariables>;
export const RenewProductSubscriptionDocument = gql`
    mutation renewProductSubscription {
  renewProductSubscription {
    productSubscription {
      ...ProductSubscription
    }
    productSubscriptionPayment {
      ...ProductSubscriptionPayment
    }
  }
}
    ${ProductSubscriptionFragmentDoc}
${ProductSubscriptionPaymentFragmentDoc}`;
export type RenewProductSubscriptionMutationFn = Apollo.MutationFunction<RenewProductSubscriptionMutation, RenewProductSubscriptionMutationVariables>;

/**
 * __useRenewProductSubscriptionMutation__
 *
 * To run a mutation, you first call `useRenewProductSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewProductSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewProductSubscriptionMutation, { data, loading, error }] = useRenewProductSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useRenewProductSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RenewProductSubscriptionMutation, RenewProductSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewProductSubscriptionMutation, RenewProductSubscriptionMutationVariables>(RenewProductSubscriptionDocument, options);
      }
export type RenewProductSubscriptionMutationHookResult = ReturnType<typeof useRenewProductSubscriptionMutation>;
export type RenewProductSubscriptionMutationResult = Apollo.MutationResult<RenewProductSubscriptionMutation>;
export type RenewProductSubscriptionMutationOptions = Apollo.BaseMutationOptions<RenewProductSubscriptionMutation, RenewProductSubscriptionMutationVariables>;
export const ValidateCouponDocument = gql`
    mutation validateCoupon($args: ValidateCouponInput!) {
  validateCoupon(args: $args) {
    isValid
    invalidMessageType
    coupon {
      stripeCouponId
      percentOff
      active
      code
      amountOff
      description
      duration
      duration_in_months
    }
  }
}
    `;
export type ValidateCouponMutationFn = Apollo.MutationFunction<ValidateCouponMutation, ValidateCouponMutationVariables>;

/**
 * __useValidateCouponMutation__
 *
 * To run a mutation, you first call `useValidateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCouponMutation, { data, loading, error }] = useValidateCouponMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useValidateCouponMutation(baseOptions?: Apollo.MutationHookOptions<ValidateCouponMutation, ValidateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateCouponMutation, ValidateCouponMutationVariables>(ValidateCouponDocument, options);
      }
export type ValidateCouponMutationHookResult = ReturnType<typeof useValidateCouponMutation>;
export type ValidateCouponMutationResult = Apollo.MutationResult<ValidateCouponMutation>;
export type ValidateCouponMutationOptions = Apollo.BaseMutationOptions<ValidateCouponMutation, ValidateCouponMutationVariables>;
export const GetSubscriptionProductsDocument = gql`
    query getSubscriptionProducts($filter: GetSubscriptionProductsFilterInput) {
  getSubscriptionProducts(filter: $filter) {
    ...SubscriptionProduct
  }
}
    ${SubscriptionProductFragmentDoc}`;

/**
 * __useGetSubscriptionProductsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionProductsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSubscriptionProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionProductsQuery, GetSubscriptionProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionProductsQuery, GetSubscriptionProductsQueryVariables>(GetSubscriptionProductsDocument, options);
      }
export function useGetSubscriptionProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionProductsQuery, GetSubscriptionProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionProductsQuery, GetSubscriptionProductsQueryVariables>(GetSubscriptionProductsDocument, options);
        }
export function useGetSubscriptionProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionProductsQuery, GetSubscriptionProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionProductsQuery, GetSubscriptionProductsQueryVariables>(GetSubscriptionProductsDocument, options);
        }
export type GetSubscriptionProductsQueryHookResult = ReturnType<typeof useGetSubscriptionProductsQuery>;
export type GetSubscriptionProductsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionProductsLazyQuery>;
export type GetSubscriptionProductsSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionProductsSuspenseQuery>;
export type GetSubscriptionProductsQueryResult = Apollo.QueryResult<GetSubscriptionProductsQuery, GetSubscriptionProductsQueryVariables>;
export const GetCheckoutSessionDetailsDocument = gql`
    query getCheckoutSessionDetails($sessionId: String!) {
  getCheckoutSessionDetails(sessionId: $sessionId) {
    customerName
    totalAmount
    status
    trialEndAt
  }
}
    `;

/**
 * __useGetCheckoutSessionDetailsQuery__
 *
 * To run a query within a React component, call `useGetCheckoutSessionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutSessionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckoutSessionDetailsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetCheckoutSessionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCheckoutSessionDetailsQuery, GetCheckoutSessionDetailsQueryVariables> & ({ variables: GetCheckoutSessionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckoutSessionDetailsQuery, GetCheckoutSessionDetailsQueryVariables>(GetCheckoutSessionDetailsDocument, options);
      }
export function useGetCheckoutSessionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckoutSessionDetailsQuery, GetCheckoutSessionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckoutSessionDetailsQuery, GetCheckoutSessionDetailsQueryVariables>(GetCheckoutSessionDetailsDocument, options);
        }
export function useGetCheckoutSessionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCheckoutSessionDetailsQuery, GetCheckoutSessionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCheckoutSessionDetailsQuery, GetCheckoutSessionDetailsQueryVariables>(GetCheckoutSessionDetailsDocument, options);
        }
export type GetCheckoutSessionDetailsQueryHookResult = ReturnType<typeof useGetCheckoutSessionDetailsQuery>;
export type GetCheckoutSessionDetailsLazyQueryHookResult = ReturnType<typeof useGetCheckoutSessionDetailsLazyQuery>;
export type GetCheckoutSessionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCheckoutSessionDetailsSuspenseQuery>;
export type GetCheckoutSessionDetailsQueryResult = Apollo.QueryResult<GetCheckoutSessionDetailsQuery, GetCheckoutSessionDetailsQueryVariables>;
export const GetPreviewInvoiceDocument = gql`
    query getPreviewInvoice($input: GetPreviewInvoiceInput!) {
  getPreviewInvoice(input: $input) {
    amountDue
    items {
      amount
      description
      id
    }
    dueDateMillis
    coupon {
      name
      amountOff
      percentOff
    }
  }
}
    `;

/**
 * __useGetPreviewInvoiceQuery__
 *
 * To run a query within a React component, call `useGetPreviewInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewInvoiceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPreviewInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewInvoiceQuery, GetPreviewInvoiceQueryVariables> & ({ variables: GetPreviewInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewInvoiceQuery, GetPreviewInvoiceQueryVariables>(GetPreviewInvoiceDocument, options);
      }
export function useGetPreviewInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewInvoiceQuery, GetPreviewInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewInvoiceQuery, GetPreviewInvoiceQueryVariables>(GetPreviewInvoiceDocument, options);
        }
export function useGetPreviewInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviewInvoiceQuery, GetPreviewInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviewInvoiceQuery, GetPreviewInvoiceQueryVariables>(GetPreviewInvoiceDocument, options);
        }
export type GetPreviewInvoiceQueryHookResult = ReturnType<typeof useGetPreviewInvoiceQuery>;
export type GetPreviewInvoiceLazyQueryHookResult = ReturnType<typeof useGetPreviewInvoiceLazyQuery>;
export type GetPreviewInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetPreviewInvoiceSuspenseQuery>;
export type GetPreviewInvoiceQueryResult = Apollo.QueryResult<GetPreviewInvoiceQuery, GetPreviewInvoiceQueryVariables>;
export const CanUserTrialForProductDocument = gql`
    query canUserTrialForProduct($input: CanUserTrialForProductInput!) {
  canUserTrialForProduct(input: $input)
}
    `;

/**
 * __useCanUserTrialForProductQuery__
 *
 * To run a query within a React component, call `useCanUserTrialForProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanUserTrialForProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanUserTrialForProductQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCanUserTrialForProductQuery(baseOptions: Apollo.QueryHookOptions<CanUserTrialForProductQuery, CanUserTrialForProductQueryVariables> & ({ variables: CanUserTrialForProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanUserTrialForProductQuery, CanUserTrialForProductQueryVariables>(CanUserTrialForProductDocument, options);
      }
export function useCanUserTrialForProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanUserTrialForProductQuery, CanUserTrialForProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanUserTrialForProductQuery, CanUserTrialForProductQueryVariables>(CanUserTrialForProductDocument, options);
        }
export function useCanUserTrialForProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanUserTrialForProductQuery, CanUserTrialForProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanUserTrialForProductQuery, CanUserTrialForProductQueryVariables>(CanUserTrialForProductDocument, options);
        }
export type CanUserTrialForProductQueryHookResult = ReturnType<typeof useCanUserTrialForProductQuery>;
export type CanUserTrialForProductLazyQueryHookResult = ReturnType<typeof useCanUserTrialForProductLazyQuery>;
export type CanUserTrialForProductSuspenseQueryHookResult = ReturnType<typeof useCanUserTrialForProductSuspenseQuery>;
export type CanUserTrialForProductQueryResult = Apollo.QueryResult<CanUserTrialForProductQuery, CanUserTrialForProductQueryVariables>;
export const ObserveSubscriptionProductsChangesDocument = gql`
    subscription observeSubscriptionProductsChanges {
  observeSubscriptionProductsChanges {
    trigger
    document {
      ...SubscriptionProduct
    }
  }
}
    ${SubscriptionProductFragmentDoc}`;

/**
 * __useObserveSubscriptionProductsChangesSubscription__
 *
 * To run a query within a React component, call `useObserveSubscriptionProductsChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObserveSubscriptionProductsChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObserveSubscriptionProductsChangesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useObserveSubscriptionProductsChangesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ObserveSubscriptionProductsChangesSubscription, ObserveSubscriptionProductsChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ObserveSubscriptionProductsChangesSubscription, ObserveSubscriptionProductsChangesSubscriptionVariables>(ObserveSubscriptionProductsChangesDocument, options);
      }
export type ObserveSubscriptionProductsChangesSubscriptionHookResult = ReturnType<typeof useObserveSubscriptionProductsChangesSubscription>;
export type ObserveSubscriptionProductsChangesSubscriptionResult = Apollo.SubscriptionResult<ObserveSubscriptionProductsChangesSubscription>;
export const GetTrendingListDocument = gql`
    query getTrendingList($type: String!) {
  getTrendingList(type: $type) {
    _id
    periodStart
    periodEnd
    type
    items {
      propertyId
      property {
        _id
        name
        averageBathroomsNumberValue {
          min
          max
        }
        averageBedroomsNumberValue {
          min
          max
        }
        mainPropertyMediaFile {
          _id
          files {
            _id
            type
            publicUrl
            thumbnailFileUrl
            thumbnailFile {
              publicUrl
            }
          }
        }
        priceRange {
          min
          max
        }
        numberOfUnits
        projectStatus
        yearBuilt
        cmsStatus
        lastUpdatedAtByChangelog
        lastChangelogType
        createdAt
        buildingTypes
        completionDate
        constructionStartDate
        amenityNames {
          name
        }
        verifiedAt
        market
        marketArea {
          ...MarketArea
        }
        location {
          geoLocation {
            coordinates
          }
          address {
            city
            county
            state
            street
          }
        }
        isMarkedAsVerified
      }
    }
  }
}
    ${MarketAreaFragmentDoc}`;

/**
 * __useGetTrendingListQuery__
 *
 * To run a query within a React component, call `useGetTrendingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingListQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetTrendingListQuery(baseOptions: Apollo.QueryHookOptions<GetTrendingListQuery, GetTrendingListQueryVariables> & ({ variables: GetTrendingListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendingListQuery, GetTrendingListQueryVariables>(GetTrendingListDocument, options);
      }
export function useGetTrendingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendingListQuery, GetTrendingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendingListQuery, GetTrendingListQueryVariables>(GetTrendingListDocument, options);
        }
export function useGetTrendingListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrendingListQuery, GetTrendingListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrendingListQuery, GetTrendingListQueryVariables>(GetTrendingListDocument, options);
        }
export type GetTrendingListQueryHookResult = ReturnType<typeof useGetTrendingListQuery>;
export type GetTrendingListLazyQueryHookResult = ReturnType<typeof useGetTrendingListLazyQuery>;
export type GetTrendingListSuspenseQueryHookResult = ReturnType<typeof useGetTrendingListSuspenseQuery>;
export type GetTrendingListQueryResult = Apollo.QueryResult<GetTrendingListQuery, GetTrendingListQueryVariables>;
export const GetUnitsDocument = gql`
    query getUnits($sort: [SortInput!], $pagination: PaginationInput, $filter: GetUnitsFilterInput) {
  getUnits(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
    collection {
      ...Unit
    }
  }
}
    ${UnitFragmentDoc}`;

/**
 * __useGetUnitsQuery__
 *
 * To run a query within a React component, call `useGetUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsQuery, GetUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, options);
      }
export function useGetUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsQuery, GetUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, options);
        }
export function useGetUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitsQuery, GetUnitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnitsQuery, GetUnitsQueryVariables>(GetUnitsDocument, options);
        }
export type GetUnitsQueryHookResult = ReturnType<typeof useGetUnitsQuery>;
export type GetUnitsLazyQueryHookResult = ReturnType<typeof useGetUnitsLazyQuery>;
export type GetUnitsSuspenseQueryHookResult = ReturnType<typeof useGetUnitsSuspenseQuery>;
export type GetUnitsQueryResult = Apollo.QueryResult<GetUnitsQuery, GetUnitsQueryVariables>;
export const GetUnitsCountDocument = gql`
    query getUnitsCount($sort: [SortInput!], $pagination: PaginationInput, $filter: GetUnitsFilterInput) {
  getUnits(sort: $sort, pagination: $pagination, filter: $filter) {
    totalCount
  }
}
    `;

/**
 * __useGetUnitsCountQuery__
 *
 * To run a query within a React component, call `useGetUnitsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsCountQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetUnitsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitsCountQuery, GetUnitsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsCountQuery, GetUnitsCountQueryVariables>(GetUnitsCountDocument, options);
      }
export function useGetUnitsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsCountQuery, GetUnitsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsCountQuery, GetUnitsCountQueryVariables>(GetUnitsCountDocument, options);
        }
export function useGetUnitsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitsCountQuery, GetUnitsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnitsCountQuery, GetUnitsCountQueryVariables>(GetUnitsCountDocument, options);
        }
export type GetUnitsCountQueryHookResult = ReturnType<typeof useGetUnitsCountQuery>;
export type GetUnitsCountLazyQueryHookResult = ReturnType<typeof useGetUnitsCountLazyQuery>;
export type GetUnitsCountSuspenseQueryHookResult = ReturnType<typeof useGetUnitsCountSuspenseQuery>;
export type GetUnitsCountQueryResult = Apollo.QueryResult<GetUnitsCountQuery, GetUnitsCountQueryVariables>;
export const GetPropertyUnitsInPublicBrokerPortfolioDocument = gql`
    query getPropertyUnitsInPublicBrokerPortfolio($brokerId: ObjectId!, $password: String, $portfolioFolderId: ObjectId, $propertyId: ObjectId!, $sort: [SortInput!], $pagination: PaginationInput, $filter: GetUnitsFilterInput) {
  getPropertyUnitsInPublicBrokerPortfolio(
    brokerId: $brokerId
    password: $password
    portfolioFolderId: $portfolioFolderId
    propertyId: $propertyId
    sort: $sort
    pagination: $pagination
    filter: $filter
  ) {
    totalCount
    collection {
      ...Unit
    }
  }
}
    ${UnitFragmentDoc}`;

/**
 * __useGetPropertyUnitsInPublicBrokerPortfolioQuery__
 *
 * To run a query within a React component, call `useGetPropertyUnitsInPublicBrokerPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyUnitsInPublicBrokerPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyUnitsInPublicBrokerPortfolioQuery({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *      password: // value for 'password'
 *      portfolioFolderId: // value for 'portfolioFolderId'
 *      propertyId: // value for 'propertyId'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPropertyUnitsInPublicBrokerPortfolioQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyUnitsInPublicBrokerPortfolioQuery, GetPropertyUnitsInPublicBrokerPortfolioQueryVariables> & ({ variables: GetPropertyUnitsInPublicBrokerPortfolioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyUnitsInPublicBrokerPortfolioQuery, GetPropertyUnitsInPublicBrokerPortfolioQueryVariables>(GetPropertyUnitsInPublicBrokerPortfolioDocument, options);
      }
export function useGetPropertyUnitsInPublicBrokerPortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyUnitsInPublicBrokerPortfolioQuery, GetPropertyUnitsInPublicBrokerPortfolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyUnitsInPublicBrokerPortfolioQuery, GetPropertyUnitsInPublicBrokerPortfolioQueryVariables>(GetPropertyUnitsInPublicBrokerPortfolioDocument, options);
        }
export function useGetPropertyUnitsInPublicBrokerPortfolioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyUnitsInPublicBrokerPortfolioQuery, GetPropertyUnitsInPublicBrokerPortfolioQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyUnitsInPublicBrokerPortfolioQuery, GetPropertyUnitsInPublicBrokerPortfolioQueryVariables>(GetPropertyUnitsInPublicBrokerPortfolioDocument, options);
        }
export type GetPropertyUnitsInPublicBrokerPortfolioQueryHookResult = ReturnType<typeof useGetPropertyUnitsInPublicBrokerPortfolioQuery>;
export type GetPropertyUnitsInPublicBrokerPortfolioLazyQueryHookResult = ReturnType<typeof useGetPropertyUnitsInPublicBrokerPortfolioLazyQuery>;
export type GetPropertyUnitsInPublicBrokerPortfolioSuspenseQueryHookResult = ReturnType<typeof useGetPropertyUnitsInPublicBrokerPortfolioSuspenseQuery>;
export type GetPropertyUnitsInPublicBrokerPortfolioQueryResult = Apollo.QueryResult<GetPropertyUnitsInPublicBrokerPortfolioQuery, GetPropertyUnitsInPublicBrokerPortfolioQueryVariables>;
export const GetPropertyUnitsSqftRangeDocument = gql`
    query getPropertyUnitsSqftRange($propertyId: ObjectId!) {
  getPropertyUnitsSqftRange(propertyId: $propertyId) {
    min
    max
  }
}
    `;

/**
 * __useGetPropertyUnitsSqftRangeQuery__
 *
 * To run a query within a React component, call `useGetPropertyUnitsSqftRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyUnitsSqftRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyUnitsSqftRangeQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropertyUnitsSqftRangeQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables> & ({ variables: GetPropertyUnitsSqftRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables>(GetPropertyUnitsSqftRangeDocument, options);
      }
export function useGetPropertyUnitsSqftRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables>(GetPropertyUnitsSqftRangeDocument, options);
        }
export function useGetPropertyUnitsSqftRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables>(GetPropertyUnitsSqftRangeDocument, options);
        }
export type GetPropertyUnitsSqftRangeQueryHookResult = ReturnType<typeof useGetPropertyUnitsSqftRangeQuery>;
export type GetPropertyUnitsSqftRangeLazyQueryHookResult = ReturnType<typeof useGetPropertyUnitsSqftRangeLazyQuery>;
export type GetPropertyUnitsSqftRangeSuspenseQueryHookResult = ReturnType<typeof useGetPropertyUnitsSqftRangeSuspenseQuery>;
export type GetPropertyUnitsSqftRangeQueryResult = Apollo.QueryResult<GetPropertyUnitsSqftRangeQuery, GetPropertyUnitsSqftRangeQueryVariables>;